import { SVGProps } from "react";

export const AccessibilityIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_2023_11961)">
        <path
          d="M30.8 31.1557C30.1998 31.2779 29.6437 31.5608 29.1909 31.9745C28.7382 32.3882 28.4056 32.9172 28.2286 33.5053C28.0296 34.0683 27.9708 34.6716 28.0572 35.2627C28.1715 35.8357 28.6667 36.3133 29.2762 36.1796C30.4762 35.9121 30.4953 34.0401 29.4667 33.5626C28.4381 33.085 27.2381 33.8109 26.6286 34.6323C25.7715 35.7784 25.7524 37.3066 26.2667 38.6055C26.3619 38.873 26.9143 38.7202 26.8191 38.4718C26.4572 37.5167 26.3238 36.447 26.7238 35.4919C27.1238 34.5368 27.6381 34.021 28.4381 33.8873C28.6197 33.8375 28.8117 33.8417 28.991 33.8994C29.1702 33.957 29.3288 34.0657 29.4477 34.212C29.5768 34.4173 29.6469 34.6543 29.6503 34.897C29.6536 35.1397 29.5901 35.3786 29.4667 35.5874C29.4088 35.6706 29.3215 35.7287 29.2225 35.75C29.1236 35.7713 29.0202 35.7541 28.9334 35.702C28.7361 35.5328 28.613 35.2927 28.5905 35.0334C28.5458 34.5568 28.5976 34.0759 28.7429 33.6199C28.8765 33.1088 29.1511 32.6459 29.5352 32.2844C29.9193 31.9228 30.3973 31.6773 30.9143 31.5759C31.0286 31.5377 31.1619 31.4231 31.1238 31.2894C31.0857 31.1557 30.9143 31.1366 30.8 31.1557Z"
          fill="#00244C"
        />
        <path
          d="M34.1339 4.64221L36.3815 3.07583L36.7054 2.84661C36.7702 2.81029 36.8183 2.75011 36.8397 2.6788C36.861 2.60749 36.8538 2.53065 36.8196 2.46456C36.7798 2.39819 36.7164 2.34944 36.6422 2.32817C36.5679 2.30689 36.4884 2.31468 36.4196 2.34995L34.172 3.91633L33.8482 4.14556C33.8158 4.16325 33.7874 4.18749 33.7648 4.21677C33.7422 4.24604 33.7259 4.27969 33.7169 4.31561C33.708 4.35152 33.7066 4.3889 33.7128 4.42539C33.719 4.46188 33.7327 4.49669 33.753 4.5276C33.7892 4.59259 33.8492 4.6409 33.9203 4.66229C33.9914 4.68369 34.068 4.67648 34.1339 4.64221Z"
          fill="#00244C"
        />
        <path
          d="M34.4012 6.13099L39.0678 5.76805L39.7345 5.71074C40.0964 5.69164 40.0964 5.11857 39.7345 5.13767L35.0488 5.50062L34.4012 5.55792C34.0393 5.57702 34.0202 6.15009 34.4012 6.13099Z"
          fill="#00244C"
        />
        <path
          d="M21.0485 33.6389L17.8866 32.8175L12.8009 31.4613L11.5437 31.1365C10.3789 30.8372 9.36942 30.1086 8.71634 29.0961C8.06327 28.0836 7.81461 26.8615 8.01992 25.6733C8.06533 25.4019 8.12897 25.1338 8.2104 24.871L8.99135 21.872L10.2866 16.9436L11.7152 11.4995L12.9342 6.83855L13.5818 4.37436C14.0771 2.42594 15.5818 0.840458 17.5818 0.42021C18.9914 0.133677 20.3628 0.611232 21.7152 0.955071L26.8961 2.33043C28.1914 2.67427 29.639 2.9035 30.7056 3.7822C31.1963 4.19915 31.6003 4.70898 31.8945 5.28257C32.1886 5.85616 32.3672 6.48226 32.4199 7.12508C32.453 7.7111 32.3886 8.29855 32.2294 8.86338L31.5628 11.4422L30.3437 16.1031L28.9152 21.5472L27.6009 26.552L26.7628 29.7612L26.6104 30.3151C26.319 31.4545 25.6122 32.4429 24.6294 33.085C24.1045 33.4236 23.5145 33.6479 22.8976 33.7433C22.2808 33.8388 21.6508 33.8032 21.0485 33.6389C20.9805 33.6249 20.9101 33.628 20.8436 33.648C20.7771 33.668 20.7166 33.7043 20.6675 33.7535C20.5914 33.83 20.6104 33.9255 20.7247 33.9637C23.3533 34.6322 26.1914 33.1805 27.0675 30.5826C27.2771 29.9522 27.4294 29.2836 27.6009 28.6342L28.7056 24.4317L30.1342 18.9684L31.5247 13.6007L32.5342 9.74208C32.7818 8.82518 33.0485 7.92737 32.9723 6.95316C32.8596 5.64699 32.2366 4.43848 31.239 3.59117C30.5983 3.05473 29.8418 2.67539 29.0294 2.48325L24.6485 1.33712L20.4009 0.210085C18.2294 -0.36298 15.8866 0.229188 14.3628 1.91018C13.7262 2.61138 13.2687 3.45694 13.0294 4.37436C12.9723 4.62269 12.9152 4.87102 12.839 5.11935L11.8866 8.74877L10.5152 14.021L9.06754 19.5033L7.96278 23.744C7.79135 24.4508 7.54373 25.1576 7.44849 25.8643C7.08659 28.4049 8.74373 30.7927 11.2009 31.4613L14.7818 32.3973L19.8294 33.7344L20.7247 33.9637C20.7926 33.9795 20.8635 33.9773 20.9304 33.9572C20.9972 33.9371 21.0576 33.8998 21.1056 33.8491C21.2009 33.7726 21.1818 33.6771 21.0485 33.6389Z"
          fill="#00244C"
        />
        <path
          d="M32.5529 8.672L26.8958 30.2766C26.7339 30.9041 26.4501 31.4935 26.0608 32.0109C25.6715 32.5283 25.1842 32.9636 24.6268 33.2919C24.0695 33.6201 23.453 33.8349 22.8128 33.9239C22.1726 34.0129 21.5211 33.9744 20.8958 33.8105L19.8291 33.524C21.0895 33.8556 22.4296 33.6716 23.5548 33.0124C24.6799 32.3533 25.498 31.2731 25.8291 30.0092L26.2482 28.3855L29.5815 15.7016L31.372 8.82482C31.5964 7.95944 31.5499 7.04574 31.2386 6.20782L32.3053 5.48193C32.7408 6.48772 32.8279 7.61075 32.5529 8.672Z"
          fill="#00244C"
        />
        <path
          d="M31.0862 8.86313L30.1528 12.4734L29.2957 15.7399C29.0481 16.6568 28.8195 17.5737 28.5719 18.4906L27.2385 23.61L26.1528 27.7552C25.9243 28.6339 25.7338 29.5317 25.4481 30.3913C25.2396 30.9849 24.9148 31.5307 24.4928 31.9966C24.0708 32.4624 23.5602 32.8389 22.9909 33.1038C22.0412 33.5382 20.9699 33.6261 19.9624 33.3521L16.3243 32.397L11.8862 31.2318C11.2859 31.0827 10.7091 30.8513 10.1719 30.5441C9.30125 29.9792 8.63373 29.1498 8.26701 28.177C7.90028 27.2043 7.8536 26.1394 8.13378 25.1382L8.41949 24.0876L9.56235 19.6941L10.9147 14.5174L11.7528 11.3082C11.9814 10.4868 12.1909 9.66542 12.4004 8.82492L13.4862 4.69885C14.0957 2.42569 16.3052 0.840205 18.6671 1.24135C19.0862 1.31776 19.5052 1.45147 19.9243 1.56609L22.21 2.15826L26.4766 3.28529L27.8481 3.64823C28.2736 3.74389 28.6838 3.89817 29.0671 4.10668C29.6187 4.40913 30.0943 4.83378 30.4576 5.34832C30.8109 5.8531 31.0502 6.4291 31.1588 7.03614C31.2673 7.64319 31.2425 8.26667 31.0862 8.86313C31.029 9.09235 31.6005 9.01595 31.6385 8.80582C31.7994 8.19104 31.8266 7.54874 31.7181 6.92251C31.6096 6.29628 31.3681 5.70078 31.01 5.1764C30.3624 4.22129 29.3909 3.64823 28.3052 3.36169L25.1624 2.5212L20.229 1.22225C19.7719 1.10764 19.3147 0.97392 18.8576 0.897511C17.5806 0.70563 16.2772 0.976538 15.1814 1.6616C14.0931 2.34918 13.2987 3.41818 12.9528 4.66064C12.8385 5.08089 12.7433 5.50114 12.629 5.92139L11.3719 10.716C11.2195 11.27 11.0862 11.8431 10.9338 12.397L9.75283 16.9434L8.3814 22.1774L7.5814 25.2146C7.30864 26.2313 7.35628 27.3076 7.71777 28.296C8.07927 29.2845 8.73691 30.1365 9.60045 30.7351C10.1805 31.1183 10.8263 31.3904 11.5052 31.5374L13.3528 32.015L18.4004 33.3521L19.6385 33.6769C20.7152 33.9647 21.8551 33.9045 22.8957 33.505C24.0879 33.0655 25.0775 32.2022 25.6766 31.079C26.0957 30.2958 26.2481 29.4171 26.4766 28.5575C26.7052 27.6979 26.8766 27.0293 27.0862 26.2652L28.4004 21.184L29.6004 16.6377L30.0576 14.8612L31.3528 9.91375L31.6385 8.80582C31.7147 8.57659 31.1433 8.653 31.0862 8.86313Z"
          fill="#00244C"
        />
        <path
          d="M7.63858 25.1L9.23858 25.5202L13.0862 26.5326L17.7148 27.7361L21.7529 28.8058L23.6957 29.3215H23.7338C23.7976 29.3404 23.8648 29.345 23.9306 29.3351C23.9964 29.3252 24.0593 29.301 24.1148 29.2642C24.1719 29.2451 24.3052 29.1114 24.1719 29.0732L22.591 28.653L18.7433 27.6405L14.0957 26.4371L10.0767 25.3674C9.42906 25.1955 8.78144 25.0044 8.11477 24.8516H8.09572C8.02878 24.8324 7.95855 24.8276 7.88963 24.8375C7.82071 24.8474 7.75463 24.8717 7.69572 24.9089C7.65763 24.928 7.52429 25.0618 7.63858 25.1Z"
          fill="#00244C"
        />
        <path
          d="M17.437 30.2256C17.6369 29.4478 17.2529 28.6762 16.5795 28.5022C15.906 28.3281 15.198 28.8175 14.9981 29.5952C14.7983 30.3729 15.1822 31.1445 15.8557 31.3186C16.5291 31.4927 17.2371 31.0033 17.437 30.2256Z"
          fill="#00244C"
        />
        <path
          d="M10.7819 25.368C10.9338 25.7682 11.1252 26.1521 11.3533 26.5141C11.3662 26.5555 11.3883 26.5935 11.4179 26.6251C11.4475 26.6566 11.4839 26.6811 11.5244 26.6965C11.5648 26.712 11.6082 26.718 11.6512 26.7142C11.6943 26.7104 11.736 26.6968 11.7731 26.6745C11.8102 26.6521 11.8417 26.6217 11.8653 26.5854C11.889 26.549 11.9041 26.5078 11.9095 26.4648C11.9149 26.4217 11.9106 26.378 11.8967 26.3369C11.8829 26.2959 11.8599 26.2585 11.8295 26.2276C11.7343 26.0557 11.639 25.8837 11.5628 25.7118C11.5071 25.6288 11.4623 25.5389 11.4295 25.4444L11.3724 25.3298C11.3724 25.3107 11.3343 25.2152 11.3724 25.2916C11.3605 25.2827 11.3509 25.2711 11.3443 25.2579C11.3377 25.2446 11.3343 25.23 11.3343 25.2152C11.3021 25.1493 11.2567 25.0908 11.2009 25.0432C11.1301 25.0073 11.0481 25.0004 10.9724 25.0241C10.9378 25.0317 10.9057 25.0479 10.879 25.0713C10.8524 25.0947 10.8321 25.1245 10.82 25.1579C10.7819 25.2152 10.7438 25.3107 10.7819 25.368Z"
          fill="#00244C"
        />
        <path
          d="M11.6007 25.2528L10.5722 26.0168C10.5175 26.0654 10.4723 26.1237 10.4388 26.1888C10.4209 26.2672 10.4346 26.3496 10.4769 26.418C10.5162 26.4797 10.5776 26.524 10.6484 26.5418C10.7193 26.5595 10.7942 26.5494 10.8579 26.5135L11.8864 25.7494C11.9436 25.6921 12.0007 25.6539 12.0198 25.5775C12.0434 25.5015 12.0366 25.4193 12.0007 25.3483C11.958 25.2851 11.8932 25.2403 11.8192 25.2227C11.7452 25.205 11.6673 25.2157 11.6007 25.2528Z"
          fill="#00244C"
        />
        <path
          d="M11.1434 23.9159L12.0767 17.9179C12.129 17.5345 12.3262 17.1859 12.6276 16.9441C12.9289 16.7024 13.3113 16.5859 13.6958 16.6189C14.0673 16.6416 14.4177 16.7998 14.6808 17.0637C14.944 17.3276 15.1018 17.679 15.1243 18.0516L15.5053 23.8777C15.5724 24.938 15.4366 26.0014 15.1053 27.0105L12.7434 34.0592L4.15291 31.7096L3.0672 26.0172C2.97174 25.5509 2.97174 25.07 3.0672 24.6036L3.77196 20.745C4.09172 19.114 5.00915 17.6624 6.34339 16.6762L10.6291 13.5435L9.21958 19.1786L8.76243 19.809C8.61054 20.0365 8.50974 20.2944 8.46698 20.5649C8.42423 20.8353 8.44055 21.1119 8.51482 21.3754L9.35291 24.0497C9.43129 24.2809 9.59665 24.4722 9.81373 24.5828C10.0308 24.6935 10.2824 24.7146 10.5148 24.6418C10.6753 24.5892 10.8184 24.4938 10.9291 24.366C11.0398 24.2382 11.1139 24.0826 11.1434 23.9159Z"
          fill="#00244C"
        />
        <path
          d="M14.3818 36.9246C14.6752 36.4873 14.7973 35.9567 14.7246 35.4347C14.6675 34.9189 14.4579 34.3267 14.0198 34.002C13.7557 33.8578 13.474 33.7486 13.1818 33.6773L10.2865 32.9132L4.09604 31.2704C3.33413 31.0794 2.64842 31.385 2.13413 31.939C1.7892 32.3051 1.54046 32.7514 1.41032 33.2379C1.37501 33.367 1.31012 33.486 1.22084 33.5855C1.13155 33.685 1.02033 33.7622 0.896037 33.811C0.673346 33.9268 0.478381 34.0898 0.324609 34.2885C0.08435 34.5954 -0.0280388 34.9837 0.0110266 35.3719C0.050092 35.7602 0.237575 36.1181 0.534132 36.3707C0.780766 36.576 1.07596 36.7141 1.39128 36.7718L7.52461 38.3764L13.3341 39.9046L13.4294 39.9428C13.6008 39.981 14.077 39.7327 13.7722 39.6563L9.10556 38.4337L2.38175 36.6572C1.75318 36.4853 1.04842 36.4089 0.705561 35.7594C0.61841 35.5862 0.566766 35.3972 0.553679 35.2036C0.540593 35.0101 0.56633 34.8158 0.629371 34.6324C0.703151 34.4421 0.820612 34.272 0.972228 34.1357C1.18175 33.9638 1.44842 33.9065 1.63889 33.7155C1.82937 33.5244 2.01985 32.8177 2.26747 32.4165C2.51508 32.0154 2.95318 31.4996 3.46747 31.5187C3.68885 31.5423 3.90642 31.5937 4.11509 31.6715L5.31508 31.9772L8.85794 32.9323L12.1913 33.811L13.0484 34.0402C13.7151 34.2121 14.0198 34.747 14.1341 35.3965C14.249 35.9212 14.1532 36.4702 13.8675 36.9246C13.7341 37.1348 14.2865 37.0775 14.3818 36.9246Z"
          fill="#00244C"
        />
        <path
          d="M14.0578 17.5931L14.0197 18.7011C14.0216 18.9205 13.9399 19.1323 13.7911 19.2932L13.6578 19.3696H13.5244C13.3682 19.3433 13.2264 19.2621 13.1244 19.1404C12.9149 18.9303 12.953 18.6438 12.953 18.3763C12.953 18.1089 12.534 18.3381 12.534 18.4909V18.7584C12.529 18.9393 12.59 19.1159 12.7054 19.255C12.8444 19.4014 13.0246 19.5018 13.2221 19.5428C13.4195 19.5838 13.6246 19.5633 13.8102 19.4843C13.9802 19.4271 14.1292 19.3201 14.2379 19.1771C14.3466 19.034 14.4099 18.8615 14.4197 18.682C14.4197 18.4909 14.4387 18.2999 14.4387 18.1089V17.4976C14.4578 17.4021 14.0387 17.4594 14.0387 17.5931H14.0578Z"
          fill="white"
        />
        <path
          opacity="0.15"
          d="M26.8201 3.17119C26.2956 5.68561 24.9247 7.94259 22.9374 9.56342C20.9501 11.1842 18.4674 12.0703 15.9059 12.0728C14.3981 12.0734 12.9066 11.7612 11.5249 11.1559L13.2201 4.69936C13.382 4.07182 13.6658 3.48247 14.0551 2.96506C14.4445 2.44764 14.9317 2.01234 15.4891 1.68408C16.0464 1.35581 16.6629 1.14103 17.3031 1.05204C17.9433 0.963046 18.5948 1.00159 19.2201 1.16546L26.8201 3.17119Z"
          fill="url(#paint0_linear_2023_11961)"
        />
        <path
          opacity="0.15"
          d="M29.5814 15.7022L26.2481 28.3861C24.7083 27.9853 23.3671 27.0349 22.4763 25.7131C21.5855 24.3913 21.2062 22.7889 21.4096 21.2066C21.6129 19.6243 22.385 18.1708 23.5809 17.1187C24.7768 16.0666 26.3144 15.4882 27.9052 15.4921C28.4709 15.4855 29.0348 15.5562 29.5814 15.7022Z"
          fill="url(#paint1_linear_2023_11961)"
        />
        <path
          d="M7.60068 38.5675L7.58154 38.5483L7.60068 38.5675Z"
          fill="white"
        />
        <path
          d="M7.63876 38.5865H7.61963V38.5674L7.63876 38.5865Z"
          fill="white"
        />
        <path
          d="M9.08661 34.7852H9.12487C9.12895 34.7887 9.13221 34.7932 9.13444 34.7981C9.13667 34.8031 9.13783 34.8084 9.13783 34.8139C9.13783 34.8193 9.13667 34.8247 9.13444 34.8296C9.13221 34.8346 9.12895 34.839 9.12487 34.8426H9.06747C9.065 34.8322 9.06548 34.8213 9.06886 34.8111C9.07224 34.801 9.07839 34.792 9.08661 34.7852Z"
          fill="#214063"
        />
        <path
          d="M9.18151 34.6707V34.709H9.14325C9.12412 34.6899 9.14325 34.6516 9.18151 34.6707Z"
          fill="#214063"
        />
        <path
          d="M7.12451 35.855H7.14364V35.8741L7.12451 35.855Z"
          fill="#214063"
        />
        <path
          d="M7.29617 35.9505C7.28095 35.9505 7.26635 35.9444 7.25558 35.9337C7.24482 35.9229 7.23877 35.9083 7.23877 35.8931L7.29617 35.9505Z"
          fill="#214063"
        />
        <path
          d="M4.09588 35.6064C4.09588 35.6256 4.09588 35.6447 4.05762 35.6256H4.09588V35.6064Z"
          fill="#214063"
        />
        <path
          d="M3.60107 34.0972C3.63917 34.0972 3.69631 34.0972 3.71536 34.1354C3.73441 34.1736 3.69631 34.1354 3.67726 34.1354L3.60107 34.0972Z"
          fill="#214063"
        />
        <path
          d="M10.3814 36.2369C10.3814 36.1987 10.4195 36.2369 10.4385 36.2178L10.5147 36.256C10.5147 36.2942 10.4956 36.2942 10.4956 36.3324C10.4956 36.3706 10.4956 36.3897 10.4385 36.3706C10.3814 36.3515 10.4004 36.3515 10.3814 36.3515H10.3623C10.3814 36.3515 10.3623 36.3324 10.3433 36.3133L10.3814 36.2369Z"
          fill="#214063"
        />
        <path
          d="M3.86737 34.2507H3.8291V34.2124L3.86737 34.2507Z"
          fill="#214063"
        />
        <path
          d="M4.00125 34.1931H4.02038L3.94385 34.1548L4.00125 34.1931Z"
          fill="#214063"
        />
        <path
          d="M5.4288 35.1291H5.40967C5.40967 35.1291 5.40967 35.11 5.4288 35.1291Z"
          fill="#214063"
        />
        <path
          d="M5.79114 34.6895H5.81027C5.81027 34.6945 5.80825 34.6994 5.80467 34.703C5.80108 34.7066 5.79621 34.7086 5.79114 34.7086C5.78946 34.7057 5.78857 34.7024 5.78857 34.699C5.78857 34.6957 5.78946 34.6924 5.79114 34.6895Z"
          fill="#214063"
        />
        <path
          d="M5.90529 34.4224C5.90529 34.4224 5.94338 34.4415 5.92433 34.4606C5.90529 34.4797 5.90529 34.4988 5.88624 34.4797C5.86719 34.4606 5.86719 34.4606 5.84814 34.4606L5.90529 34.4224Z"
          fill="#214063"
        />
        <path
          d="M5.84785 34.6323C5.82871 34.6323 5.82871 34.6515 5.84785 34.6323V34.6323Z"
          fill="#214063"
        />
        <path
          d="M5.8103 35.186H5.82944C5.82944 35.2052 5.82944 35.2243 5.8103 35.2243C5.80694 35.2185 5.80518 35.2119 5.80518 35.2052C5.80518 35.1985 5.80694 35.1919 5.8103 35.186Z"
          fill="#214063"
        />
        <path
          d="M4.47665 34.8995H4.45752V34.8804L4.47665 34.8995Z"
          fill="#214063"
        />
        <path
          d="M4.59134 34.9759C4.61038 34.9759 4.62943 34.995 4.61038 35.0141C4.59134 35.0332 4.55324 35.0141 4.51515 34.995H4.47705C4.49267 34.9819 4.51151 34.9732 4.5316 34.9698C4.55169 34.9665 4.57232 34.9686 4.59134 34.9759Z"
          fill="#214063"
        />
        <path
          d="M6.00069 35.1862H5.98156C5.96242 35.1862 5.98156 35.1671 6.00069 35.1862Z"
          fill="#214063"
        />
        <path
          d="M6.05781 34.9949C6.07695 34.9949 6.07695 35.0141 6.05781 35.0332H6.03868C6.03361 35.0307 6.02975 35.0262 6.02795 35.0208C6.02616 35.0155 6.02658 35.0096 6.02911 35.0045C6.03165 34.9994 6.0361 34.9956 6.04148 34.9938C6.04686 34.992 6.05274 34.9924 6.05781 34.9949Z"
          fill="#214063"
        />
        <path
          d="M6.03915 35.1675C6.03915 35.1866 6.07742 35.1675 6.05829 35.2058C6.03915 35.2441 6.02002 35.2058 6.02002 35.1866L6.03915 35.1675Z"
          fill="#214063"
        />
        <path
          d="M4.87646 34.9952H4.91456V34.957C4.9717 34.9952 5.04789 34.9952 5.06694 35.0525L5.02885 35.0907H4.99075C4.9717 35.0716 4.93361 35.0907 4.91456 35.0525C4.91456 35.0334 4.87646 35.0143 4.87646 34.9952Z"
          fill="#214063"
        />
        <path
          d="M4.95266 35.2818C4.93362 35.3391 4.89552 35.3009 4.87647 35.2818H4.83838C4.85486 35.2694 4.87492 35.2627 4.89552 35.2627C4.91613 35.2627 4.93618 35.2694 4.95266 35.2818Z"
          fill="#214063"
        />
        <path
          d="M4.91513 35.2818L4.896 35.301V35.2627V35.2818H4.91513Z"
          fill="white"
        />
        <path
          d="M8.28667 36.4469C8.22952 36.466 8.17238 36.4278 8.11524 36.3896H8.09619C8.13012 36.3806 8.16587 36.3812 8.19948 36.3914C8.23309 36.4015 8.26326 36.4207 8.28667 36.4469Z"
          fill="#214063"
        />
        <path
          d="M5.16279 35.4156V35.4538H5.14374L5.06755 35.4156C5.0485 35.4156 5.06755 35.4156 5.06755 35.3965H5.14374L5.16279 35.4156Z"
          fill="#214063"
        />
        <path
          d="M5.21924 35.5108C5.23829 35.4917 5.27638 35.5108 5.31448 35.5299C5.31953 35.5299 5.32437 35.532 5.32795 35.5355C5.33152 35.5391 5.33352 35.544 5.33352 35.549C5.33352 35.5541 5.33152 35.559 5.32795 35.5626C5.32437 35.5661 5.31953 35.5681 5.31448 35.5681H5.21924V35.5108Z"
          fill="#214063"
        />
        <path
          d="M5.31448 36.4472H5.23829C5.23829 36.4281 5.21924 36.4472 5.21924 36.4281C5.21924 36.409 5.27638 36.409 5.31448 36.4472Z"
          fill="#214063"
        />
        <path
          d="M6.43853 33.6771C6.43853 33.7153 6.40043 33.6962 6.38138 33.6962C6.36234 33.6962 6.30519 33.6197 6.2671 33.6197L6.229 33.5815C6.28615 33.6197 6.40043 33.5815 6.43853 33.6771Z"
          fill="#214063"
        />
        <path
          d="M6.19092 36.103H6.21005C6.21005 36.1222 6.21005 36.1413 6.19092 36.1413V36.103Z"
          fill="#214063"
        />
        <path
          d="M6.59082 36.2178H6.64797L6.68606 36.256C6.68606 36.2751 6.66702 36.2751 6.64797 36.2942C6.62892 36.3133 6.62892 36.256 6.59082 36.2751H6.60987L6.57178 36.2369L6.59082 36.2178Z"
          fill="#214063"
        />
        <path
          d="M6.57254 34.2886H6.5534V34.3269L6.51514 34.2886H6.57254Z"
          fill="#214063"
        />
        <path
          d="M6.57236 34.2886H6.59149V34.3269H6.55322L6.57236 34.2886Z"
          fill="#214063"
        />
        <path
          d="M6.64795 35.5298C6.68604 35.5489 6.74319 35.5107 6.78128 35.568C6.78128 35.5781 6.77727 35.5878 6.77012 35.595C6.76298 35.6022 6.75329 35.6062 6.74319 35.6062L6.64795 35.5298Z"
          fill="#214063"
        />
        <path
          d="M6.85742 36.4277L6.91482 36.466H6.85742V36.4277Z"
          fill="#214063"
        />
        <path
          d="M6.93426 34.9761C6.94441 34.9761 6.95414 34.9801 6.96132 34.9873C6.9685 34.9945 6.97253 35.0042 6.97253 35.0144H6.9534C6.93426 35.0144 6.896 34.9952 6.896 34.9761H6.93426Z"
          fill="#214063"
        />
        <path
          d="M6.896 36.5616C6.91513 36.5425 6.896 36.5425 6.896 36.5425V36.5616Z"
          fill="#214063"
        />
        <path
          d="M7.1819 34.0591H7.22017C7.22017 34.0782 7.22017 34.1165 7.20103 34.0974C7.1819 34.0782 7.14363 34.0591 7.1819 34.0591Z"
          fill="#214063"
        />
        <path
          d="M7.14355 34.4795H7.1626C7.2007 34.4795 7.25784 34.4795 7.27689 34.5368V34.575H7.2007L7.14355 34.4986V34.4795Z"
          fill="#214063"
        />
        <path
          d="M7.0293 35.2625C7.04834 35.2816 7.04834 35.2816 7.06739 35.2625C7.08644 35.2434 7.06739 35.2434 7.04834 35.2243C7.0293 35.2052 7.12453 35.2243 7.12453 35.2625C7.12453 35.3007 7.10549 35.2816 7.08644 35.2816H7.0293V35.2625Z"
          fill="#214063"
        />
        <path
          d="M6.99074 37.1348C7.00979 37.1539 6.99074 37.173 6.97169 37.173C6.95265 37.173 6.9336 37.1348 6.91455 37.1539L6.99074 37.1348Z"
          fill="#214063"
        />
        <path
          d="M7.06689 35.2627C7.08603 35.2818 7.08603 35.2818 7.06689 35.2818C7.06689 35.2818 7.08603 35.2818 7.06689 35.2627Z"
          fill="white"
        />
        <path
          d="M9.37208 37.2873H9.35304C9.35304 37.2873 9.41018 37.3255 9.41018 37.2873C9.41018 37.2491 9.52446 37.3255 9.54351 37.3637H9.63875C9.63875 37.3828 9.6578 37.4019 9.63875 37.4019C9.6197 37.4019 9.52447 37.3255 9.46732 37.421H9.31494C9.33399 37.421 9.33399 37.3828 9.33399 37.3828H9.37208V37.2873Z"
          fill="#214063"
        />
        <path
          d="M7.16278 36.638C7.17293 36.638 7.18266 36.6421 7.18984 36.6492C7.19701 36.6564 7.20104 36.6662 7.20104 36.6763H7.12451C7.12451 36.6572 7.12451 36.6189 7.16278 36.638Z"
          fill="#214063"
        />
        <path
          d="M7.35254 34.7085H7.40969C7.40969 34.7085 7.42873 34.7276 7.40969 34.7276C7.39064 34.7276 7.35254 34.7276 7.3335 34.7085C7.33639 34.7102 7.33968 34.7111 7.34302 34.7111C7.34636 34.7111 7.34965 34.7102 7.35254 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.33419 36.8863C7.31505 36.8863 7.33419 36.8672 7.33419 36.8672V36.8863Z"
          fill="#214063"
        />
        <path
          d="M7.3335 36.8862H7.35263L7.3335 36.9054V36.8862Z"
          fill="white"
        />
        <path
          d="M7.67676 36.9058H7.75295V36.944C7.73391 36.9822 7.69581 36.9631 7.67676 36.9631H7.65771L7.67676 36.9058Z"
          fill="#214063"
        />
        <path
          d="M7.58155 37.5551H7.5625C7.6006 37.5551 7.63869 37.536 7.67679 37.5742H7.58155V37.5551Z"
          fill="#214063"
        />
        <path
          d="M7.73393 34.7085H7.81012C7.82916 34.7085 7.84821 34.7276 7.82916 34.7467L7.79107 34.7849H7.75297C7.77202 34.7467 7.71488 34.7658 7.73393 34.7276C7.73393 34.7276 7.75297 34.7085 7.73393 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.73356 37.1346H7.75261C7.75261 37.1537 7.8288 37.1346 7.8288 37.1728C7.8288 37.211 7.79071 37.211 7.77166 37.2301C7.75261 37.2492 7.75261 37.211 7.73356 37.211V37.1728C7.73356 37.1537 7.71452 37.1155 7.73356 37.1346Z"
          fill="#214063"
        />
        <path
          d="M7.7152 35.3007H7.67694C7.65781 35.3198 7.69607 35.3007 7.69607 35.3198C7.69607 35.2815 7.67694 35.3007 7.65781 35.3007H7.63867C7.67694 35.2624 7.7152 35.2624 7.7152 35.3007Z"
          fill="#214063"
        />
        <path
          d="M8.64844 35.8165H8.66757C8.6867 35.8165 8.66757 35.7974 8.66757 35.7974H8.70584V35.8357H8.64844V35.8165Z"
          fill="#214063"
        />
        <path
          d="M9.01004 37.0776C9.01411 37.0812 9.01737 37.0856 9.0196 37.0906C9.02184 37.0955 9.02299 37.1009 9.02299 37.1064C9.02299 37.1118 9.02184 37.1172 9.0196 37.1221C9.01737 37.1271 9.01411 37.1315 9.01004 37.1351H8.97177C8.97177 37.1351 8.9909 37.1159 8.95264 37.1159H9.01004V37.0776Z"
          fill="#214063"
        />
        <path
          d="M8.87695 36.2179C8.89207 36.216 8.90743 36.2185 8.92107 36.2254C8.9347 36.2322 8.94599 36.2429 8.95349 36.2562H8.87695V36.2179Z"
          fill="#214063"
        />
        <path
          d="M8.91522 36.2372V36.2754H8.87695C8.89609 36.2563 8.87695 36.218 8.91522 36.2372Z"
          fill="white"
        />
        <path
          d="M8.80029 37.1538C8.81943 37.1538 8.80029 37.1538 8.80029 37.173V37.1538Z"
          fill="#214063"
        />
        <path
          d="M10.8008 38.0134C10.8198 37.9943 10.7817 38.0134 10.7627 37.9943C10.7817 37.9752 10.8198 38.0134 10.8389 37.9752H10.9913C10.9722 37.9561 11.0294 37.9943 11.0294 37.9561L11.0675 37.9943C11.0965 38.0189 11.1167 38.0525 11.1246 38.0898L11.0865 38.128C11.0865 38.1471 11.0675 38.1471 11.0865 38.1471H11.0484C11.0484 38.1662 11.0294 38.1853 11.0103 38.1662H10.8389C10.8389 38.1662 10.877 38.1471 10.8579 38.128H10.7817C10.8198 38.1089 10.8008 38.0898 10.7817 38.0707H10.7437C10.7627 38.0516 10.7817 38.0516 10.8008 38.0134Z"
          fill="#214063"
        />
        <path
          d="M9.23877 36.313H9.27704C9.29617 36.3513 9.2579 36.3321 9.23877 36.3321V36.313Z"
          fill="#214063"
        />
        <path
          d="M9.48587 36.4278C9.50492 36.4469 9.52396 36.466 9.50492 36.4851C9.48587 36.5042 9.50492 36.5042 9.50492 36.5042C9.5104 36.5062 9.51537 36.5093 9.51945 36.5135C9.52353 36.5176 9.52661 36.5227 9.52845 36.5282C9.53029 36.5337 9.53084 36.5396 9.53006 36.5454C9.52928 36.5512 9.5272 36.5567 9.52396 36.5615C9.44777 36.5806 9.40968 36.5042 9.37158 36.4851C9.38432 36.4667 9.40147 36.4519 9.42143 36.4419C9.4414 36.4318 9.46356 36.427 9.48587 36.4278Z"
          fill="#214063"
        />
        <path
          d="M12.4199 37.3065H12.4009C12.4199 37.3065 12.439 37.3065 12.439 37.2874H12.5342C12.5723 37.2683 12.5914 37.3065 12.6104 37.3256H12.6295V37.402H12.5723L12.6104 37.4785C12.6104 37.5167 12.5723 37.5167 12.5533 37.5358H12.4961C12.5152 37.4976 12.458 37.4976 12.439 37.4976H12.4199C12.439 37.4785 12.458 37.4976 12.458 37.4785C12.458 37.4785 12.439 37.4785 12.458 37.4594H12.3818C12.4009 37.3256 12.439 37.3256 12.4199 37.3065Z"
          fill="#214063"
        />
        <path
          d="M9.98145 37.5546C10.0005 37.5355 10.0386 37.4973 10.0767 37.5164L10.1529 37.5546C10.1529 37.5928 10.1148 37.6119 10.0957 37.6502H10.0195L9.9624 37.6119C9.98145 37.5928 9.98145 37.5737 9.98145 37.5546Z"
          fill="#214063"
        />
        <path
          d="M9.71493 36.7527C9.71493 36.7335 9.71493 36.7144 9.6958 36.7335L9.71493 36.7527Z"
          fill="#214063"
        />
        <path
          d="M9.86719 36.8096C9.84814 36.8096 9.88624 36.7905 9.86719 36.7905C9.84814 36.7905 9.92434 36.8478 9.98148 36.8096C10.0386 36.7714 10.0386 36.8478 10.0386 36.886L9.98148 36.9242H9.92433C9.94338 36.9242 9.92433 36.9051 9.92433 36.9051H9.90529C9.92433 36.886 9.88624 36.9051 9.88624 36.886C9.88624 36.8478 9.84814 36.8669 9.84814 36.8287C9.84814 36.8096 9.84814 36.8096 9.86719 36.8096Z"
          fill="#214063"
        />
        <path
          d="M10.9147 37.1346C10.9147 37.1346 10.9528 37.1346 10.9337 37.1155H10.9528C10.9909 37.1346 10.9909 37.0773 11.029 37.1155C11.0671 37.1537 11.0671 37.1537 11.0861 37.1346C11.0945 37.1491 11.0989 37.1656 11.0989 37.1824C11.0989 37.1991 11.0945 37.2156 11.0861 37.2301H11.029C11.0099 37.1919 10.9909 37.2492 10.9909 37.211H10.9147C10.8956 37.1537 10.9337 37.1537 10.9147 37.1346Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.0704C11.4482 38.0653 11.4503 38.0605 11.4538 38.0569C11.4574 38.0533 11.4623 38.0513 11.4674 38.0513L11.5248 38.0896V38.1278H11.4674L11.4482 38.0704Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.1085V38.0894L11.4674 38.1085H11.4482Z"
          fill="white"
        />
        <path
          d="M11.3343 39.0258C11.3535 39.045 11.3726 39.0641 11.3535 39.0833H11.2961C11.2769 39.0641 11.2961 39.0067 11.3343 39.0258Z"
          fill="#214063"
        />
        <path
          d="M12.0768 37.8034V37.7651C12.0959 37.7651 12.1342 37.7651 12.1342 37.7843C12.1342 37.8034 12.1342 37.8226 12.115 37.8226H12.0959C12.0768 37.8034 12.0576 37.7843 12.0768 37.7843V37.8034Z"
          fill="#214063"
        />
        <path
          d="M11.6198 38.3384H11.6581C11.6581 38.3384 11.6772 38.3575 11.6581 38.3575H11.6198C11.6198 38.3575 11.6007 38.3575 11.6198 38.3384Z"
          fill="#214063"
        />
        <path
          d="M11.6388 38.3571H11.6196C11.6196 38.338 11.6388 38.3571 11.6388 38.3571Z"
          fill="white"
        />
        <path
          d="M12.0005 38.7202H12.0386C12.0767 38.7393 12.1529 38.7202 12.1719 38.7966V38.8539C12.1529 38.8921 12.1148 38.873 12.0957 38.8921H12.0767C12.0767 38.8871 12.0747 38.8822 12.0711 38.8786C12.0675 38.875 12.0627 38.873 12.0576 38.873H12.0005C12.0014 38.8627 12.0001 38.8523 11.9969 38.8424C11.9936 38.8326 11.9883 38.8235 11.9815 38.8157H11.9624C11.9624 38.7202 12.0005 38.7393 12.0005 38.7202Z"
          fill="#214063"
        />
        <path
          d="M12.229 38.1278H12.2862C12.3052 38.1278 12.2862 38.1087 12.2862 38.1087H12.3243C12.3623 38.0705 12.3814 38.1278 12.4004 38.1087H12.4385C12.4509 38.1252 12.4576 38.1453 12.4576 38.166H12.4766V38.2042C12.4576 38.2042 12.5147 38.2233 12.4766 38.2233C12.4385 38.2233 12.4766 38.2424 12.4766 38.2615H12.4576C12.4766 38.2997 12.4195 38.2997 12.4195 38.3188H12.3623C12.3433 38.3379 12.3243 38.2806 12.2862 38.3188C12.2481 38.357 12.2862 38.2615 12.2481 38.2806H12.229C12.229 38.2615 12.2671 38.2615 12.2481 38.2424C12.229 38.2233 12.229 38.2615 12.21 38.2615C12.1909 38.2615 12.2671 38.2233 12.229 38.2042H12.1909C12.21 38.2042 12.229 38.2042 12.21 38.1851H12.1909C12.21 38.166 12.21 38.1278 12.229 38.1278Z"
          fill="#214063"
        />
        <path
          d="M12.877 38.7967L12.9151 38.7394C12.9341 38.7585 12.9341 38.7012 12.9722 38.7203H13.0103C13.0293 38.7394 13.0674 38.7203 13.1055 38.7585C13.1436 38.7967 13.1055 38.7967 13.1246 38.7967C13.1246 38.8158 13.1436 38.8349 13.1246 38.854L13.0865 38.9113C13.0865 38.9113 13.0484 38.9113 13.0484 38.9304C13.0484 38.9495 13.0293 38.9495 13.0103 38.9495H12.9532C12.9532 38.9304 12.9341 38.9495 12.9151 38.9495H12.8579V38.9113H12.8198C12.877 38.8349 12.8579 38.8158 12.877 38.7967Z"
          fill="#214063"
        />
        <path
          d="M12.8962 37.6314C12.877 37.6506 12.8579 37.6314 12.8579 37.6123L12.8962 37.6314Z"
          fill="#214063"
        />
        <path
          d="M13.124 38.5288C13.1432 38.5288 13.1623 38.5288 13.1623 38.548H13.124C13.124 38.5288 13.1432 38.5288 13.124 38.5288Z"
          fill="#214063"
        />
        <path
          d="M13.3335 37.9371V37.8989H13.4097C13.4287 37.9371 13.4478 37.9371 13.4287 37.9753C13.4097 38.0135 13.4097 37.9944 13.4287 38.0135C13.4478 38.0326 13.3906 37.9944 13.4097 38.0326H13.3335V37.9371Z"
          fill="#214063"
        />
        <path
          d="M13.3906 38.0704C13.3906 38.0513 13.4287 38.0704 13.4287 38.0513H13.5049C13.543 38.0513 13.543 38.0895 13.5621 38.0895C13.5811 38.0895 13.543 38.1277 13.5811 38.1468C13.6192 38.1659 13.5811 38.2041 13.524 38.2232H13.4859C13.4668 38.2614 13.4478 38.2232 13.4287 38.2423H13.3906C13.3716 38.2232 13.3906 38.2041 13.3716 38.2041C13.3716 38.199 13.3736 38.1942 13.3772 38.1906C13.3807 38.187 13.3856 38.185 13.3906 38.185C13.3525 38.1086 13.4097 38.0895 13.3906 38.0704Z"
          fill="#214063"
        />
        <path
          d="M13.7339 38.3953C13.7529 38.3762 13.7339 38.3762 13.7339 38.3762C13.7339 38.3762 13.7529 38.3953 13.7529 38.3762H13.8101C13.8291 38.3762 13.8101 38.338 13.8291 38.3571L13.8672 38.2998H13.9244L13.9625 38.338C13.9434 38.3571 13.9625 38.3571 13.9625 38.3762C13.9625 38.3953 13.9625 38.338 13.9815 38.338C14.0006 38.338 13.9625 38.3762 14.0006 38.3953H14.0767C14.0577 38.3953 14.0577 38.4144 14.0767 38.4335C14.1148 38.4335 14.0767 38.4717 14.0958 38.4717C14.1148 38.4717 14.0958 38.5099 14.1148 38.5099H14.0767V38.5481C14.0767 38.5481 14.0386 38.5672 14.0577 38.5863C14.0386 38.5863 14.0577 38.6054 14.0577 38.6054C14.0577 38.6054 14.0386 38.5672 14.0196 38.6054C13.9815 38.6054 14.0006 38.6818 13.9434 38.6818V38.6436C13.9244 38.6436 13.9244 38.6818 13.8863 38.6627C13.8482 38.6436 13.8672 38.6245 13.8482 38.6245H13.8291C13.8101 38.6245 13.8482 38.6054 13.8291 38.5863H13.8101V38.5481H13.791C13.791 38.529 13.8101 38.529 13.791 38.5099H13.772C13.772 38.5049 13.774 38.5 13.7776 38.4964C13.7811 38.4928 13.786 38.4908 13.791 38.4908H13.772C13.7529 38.4908 13.791 38.4717 13.772 38.4526L13.7339 38.3953Z"
          fill="#214063"
        />
        <path
          d="M11.6768 37.001C11.6958 37.0201 11.7339 37.001 11.7339 37.0392C11.7339 37.0774 11.6958 37.0965 11.6768 37.0774H11.6387V37.0392C11.6437 37.0442 11.6506 37.0471 11.6577 37.0471C11.6649 37.0471 11.6717 37.0442 11.6768 37.0392C11.6818 37.0341 11.6847 37.0272 11.6847 37.0201C11.6847 37.0129 11.6818 37.006 11.6768 37.001Z"
          fill="#214063"
        />
        <path
          d="M11.8483 37.0773H11.8101V37.0581L11.8483 37.0773Z"
          fill="#214063"
        />
        <path
          d="M11.9053 37.0391H12.0386C12.0577 37.0582 12.0577 37.0964 12.0958 37.0964C12.1339 37.0964 12.0767 37.0964 12.0958 37.1155V37.1728L12.0577 37.2301C12.0526 37.2301 12.0478 37.2321 12.0442 37.2357C12.0406 37.2393 12.0386 37.2441 12.0386 37.2492C12.0196 37.2492 12.0196 37.2683 12.0196 37.2874V37.2492H11.9624C11.9434 37.211 11.9053 37.2492 11.8862 37.2492C11.8672 37.2492 11.9243 37.211 11.9053 37.1919C11.8862 37.1728 11.9243 37.1728 11.9053 37.1537H11.8672C11.8835 37.14 11.8958 37.1221 11.9025 37.1018C11.9092 37.0816 11.9102 37.0598 11.9053 37.0391Z"
          fill="#214063"
        />
        <path
          d="M7.60068 38.5675L7.58154 38.5483L7.60068 38.5675Z"
          fill="white"
        />
        <path
          d="M7.63876 38.5865H7.61963V38.5674L7.63876 38.5865Z"
          fill="white"
        />
        <path
          d="M9.08661 34.7852H9.12487C9.12895 34.7887 9.13221 34.7932 9.13444 34.7981C9.13667 34.8031 9.13783 34.8084 9.13783 34.8139C9.13783 34.8193 9.13667 34.8247 9.13444 34.8296C9.13221 34.8346 9.12895 34.839 9.12487 34.8426H9.06747C9.065 34.8322 9.06548 34.8213 9.06886 34.8111C9.07224 34.801 9.07839 34.792 9.08661 34.7852Z"
          fill="#214063"
        />
        <path
          d="M9.18151 34.6707V34.709H9.14325C9.12412 34.6899 9.14325 34.6516 9.18151 34.6707Z"
          fill="#214063"
        />
        <path
          d="M7.12451 35.855H7.14364V35.8741L7.12451 35.855Z"
          fill="#214063"
        />
        <path
          d="M7.29617 35.9505C7.28095 35.9505 7.26635 35.9444 7.25558 35.9337C7.24482 35.9229 7.23877 35.9083 7.23877 35.8931L7.29617 35.9505Z"
          fill="#214063"
        />
        <path
          d="M4.09588 35.6064C4.09588 35.6256 4.09588 35.6447 4.05762 35.6256H4.09588V35.6064Z"
          fill="#214063"
        />
        <path
          d="M3.60107 34.0972C3.63917 34.0972 3.69631 34.0972 3.71536 34.1354C3.73441 34.1736 3.69631 34.1354 3.67726 34.1354L3.60107 34.0972Z"
          fill="#214063"
        />
        <path
          d="M10.3814 36.2369C10.3814 36.1987 10.4195 36.2369 10.4385 36.2178L10.5147 36.256C10.5147 36.2942 10.4956 36.2942 10.4956 36.3324C10.4956 36.3706 10.4956 36.3897 10.4385 36.3706C10.3814 36.3515 10.4004 36.3515 10.3814 36.3515H10.3623C10.3814 36.3515 10.3623 36.3324 10.3433 36.3133L10.3814 36.2369Z"
          fill="#214063"
        />
        <path
          d="M3.86737 34.2507H3.8291V34.2124L3.86737 34.2507Z"
          fill="#214063"
        />
        <path
          d="M4.00125 34.1931H4.02038L3.94385 34.1548L4.00125 34.1931Z"
          fill="#214063"
        />
        <path
          d="M5.4288 35.1291H5.40967C5.40967 35.1291 5.40967 35.11 5.4288 35.1291Z"
          fill="#214063"
        />
        <path
          d="M5.79114 34.6895H5.81027C5.81027 34.6945 5.80825 34.6994 5.80467 34.703C5.80108 34.7066 5.79621 34.7086 5.79114 34.7086C5.78946 34.7057 5.78857 34.7024 5.78857 34.699C5.78857 34.6957 5.78946 34.6924 5.79114 34.6895Z"
          fill="#214063"
        />
        <path
          d="M5.90529 34.4224C5.90529 34.4224 5.94338 34.4415 5.92433 34.4606C5.90529 34.4797 5.90529 34.4988 5.88624 34.4797C5.86719 34.4606 5.86719 34.4606 5.84814 34.4606L5.90529 34.4224Z"
          fill="#214063"
        />
        <path
          d="M5.84785 34.6323C5.82871 34.6323 5.82871 34.6515 5.84785 34.6323V34.6323Z"
          fill="#214063"
        />
        <path
          d="M5.8103 35.186H5.82944C5.82944 35.2052 5.82944 35.2243 5.8103 35.2243C5.80694 35.2185 5.80518 35.2119 5.80518 35.2052C5.80518 35.1985 5.80694 35.1919 5.8103 35.186Z"
          fill="#214063"
        />
        <path
          d="M4.47665 34.8995H4.45752V34.8804L4.47665 34.8995Z"
          fill="#214063"
        />
        <path
          d="M4.59134 34.9759C4.61038 34.9759 4.62943 34.995 4.61038 35.0141C4.59134 35.0332 4.55324 35.0141 4.51515 34.995H4.47705C4.49267 34.9819 4.51151 34.9732 4.5316 34.9698C4.55169 34.9665 4.57232 34.9686 4.59134 34.9759Z"
          fill="#214063"
        />
        <path
          d="M6.00069 35.1862H5.98156C5.96242 35.1862 5.98156 35.1671 6.00069 35.1862Z"
          fill="#214063"
        />
        <path
          d="M6.05781 34.9949C6.07695 34.9949 6.07695 35.0141 6.05781 35.0332H6.03868C6.03361 35.0307 6.02975 35.0262 6.02795 35.0208C6.02616 35.0155 6.02658 35.0096 6.02911 35.0045C6.03165 34.9994 6.0361 34.9956 6.04148 34.9938C6.04686 34.992 6.05274 34.9924 6.05781 34.9949Z"
          fill="#214063"
        />
        <path
          d="M6.03915 35.1675C6.03915 35.1866 6.07742 35.1675 6.05829 35.2058C6.03915 35.2441 6.02002 35.2058 6.02002 35.1866L6.03915 35.1675Z"
          fill="#214063"
        />
        <path
          d="M4.87646 34.9952H4.91456V34.957C4.9717 34.9952 5.04789 34.9952 5.06694 35.0525L5.02885 35.0907H4.99075C4.9717 35.0716 4.93361 35.0907 4.91456 35.0525C4.91456 35.0334 4.87646 35.0143 4.87646 34.9952Z"
          fill="#214063"
        />
        <path
          d="M4.95266 35.2818C4.93362 35.3391 4.89552 35.3009 4.87647 35.2818H4.83838C4.85486 35.2694 4.87492 35.2627 4.89552 35.2627C4.91613 35.2627 4.93618 35.2694 4.95266 35.2818Z"
          fill="#214063"
        />
        <path
          d="M4.91513 35.2818L4.896 35.301V35.2627V35.2818H4.91513Z"
          fill="white"
        />
        <path
          d="M8.28667 36.4469C8.22952 36.466 8.17238 36.4278 8.11524 36.3896H8.09619C8.13012 36.3806 8.16587 36.3812 8.19948 36.3914C8.23309 36.4015 8.26326 36.4207 8.28667 36.4469Z"
          fill="#214063"
        />
        <path
          d="M5.16279 35.4156V35.4538H5.14374L5.06755 35.4156C5.0485 35.4156 5.06755 35.4156 5.06755 35.3965H5.14374L5.16279 35.4156Z"
          fill="#214063"
        />
        <path
          d="M5.21924 35.5108C5.23829 35.4917 5.27638 35.5108 5.31448 35.5299C5.31953 35.5299 5.32437 35.532 5.32795 35.5355C5.33152 35.5391 5.33352 35.544 5.33352 35.549C5.33352 35.5541 5.33152 35.559 5.32795 35.5626C5.32437 35.5661 5.31953 35.5681 5.31448 35.5681H5.21924V35.5108Z"
          fill="#214063"
        />
        <path
          d="M5.31448 36.4472H5.23829C5.23829 36.4281 5.21924 36.4472 5.21924 36.4281C5.21924 36.409 5.27638 36.409 5.31448 36.4472Z"
          fill="#214063"
        />
        <path
          d="M6.43853 33.6771C6.43853 33.7153 6.40043 33.6962 6.38138 33.6962C6.36234 33.6962 6.30519 33.6197 6.2671 33.6197L6.229 33.5815C6.28615 33.6197 6.40043 33.5815 6.43853 33.6771Z"
          fill="#214063"
        />
        <path
          d="M6.19092 36.103H6.21005C6.21005 36.1222 6.21005 36.1413 6.19092 36.1413V36.103Z"
          fill="#214063"
        />
        <path
          d="M6.59082 36.2178H6.64797L6.68606 36.256C6.68606 36.2751 6.66702 36.2751 6.64797 36.2942C6.62892 36.3133 6.62892 36.256 6.59082 36.2751H6.60987L6.57178 36.2369L6.59082 36.2178Z"
          fill="#214063"
        />
        <path
          d="M6.57254 34.2886H6.5534V34.3269L6.51514 34.2886H6.57254Z"
          fill="#214063"
        />
        <path
          d="M6.57236 34.2886H6.59149V34.3269H6.55322L6.57236 34.2886Z"
          fill="#214063"
        />
        <path
          d="M6.64795 35.5298C6.68604 35.5489 6.74319 35.5107 6.78128 35.568C6.78128 35.5781 6.77727 35.5878 6.77012 35.595C6.76298 35.6022 6.75329 35.6062 6.74319 35.6062L6.64795 35.5298Z"
          fill="#214063"
        />
        <path
          d="M6.85742 36.4277L6.91482 36.466H6.85742V36.4277Z"
          fill="#214063"
        />
        <path
          d="M6.93426 34.9761C6.94441 34.9761 6.95414 34.9801 6.96132 34.9873C6.9685 34.9945 6.97253 35.0042 6.97253 35.0144H6.9534C6.93426 35.0144 6.896 34.9952 6.896 34.9761H6.93426Z"
          fill="#214063"
        />
        <path
          d="M6.896 36.5616C6.91513 36.5425 6.896 36.5425 6.896 36.5425V36.5616Z"
          fill="#214063"
        />
        <path
          d="M7.1819 34.0591H7.22017C7.22017 34.0782 7.22017 34.1165 7.20103 34.0974C7.1819 34.0782 7.14363 34.0591 7.1819 34.0591Z"
          fill="#214063"
        />
        <path
          d="M7.14355 34.4795H7.1626C7.2007 34.4795 7.25784 34.4795 7.27689 34.5368V34.575H7.2007L7.14355 34.4986V34.4795Z"
          fill="#214063"
        />
        <path
          d="M7.0293 35.2625C7.04834 35.2816 7.04834 35.2816 7.06739 35.2625C7.08644 35.2434 7.06739 35.2434 7.04834 35.2243C7.0293 35.2052 7.12453 35.2243 7.12453 35.2625C7.12453 35.3007 7.10549 35.2816 7.08644 35.2816H7.0293V35.2625Z"
          fill="#214063"
        />
        <path
          d="M6.99074 37.1348C7.00979 37.1539 6.99074 37.173 6.97169 37.173C6.95265 37.173 6.9336 37.1348 6.91455 37.1539L6.99074 37.1348Z"
          fill="#214063"
        />
        <path
          d="M7.06689 35.2627C7.08603 35.2818 7.08603 35.2818 7.06689 35.2818C7.06689 35.2818 7.08603 35.2818 7.06689 35.2627Z"
          fill="white"
        />
        <path
          d="M9.37208 37.2873H9.35304C9.35304 37.2873 9.41018 37.3255 9.41018 37.2873C9.41018 37.2491 9.52446 37.3255 9.54351 37.3637H9.63875C9.63875 37.3828 9.6578 37.4019 9.63875 37.4019C9.6197 37.4019 9.52447 37.3255 9.46732 37.421H9.31494C9.33399 37.421 9.33399 37.3828 9.33399 37.3828H9.37208V37.2873Z"
          fill="#214063"
        />
        <path
          d="M7.16278 36.638C7.17293 36.638 7.18266 36.6421 7.18984 36.6492C7.19701 36.6564 7.20104 36.6662 7.20104 36.6763H7.12451C7.12451 36.6572 7.12451 36.6189 7.16278 36.638Z"
          fill="#214063"
        />
        <path
          d="M7.35254 34.7085H7.40969C7.40969 34.7085 7.42873 34.7276 7.40969 34.7276C7.39064 34.7276 7.35254 34.7276 7.3335 34.7085C7.33639 34.7102 7.33968 34.7111 7.34302 34.7111C7.34636 34.7111 7.34965 34.7102 7.35254 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.33419 36.8863C7.31505 36.8863 7.33419 36.8672 7.33419 36.8672V36.8863Z"
          fill="#214063"
        />
        <path
          d="M7.3335 36.8862H7.35263L7.3335 36.9054V36.8862Z"
          fill="white"
        />
        <path
          d="M7.67676 36.9058H7.75295V36.944C7.73391 36.9822 7.69581 36.9631 7.67676 36.9631H7.65771L7.67676 36.9058Z"
          fill="#214063"
        />
        <path
          d="M7.58155 37.5551H7.5625C7.6006 37.5551 7.63869 37.536 7.67679 37.5742H7.58155V37.5551Z"
          fill="#214063"
        />
        <path
          d="M7.73393 34.7085H7.81012C7.82916 34.7085 7.84821 34.7276 7.82916 34.7467L7.79107 34.7849H7.75297C7.77202 34.7467 7.71488 34.7658 7.73393 34.7276C7.73393 34.7276 7.75297 34.7085 7.73393 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.73356 37.1346H7.75261C7.75261 37.1537 7.8288 37.1346 7.8288 37.1728C7.8288 37.211 7.79071 37.211 7.77166 37.2301C7.75261 37.2492 7.75261 37.211 7.73356 37.211V37.1728C7.73356 37.1537 7.71452 37.1155 7.73356 37.1346Z"
          fill="#214063"
        />
        <path
          d="M7.7152 35.3007H7.67694C7.65781 35.3198 7.69607 35.3007 7.69607 35.3198C7.69607 35.2815 7.67694 35.3007 7.65781 35.3007H7.63867C7.67694 35.2624 7.7152 35.2624 7.7152 35.3007Z"
          fill="#214063"
        />
        <path
          d="M8.64844 35.8165H8.66757C8.6867 35.8165 8.66757 35.7974 8.66757 35.7974H8.70584V35.8357H8.64844V35.8165Z"
          fill="#214063"
        />
        <path
          d="M9.01004 37.0776C9.01411 37.0812 9.01737 37.0856 9.0196 37.0906C9.02184 37.0955 9.02299 37.1009 9.02299 37.1064C9.02299 37.1118 9.02184 37.1172 9.0196 37.1221C9.01737 37.1271 9.01411 37.1315 9.01004 37.1351H8.97177C8.97177 37.1351 8.9909 37.1159 8.95264 37.1159H9.01004V37.0776Z"
          fill="#214063"
        />
        <path
          d="M8.87695 36.2179C8.89207 36.216 8.90743 36.2185 8.92107 36.2254C8.9347 36.2322 8.94599 36.2429 8.95349 36.2562H8.87695V36.2179Z"
          fill="#214063"
        />
        <path
          d="M8.91522 36.2372V36.2754H8.87695C8.89609 36.2563 8.87695 36.218 8.91522 36.2372Z"
          fill="white"
        />
        <path
          d="M8.80029 37.1538C8.81943 37.1538 8.80029 37.1538 8.80029 37.173V37.1538Z"
          fill="#214063"
        />
        <path
          d="M10.8008 38.0134C10.8198 37.9943 10.7817 38.0134 10.7627 37.9943C10.7817 37.9752 10.8198 38.0134 10.8389 37.9752H10.9913C10.9722 37.9561 11.0294 37.9943 11.0294 37.9561L11.0675 37.9943C11.0965 38.0189 11.1167 38.0525 11.1246 38.0898L11.0865 38.128C11.0865 38.1471 11.0675 38.1471 11.0865 38.1471H11.0484C11.0484 38.1662 11.0294 38.1853 11.0103 38.1662H10.8389C10.8389 38.1662 10.877 38.1471 10.8579 38.128H10.7817C10.8198 38.1089 10.8008 38.0898 10.7817 38.0707H10.7437C10.7627 38.0516 10.7817 38.0516 10.8008 38.0134Z"
          fill="#214063"
        />
        <path
          d="M9.23877 36.313H9.27704C9.29617 36.3513 9.2579 36.3321 9.23877 36.3321V36.313Z"
          fill="#214063"
        />
        <path
          d="M9.48587 36.4278C9.50492 36.4469 9.52396 36.466 9.50492 36.4851C9.48587 36.5042 9.50492 36.5042 9.50492 36.5042C9.5104 36.5062 9.51537 36.5093 9.51945 36.5135C9.52353 36.5176 9.52661 36.5227 9.52845 36.5282C9.53029 36.5337 9.53084 36.5396 9.53006 36.5454C9.52928 36.5512 9.5272 36.5567 9.52396 36.5615C9.44777 36.5806 9.40968 36.5042 9.37158 36.4851C9.38432 36.4667 9.40147 36.4519 9.42143 36.4419C9.4414 36.4318 9.46356 36.427 9.48587 36.4278Z"
          fill="#214063"
        />
        <path
          d="M12.4199 37.3065H12.4009C12.4199 37.3065 12.439 37.3065 12.439 37.2874H12.5342C12.5723 37.2683 12.5914 37.3065 12.6104 37.3256H12.6295V37.402H12.5723L12.6104 37.4785C12.6104 37.5167 12.5723 37.5167 12.5533 37.5358H12.4961C12.5152 37.4976 12.458 37.4976 12.439 37.4976H12.4199C12.439 37.4785 12.458 37.4976 12.458 37.4785C12.458 37.4785 12.439 37.4785 12.458 37.4594H12.3818C12.4009 37.3256 12.439 37.3256 12.4199 37.3065Z"
          fill="#214063"
        />
        <path
          d="M9.98145 37.5546C10.0005 37.5355 10.0386 37.4973 10.0767 37.5164L10.1529 37.5546C10.1529 37.5928 10.1148 37.6119 10.0957 37.6502H10.0195L9.9624 37.6119C9.98145 37.5928 9.98145 37.5737 9.98145 37.5546Z"
          fill="#214063"
        />
        <path
          d="M9.71493 36.7527C9.71493 36.7335 9.71493 36.7144 9.6958 36.7335L9.71493 36.7527Z"
          fill="#214063"
        />
        <path
          d="M9.86719 36.8096C9.84814 36.8096 9.88624 36.7905 9.86719 36.7905C9.84814 36.7905 9.92434 36.8478 9.98148 36.8096C10.0386 36.7714 10.0386 36.8478 10.0386 36.886L9.98148 36.9242H9.92433C9.94338 36.9242 9.92433 36.9051 9.92433 36.9051H9.90529C9.92433 36.886 9.88624 36.9051 9.88624 36.886C9.88624 36.8478 9.84814 36.8669 9.84814 36.8287C9.84814 36.8096 9.84814 36.8096 9.86719 36.8096Z"
          fill="#214063"
        />
        <path
          d="M10.9147 37.1346C10.9147 37.1346 10.9528 37.1346 10.9337 37.1155H10.9528C10.9909 37.1346 10.9909 37.0773 11.029 37.1155C11.0671 37.1537 11.0671 37.1537 11.0861 37.1346C11.0945 37.1491 11.0989 37.1656 11.0989 37.1824C11.0989 37.1991 11.0945 37.2156 11.0861 37.2301H11.029C11.0099 37.1919 10.9909 37.2492 10.9909 37.211H10.9147C10.8956 37.1537 10.9337 37.1537 10.9147 37.1346Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.0704C11.4482 38.0653 11.4503 38.0605 11.4538 38.0569C11.4574 38.0533 11.4623 38.0513 11.4674 38.0513L11.5248 38.0896V38.1278H11.4674L11.4482 38.0704Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.1085V38.0894L11.4674 38.1085H11.4482Z"
          fill="white"
        />
        <path
          d="M11.3343 39.0258C11.3535 39.045 11.3726 39.0641 11.3535 39.0833H11.2961C11.2769 39.0641 11.2961 39.0067 11.3343 39.0258Z"
          fill="#214063"
        />
        <path
          d="M12.0768 37.8034V37.7651C12.0959 37.7651 12.1342 37.7651 12.1342 37.7843C12.1342 37.8034 12.1342 37.8226 12.115 37.8226H12.0959C12.0768 37.8034 12.0576 37.7843 12.0768 37.7843V37.8034Z"
          fill="#214063"
        />
        <path
          d="M11.6198 38.3384H11.6581C11.6581 38.3384 11.6772 38.3575 11.6581 38.3575H11.6198C11.6198 38.3575 11.6007 38.3575 11.6198 38.3384Z"
          fill="#214063"
        />
        <path
          d="M11.6388 38.3571H11.6196C11.6196 38.338 11.6388 38.3571 11.6388 38.3571Z"
          fill="white"
        />
        <path
          d="M12.0005 38.7202H12.0386C12.0767 38.7393 12.1529 38.7202 12.1719 38.7966V38.8539C12.1529 38.8921 12.1148 38.873 12.0957 38.8921H12.0767C12.0767 38.8871 12.0747 38.8822 12.0711 38.8786C12.0675 38.875 12.0627 38.873 12.0576 38.873H12.0005C12.0014 38.8627 12.0001 38.8523 11.9969 38.8424C11.9936 38.8326 11.9883 38.8235 11.9815 38.8157H11.9624C11.9624 38.7202 12.0005 38.7393 12.0005 38.7202Z"
          fill="#214063"
        />
        <path
          d="M12.229 38.1278H12.2862C12.3052 38.1278 12.2862 38.1087 12.2862 38.1087H12.3243C12.3623 38.0705 12.3814 38.1278 12.4004 38.1087H12.4385C12.4509 38.1252 12.4576 38.1453 12.4576 38.166H12.4766V38.2042C12.4576 38.2042 12.5147 38.2233 12.4766 38.2233C12.4385 38.2233 12.4766 38.2424 12.4766 38.2615H12.4576C12.4766 38.2997 12.4195 38.2997 12.4195 38.3188H12.3623C12.3433 38.3379 12.3243 38.2806 12.2862 38.3188C12.2481 38.357 12.2862 38.2615 12.2481 38.2806H12.229C12.229 38.2615 12.2671 38.2615 12.2481 38.2424C12.229 38.2233 12.229 38.2615 12.21 38.2615C12.1909 38.2615 12.2671 38.2233 12.229 38.2042H12.1909C12.21 38.2042 12.229 38.2042 12.21 38.1851H12.1909C12.21 38.166 12.21 38.1278 12.229 38.1278Z"
          fill="#214063"
        />
        <path
          d="M12.877 38.7967L12.9151 38.7394C12.9341 38.7585 12.9341 38.7012 12.9722 38.7203H13.0103C13.0293 38.7394 13.0674 38.7203 13.1055 38.7585C13.1436 38.7967 13.1055 38.7967 13.1246 38.7967C13.1246 38.8158 13.1436 38.8349 13.1246 38.854L13.0865 38.9113C13.0865 38.9113 13.0484 38.9113 13.0484 38.9304C13.0484 38.9495 13.0293 38.9495 13.0103 38.9495H12.9532C12.9532 38.9304 12.9341 38.9495 12.9151 38.9495H12.8579V38.9113H12.8198C12.877 38.8349 12.8579 38.8158 12.877 38.7967Z"
          fill="#214063"
        />
        <path
          d="M12.8962 37.6314C12.877 37.6506 12.8579 37.6314 12.8579 37.6123L12.8962 37.6314Z"
          fill="#214063"
        />
        <path
          d="M13.124 38.5288C13.1432 38.5288 13.1623 38.5288 13.1623 38.548H13.124C13.124 38.5288 13.1432 38.5288 13.124 38.5288Z"
          fill="#214063"
        />
        <path
          d="M13.3335 37.9371V37.8989H13.4097C13.4287 37.9371 13.4478 37.9371 13.4287 37.9753C13.4097 38.0135 13.4097 37.9944 13.4287 38.0135C13.4478 38.0326 13.3906 37.9944 13.4097 38.0326H13.3335V37.9371Z"
          fill="#214063"
        />
        <path
          d="M13.3906 38.0704C13.3906 38.0513 13.4287 38.0704 13.4287 38.0513H13.5049C13.543 38.0513 13.543 38.0895 13.5621 38.0895C13.5811 38.0895 13.543 38.1277 13.5811 38.1468C13.6192 38.1659 13.5811 38.2041 13.524 38.2232H13.4859C13.4668 38.2614 13.4478 38.2232 13.4287 38.2423H13.3906C13.3716 38.2232 13.3906 38.2041 13.3716 38.2041C13.3716 38.199 13.3736 38.1942 13.3772 38.1906C13.3807 38.187 13.3856 38.185 13.3906 38.185C13.3525 38.1086 13.4097 38.0895 13.3906 38.0704Z"
          fill="#214063"
        />
        <path
          d="M13.7339 38.3953C13.7529 38.3762 13.7339 38.3762 13.7339 38.3762C13.7339 38.3762 13.7529 38.3953 13.7529 38.3762H13.8101C13.8291 38.3762 13.8101 38.338 13.8291 38.3571L13.8672 38.2998H13.9244L13.9625 38.338C13.9434 38.3571 13.9625 38.3571 13.9625 38.3762C13.9625 38.3953 13.9625 38.338 13.9815 38.338C14.0006 38.338 13.9625 38.3762 14.0006 38.3953H14.0767C14.0577 38.3953 14.0577 38.4144 14.0767 38.4335C14.1148 38.4335 14.0767 38.4717 14.0958 38.4717C14.1148 38.4717 14.0958 38.5099 14.1148 38.5099H14.0767V38.5481C14.0767 38.5481 14.0386 38.5672 14.0577 38.5863C14.0386 38.5863 14.0577 38.6054 14.0577 38.6054C14.0577 38.6054 14.0386 38.5672 14.0196 38.6054C13.9815 38.6054 14.0006 38.6818 13.9434 38.6818V38.6436C13.9244 38.6436 13.9244 38.6818 13.8863 38.6627C13.8482 38.6436 13.8672 38.6245 13.8482 38.6245H13.8291C13.8101 38.6245 13.8482 38.6054 13.8291 38.5863H13.8101V38.5481H13.791C13.791 38.529 13.8101 38.529 13.791 38.5099H13.772C13.772 38.5049 13.774 38.5 13.7776 38.4964C13.7811 38.4928 13.786 38.4908 13.791 38.4908H13.772C13.7529 38.4908 13.791 38.4717 13.772 38.4526L13.7339 38.3953Z"
          fill="#214063"
        />
        <path
          d="M11.6768 37.001C11.6958 37.0201 11.7339 37.001 11.7339 37.0392C11.7339 37.0774 11.6958 37.0965 11.6768 37.0774H11.6387V37.0392C11.6437 37.0442 11.6506 37.0471 11.6577 37.0471C11.6649 37.0471 11.6717 37.0442 11.6768 37.0392C11.6818 37.0341 11.6847 37.0272 11.6847 37.0201C11.6847 37.0129 11.6818 37.006 11.6768 37.001Z"
          fill="#214063"
        />
        <path
          d="M11.8483 37.0773H11.8101V37.0581L11.8483 37.0773Z"
          fill="#214063"
        />
        <path
          d="M11.9053 37.0391H12.0386C12.0577 37.0582 12.0577 37.0964 12.0958 37.0964C12.1339 37.0964 12.0767 37.0964 12.0958 37.1155V37.1728L12.0577 37.2301C12.0526 37.2301 12.0478 37.2321 12.0442 37.2357C12.0406 37.2393 12.0386 37.2441 12.0386 37.2492C12.0196 37.2492 12.0196 37.2683 12.0196 37.2874V37.2492H11.9624C11.9434 37.211 11.9053 37.2492 11.8862 37.2492C11.8672 37.2492 11.9243 37.211 11.9053 37.1919C11.8862 37.1728 11.9243 37.1728 11.9053 37.1537H11.8672C11.8835 37.14 11.8958 37.1221 11.9025 37.1018C11.9092 37.0816 11.9102 37.0598 11.9053 37.0391Z"
          fill="#214063"
        />
        <path
          d="M7.60068 38.5675L7.58154 38.5483L7.60068 38.5675Z"
          fill="white"
        />
        <path
          d="M7.63876 38.5865H7.61963V38.5674L7.63876 38.5865Z"
          fill="white"
        />
        <path
          d="M9.08661 34.7852H9.12487C9.12895 34.7887 9.13221 34.7932 9.13444 34.7981C9.13667 34.8031 9.13783 34.8084 9.13783 34.8139C9.13783 34.8193 9.13667 34.8247 9.13444 34.8296C9.13221 34.8346 9.12895 34.839 9.12487 34.8426H9.06747C9.065 34.8322 9.06548 34.8213 9.06886 34.8111C9.07224 34.801 9.07839 34.792 9.08661 34.7852Z"
          fill="#214063"
        />
        <path
          d="M9.18151 34.6707V34.709H9.14325C9.12412 34.6899 9.14325 34.6516 9.18151 34.6707Z"
          fill="#214063"
        />
        <path
          d="M7.12451 35.855H7.14364V35.8741L7.12451 35.855Z"
          fill="#214063"
        />
        <path
          d="M7.29617 35.9505C7.28095 35.9505 7.26635 35.9444 7.25558 35.9337C7.24482 35.9229 7.23877 35.9083 7.23877 35.8931L7.29617 35.9505Z"
          fill="#214063"
        />
        <path
          d="M4.09588 35.6064C4.09588 35.6256 4.09588 35.6447 4.05762 35.6256H4.09588V35.6064Z"
          fill="#214063"
        />
        <path
          d="M3.60107 34.0972C3.63917 34.0972 3.69631 34.0972 3.71536 34.1354C3.73441 34.1736 3.69631 34.1354 3.67726 34.1354L3.60107 34.0972Z"
          fill="#214063"
        />
        <path
          d="M10.3814 36.2369C10.3814 36.1987 10.4195 36.2369 10.4385 36.2178L10.5147 36.256C10.5147 36.2942 10.4956 36.2942 10.4956 36.3324C10.4956 36.3706 10.4956 36.3897 10.4385 36.3706C10.3814 36.3515 10.4004 36.3515 10.3814 36.3515H10.3623C10.3814 36.3515 10.3623 36.3324 10.3433 36.3133L10.3814 36.2369Z"
          fill="#214063"
        />
        <path
          d="M3.86737 34.2507H3.8291V34.2124L3.86737 34.2507Z"
          fill="#214063"
        />
        <path
          d="M4.00125 34.1931H4.02038L3.94385 34.1548L4.00125 34.1931Z"
          fill="#214063"
        />
        <path
          d="M5.4288 35.1291H5.40967C5.40967 35.1291 5.40967 35.11 5.4288 35.1291Z"
          fill="#214063"
        />
        <path
          d="M5.79114 34.6895H5.81027C5.81027 34.6945 5.80825 34.6994 5.80467 34.703C5.80108 34.7066 5.79621 34.7086 5.79114 34.7086C5.78946 34.7057 5.78857 34.7024 5.78857 34.699C5.78857 34.6957 5.78946 34.6924 5.79114 34.6895Z"
          fill="#214063"
        />
        <path
          d="M5.90529 34.4224C5.90529 34.4224 5.94338 34.4415 5.92433 34.4606C5.90529 34.4797 5.90529 34.4988 5.88624 34.4797C5.86719 34.4606 5.86719 34.4606 5.84814 34.4606L5.90529 34.4224Z"
          fill="#214063"
        />
        <path
          d="M5.84785 34.6323C5.82871 34.6323 5.82871 34.6515 5.84785 34.6323V34.6323Z"
          fill="#214063"
        />
        <path
          d="M5.8103 35.186H5.82944C5.82944 35.2052 5.82944 35.2243 5.8103 35.2243C5.80694 35.2185 5.80518 35.2119 5.80518 35.2052C5.80518 35.1985 5.80694 35.1919 5.8103 35.186Z"
          fill="#214063"
        />
        <path
          d="M4.47665 34.8995H4.45752V34.8804L4.47665 34.8995Z"
          fill="#214063"
        />
        <path
          d="M4.59134 34.9759C4.61038 34.9759 4.62943 34.995 4.61038 35.0141C4.59134 35.0332 4.55324 35.0141 4.51515 34.995H4.47705C4.49267 34.9819 4.51151 34.9732 4.5316 34.9698C4.55169 34.9665 4.57232 34.9686 4.59134 34.9759Z"
          fill="#214063"
        />
        <path
          d="M6.00069 35.1862H5.98156C5.96242 35.1862 5.98156 35.1671 6.00069 35.1862Z"
          fill="#214063"
        />
        <path
          d="M6.05781 34.9949C6.07695 34.9949 6.07695 35.0141 6.05781 35.0332H6.03868C6.03361 35.0307 6.02975 35.0262 6.02795 35.0208C6.02616 35.0155 6.02658 35.0096 6.02911 35.0045C6.03165 34.9994 6.0361 34.9956 6.04148 34.9938C6.04686 34.992 6.05274 34.9924 6.05781 34.9949Z"
          fill="#214063"
        />
        <path
          d="M6.03915 35.1675C6.03915 35.1866 6.07742 35.1675 6.05829 35.2058C6.03915 35.2441 6.02002 35.2058 6.02002 35.1866L6.03915 35.1675Z"
          fill="#214063"
        />
        <path
          d="M4.87646 34.9952H4.91456V34.957C4.9717 34.9952 5.04789 34.9952 5.06694 35.0525L5.02885 35.0907H4.99075C4.9717 35.0716 4.93361 35.0907 4.91456 35.0525C4.91456 35.0334 4.87646 35.0143 4.87646 34.9952Z"
          fill="#214063"
        />
        <path
          d="M4.95266 35.2818C4.93362 35.3391 4.89552 35.3009 4.87647 35.2818H4.83838C4.85486 35.2694 4.87492 35.2627 4.89552 35.2627C4.91613 35.2627 4.93618 35.2694 4.95266 35.2818Z"
          fill="#214063"
        />
        <path
          d="M4.91513 35.2818L4.896 35.301V35.2627V35.2818H4.91513Z"
          fill="white"
        />
        <path
          d="M8.28667 36.4469C8.22952 36.466 8.17238 36.4278 8.11524 36.3896H8.09619C8.13012 36.3806 8.16587 36.3812 8.19948 36.3914C8.23309 36.4015 8.26326 36.4207 8.28667 36.4469Z"
          fill="#214063"
        />
        <path
          d="M5.16279 35.4156V35.4538H5.14374L5.06755 35.4156C5.0485 35.4156 5.06755 35.4156 5.06755 35.3965H5.14374L5.16279 35.4156Z"
          fill="#214063"
        />
        <path
          d="M5.21924 35.5108C5.23829 35.4917 5.27638 35.5108 5.31448 35.5299C5.31953 35.5299 5.32437 35.532 5.32795 35.5355C5.33152 35.5391 5.33352 35.544 5.33352 35.549C5.33352 35.5541 5.33152 35.559 5.32795 35.5626C5.32437 35.5661 5.31953 35.5681 5.31448 35.5681H5.21924V35.5108Z"
          fill="#214063"
        />
        <path
          d="M5.31448 36.4472H5.23829C5.23829 36.4281 5.21924 36.4472 5.21924 36.4281C5.21924 36.409 5.27638 36.409 5.31448 36.4472Z"
          fill="#214063"
        />
        <path
          d="M6.43853 33.6771C6.43853 33.7153 6.40043 33.6962 6.38138 33.6962C6.36234 33.6962 6.30519 33.6197 6.2671 33.6197L6.229 33.5815C6.28615 33.6197 6.40043 33.5815 6.43853 33.6771Z"
          fill="#214063"
        />
        <path
          d="M6.19092 36.103H6.21005C6.21005 36.1222 6.21005 36.1413 6.19092 36.1413V36.103Z"
          fill="#214063"
        />
        <path
          d="M6.59082 36.2178H6.64797L6.68606 36.256C6.68606 36.2751 6.66702 36.2751 6.64797 36.2942C6.62892 36.3133 6.62892 36.256 6.59082 36.2751H6.60987L6.57178 36.2369L6.59082 36.2178Z"
          fill="#214063"
        />
        <path
          d="M6.57254 34.2886H6.5534V34.3269L6.51514 34.2886H6.57254Z"
          fill="#214063"
        />
        <path
          d="M6.57236 34.2886H6.59149V34.3269H6.55322L6.57236 34.2886Z"
          fill="#214063"
        />
        <path
          d="M6.64795 35.5298C6.68604 35.5489 6.74319 35.5107 6.78128 35.568C6.78128 35.5781 6.77727 35.5878 6.77012 35.595C6.76298 35.6022 6.75329 35.6062 6.74319 35.6062L6.64795 35.5298Z"
          fill="#214063"
        />
        <path
          d="M6.85742 36.4277L6.91482 36.466H6.85742V36.4277Z"
          fill="#214063"
        />
        <path
          d="M6.93426 34.9761C6.94441 34.9761 6.95414 34.9801 6.96132 34.9873C6.9685 34.9945 6.97253 35.0042 6.97253 35.0144H6.9534C6.93426 35.0144 6.896 34.9952 6.896 34.9761H6.93426Z"
          fill="#214063"
        />
        <path
          d="M6.896 36.5616C6.91513 36.5425 6.896 36.5425 6.896 36.5425V36.5616Z"
          fill="#214063"
        />
        <path
          d="M7.1819 34.0591H7.22017C7.22017 34.0782 7.22017 34.1165 7.20103 34.0974C7.1819 34.0782 7.14363 34.0591 7.1819 34.0591Z"
          fill="#214063"
        />
        <path
          d="M7.14355 34.4795H7.1626C7.2007 34.4795 7.25784 34.4795 7.27689 34.5368V34.575H7.2007L7.14355 34.4986V34.4795Z"
          fill="#214063"
        />
        <path
          d="M7.0293 35.2625C7.04834 35.2816 7.04834 35.2816 7.06739 35.2625C7.08644 35.2434 7.06739 35.2434 7.04834 35.2243C7.0293 35.2052 7.12453 35.2243 7.12453 35.2625C7.12453 35.3007 7.10549 35.2816 7.08644 35.2816H7.0293V35.2625Z"
          fill="#214063"
        />
        <path
          d="M6.99074 37.1348C7.00979 37.1539 6.99074 37.173 6.97169 37.173C6.95265 37.173 6.9336 37.1348 6.91455 37.1539L6.99074 37.1348Z"
          fill="#214063"
        />
        <path
          d="M7.06689 35.2627C7.08603 35.2818 7.08603 35.2818 7.06689 35.2818C7.06689 35.2818 7.08603 35.2818 7.06689 35.2627Z"
          fill="white"
        />
        <path
          d="M9.37208 37.2873H9.35304C9.35304 37.2873 9.41018 37.3255 9.41018 37.2873C9.41018 37.2491 9.52446 37.3255 9.54351 37.3637H9.63875C9.63875 37.3828 9.6578 37.4019 9.63875 37.4019C9.6197 37.4019 9.52447 37.3255 9.46732 37.421H9.31494C9.33399 37.421 9.33399 37.3828 9.33399 37.3828H9.37208V37.2873Z"
          fill="#214063"
        />
        <path
          d="M7.16278 36.638C7.17293 36.638 7.18266 36.6421 7.18984 36.6492C7.19701 36.6564 7.20104 36.6662 7.20104 36.6763H7.12451C7.12451 36.6572 7.12451 36.6189 7.16278 36.638Z"
          fill="#214063"
        />
        <path
          d="M7.35254 34.7085H7.40969C7.40969 34.7085 7.42873 34.7276 7.40969 34.7276C7.39064 34.7276 7.35254 34.7276 7.3335 34.7085C7.33639 34.7102 7.33968 34.7111 7.34302 34.7111C7.34636 34.7111 7.34965 34.7102 7.35254 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.33419 36.8863C7.31505 36.8863 7.33419 36.8672 7.33419 36.8672V36.8863Z"
          fill="#214063"
        />
        <path
          d="M7.3335 36.8862H7.35263L7.3335 36.9054V36.8862Z"
          fill="white"
        />
        <path
          d="M7.67676 36.9058H7.75295V36.944C7.73391 36.9822 7.69581 36.9631 7.67676 36.9631H7.65771L7.67676 36.9058Z"
          fill="#214063"
        />
        <path
          d="M7.58155 37.5551H7.5625C7.6006 37.5551 7.63869 37.536 7.67679 37.5742H7.58155V37.5551Z"
          fill="#214063"
        />
        <path
          d="M7.73393 34.7085H7.81012C7.82916 34.7085 7.84821 34.7276 7.82916 34.7467L7.79107 34.7849H7.75297C7.77202 34.7467 7.71488 34.7658 7.73393 34.7276C7.73393 34.7276 7.75297 34.7085 7.73393 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.73356 37.1346H7.75261C7.75261 37.1537 7.8288 37.1346 7.8288 37.1728C7.8288 37.211 7.79071 37.211 7.77166 37.2301C7.75261 37.2492 7.75261 37.211 7.73356 37.211V37.1728C7.73356 37.1537 7.71452 37.1155 7.73356 37.1346Z"
          fill="#214063"
        />
        <path
          d="M7.7152 35.3007H7.67694C7.65781 35.3198 7.69607 35.3007 7.69607 35.3198C7.69607 35.2815 7.67694 35.3007 7.65781 35.3007H7.63867C7.67694 35.2624 7.7152 35.2624 7.7152 35.3007Z"
          fill="#214063"
        />
        <path
          d="M8.64844 35.8165H8.66757C8.6867 35.8165 8.66757 35.7974 8.66757 35.7974H8.70584V35.8357H8.64844V35.8165Z"
          fill="#214063"
        />
        <path
          d="M9.01004 37.0776C9.01411 37.0812 9.01737 37.0856 9.0196 37.0906C9.02184 37.0955 9.02299 37.1009 9.02299 37.1064C9.02299 37.1118 9.02184 37.1172 9.0196 37.1221C9.01737 37.1271 9.01411 37.1315 9.01004 37.1351H8.97177C8.97177 37.1351 8.9909 37.1159 8.95264 37.1159H9.01004V37.0776Z"
          fill="#214063"
        />
        <path
          d="M8.87695 36.2179C8.89207 36.216 8.90743 36.2185 8.92107 36.2254C8.9347 36.2322 8.94599 36.2429 8.95349 36.2562H8.87695V36.2179Z"
          fill="#214063"
        />
        <path
          d="M8.91522 36.2372V36.2754H8.87695C8.89609 36.2563 8.87695 36.218 8.91522 36.2372Z"
          fill="white"
        />
        <path
          d="M8.80029 37.1538C8.81943 37.1538 8.80029 37.1538 8.80029 37.173V37.1538Z"
          fill="#214063"
        />
        <path
          d="M10.8008 38.0134C10.8198 37.9943 10.7817 38.0134 10.7627 37.9943C10.7817 37.9752 10.8198 38.0134 10.8389 37.9752H10.9913C10.9722 37.9561 11.0294 37.9943 11.0294 37.9561L11.0675 37.9943C11.0965 38.0189 11.1167 38.0525 11.1246 38.0898L11.0865 38.128C11.0865 38.1471 11.0675 38.1471 11.0865 38.1471H11.0484C11.0484 38.1662 11.0294 38.1853 11.0103 38.1662H10.8389C10.8389 38.1662 10.877 38.1471 10.8579 38.128H10.7817C10.8198 38.1089 10.8008 38.0898 10.7817 38.0707H10.7437C10.7627 38.0516 10.7817 38.0516 10.8008 38.0134Z"
          fill="#214063"
        />
        <path
          d="M9.23877 36.313H9.27704C9.29617 36.3513 9.2579 36.3321 9.23877 36.3321V36.313Z"
          fill="#214063"
        />
        <path
          d="M9.48587 36.4278C9.50492 36.4469 9.52396 36.466 9.50492 36.4851C9.48587 36.5042 9.50492 36.5042 9.50492 36.5042C9.5104 36.5062 9.51537 36.5093 9.51945 36.5135C9.52353 36.5176 9.52661 36.5227 9.52845 36.5282C9.53029 36.5337 9.53084 36.5396 9.53006 36.5454C9.52928 36.5512 9.5272 36.5567 9.52396 36.5615C9.44777 36.5806 9.40968 36.5042 9.37158 36.4851C9.38432 36.4667 9.40147 36.4519 9.42143 36.4419C9.4414 36.4318 9.46356 36.427 9.48587 36.4278Z"
          fill="#214063"
        />
        <path
          d="M12.4199 37.3065H12.4009C12.4199 37.3065 12.439 37.3065 12.439 37.2874H12.5342C12.5723 37.2683 12.5914 37.3065 12.6104 37.3256H12.6295V37.402H12.5723L12.6104 37.4785C12.6104 37.5167 12.5723 37.5167 12.5533 37.5358H12.4961C12.5152 37.4976 12.458 37.4976 12.439 37.4976H12.4199C12.439 37.4785 12.458 37.4976 12.458 37.4785C12.458 37.4785 12.439 37.4785 12.458 37.4594H12.3818C12.4009 37.3256 12.439 37.3256 12.4199 37.3065Z"
          fill="#214063"
        />
        <path
          d="M9.98145 37.5546C10.0005 37.5355 10.0386 37.4973 10.0767 37.5164L10.1529 37.5546C10.1529 37.5928 10.1148 37.6119 10.0957 37.6502H10.0195L9.9624 37.6119C9.98145 37.5928 9.98145 37.5737 9.98145 37.5546Z"
          fill="#214063"
        />
        <path
          d="M9.71493 36.7527C9.71493 36.7335 9.71493 36.7144 9.6958 36.7335L9.71493 36.7527Z"
          fill="#214063"
        />
        <path
          d="M9.86719 36.8096C9.84814 36.8096 9.88624 36.7905 9.86719 36.7905C9.84814 36.7905 9.92434 36.8478 9.98148 36.8096C10.0386 36.7714 10.0386 36.8478 10.0386 36.886L9.98148 36.9242H9.92433C9.94338 36.9242 9.92433 36.9051 9.92433 36.9051H9.90529C9.92433 36.886 9.88624 36.9051 9.88624 36.886C9.88624 36.8478 9.84814 36.8669 9.84814 36.8287C9.84814 36.8096 9.84814 36.8096 9.86719 36.8096Z"
          fill="#214063"
        />
        <path
          d="M10.9147 37.1346C10.9147 37.1346 10.9528 37.1346 10.9337 37.1155H10.9528C10.9909 37.1346 10.9909 37.0773 11.029 37.1155C11.0671 37.1537 11.0671 37.1537 11.0861 37.1346C11.0945 37.1491 11.0989 37.1656 11.0989 37.1824C11.0989 37.1991 11.0945 37.2156 11.0861 37.2301H11.029C11.0099 37.1919 10.9909 37.2492 10.9909 37.211H10.9147C10.8956 37.1537 10.9337 37.1537 10.9147 37.1346Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.0704C11.4482 38.0653 11.4503 38.0605 11.4538 38.0569C11.4574 38.0533 11.4623 38.0513 11.4674 38.0513L11.5248 38.0896V38.1278H11.4674L11.4482 38.0704Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.1085V38.0894L11.4674 38.1085H11.4482Z"
          fill="white"
        />
        <path
          d="M11.3343 39.0258C11.3535 39.045 11.3726 39.0641 11.3535 39.0833H11.2961C11.2769 39.0641 11.2961 39.0067 11.3343 39.0258Z"
          fill="#214063"
        />
        <path
          d="M12.0768 37.8034V37.7651C12.0959 37.7651 12.1342 37.7651 12.1342 37.7843C12.1342 37.8034 12.1342 37.8226 12.115 37.8226H12.0959C12.0768 37.8034 12.0576 37.7843 12.0768 37.7843V37.8034Z"
          fill="#214063"
        />
        <path
          d="M11.6198 38.3384H11.6581C11.6581 38.3384 11.6772 38.3575 11.6581 38.3575H11.6198C11.6198 38.3575 11.6007 38.3575 11.6198 38.3384Z"
          fill="#214063"
        />
        <path
          d="M11.6388 38.3571H11.6196C11.6196 38.338 11.6388 38.3571 11.6388 38.3571Z"
          fill="white"
        />
        <path
          d="M12.0005 38.7202H12.0386C12.0767 38.7393 12.1529 38.7202 12.1719 38.7966V38.8539C12.1529 38.8921 12.1148 38.873 12.0957 38.8921H12.0767C12.0767 38.8871 12.0747 38.8822 12.0711 38.8786C12.0675 38.875 12.0627 38.873 12.0576 38.873H12.0005C12.0014 38.8627 12.0001 38.8523 11.9969 38.8424C11.9936 38.8326 11.9883 38.8235 11.9815 38.8157H11.9624C11.9624 38.7202 12.0005 38.7393 12.0005 38.7202Z"
          fill="#214063"
        />
        <path
          d="M12.229 38.1278H12.2862C12.3052 38.1278 12.2862 38.1087 12.2862 38.1087H12.3243C12.3623 38.0705 12.3814 38.1278 12.4004 38.1087H12.4385C12.4509 38.1252 12.4576 38.1453 12.4576 38.166H12.4766V38.2042C12.4576 38.2042 12.5147 38.2233 12.4766 38.2233C12.4385 38.2233 12.4766 38.2424 12.4766 38.2615H12.4576C12.4766 38.2997 12.4195 38.2997 12.4195 38.3188H12.3623C12.3433 38.3379 12.3243 38.2806 12.2862 38.3188C12.2481 38.357 12.2862 38.2615 12.2481 38.2806H12.229C12.229 38.2615 12.2671 38.2615 12.2481 38.2424C12.229 38.2233 12.229 38.2615 12.21 38.2615C12.1909 38.2615 12.2671 38.2233 12.229 38.2042H12.1909C12.21 38.2042 12.229 38.2042 12.21 38.1851H12.1909C12.21 38.166 12.21 38.1278 12.229 38.1278Z"
          fill="#214063"
        />
        <path
          d="M12.877 38.7967L12.9151 38.7394C12.9341 38.7585 12.9341 38.7012 12.9722 38.7203H13.0103C13.0293 38.7394 13.0674 38.7203 13.1055 38.7585C13.1436 38.7967 13.1055 38.7967 13.1246 38.7967C13.1246 38.8158 13.1436 38.8349 13.1246 38.854L13.0865 38.9113C13.0865 38.9113 13.0484 38.9113 13.0484 38.9304C13.0484 38.9495 13.0293 38.9495 13.0103 38.9495H12.9532C12.9532 38.9304 12.9341 38.9495 12.9151 38.9495H12.8579V38.9113H12.8198C12.877 38.8349 12.8579 38.8158 12.877 38.7967Z"
          fill="#214063"
        />
        <path
          d="M12.8962 37.6314C12.877 37.6506 12.8579 37.6314 12.8579 37.6123L12.8962 37.6314Z"
          fill="#214063"
        />
        <path
          d="M13.124 38.5288C13.1432 38.5288 13.1623 38.5288 13.1623 38.548H13.124C13.124 38.5288 13.1432 38.5288 13.124 38.5288Z"
          fill="#214063"
        />
        <path
          d="M13.3335 37.9371V37.8989H13.4097C13.4287 37.9371 13.4478 37.9371 13.4287 37.9753C13.4097 38.0135 13.4097 37.9944 13.4287 38.0135C13.4478 38.0326 13.3906 37.9944 13.4097 38.0326H13.3335V37.9371Z"
          fill="#214063"
        />
        <path
          d="M13.3906 38.0704C13.3906 38.0513 13.4287 38.0704 13.4287 38.0513H13.5049C13.543 38.0513 13.543 38.0895 13.5621 38.0895C13.5811 38.0895 13.543 38.1277 13.5811 38.1468C13.6192 38.1659 13.5811 38.2041 13.524 38.2232H13.4859C13.4668 38.2614 13.4478 38.2232 13.4287 38.2423H13.3906C13.3716 38.2232 13.3906 38.2041 13.3716 38.2041C13.3716 38.199 13.3736 38.1942 13.3772 38.1906C13.3807 38.187 13.3856 38.185 13.3906 38.185C13.3525 38.1086 13.4097 38.0895 13.3906 38.0704Z"
          fill="#214063"
        />
        <path
          d="M13.7339 38.3953C13.7529 38.3762 13.7339 38.3762 13.7339 38.3762C13.7339 38.3762 13.7529 38.3953 13.7529 38.3762H13.8101C13.8291 38.3762 13.8101 38.338 13.8291 38.3571L13.8672 38.2998H13.9244L13.9625 38.338C13.9434 38.3571 13.9625 38.3571 13.9625 38.3762C13.9625 38.3953 13.9625 38.338 13.9815 38.338C14.0006 38.338 13.9625 38.3762 14.0006 38.3953H14.0767C14.0577 38.3953 14.0577 38.4144 14.0767 38.4335C14.1148 38.4335 14.0767 38.4717 14.0958 38.4717C14.1148 38.4717 14.0958 38.5099 14.1148 38.5099H14.0767V38.5481C14.0767 38.5481 14.0386 38.5672 14.0577 38.5863C14.0386 38.5863 14.0577 38.6054 14.0577 38.6054C14.0577 38.6054 14.0386 38.5672 14.0196 38.6054C13.9815 38.6054 14.0006 38.6818 13.9434 38.6818V38.6436C13.9244 38.6436 13.9244 38.6818 13.8863 38.6627C13.8482 38.6436 13.8672 38.6245 13.8482 38.6245H13.8291C13.8101 38.6245 13.8482 38.6054 13.8291 38.5863H13.8101V38.5481H13.791C13.791 38.529 13.8101 38.529 13.791 38.5099H13.772C13.772 38.5049 13.774 38.5 13.7776 38.4964C13.7811 38.4928 13.786 38.4908 13.791 38.4908H13.772C13.7529 38.4908 13.791 38.4717 13.772 38.4526L13.7339 38.3953Z"
          fill="#214063"
        />
        <path
          d="M11.6768 37.001C11.6958 37.0201 11.7339 37.001 11.7339 37.0392C11.7339 37.0774 11.6958 37.0965 11.6768 37.0774H11.6387V37.0392C11.6437 37.0442 11.6506 37.0471 11.6577 37.0471C11.6649 37.0471 11.6717 37.0442 11.6768 37.0392C11.6818 37.0341 11.6847 37.0272 11.6847 37.0201C11.6847 37.0129 11.6818 37.006 11.6768 37.001Z"
          fill="#214063"
        />
        <path
          d="M11.8483 37.0773H11.8101V37.0581L11.8483 37.0773Z"
          fill="#214063"
        />
        <path
          d="M11.9053 37.0391H12.0386C12.0577 37.0582 12.0577 37.0964 12.0958 37.0964C12.1339 37.0964 12.0767 37.0964 12.0958 37.1155V37.1728L12.0577 37.2301C12.0526 37.2301 12.0478 37.2321 12.0442 37.2357C12.0406 37.2393 12.0386 37.2441 12.0386 37.2492C12.0196 37.2492 12.0196 37.2683 12.0196 37.2874V37.2492H11.9624C11.9434 37.211 11.9053 37.2492 11.8862 37.2492C11.8672 37.2492 11.9243 37.211 11.9053 37.1919C11.8862 37.1728 11.9243 37.1728 11.9053 37.1537H11.8672C11.8835 37.14 11.8958 37.1221 11.9025 37.1018C11.9092 37.0816 11.9102 37.0598 11.9053 37.0391Z"
          fill="#214063"
        />
        <path
          d="M7.60068 38.5675L7.58154 38.5483L7.60068 38.5675Z"
          fill="white"
        />
        <path
          d="M7.63876 38.5865H7.61963V38.5674L7.63876 38.5865Z"
          fill="white"
        />
        <path
          d="M9.08661 34.7852H9.12487C9.12895 34.7887 9.13221 34.7932 9.13444 34.7981C9.13667 34.8031 9.13783 34.8084 9.13783 34.8139C9.13783 34.8193 9.13667 34.8247 9.13444 34.8296C9.13221 34.8346 9.12895 34.839 9.12487 34.8426H9.06747C9.065 34.8322 9.06548 34.8213 9.06886 34.8111C9.07224 34.801 9.07839 34.792 9.08661 34.7852Z"
          fill="#214063"
        />
        <path
          d="M9.18151 34.6707V34.709H9.14325C9.12412 34.6899 9.14325 34.6516 9.18151 34.6707Z"
          fill="#214063"
        />
        <path
          d="M7.12451 35.855H7.14364V35.8741L7.12451 35.855Z"
          fill="#214063"
        />
        <path
          d="M7.29617 35.9505C7.28095 35.9505 7.26635 35.9444 7.25558 35.9337C7.24482 35.9229 7.23877 35.9083 7.23877 35.8931L7.29617 35.9505Z"
          fill="#214063"
        />
        <path
          d="M4.09588 35.6064C4.09588 35.6256 4.09588 35.6447 4.05762 35.6256H4.09588V35.6064Z"
          fill="#214063"
        />
        <path
          d="M3.60107 34.0972C3.63917 34.0972 3.69631 34.0972 3.71536 34.1354C3.73441 34.1736 3.69631 34.1354 3.67726 34.1354L3.60107 34.0972Z"
          fill="#214063"
        />
        <path
          d="M10.3814 36.2369C10.3814 36.1987 10.4195 36.2369 10.4385 36.2178L10.5147 36.256C10.5147 36.2942 10.4956 36.2942 10.4956 36.3324C10.4956 36.3706 10.4956 36.3897 10.4385 36.3706C10.3814 36.3515 10.4004 36.3515 10.3814 36.3515H10.3623C10.3814 36.3515 10.3623 36.3324 10.3433 36.3133L10.3814 36.2369Z"
          fill="#214063"
        />
        <path
          d="M3.86737 34.2507H3.8291V34.2124L3.86737 34.2507Z"
          fill="#214063"
        />
        <path
          d="M4.00125 34.1931H4.02038L3.94385 34.1548L4.00125 34.1931Z"
          fill="#214063"
        />
        <path
          d="M5.4288 35.1291H5.40967C5.40967 35.1291 5.40967 35.11 5.4288 35.1291Z"
          fill="#214063"
        />
        <path
          d="M5.79114 34.6895H5.81027C5.81027 34.6945 5.80825 34.6994 5.80467 34.703C5.80108 34.7066 5.79621 34.7086 5.79114 34.7086C5.78946 34.7057 5.78857 34.7024 5.78857 34.699C5.78857 34.6957 5.78946 34.6924 5.79114 34.6895Z"
          fill="#214063"
        />
        <path
          d="M5.90529 34.4224C5.90529 34.4224 5.94338 34.4415 5.92433 34.4606C5.90529 34.4797 5.90529 34.4988 5.88624 34.4797C5.86719 34.4606 5.86719 34.4606 5.84814 34.4606L5.90529 34.4224Z"
          fill="#214063"
        />
        <path
          d="M5.84785 34.6323C5.82871 34.6323 5.82871 34.6515 5.84785 34.6323V34.6323Z"
          fill="#214063"
        />
        <path
          d="M5.8103 35.186H5.82944C5.82944 35.2052 5.82944 35.2243 5.8103 35.2243C5.80694 35.2185 5.80518 35.2119 5.80518 35.2052C5.80518 35.1985 5.80694 35.1919 5.8103 35.186Z"
          fill="#214063"
        />
        <path
          d="M4.47665 34.8995H4.45752V34.8804L4.47665 34.8995Z"
          fill="#214063"
        />
        <path
          d="M4.59134 34.9759C4.61038 34.9759 4.62943 34.995 4.61038 35.0141C4.59134 35.0332 4.55324 35.0141 4.51515 34.995H4.47705C4.49267 34.9819 4.51151 34.9732 4.5316 34.9698C4.55169 34.9665 4.57232 34.9686 4.59134 34.9759Z"
          fill="#214063"
        />
        <path
          d="M6.00069 35.1862H5.98156C5.96242 35.1862 5.98156 35.1671 6.00069 35.1862Z"
          fill="#214063"
        />
        <path
          d="M6.05781 34.9949C6.07695 34.9949 6.07695 35.0141 6.05781 35.0332H6.03868C6.03361 35.0307 6.02975 35.0262 6.02795 35.0208C6.02616 35.0155 6.02658 35.0096 6.02911 35.0045C6.03165 34.9994 6.0361 34.9956 6.04148 34.9938C6.04686 34.992 6.05274 34.9924 6.05781 34.9949Z"
          fill="#214063"
        />
        <path
          d="M6.03915 35.1675C6.03915 35.1866 6.07742 35.1675 6.05829 35.2058C6.03915 35.2441 6.02002 35.2058 6.02002 35.1866L6.03915 35.1675Z"
          fill="#214063"
        />
        <path
          d="M4.87646 34.9952H4.91456V34.957C4.9717 34.9952 5.04789 34.9952 5.06694 35.0525L5.02885 35.0907H4.99075C4.9717 35.0716 4.93361 35.0907 4.91456 35.0525C4.91456 35.0334 4.87646 35.0143 4.87646 34.9952Z"
          fill="#214063"
        />
        <path
          d="M4.95266 35.2818C4.93362 35.3391 4.89552 35.3009 4.87647 35.2818H4.83838C4.85486 35.2694 4.87492 35.2627 4.89552 35.2627C4.91613 35.2627 4.93618 35.2694 4.95266 35.2818Z"
          fill="#214063"
        />
        <path
          d="M4.91513 35.2818L4.896 35.301V35.2627V35.2818H4.91513Z"
          fill="white"
        />
        <path
          d="M8.28667 36.4469C8.22952 36.466 8.17238 36.4278 8.11524 36.3896H8.09619C8.13012 36.3806 8.16587 36.3812 8.19948 36.3914C8.23309 36.4015 8.26326 36.4207 8.28667 36.4469Z"
          fill="#214063"
        />
        <path
          d="M5.16279 35.4156V35.4538H5.14374L5.06755 35.4156C5.0485 35.4156 5.06755 35.4156 5.06755 35.3965H5.14374L5.16279 35.4156Z"
          fill="#214063"
        />
        <path
          d="M5.21924 35.5108C5.23829 35.4917 5.27638 35.5108 5.31448 35.5299C5.31953 35.5299 5.32437 35.532 5.32795 35.5355C5.33152 35.5391 5.33352 35.544 5.33352 35.549C5.33352 35.5541 5.33152 35.559 5.32795 35.5626C5.32437 35.5661 5.31953 35.5681 5.31448 35.5681H5.21924V35.5108Z"
          fill="#214063"
        />
        <path
          d="M5.31448 36.4472H5.23829C5.23829 36.4281 5.21924 36.4472 5.21924 36.4281C5.21924 36.409 5.27638 36.409 5.31448 36.4472Z"
          fill="#214063"
        />
        <path
          d="M6.43853 33.6771C6.43853 33.7153 6.40043 33.6962 6.38138 33.6962C6.36234 33.6962 6.30519 33.6197 6.2671 33.6197L6.229 33.5815C6.28615 33.6197 6.40043 33.5815 6.43853 33.6771Z"
          fill="#214063"
        />
        <path
          d="M6.19092 36.103H6.21005C6.21005 36.1222 6.21005 36.1413 6.19092 36.1413V36.103Z"
          fill="#214063"
        />
        <path
          d="M6.59082 36.2178H6.64797L6.68606 36.256C6.68606 36.2751 6.66702 36.2751 6.64797 36.2942C6.62892 36.3133 6.62892 36.256 6.59082 36.2751H6.60987L6.57178 36.2369L6.59082 36.2178Z"
          fill="#214063"
        />
        <path
          d="M6.57254 34.2886H6.5534V34.3269L6.51514 34.2886H6.57254Z"
          fill="#214063"
        />
        <path
          d="M6.57236 34.2886H6.59149V34.3269H6.55322L6.57236 34.2886Z"
          fill="#214063"
        />
        <path
          d="M6.64795 35.5298C6.68604 35.5489 6.74319 35.5107 6.78128 35.568C6.78128 35.5781 6.77727 35.5878 6.77012 35.595C6.76298 35.6022 6.75329 35.6062 6.74319 35.6062L6.64795 35.5298Z"
          fill="#214063"
        />
        <path
          d="M6.85742 36.4277L6.91482 36.466H6.85742V36.4277Z"
          fill="#214063"
        />
        <path
          d="M6.93426 34.9761C6.94441 34.9761 6.95414 34.9801 6.96132 34.9873C6.9685 34.9945 6.97253 35.0042 6.97253 35.0144H6.9534C6.93426 35.0144 6.896 34.9952 6.896 34.9761H6.93426Z"
          fill="#214063"
        />
        <path
          d="M6.896 36.5616C6.91513 36.5425 6.896 36.5425 6.896 36.5425V36.5616Z"
          fill="#214063"
        />
        <path
          d="M7.1819 34.0591H7.22017C7.22017 34.0782 7.22017 34.1165 7.20103 34.0974C7.1819 34.0782 7.14363 34.0591 7.1819 34.0591Z"
          fill="#214063"
        />
        <path
          d="M7.14355 34.4795H7.1626C7.2007 34.4795 7.25784 34.4795 7.27689 34.5368V34.575H7.2007L7.14355 34.4986V34.4795Z"
          fill="#214063"
        />
        <path
          d="M7.0293 35.2625C7.04834 35.2816 7.04834 35.2816 7.06739 35.2625C7.08644 35.2434 7.06739 35.2434 7.04834 35.2243C7.0293 35.2052 7.12453 35.2243 7.12453 35.2625C7.12453 35.3007 7.10549 35.2816 7.08644 35.2816H7.0293V35.2625Z"
          fill="#214063"
        />
        <path
          d="M6.99074 37.1348C7.00979 37.1539 6.99074 37.173 6.97169 37.173C6.95265 37.173 6.9336 37.1348 6.91455 37.1539L6.99074 37.1348Z"
          fill="#214063"
        />
        <path
          d="M7.06689 35.2627C7.08603 35.2818 7.08603 35.2818 7.06689 35.2818C7.06689 35.2818 7.08603 35.2818 7.06689 35.2627Z"
          fill="white"
        />
        <path
          d="M9.37208 37.2873H9.35304C9.35304 37.2873 9.41018 37.3255 9.41018 37.2873C9.41018 37.2491 9.52446 37.3255 9.54351 37.3637H9.63875C9.63875 37.3828 9.6578 37.4019 9.63875 37.4019C9.6197 37.4019 9.52447 37.3255 9.46732 37.421H9.31494C9.33399 37.421 9.33399 37.3828 9.33399 37.3828H9.37208V37.2873Z"
          fill="#214063"
        />
        <path
          d="M7.16278 36.638C7.17293 36.638 7.18266 36.6421 7.18984 36.6492C7.19701 36.6564 7.20104 36.6662 7.20104 36.6763H7.12451C7.12451 36.6572 7.12451 36.6189 7.16278 36.638Z"
          fill="#214063"
        />
        <path
          d="M7.35254 34.7085H7.40969C7.40969 34.7085 7.42873 34.7276 7.40969 34.7276C7.39064 34.7276 7.35254 34.7276 7.3335 34.7085C7.33639 34.7102 7.33968 34.7111 7.34302 34.7111C7.34636 34.7111 7.34965 34.7102 7.35254 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.33419 36.8863C7.31505 36.8863 7.33419 36.8672 7.33419 36.8672V36.8863Z"
          fill="#214063"
        />
        <path
          d="M7.3335 36.8862H7.35263L7.3335 36.9054V36.8862Z"
          fill="white"
        />
        <path
          d="M7.67676 36.9058H7.75295V36.944C7.73391 36.9822 7.69581 36.9631 7.67676 36.9631H7.65771L7.67676 36.9058Z"
          fill="#214063"
        />
        <path
          d="M7.58155 37.5551H7.5625C7.6006 37.5551 7.63869 37.536 7.67679 37.5742H7.58155V37.5551Z"
          fill="#214063"
        />
        <path
          d="M7.73393 34.7085H7.81012C7.82916 34.7085 7.84821 34.7276 7.82916 34.7467L7.79107 34.7849H7.75297C7.77202 34.7467 7.71488 34.7658 7.73393 34.7276C7.73393 34.7276 7.75297 34.7085 7.73393 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.73356 37.1346H7.75261C7.75261 37.1537 7.8288 37.1346 7.8288 37.1728C7.8288 37.211 7.79071 37.211 7.77166 37.2301C7.75261 37.2492 7.75261 37.211 7.73356 37.211V37.1728C7.73356 37.1537 7.71452 37.1155 7.73356 37.1346Z"
          fill="#214063"
        />
        <path
          d="M7.7152 35.3007H7.67694C7.65781 35.3198 7.69607 35.3007 7.69607 35.3198C7.69607 35.2815 7.67694 35.3007 7.65781 35.3007H7.63867C7.67694 35.2624 7.7152 35.2624 7.7152 35.3007Z"
          fill="#214063"
        />
        <path
          d="M8.64844 35.8165H8.66757C8.6867 35.8165 8.66757 35.7974 8.66757 35.7974H8.70584V35.8357H8.64844V35.8165Z"
          fill="#214063"
        />
        <path
          d="M9.01004 37.0776C9.01411 37.0812 9.01737 37.0856 9.0196 37.0906C9.02184 37.0955 9.02299 37.1009 9.02299 37.1064C9.02299 37.1118 9.02184 37.1172 9.0196 37.1221C9.01737 37.1271 9.01411 37.1315 9.01004 37.1351H8.97177C8.97177 37.1351 8.9909 37.1159 8.95264 37.1159H9.01004V37.0776Z"
          fill="#214063"
        />
        <path
          d="M8.87695 36.2179C8.89207 36.216 8.90743 36.2185 8.92107 36.2254C8.9347 36.2322 8.94599 36.2429 8.95349 36.2562H8.87695V36.2179Z"
          fill="#214063"
        />
        <path
          d="M8.91522 36.2372V36.2754H8.87695C8.89609 36.2563 8.87695 36.218 8.91522 36.2372Z"
          fill="white"
        />
        <path
          d="M8.80029 37.1538C8.81943 37.1538 8.80029 37.1538 8.80029 37.173V37.1538Z"
          fill="#214063"
        />
        <path
          d="M10.8008 38.0134C10.8198 37.9943 10.7817 38.0134 10.7627 37.9943C10.7817 37.9752 10.8198 38.0134 10.8389 37.9752H10.9913C10.9722 37.9561 11.0294 37.9943 11.0294 37.9561L11.0675 37.9943C11.0965 38.0189 11.1167 38.0525 11.1246 38.0898L11.0865 38.128C11.0865 38.1471 11.0675 38.1471 11.0865 38.1471H11.0484C11.0484 38.1662 11.0294 38.1853 11.0103 38.1662H10.8389C10.8389 38.1662 10.877 38.1471 10.8579 38.128H10.7817C10.8198 38.1089 10.8008 38.0898 10.7817 38.0707H10.7437C10.7627 38.0516 10.7817 38.0516 10.8008 38.0134Z"
          fill="#214063"
        />
        <path
          d="M9.23877 36.313H9.27704C9.29617 36.3513 9.2579 36.3321 9.23877 36.3321V36.313Z"
          fill="#214063"
        />
        <path
          d="M9.48587 36.4278C9.50492 36.4469 9.52396 36.466 9.50492 36.4851C9.48587 36.5042 9.50492 36.5042 9.50492 36.5042C9.5104 36.5062 9.51537 36.5093 9.51945 36.5135C9.52353 36.5176 9.52661 36.5227 9.52845 36.5282C9.53029 36.5337 9.53084 36.5396 9.53006 36.5454C9.52928 36.5512 9.5272 36.5567 9.52396 36.5615C9.44777 36.5806 9.40968 36.5042 9.37158 36.4851C9.38432 36.4667 9.40147 36.4519 9.42143 36.4419C9.4414 36.4318 9.46356 36.427 9.48587 36.4278Z"
          fill="#214063"
        />
        <path
          d="M12.4199 37.3065H12.4009C12.4199 37.3065 12.439 37.3065 12.439 37.2874H12.5342C12.5723 37.2683 12.5914 37.3065 12.6104 37.3256H12.6295V37.402H12.5723L12.6104 37.4785C12.6104 37.5167 12.5723 37.5167 12.5533 37.5358H12.4961C12.5152 37.4976 12.458 37.4976 12.439 37.4976H12.4199C12.439 37.4785 12.458 37.4976 12.458 37.4785C12.458 37.4785 12.439 37.4785 12.458 37.4594H12.3818C12.4009 37.3256 12.439 37.3256 12.4199 37.3065Z"
          fill="#214063"
        />
        <path
          d="M9.98145 37.5546C10.0005 37.5355 10.0386 37.4973 10.0767 37.5164L10.1529 37.5546C10.1529 37.5928 10.1148 37.6119 10.0957 37.6502H10.0195L9.9624 37.6119C9.98145 37.5928 9.98145 37.5737 9.98145 37.5546Z"
          fill="#214063"
        />
        <path
          d="M9.71493 36.7527C9.71493 36.7335 9.71493 36.7144 9.6958 36.7335L9.71493 36.7527Z"
          fill="#214063"
        />
        <path
          d="M9.86719 36.8096C9.84814 36.8096 9.88624 36.7905 9.86719 36.7905C9.84814 36.7905 9.92434 36.8478 9.98148 36.8096C10.0386 36.7714 10.0386 36.8478 10.0386 36.886L9.98148 36.9242H9.92433C9.94338 36.9242 9.92433 36.9051 9.92433 36.9051H9.90529C9.92433 36.886 9.88624 36.9051 9.88624 36.886C9.88624 36.8478 9.84814 36.8669 9.84814 36.8287C9.84814 36.8096 9.84814 36.8096 9.86719 36.8096Z"
          fill="#214063"
        />
        <path
          d="M10.9147 37.1346C10.9147 37.1346 10.9528 37.1346 10.9337 37.1155H10.9528C10.9909 37.1346 10.9909 37.0773 11.029 37.1155C11.0671 37.1537 11.0671 37.1537 11.0861 37.1346C11.0945 37.1491 11.0989 37.1656 11.0989 37.1824C11.0989 37.1991 11.0945 37.2156 11.0861 37.2301H11.029C11.0099 37.1919 10.9909 37.2492 10.9909 37.211H10.9147C10.8956 37.1537 10.9337 37.1537 10.9147 37.1346Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.0704C11.4482 38.0653 11.4503 38.0605 11.4538 38.0569C11.4574 38.0533 11.4623 38.0513 11.4674 38.0513L11.5248 38.0896V38.1278H11.4674L11.4482 38.0704Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.1085V38.0894L11.4674 38.1085H11.4482Z"
          fill="white"
        />
        <path
          d="M11.3343 39.0258C11.3535 39.045 11.3726 39.0641 11.3535 39.0833H11.2961C11.2769 39.0641 11.2961 39.0067 11.3343 39.0258Z"
          fill="#214063"
        />
        <path
          d="M12.0768 37.8034V37.7651C12.0959 37.7651 12.1342 37.7651 12.1342 37.7843C12.1342 37.8034 12.1342 37.8226 12.115 37.8226H12.0959C12.0768 37.8034 12.0576 37.7843 12.0768 37.7843V37.8034Z"
          fill="#214063"
        />
        <path
          d="M11.6198 38.3384H11.6581C11.6581 38.3384 11.6772 38.3575 11.6581 38.3575H11.6198C11.6198 38.3575 11.6007 38.3575 11.6198 38.3384Z"
          fill="#214063"
        />
        <path
          d="M11.6388 38.3571H11.6196C11.6196 38.338 11.6388 38.3571 11.6388 38.3571Z"
          fill="white"
        />
        <path
          d="M12.0005 38.7202H12.0386C12.0767 38.7393 12.1529 38.7202 12.1719 38.7966V38.8539C12.1529 38.8921 12.1148 38.873 12.0957 38.8921H12.0767C12.0767 38.8871 12.0747 38.8822 12.0711 38.8786C12.0675 38.875 12.0627 38.873 12.0576 38.873H12.0005C12.0014 38.8627 12.0001 38.8523 11.9969 38.8424C11.9936 38.8326 11.9883 38.8235 11.9815 38.8157H11.9624C11.9624 38.7202 12.0005 38.7393 12.0005 38.7202Z"
          fill="#214063"
        />
        <path
          d="M12.229 38.1278H12.2862C12.3052 38.1278 12.2862 38.1087 12.2862 38.1087H12.3243C12.3623 38.0705 12.3814 38.1278 12.4004 38.1087H12.4385C12.4509 38.1252 12.4576 38.1453 12.4576 38.166H12.4766V38.2042C12.4576 38.2042 12.5147 38.2233 12.4766 38.2233C12.4385 38.2233 12.4766 38.2424 12.4766 38.2615H12.4576C12.4766 38.2997 12.4195 38.2997 12.4195 38.3188H12.3623C12.3433 38.3379 12.3243 38.2806 12.2862 38.3188C12.2481 38.357 12.2862 38.2615 12.2481 38.2806H12.229C12.229 38.2615 12.2671 38.2615 12.2481 38.2424C12.229 38.2233 12.229 38.2615 12.21 38.2615C12.1909 38.2615 12.2671 38.2233 12.229 38.2042H12.1909C12.21 38.2042 12.229 38.2042 12.21 38.1851H12.1909C12.21 38.166 12.21 38.1278 12.229 38.1278Z"
          fill="#214063"
        />
        <path
          d="M12.877 38.7967L12.9151 38.7394C12.9341 38.7585 12.9341 38.7012 12.9722 38.7203H13.0103C13.0293 38.7394 13.0674 38.7203 13.1055 38.7585C13.1436 38.7967 13.1055 38.7967 13.1246 38.7967C13.1246 38.8158 13.1436 38.8349 13.1246 38.854L13.0865 38.9113C13.0865 38.9113 13.0484 38.9113 13.0484 38.9304C13.0484 38.9495 13.0293 38.9495 13.0103 38.9495H12.9532C12.9532 38.9304 12.9341 38.9495 12.9151 38.9495H12.8579V38.9113H12.8198C12.877 38.8349 12.8579 38.8158 12.877 38.7967Z"
          fill="#214063"
        />
        <path
          d="M12.8962 37.6314C12.877 37.6506 12.8579 37.6314 12.8579 37.6123L12.8962 37.6314Z"
          fill="#214063"
        />
        <path
          d="M13.124 38.5288C13.1432 38.5288 13.1623 38.5288 13.1623 38.548H13.124C13.124 38.5288 13.1432 38.5288 13.124 38.5288Z"
          fill="#214063"
        />
        <path
          d="M13.3335 37.9371V37.8989H13.4097C13.4287 37.9371 13.4478 37.9371 13.4287 37.9753C13.4097 38.0135 13.4097 37.9944 13.4287 38.0135C13.4478 38.0326 13.3906 37.9944 13.4097 38.0326H13.3335V37.9371Z"
          fill="#214063"
        />
        <path
          d="M13.3906 38.0704C13.3906 38.0513 13.4287 38.0704 13.4287 38.0513H13.5049C13.543 38.0513 13.543 38.0895 13.5621 38.0895C13.5811 38.0895 13.543 38.1277 13.5811 38.1468C13.6192 38.1659 13.5811 38.2041 13.524 38.2232H13.4859C13.4668 38.2614 13.4478 38.2232 13.4287 38.2423H13.3906C13.3716 38.2232 13.3906 38.2041 13.3716 38.2041C13.3716 38.199 13.3736 38.1942 13.3772 38.1906C13.3807 38.187 13.3856 38.185 13.3906 38.185C13.3525 38.1086 13.4097 38.0895 13.3906 38.0704Z"
          fill="#214063"
        />
        <path
          d="M13.7339 38.3953C13.7529 38.3762 13.7339 38.3762 13.7339 38.3762C13.7339 38.3762 13.7529 38.3953 13.7529 38.3762H13.8101C13.8291 38.3762 13.8101 38.338 13.8291 38.3571L13.8672 38.2998H13.9244L13.9625 38.338C13.9434 38.3571 13.9625 38.3571 13.9625 38.3762C13.9625 38.3953 13.9625 38.338 13.9815 38.338C14.0006 38.338 13.9625 38.3762 14.0006 38.3953H14.0767C14.0577 38.3953 14.0577 38.4144 14.0767 38.4335C14.1148 38.4335 14.0767 38.4717 14.0958 38.4717C14.1148 38.4717 14.0958 38.5099 14.1148 38.5099H14.0767V38.5481C14.0767 38.5481 14.0386 38.5672 14.0577 38.5863C14.0386 38.5863 14.0577 38.6054 14.0577 38.6054C14.0577 38.6054 14.0386 38.5672 14.0196 38.6054C13.9815 38.6054 14.0006 38.6818 13.9434 38.6818V38.6436C13.9244 38.6436 13.9244 38.6818 13.8863 38.6627C13.8482 38.6436 13.8672 38.6245 13.8482 38.6245H13.8291C13.8101 38.6245 13.8482 38.6054 13.8291 38.5863H13.8101V38.5481H13.791C13.791 38.529 13.8101 38.529 13.791 38.5099H13.772C13.772 38.5049 13.774 38.5 13.7776 38.4964C13.7811 38.4928 13.786 38.4908 13.791 38.4908H13.772C13.7529 38.4908 13.791 38.4717 13.772 38.4526L13.7339 38.3953Z"
          fill="#214063"
        />
        <path
          d="M11.6768 37.001C11.6958 37.0201 11.7339 37.001 11.7339 37.0392C11.7339 37.0774 11.6958 37.0965 11.6768 37.0774H11.6387V37.0392C11.6437 37.0442 11.6506 37.0471 11.6577 37.0471C11.6649 37.0471 11.6717 37.0442 11.6768 37.0392C11.6818 37.0341 11.6847 37.0272 11.6847 37.0201C11.6847 37.0129 11.6818 37.006 11.6768 37.001Z"
          fill="#214063"
        />
        <path
          d="M11.8483 37.0773H11.8101V37.0581L11.8483 37.0773Z"
          fill="#214063"
        />
        <path
          d="M11.9053 37.0391H12.0386C12.0577 37.0582 12.0577 37.0964 12.0958 37.0964C12.1339 37.0964 12.0767 37.0964 12.0958 37.1155V37.1728L12.0577 37.2301C12.0526 37.2301 12.0478 37.2321 12.0442 37.2357C12.0406 37.2393 12.0386 37.2441 12.0386 37.2492C12.0196 37.2492 12.0196 37.2683 12.0196 37.2874V37.2492H11.9624C11.9434 37.211 11.9053 37.2492 11.8862 37.2492C11.8672 37.2492 11.9243 37.211 11.9053 37.1919C11.8862 37.1728 11.9243 37.1728 11.9053 37.1537H11.8672C11.8835 37.14 11.8958 37.1221 11.9025 37.1018C11.9092 37.0816 11.9102 37.0598 11.9053 37.0391Z"
          fill="#214063"
        />
        <path
          d="M7.60068 38.5675L7.58154 38.5483L7.60068 38.5675Z"
          fill="white"
        />
        <path
          d="M7.63876 38.5865H7.61963V38.5674L7.63876 38.5865Z"
          fill="white"
        />
        <path
          d="M9.08661 34.7852H9.12487C9.12895 34.7887 9.13221 34.7932 9.13444 34.7981C9.13667 34.8031 9.13783 34.8084 9.13783 34.8139C9.13783 34.8193 9.13667 34.8247 9.13444 34.8296C9.13221 34.8346 9.12895 34.839 9.12487 34.8426H9.06747C9.065 34.8322 9.06548 34.8213 9.06886 34.8111C9.07224 34.801 9.07839 34.792 9.08661 34.7852Z"
          fill="#214063"
        />
        <path
          d="M9.18151 34.6707V34.709H9.14325C9.12412 34.6899 9.14325 34.6516 9.18151 34.6707Z"
          fill="#214063"
        />
        <path
          d="M7.12451 35.855H7.14364V35.8741L7.12451 35.855Z"
          fill="#214063"
        />
        <path
          d="M7.29617 35.9505C7.28095 35.9505 7.26635 35.9444 7.25558 35.9337C7.24482 35.9229 7.23877 35.9083 7.23877 35.8931L7.29617 35.9505Z"
          fill="#214063"
        />
        <path
          d="M4.09588 35.6064C4.09588 35.6256 4.09588 35.6447 4.05762 35.6256H4.09588V35.6064Z"
          fill="#214063"
        />
        <path
          d="M3.60107 34.0972C3.63917 34.0972 3.69631 34.0972 3.71536 34.1354C3.73441 34.1736 3.69631 34.1354 3.67726 34.1354L3.60107 34.0972Z"
          fill="#214063"
        />
        <path
          d="M10.3814 36.2369C10.3814 36.1987 10.4195 36.2369 10.4385 36.2178L10.5147 36.256C10.5147 36.2942 10.4956 36.2942 10.4956 36.3324C10.4956 36.3706 10.4956 36.3897 10.4385 36.3706C10.3814 36.3515 10.4004 36.3515 10.3814 36.3515H10.3623C10.3814 36.3515 10.3623 36.3324 10.3433 36.3133L10.3814 36.2369Z"
          fill="#214063"
        />
        <path
          d="M3.86737 34.2507H3.8291V34.2124L3.86737 34.2507Z"
          fill="#214063"
        />
        <path
          d="M4.00125 34.1931H4.02038L3.94385 34.1548L4.00125 34.1931Z"
          fill="#214063"
        />
        <path
          d="M5.4288 35.1291H5.40967C5.40967 35.1291 5.40967 35.11 5.4288 35.1291Z"
          fill="#214063"
        />
        <path
          d="M5.79114 34.6895H5.81027C5.81027 34.6945 5.80825 34.6994 5.80467 34.703C5.80108 34.7066 5.79621 34.7086 5.79114 34.7086C5.78946 34.7057 5.78857 34.7024 5.78857 34.699C5.78857 34.6957 5.78946 34.6924 5.79114 34.6895Z"
          fill="#214063"
        />
        <path
          d="M5.90529 34.4224C5.90529 34.4224 5.94338 34.4415 5.92433 34.4606C5.90529 34.4797 5.90529 34.4988 5.88624 34.4797C5.86719 34.4606 5.86719 34.4606 5.84814 34.4606L5.90529 34.4224Z"
          fill="#214063"
        />
        <path
          d="M5.84785 34.6323C5.82871 34.6323 5.82871 34.6515 5.84785 34.6323V34.6323Z"
          fill="#214063"
        />
        <path
          d="M5.8103 35.186H5.82944C5.82944 35.2052 5.82944 35.2243 5.8103 35.2243C5.80694 35.2185 5.80518 35.2119 5.80518 35.2052C5.80518 35.1985 5.80694 35.1919 5.8103 35.186Z"
          fill="#214063"
        />
        <path
          d="M4.47665 34.8995H4.45752V34.8804L4.47665 34.8995Z"
          fill="#214063"
        />
        <path
          d="M4.59134 34.9759C4.61038 34.9759 4.62943 34.995 4.61038 35.0141C4.59134 35.0332 4.55324 35.0141 4.51515 34.995H4.47705C4.49267 34.9819 4.51151 34.9732 4.5316 34.9698C4.55169 34.9665 4.57232 34.9686 4.59134 34.9759Z"
          fill="#214063"
        />
        <path
          d="M6.00069 35.1862H5.98156C5.96242 35.1862 5.98156 35.1671 6.00069 35.1862Z"
          fill="#214063"
        />
        <path
          d="M6.05781 34.9949C6.07695 34.9949 6.07695 35.0141 6.05781 35.0332H6.03868C6.03361 35.0307 6.02975 35.0262 6.02795 35.0208C6.02616 35.0155 6.02658 35.0096 6.02911 35.0045C6.03165 34.9994 6.0361 34.9956 6.04148 34.9938C6.04686 34.992 6.05274 34.9924 6.05781 34.9949Z"
          fill="#214063"
        />
        <path
          d="M6.03915 35.1675C6.03915 35.1866 6.07742 35.1675 6.05829 35.2058C6.03915 35.2441 6.02002 35.2058 6.02002 35.1866L6.03915 35.1675Z"
          fill="#214063"
        />
        <path
          d="M4.87646 34.9952H4.91456V34.957C4.9717 34.9952 5.04789 34.9952 5.06694 35.0525L5.02885 35.0907H4.99075C4.9717 35.0716 4.93361 35.0907 4.91456 35.0525C4.91456 35.0334 4.87646 35.0143 4.87646 34.9952Z"
          fill="#214063"
        />
        <path
          d="M4.95266 35.2818C4.93362 35.3391 4.89552 35.3009 4.87647 35.2818H4.83838C4.85486 35.2694 4.87492 35.2627 4.89552 35.2627C4.91613 35.2627 4.93618 35.2694 4.95266 35.2818Z"
          fill="#214063"
        />
        <path
          d="M4.91513 35.2818L4.896 35.301V35.2627V35.2818H4.91513Z"
          fill="white"
        />
        <path
          d="M8.28667 36.4469C8.22952 36.466 8.17238 36.4278 8.11524 36.3896H8.09619C8.13012 36.3806 8.16587 36.3812 8.19948 36.3914C8.23309 36.4015 8.26326 36.4207 8.28667 36.4469Z"
          fill="#214063"
        />
        <path
          d="M5.16279 35.4156V35.4538H5.14374L5.06755 35.4156C5.0485 35.4156 5.06755 35.4156 5.06755 35.3965H5.14374L5.16279 35.4156Z"
          fill="#214063"
        />
        <path
          d="M5.21924 35.5108C5.23829 35.4917 5.27638 35.5108 5.31448 35.5299C5.31953 35.5299 5.32437 35.532 5.32795 35.5355C5.33152 35.5391 5.33352 35.544 5.33352 35.549C5.33352 35.5541 5.33152 35.559 5.32795 35.5626C5.32437 35.5661 5.31953 35.5681 5.31448 35.5681H5.21924V35.5108Z"
          fill="#214063"
        />
        <path
          d="M5.31448 36.4472H5.23829C5.23829 36.4281 5.21924 36.4472 5.21924 36.4281C5.21924 36.409 5.27638 36.409 5.31448 36.4472Z"
          fill="#214063"
        />
        <path
          d="M6.43853 33.6771C6.43853 33.7153 6.40043 33.6962 6.38138 33.6962C6.36234 33.6962 6.30519 33.6197 6.2671 33.6197L6.229 33.5815C6.28615 33.6197 6.40043 33.5815 6.43853 33.6771Z"
          fill="#214063"
        />
        <path
          d="M6.19092 36.103H6.21005C6.21005 36.1222 6.21005 36.1413 6.19092 36.1413V36.103Z"
          fill="#214063"
        />
        <path
          d="M6.59082 36.2178H6.64797L6.68606 36.256C6.68606 36.2751 6.66702 36.2751 6.64797 36.2942C6.62892 36.3133 6.62892 36.256 6.59082 36.2751H6.60987L6.57178 36.2369L6.59082 36.2178Z"
          fill="#214063"
        />
        <path
          d="M6.57254 34.2886H6.5534V34.3269L6.51514 34.2886H6.57254Z"
          fill="#214063"
        />
        <path
          d="M6.57236 34.2886H6.59149V34.3269H6.55322L6.57236 34.2886Z"
          fill="#214063"
        />
        <path
          d="M6.64795 35.5298C6.68604 35.5489 6.74319 35.5107 6.78128 35.568C6.78128 35.5781 6.77727 35.5878 6.77012 35.595C6.76298 35.6022 6.75329 35.6062 6.74319 35.6062L6.64795 35.5298Z"
          fill="#214063"
        />
        <path
          d="M6.85742 36.4277L6.91482 36.466H6.85742V36.4277Z"
          fill="#214063"
        />
        <path
          d="M6.93426 34.9761C6.94441 34.9761 6.95414 34.9801 6.96132 34.9873C6.9685 34.9945 6.97253 35.0042 6.97253 35.0144H6.9534C6.93426 35.0144 6.896 34.9952 6.896 34.9761H6.93426Z"
          fill="#214063"
        />
        <path
          d="M6.896 36.5616C6.91513 36.5425 6.896 36.5425 6.896 36.5425V36.5616Z"
          fill="#214063"
        />
        <path
          d="M7.1819 34.0591H7.22017C7.22017 34.0782 7.22017 34.1165 7.20103 34.0974C7.1819 34.0782 7.14363 34.0591 7.1819 34.0591Z"
          fill="#214063"
        />
        <path
          d="M7.14355 34.4795H7.1626C7.2007 34.4795 7.25784 34.4795 7.27689 34.5368V34.575H7.2007L7.14355 34.4986V34.4795Z"
          fill="#214063"
        />
        <path
          d="M7.0293 35.2625C7.04834 35.2816 7.04834 35.2816 7.06739 35.2625C7.08644 35.2434 7.06739 35.2434 7.04834 35.2243C7.0293 35.2052 7.12453 35.2243 7.12453 35.2625C7.12453 35.3007 7.10549 35.2816 7.08644 35.2816H7.0293V35.2625Z"
          fill="#214063"
        />
        <path
          d="M6.99074 37.1348C7.00979 37.1539 6.99074 37.173 6.97169 37.173C6.95265 37.173 6.9336 37.1348 6.91455 37.1539L6.99074 37.1348Z"
          fill="#214063"
        />
        <path
          d="M7.06689 35.2627C7.08603 35.2818 7.08603 35.2818 7.06689 35.2818C7.06689 35.2818 7.08603 35.2818 7.06689 35.2627Z"
          fill="white"
        />
        <path
          d="M9.37208 37.2873H9.35304C9.35304 37.2873 9.41018 37.3255 9.41018 37.2873C9.41018 37.2491 9.52446 37.3255 9.54351 37.3637H9.63875C9.63875 37.3828 9.6578 37.4019 9.63875 37.4019C9.6197 37.4019 9.52447 37.3255 9.46732 37.421H9.31494C9.33399 37.421 9.33399 37.3828 9.33399 37.3828H9.37208V37.2873Z"
          fill="#214063"
        />
        <path
          d="M7.16278 36.638C7.17293 36.638 7.18266 36.6421 7.18984 36.6492C7.19701 36.6564 7.20104 36.6662 7.20104 36.6763H7.12451C7.12451 36.6572 7.12451 36.6189 7.16278 36.638Z"
          fill="#214063"
        />
        <path
          d="M7.35254 34.7085H7.40969C7.40969 34.7085 7.42873 34.7276 7.40969 34.7276C7.39064 34.7276 7.35254 34.7276 7.3335 34.7085C7.33639 34.7102 7.33968 34.7111 7.34302 34.7111C7.34636 34.7111 7.34965 34.7102 7.35254 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.33419 36.8863C7.31505 36.8863 7.33419 36.8672 7.33419 36.8672V36.8863Z"
          fill="#214063"
        />
        <path
          d="M7.3335 36.8862H7.35263L7.3335 36.9054V36.8862Z"
          fill="white"
        />
        <path
          d="M7.67676 36.9058H7.75295V36.944C7.73391 36.9822 7.69581 36.9631 7.67676 36.9631H7.65771L7.67676 36.9058Z"
          fill="#214063"
        />
        <path
          d="M7.58155 37.5551H7.5625C7.6006 37.5551 7.63869 37.536 7.67679 37.5742H7.58155V37.5551Z"
          fill="#214063"
        />
        <path
          d="M7.73393 34.7085H7.81012C7.82916 34.7085 7.84821 34.7276 7.82916 34.7467L7.79107 34.7849H7.75297C7.77202 34.7467 7.71488 34.7658 7.73393 34.7276C7.73393 34.7276 7.75297 34.7085 7.73393 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.73356 37.1346H7.75261C7.75261 37.1537 7.8288 37.1346 7.8288 37.1728C7.8288 37.211 7.79071 37.211 7.77166 37.2301C7.75261 37.2492 7.75261 37.211 7.73356 37.211V37.1728C7.73356 37.1537 7.71452 37.1155 7.73356 37.1346Z"
          fill="#214063"
        />
        <path
          d="M7.7152 35.3007H7.67694C7.65781 35.3198 7.69607 35.3007 7.69607 35.3198C7.69607 35.2815 7.67694 35.3007 7.65781 35.3007H7.63867C7.67694 35.2624 7.7152 35.2624 7.7152 35.3007Z"
          fill="#214063"
        />
        <path
          d="M8.64844 35.8165H8.66757C8.6867 35.8165 8.66757 35.7974 8.66757 35.7974H8.70584V35.8357H8.64844V35.8165Z"
          fill="#214063"
        />
        <path
          d="M9.01004 37.0776C9.01411 37.0812 9.01737 37.0856 9.0196 37.0906C9.02184 37.0955 9.02299 37.1009 9.02299 37.1064C9.02299 37.1118 9.02184 37.1172 9.0196 37.1221C9.01737 37.1271 9.01411 37.1315 9.01004 37.1351H8.97177C8.97177 37.1351 8.9909 37.1159 8.95264 37.1159H9.01004V37.0776Z"
          fill="#214063"
        />
        <path
          d="M8.87695 36.2179C8.89207 36.216 8.90743 36.2185 8.92107 36.2254C8.9347 36.2322 8.94599 36.2429 8.95349 36.2562H8.87695V36.2179Z"
          fill="#214063"
        />
        <path
          d="M8.91522 36.2372V36.2754H8.87695C8.89609 36.2563 8.87695 36.218 8.91522 36.2372Z"
          fill="white"
        />
        <path
          d="M8.80029 37.1538C8.81943 37.1538 8.80029 37.1538 8.80029 37.173V37.1538Z"
          fill="#214063"
        />
        <path
          d="M10.8008 38.0134C10.8198 37.9943 10.7817 38.0134 10.7627 37.9943C10.7817 37.9752 10.8198 38.0134 10.8389 37.9752H10.9913C10.9722 37.9561 11.0294 37.9943 11.0294 37.9561L11.0675 37.9943C11.0965 38.0189 11.1167 38.0525 11.1246 38.0898L11.0865 38.128C11.0865 38.1471 11.0675 38.1471 11.0865 38.1471H11.0484C11.0484 38.1662 11.0294 38.1853 11.0103 38.1662H10.8389C10.8389 38.1662 10.877 38.1471 10.8579 38.128H10.7817C10.8198 38.1089 10.8008 38.0898 10.7817 38.0707H10.7437C10.7627 38.0516 10.7817 38.0516 10.8008 38.0134Z"
          fill="#214063"
        />
        <path
          d="M9.23877 36.313H9.27704C9.29617 36.3513 9.2579 36.3321 9.23877 36.3321V36.313Z"
          fill="#214063"
        />
        <path
          d="M9.48587 36.4278C9.50492 36.4469 9.52396 36.466 9.50492 36.4851C9.48587 36.5042 9.50492 36.5042 9.50492 36.5042C9.5104 36.5062 9.51537 36.5093 9.51945 36.5135C9.52353 36.5176 9.52661 36.5227 9.52845 36.5282C9.53029 36.5337 9.53084 36.5396 9.53006 36.5454C9.52928 36.5512 9.5272 36.5567 9.52396 36.5615C9.44777 36.5806 9.40968 36.5042 9.37158 36.4851C9.38432 36.4667 9.40147 36.4519 9.42143 36.4419C9.4414 36.4318 9.46356 36.427 9.48587 36.4278Z"
          fill="#214063"
        />
        <path
          d="M12.4199 37.3065H12.4009C12.4199 37.3065 12.439 37.3065 12.439 37.2874H12.5342C12.5723 37.2683 12.5914 37.3065 12.6104 37.3256H12.6295V37.402H12.5723L12.6104 37.4785C12.6104 37.5167 12.5723 37.5167 12.5533 37.5358H12.4961C12.5152 37.4976 12.458 37.4976 12.439 37.4976H12.4199C12.439 37.4785 12.458 37.4976 12.458 37.4785C12.458 37.4785 12.439 37.4785 12.458 37.4594H12.3818C12.4009 37.3256 12.439 37.3256 12.4199 37.3065Z"
          fill="#214063"
        />
        <path
          d="M9.98145 37.5546C10.0005 37.5355 10.0386 37.4973 10.0767 37.5164L10.1529 37.5546C10.1529 37.5928 10.1148 37.6119 10.0957 37.6502H10.0195L9.9624 37.6119C9.98145 37.5928 9.98145 37.5737 9.98145 37.5546Z"
          fill="#214063"
        />
        <path
          d="M9.71493 36.7527C9.71493 36.7335 9.71493 36.7144 9.6958 36.7335L9.71493 36.7527Z"
          fill="#214063"
        />
        <path
          d="M9.86719 36.8096C9.84814 36.8096 9.88624 36.7905 9.86719 36.7905C9.84814 36.7905 9.92434 36.8478 9.98148 36.8096C10.0386 36.7714 10.0386 36.8478 10.0386 36.886L9.98148 36.9242H9.92433C9.94338 36.9242 9.92433 36.9051 9.92433 36.9051H9.90529C9.92433 36.886 9.88624 36.9051 9.88624 36.886C9.88624 36.8478 9.84814 36.8669 9.84814 36.8287C9.84814 36.8096 9.84814 36.8096 9.86719 36.8096Z"
          fill="#214063"
        />
        <path
          d="M10.9147 37.1346C10.9147 37.1346 10.9528 37.1346 10.9337 37.1155H10.9528C10.9909 37.1346 10.9909 37.0773 11.029 37.1155C11.0671 37.1537 11.0671 37.1537 11.0861 37.1346C11.0945 37.1491 11.0989 37.1656 11.0989 37.1824C11.0989 37.1991 11.0945 37.2156 11.0861 37.2301H11.029C11.0099 37.1919 10.9909 37.2492 10.9909 37.211H10.9147C10.8956 37.1537 10.9337 37.1537 10.9147 37.1346Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.0704C11.4482 38.0653 11.4503 38.0605 11.4538 38.0569C11.4574 38.0533 11.4623 38.0513 11.4674 38.0513L11.5248 38.0896V38.1278H11.4674L11.4482 38.0704Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.1085V38.0894L11.4674 38.1085H11.4482Z"
          fill="white"
        />
        <path
          d="M11.3343 39.0258C11.3535 39.045 11.3726 39.0641 11.3535 39.0833H11.2961C11.2769 39.0641 11.2961 39.0067 11.3343 39.0258Z"
          fill="#214063"
        />
        <path
          d="M12.0768 37.8034V37.7651C12.0959 37.7651 12.1342 37.7651 12.1342 37.7843C12.1342 37.8034 12.1342 37.8226 12.115 37.8226H12.0959C12.0768 37.8034 12.0576 37.7843 12.0768 37.7843V37.8034Z"
          fill="#214063"
        />
        <path
          d="M11.6198 38.3384H11.6581C11.6581 38.3384 11.6772 38.3575 11.6581 38.3575H11.6198C11.6198 38.3575 11.6007 38.3575 11.6198 38.3384Z"
          fill="#214063"
        />
        <path
          d="M11.6388 38.3571H11.6196C11.6196 38.338 11.6388 38.3571 11.6388 38.3571Z"
          fill="white"
        />
        <path
          d="M12.0005 38.7202H12.0386C12.0767 38.7393 12.1529 38.7202 12.1719 38.7966V38.8539C12.1529 38.8921 12.1148 38.873 12.0957 38.8921H12.0767C12.0767 38.8871 12.0747 38.8822 12.0711 38.8786C12.0675 38.875 12.0627 38.873 12.0576 38.873H12.0005C12.0014 38.8627 12.0001 38.8523 11.9969 38.8424C11.9936 38.8326 11.9883 38.8235 11.9815 38.8157H11.9624C11.9624 38.7202 12.0005 38.7393 12.0005 38.7202Z"
          fill="#214063"
        />
        <path
          d="M12.229 38.1278H12.2862C12.3052 38.1278 12.2862 38.1087 12.2862 38.1087H12.3243C12.3623 38.0705 12.3814 38.1278 12.4004 38.1087H12.4385C12.4509 38.1252 12.4576 38.1453 12.4576 38.166H12.4766V38.2042C12.4576 38.2042 12.5147 38.2233 12.4766 38.2233C12.4385 38.2233 12.4766 38.2424 12.4766 38.2615H12.4576C12.4766 38.2997 12.4195 38.2997 12.4195 38.3188H12.3623C12.3433 38.3379 12.3243 38.2806 12.2862 38.3188C12.2481 38.357 12.2862 38.2615 12.2481 38.2806H12.229C12.229 38.2615 12.2671 38.2615 12.2481 38.2424C12.229 38.2233 12.229 38.2615 12.21 38.2615C12.1909 38.2615 12.2671 38.2233 12.229 38.2042H12.1909C12.21 38.2042 12.229 38.2042 12.21 38.1851H12.1909C12.21 38.166 12.21 38.1278 12.229 38.1278Z"
          fill="#214063"
        />
        <path
          d="M12.877 38.7967L12.9151 38.7394C12.9341 38.7585 12.9341 38.7012 12.9722 38.7203H13.0103C13.0293 38.7394 13.0674 38.7203 13.1055 38.7585C13.1436 38.7967 13.1055 38.7967 13.1246 38.7967C13.1246 38.8158 13.1436 38.8349 13.1246 38.854L13.0865 38.9113C13.0865 38.9113 13.0484 38.9113 13.0484 38.9304C13.0484 38.9495 13.0293 38.9495 13.0103 38.9495H12.9532C12.9532 38.9304 12.9341 38.9495 12.9151 38.9495H12.8579V38.9113H12.8198C12.877 38.8349 12.8579 38.8158 12.877 38.7967Z"
          fill="#214063"
        />
        <path
          d="M12.8962 37.6314C12.877 37.6506 12.8579 37.6314 12.8579 37.6123L12.8962 37.6314Z"
          fill="#214063"
        />
        <path
          d="M13.124 38.5288C13.1432 38.5288 13.1623 38.5288 13.1623 38.548H13.124C13.124 38.5288 13.1432 38.5288 13.124 38.5288Z"
          fill="#214063"
        />
        <path
          d="M13.3335 37.9371V37.8989H13.4097C13.4287 37.9371 13.4478 37.9371 13.4287 37.9753C13.4097 38.0135 13.4097 37.9944 13.4287 38.0135C13.4478 38.0326 13.3906 37.9944 13.4097 38.0326H13.3335V37.9371Z"
          fill="#214063"
        />
        <path
          d="M13.3906 38.0704C13.3906 38.0513 13.4287 38.0704 13.4287 38.0513H13.5049C13.543 38.0513 13.543 38.0895 13.5621 38.0895C13.5811 38.0895 13.543 38.1277 13.5811 38.1468C13.6192 38.1659 13.5811 38.2041 13.524 38.2232H13.4859C13.4668 38.2614 13.4478 38.2232 13.4287 38.2423H13.3906C13.3716 38.2232 13.3906 38.2041 13.3716 38.2041C13.3716 38.199 13.3736 38.1942 13.3772 38.1906C13.3807 38.187 13.3856 38.185 13.3906 38.185C13.3525 38.1086 13.4097 38.0895 13.3906 38.0704Z"
          fill="#214063"
        />
        <path
          d="M13.7339 38.3953C13.7529 38.3762 13.7339 38.3762 13.7339 38.3762C13.7339 38.3762 13.7529 38.3953 13.7529 38.3762H13.8101C13.8291 38.3762 13.8101 38.338 13.8291 38.3571L13.8672 38.2998H13.9244L13.9625 38.338C13.9434 38.3571 13.9625 38.3571 13.9625 38.3762C13.9625 38.3953 13.9625 38.338 13.9815 38.338C14.0006 38.338 13.9625 38.3762 14.0006 38.3953H14.0767C14.0577 38.3953 14.0577 38.4144 14.0767 38.4335C14.1148 38.4335 14.0767 38.4717 14.0958 38.4717C14.1148 38.4717 14.0958 38.5099 14.1148 38.5099H14.0767V38.5481C14.0767 38.5481 14.0386 38.5672 14.0577 38.5863C14.0386 38.5863 14.0577 38.6054 14.0577 38.6054C14.0577 38.6054 14.0386 38.5672 14.0196 38.6054C13.9815 38.6054 14.0006 38.6818 13.9434 38.6818V38.6436C13.9244 38.6436 13.9244 38.6818 13.8863 38.6627C13.8482 38.6436 13.8672 38.6245 13.8482 38.6245H13.8291C13.8101 38.6245 13.8482 38.6054 13.8291 38.5863H13.8101V38.5481H13.791C13.791 38.529 13.8101 38.529 13.791 38.5099H13.772C13.772 38.5049 13.774 38.5 13.7776 38.4964C13.7811 38.4928 13.786 38.4908 13.791 38.4908H13.772C13.7529 38.4908 13.791 38.4717 13.772 38.4526L13.7339 38.3953Z"
          fill="#214063"
        />
        <path
          d="M11.6768 37.001C11.6958 37.0201 11.7339 37.001 11.7339 37.0392C11.7339 37.0774 11.6958 37.0965 11.6768 37.0774H11.6387V37.0392C11.6437 37.0442 11.6506 37.0471 11.6577 37.0471C11.6649 37.0471 11.6717 37.0442 11.6768 37.0392C11.6818 37.0341 11.6847 37.0272 11.6847 37.0201C11.6847 37.0129 11.6818 37.006 11.6768 37.001Z"
          fill="#214063"
        />
        <path
          d="M11.8483 37.0773H11.8101V37.0581L11.8483 37.0773Z"
          fill="#214063"
        />
        <path
          d="M11.9053 37.0391H12.0386C12.0577 37.0582 12.0577 37.0964 12.0958 37.0964C12.1339 37.0964 12.0767 37.0964 12.0958 37.1155V37.1728L12.0577 37.2301C12.0526 37.2301 12.0478 37.2321 12.0442 37.2357C12.0406 37.2393 12.0386 37.2441 12.0386 37.2492C12.0196 37.2492 12.0196 37.2683 12.0196 37.2874V37.2492H11.9624C11.9434 37.211 11.9053 37.2492 11.8862 37.2492C11.8672 37.2492 11.9243 37.211 11.9053 37.1919C11.8862 37.1728 11.9243 37.1728 11.9053 37.1537H11.8672C11.8835 37.14 11.8958 37.1221 11.9025 37.1018C11.9092 37.0816 11.9102 37.0598 11.9053 37.0391Z"
          fill="#214063"
        />
        <path
          d="M7.60068 38.5675L7.58154 38.5483L7.60068 38.5675Z"
          fill="white"
        />
        <path
          d="M7.63876 38.5865H7.61963V38.5674L7.63876 38.5865Z"
          fill="white"
        />
        <path
          d="M9.08661 34.7852H9.12487C9.12895 34.7887 9.13221 34.7932 9.13444 34.7981C9.13667 34.8031 9.13783 34.8084 9.13783 34.8139C9.13783 34.8193 9.13667 34.8247 9.13444 34.8296C9.13221 34.8346 9.12895 34.839 9.12487 34.8426H9.06747C9.065 34.8322 9.06548 34.8213 9.06886 34.8111C9.07224 34.801 9.07839 34.792 9.08661 34.7852Z"
          fill="#214063"
        />
        <path
          d="M9.18151 34.6707V34.709H9.14325C9.12412 34.6899 9.14325 34.6516 9.18151 34.6707Z"
          fill="#214063"
        />
        <path
          d="M7.12451 35.855H7.14364V35.8741L7.12451 35.855Z"
          fill="#214063"
        />
        <path
          d="M7.29617 35.9505C7.28095 35.9505 7.26635 35.9444 7.25558 35.9337C7.24482 35.9229 7.23877 35.9083 7.23877 35.8931L7.29617 35.9505Z"
          fill="#214063"
        />
        <path
          d="M4.09588 35.6064C4.09588 35.6256 4.09588 35.6447 4.05762 35.6256H4.09588V35.6064Z"
          fill="#214063"
        />
        <path
          d="M3.60107 34.0972C3.63917 34.0972 3.69631 34.0972 3.71536 34.1354C3.73441 34.1736 3.69631 34.1354 3.67726 34.1354L3.60107 34.0972Z"
          fill="#214063"
        />
        <path
          d="M10.3814 36.2369C10.3814 36.1987 10.4195 36.2369 10.4385 36.2178L10.5147 36.256C10.5147 36.2942 10.4956 36.2942 10.4956 36.3324C10.4956 36.3706 10.4956 36.3897 10.4385 36.3706C10.3814 36.3515 10.4004 36.3515 10.3814 36.3515H10.3623C10.3814 36.3515 10.3623 36.3324 10.3433 36.3133L10.3814 36.2369Z"
          fill="#214063"
        />
        <path
          d="M3.86737 34.2507H3.8291V34.2124L3.86737 34.2507Z"
          fill="#214063"
        />
        <path
          d="M4.00125 34.1931H4.02038L3.94385 34.1548L4.00125 34.1931Z"
          fill="#214063"
        />
        <path
          d="M5.4288 35.1291H5.40967C5.40967 35.1291 5.40967 35.11 5.4288 35.1291Z"
          fill="#214063"
        />
        <path
          d="M5.79114 34.6895H5.81027C5.81027 34.6945 5.80825 34.6994 5.80467 34.703C5.80108 34.7066 5.79621 34.7086 5.79114 34.7086C5.78946 34.7057 5.78857 34.7024 5.78857 34.699C5.78857 34.6957 5.78946 34.6924 5.79114 34.6895Z"
          fill="#214063"
        />
        <path
          d="M5.90529 34.4224C5.90529 34.4224 5.94338 34.4415 5.92433 34.4606C5.90529 34.4797 5.90529 34.4988 5.88624 34.4797C5.86719 34.4606 5.86719 34.4606 5.84814 34.4606L5.90529 34.4224Z"
          fill="#214063"
        />
        <path
          d="M5.84785 34.6323C5.82871 34.6323 5.82871 34.6515 5.84785 34.6323V34.6323Z"
          fill="#214063"
        />
        <path
          d="M5.8103 35.186H5.82944C5.82944 35.2052 5.82944 35.2243 5.8103 35.2243C5.80694 35.2185 5.80518 35.2119 5.80518 35.2052C5.80518 35.1985 5.80694 35.1919 5.8103 35.186Z"
          fill="#214063"
        />
        <path
          d="M4.47665 34.8995H4.45752V34.8804L4.47665 34.8995Z"
          fill="#214063"
        />
        <path
          d="M4.59134 34.9759C4.61038 34.9759 4.62943 34.995 4.61038 35.0141C4.59134 35.0332 4.55324 35.0141 4.51515 34.995H4.47705C4.49267 34.9819 4.51151 34.9732 4.5316 34.9698C4.55169 34.9665 4.57232 34.9686 4.59134 34.9759Z"
          fill="#214063"
        />
        <path
          d="M6.00069 35.1862H5.98156C5.96242 35.1862 5.98156 35.1671 6.00069 35.1862Z"
          fill="#214063"
        />
        <path
          d="M6.05781 34.9949C6.07695 34.9949 6.07695 35.0141 6.05781 35.0332H6.03868C6.03361 35.0307 6.02975 35.0262 6.02795 35.0208C6.02616 35.0155 6.02658 35.0096 6.02911 35.0045C6.03165 34.9994 6.0361 34.9956 6.04148 34.9938C6.04686 34.992 6.05274 34.9924 6.05781 34.9949Z"
          fill="#214063"
        />
        <path
          d="M6.03915 35.1675C6.03915 35.1866 6.07742 35.1675 6.05829 35.2058C6.03915 35.2441 6.02002 35.2058 6.02002 35.1866L6.03915 35.1675Z"
          fill="#214063"
        />
        <path
          d="M4.87646 34.9952H4.91456V34.957C4.9717 34.9952 5.04789 34.9952 5.06694 35.0525L5.02885 35.0907H4.99075C4.9717 35.0716 4.93361 35.0907 4.91456 35.0525C4.91456 35.0334 4.87646 35.0143 4.87646 34.9952Z"
          fill="#214063"
        />
        <path
          d="M4.95266 35.2818C4.93362 35.3391 4.89552 35.3009 4.87647 35.2818H4.83838C4.85486 35.2694 4.87492 35.2627 4.89552 35.2627C4.91613 35.2627 4.93618 35.2694 4.95266 35.2818Z"
          fill="#214063"
        />
        <path
          d="M4.91513 35.2818L4.896 35.301V35.2627V35.2818H4.91513Z"
          fill="white"
        />
        <path
          d="M8.28667 36.4469C8.22952 36.466 8.17238 36.4278 8.11524 36.3896H8.09619C8.13012 36.3806 8.16587 36.3812 8.19948 36.3914C8.23309 36.4015 8.26326 36.4207 8.28667 36.4469Z"
          fill="#214063"
        />
        <path
          d="M5.16279 35.4156V35.4538H5.14374L5.06755 35.4156C5.0485 35.4156 5.06755 35.4156 5.06755 35.3965H5.14374L5.16279 35.4156Z"
          fill="#214063"
        />
        <path
          d="M5.21924 35.5108C5.23829 35.4917 5.27638 35.5108 5.31448 35.5299C5.31953 35.5299 5.32437 35.532 5.32795 35.5355C5.33152 35.5391 5.33352 35.544 5.33352 35.549C5.33352 35.5541 5.33152 35.559 5.32795 35.5626C5.32437 35.5661 5.31953 35.5681 5.31448 35.5681H5.21924V35.5108Z"
          fill="#214063"
        />
        <path
          d="M5.31448 36.4472H5.23829C5.23829 36.4281 5.21924 36.4472 5.21924 36.4281C5.21924 36.409 5.27638 36.409 5.31448 36.4472Z"
          fill="#214063"
        />
        <path
          d="M6.43853 33.6771C6.43853 33.7153 6.40043 33.6962 6.38138 33.6962C6.36234 33.6962 6.30519 33.6197 6.2671 33.6197L6.229 33.5815C6.28615 33.6197 6.40043 33.5815 6.43853 33.6771Z"
          fill="#214063"
        />
        <path
          d="M6.19092 36.103H6.21005C6.21005 36.1222 6.21005 36.1413 6.19092 36.1413V36.103Z"
          fill="#214063"
        />
        <path
          d="M6.59082 36.2178H6.64797L6.68606 36.256C6.68606 36.2751 6.66702 36.2751 6.64797 36.2942C6.62892 36.3133 6.62892 36.256 6.59082 36.2751H6.60987L6.57178 36.2369L6.59082 36.2178Z"
          fill="#214063"
        />
        <path
          d="M6.57254 34.2886H6.5534V34.3269L6.51514 34.2886H6.57254Z"
          fill="#214063"
        />
        <path
          d="M6.57236 34.2886H6.59149V34.3269H6.55322L6.57236 34.2886Z"
          fill="#214063"
        />
        <path
          d="M6.64795 35.5298C6.68604 35.5489 6.74319 35.5107 6.78128 35.568C6.78128 35.5781 6.77727 35.5878 6.77012 35.595C6.76298 35.6022 6.75329 35.6062 6.74319 35.6062L6.64795 35.5298Z"
          fill="#214063"
        />
        <path
          d="M6.85742 36.4277L6.91482 36.466H6.85742V36.4277Z"
          fill="#214063"
        />
        <path
          d="M6.93426 34.9761C6.94441 34.9761 6.95414 34.9801 6.96132 34.9873C6.9685 34.9945 6.97253 35.0042 6.97253 35.0144H6.9534C6.93426 35.0144 6.896 34.9952 6.896 34.9761H6.93426Z"
          fill="#214063"
        />
        <path
          d="M6.896 36.5616C6.91513 36.5425 6.896 36.5425 6.896 36.5425V36.5616Z"
          fill="#214063"
        />
        <path
          d="M7.1819 34.0591H7.22017C7.22017 34.0782 7.22017 34.1165 7.20103 34.0974C7.1819 34.0782 7.14363 34.0591 7.1819 34.0591Z"
          fill="#214063"
        />
        <path
          d="M7.14355 34.4795H7.1626C7.2007 34.4795 7.25784 34.4795 7.27689 34.5368V34.575H7.2007L7.14355 34.4986V34.4795Z"
          fill="#214063"
        />
        <path
          d="M7.0293 35.2625C7.04834 35.2816 7.04834 35.2816 7.06739 35.2625C7.08644 35.2434 7.06739 35.2434 7.04834 35.2243C7.0293 35.2052 7.12453 35.2243 7.12453 35.2625C7.12453 35.3007 7.10549 35.2816 7.08644 35.2816H7.0293V35.2625Z"
          fill="#214063"
        />
        <path
          d="M6.99074 37.1348C7.00979 37.1539 6.99074 37.173 6.97169 37.173C6.95265 37.173 6.9336 37.1348 6.91455 37.1539L6.99074 37.1348Z"
          fill="#214063"
        />
        <path
          d="M7.06689 35.2627C7.08603 35.2818 7.08603 35.2818 7.06689 35.2818C7.06689 35.2818 7.08603 35.2818 7.06689 35.2627Z"
          fill="white"
        />
        <path
          d="M9.37208 37.2873H9.35304C9.35304 37.2873 9.41018 37.3255 9.41018 37.2873C9.41018 37.2491 9.52446 37.3255 9.54351 37.3637H9.63875C9.63875 37.3828 9.6578 37.4019 9.63875 37.4019C9.6197 37.4019 9.52447 37.3255 9.46732 37.421H9.31494C9.33399 37.421 9.33399 37.3828 9.33399 37.3828H9.37208V37.2873Z"
          fill="#214063"
        />
        <path
          d="M7.16278 36.638C7.17293 36.638 7.18266 36.6421 7.18984 36.6492C7.19701 36.6564 7.20104 36.6662 7.20104 36.6763H7.12451C7.12451 36.6572 7.12451 36.6189 7.16278 36.638Z"
          fill="#214063"
        />
        <path
          d="M7.35254 34.7085H7.40969C7.40969 34.7085 7.42873 34.7276 7.40969 34.7276C7.39064 34.7276 7.35254 34.7276 7.3335 34.7085C7.33639 34.7102 7.33968 34.7111 7.34302 34.7111C7.34636 34.7111 7.34965 34.7102 7.35254 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.33419 36.8863C7.31505 36.8863 7.33419 36.8672 7.33419 36.8672V36.8863Z"
          fill="#214063"
        />
        <path
          d="M7.3335 36.8862H7.35263L7.3335 36.9054V36.8862Z"
          fill="white"
        />
        <path
          d="M7.67676 36.9058H7.75295V36.944C7.73391 36.9822 7.69581 36.9631 7.67676 36.9631H7.65771L7.67676 36.9058Z"
          fill="#214063"
        />
        <path
          d="M7.58155 37.5551H7.5625C7.6006 37.5551 7.63869 37.536 7.67679 37.5742H7.58155V37.5551Z"
          fill="#214063"
        />
        <path
          d="M7.73393 34.7085H7.81012C7.82916 34.7085 7.84821 34.7276 7.82916 34.7467L7.79107 34.7849H7.75297C7.77202 34.7467 7.71488 34.7658 7.73393 34.7276C7.73393 34.7276 7.75297 34.7085 7.73393 34.7085Z"
          fill="#214063"
        />
        <path
          d="M7.73356 37.1346H7.75261C7.75261 37.1537 7.8288 37.1346 7.8288 37.1728C7.8288 37.211 7.79071 37.211 7.77166 37.2301C7.75261 37.2492 7.75261 37.211 7.73356 37.211V37.1728C7.73356 37.1537 7.71452 37.1155 7.73356 37.1346Z"
          fill="#214063"
        />
        <path
          d="M7.7152 35.3007H7.67694C7.65781 35.3198 7.69607 35.3007 7.69607 35.3198C7.69607 35.2815 7.67694 35.3007 7.65781 35.3007H7.63867C7.67694 35.2624 7.7152 35.2624 7.7152 35.3007Z"
          fill="#214063"
        />
        <path
          d="M8.64844 35.8165H8.66757C8.6867 35.8165 8.66757 35.7974 8.66757 35.7974H8.70584V35.8357H8.64844V35.8165Z"
          fill="#214063"
        />
        <path
          d="M9.01004 37.0776C9.01411 37.0812 9.01737 37.0856 9.0196 37.0906C9.02184 37.0955 9.02299 37.1009 9.02299 37.1064C9.02299 37.1118 9.02184 37.1172 9.0196 37.1221C9.01737 37.1271 9.01411 37.1315 9.01004 37.1351H8.97177C8.97177 37.1351 8.9909 37.1159 8.95264 37.1159H9.01004V37.0776Z"
          fill="#214063"
        />
        <path
          d="M8.87695 36.2179C8.89207 36.216 8.90743 36.2185 8.92107 36.2254C8.9347 36.2322 8.94599 36.2429 8.95349 36.2562H8.87695V36.2179Z"
          fill="#214063"
        />
        <path
          d="M8.91522 36.2372V36.2754H8.87695C8.89609 36.2563 8.87695 36.218 8.91522 36.2372Z"
          fill="white"
        />
        <path
          d="M8.80029 37.1538C8.81943 37.1538 8.80029 37.1538 8.80029 37.173V37.1538Z"
          fill="#214063"
        />
        <path
          d="M10.8008 38.0134C10.8198 37.9943 10.7817 38.0134 10.7627 37.9943C10.7817 37.9752 10.8198 38.0134 10.8389 37.9752H10.9913C10.9722 37.9561 11.0294 37.9943 11.0294 37.9561L11.0675 37.9943C11.0965 38.0189 11.1167 38.0525 11.1246 38.0898L11.0865 38.128C11.0865 38.1471 11.0675 38.1471 11.0865 38.1471H11.0484C11.0484 38.1662 11.0294 38.1853 11.0103 38.1662H10.8389C10.8389 38.1662 10.877 38.1471 10.8579 38.128H10.7817C10.8198 38.1089 10.8008 38.0898 10.7817 38.0707H10.7437C10.7627 38.0516 10.7817 38.0516 10.8008 38.0134Z"
          fill="#214063"
        />
        <path
          d="M9.23877 36.313H9.27704C9.29617 36.3513 9.2579 36.3321 9.23877 36.3321V36.313Z"
          fill="#214063"
        />
        <path
          d="M9.48587 36.4278C9.50492 36.4469 9.52396 36.466 9.50492 36.4851C9.48587 36.5042 9.50492 36.5042 9.50492 36.5042C9.5104 36.5062 9.51537 36.5093 9.51945 36.5135C9.52353 36.5176 9.52661 36.5227 9.52845 36.5282C9.53029 36.5337 9.53084 36.5396 9.53006 36.5454C9.52928 36.5512 9.5272 36.5567 9.52396 36.5615C9.44777 36.5806 9.40968 36.5042 9.37158 36.4851C9.38432 36.4667 9.40147 36.4519 9.42143 36.4419C9.4414 36.4318 9.46356 36.427 9.48587 36.4278Z"
          fill="#214063"
        />
        <path
          d="M12.4199 37.3065H12.4009C12.4199 37.3065 12.439 37.3065 12.439 37.2874H12.5342C12.5723 37.2683 12.5914 37.3065 12.6104 37.3256H12.6295V37.402H12.5723L12.6104 37.4785C12.6104 37.5167 12.5723 37.5167 12.5533 37.5358H12.4961C12.5152 37.4976 12.458 37.4976 12.439 37.4976H12.4199C12.439 37.4785 12.458 37.4976 12.458 37.4785C12.458 37.4785 12.439 37.4785 12.458 37.4594H12.3818C12.4009 37.3256 12.439 37.3256 12.4199 37.3065Z"
          fill="#214063"
        />
        <path
          d="M9.98145 37.5546C10.0005 37.5355 10.0386 37.4973 10.0767 37.5164L10.1529 37.5546C10.1529 37.5928 10.1148 37.6119 10.0957 37.6502H10.0195L9.9624 37.6119C9.98145 37.5928 9.98145 37.5737 9.98145 37.5546Z"
          fill="#214063"
        />
        <path
          d="M9.71493 36.7527C9.71493 36.7335 9.71493 36.7144 9.6958 36.7335L9.71493 36.7527Z"
          fill="#214063"
        />
        <path
          d="M9.86719 36.8096C9.84814 36.8096 9.88624 36.7905 9.86719 36.7905C9.84814 36.7905 9.92434 36.8478 9.98148 36.8096C10.0386 36.7714 10.0386 36.8478 10.0386 36.886L9.98148 36.9242H9.92433C9.94338 36.9242 9.92433 36.9051 9.92433 36.9051H9.90529C9.92433 36.886 9.88624 36.9051 9.88624 36.886C9.88624 36.8478 9.84814 36.8669 9.84814 36.8287C9.84814 36.8096 9.84814 36.8096 9.86719 36.8096Z"
          fill="#214063"
        />
        <path
          d="M10.9147 37.1346C10.9147 37.1346 10.9528 37.1346 10.9337 37.1155H10.9528C10.9909 37.1346 10.9909 37.0773 11.029 37.1155C11.0671 37.1537 11.0671 37.1537 11.0861 37.1346C11.0945 37.1491 11.0989 37.1656 11.0989 37.1824C11.0989 37.1991 11.0945 37.2156 11.0861 37.2301H11.029C11.0099 37.1919 10.9909 37.2492 10.9909 37.211H10.9147C10.8956 37.1537 10.9337 37.1537 10.9147 37.1346Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.0704C11.4482 38.0653 11.4503 38.0605 11.4538 38.0569C11.4574 38.0533 11.4623 38.0513 11.4674 38.0513L11.5248 38.0896V38.1278H11.4674L11.4482 38.0704Z"
          fill="#214063"
        />
        <path
          d="M11.4482 38.1085V38.0894L11.4674 38.1085H11.4482Z"
          fill="white"
        />
        <path
          d="M11.3343 39.0258C11.3535 39.045 11.3726 39.0641 11.3535 39.0833H11.2961C11.2769 39.0641 11.2961 39.0067 11.3343 39.0258Z"
          fill="#214063"
        />
        <path
          d="M12.0768 37.8034V37.7651C12.0959 37.7651 12.1342 37.7651 12.1342 37.7843C12.1342 37.8034 12.1342 37.8226 12.115 37.8226H12.0959C12.0768 37.8034 12.0576 37.7843 12.0768 37.7843V37.8034Z"
          fill="#214063"
        />
        <path
          d="M11.6198 38.3384H11.6581C11.6581 38.3384 11.6772 38.3575 11.6581 38.3575H11.6198C11.6198 38.3575 11.6007 38.3575 11.6198 38.3384Z"
          fill="#214063"
        />
        <path
          d="M11.6388 38.3571H11.6196C11.6196 38.338 11.6388 38.3571 11.6388 38.3571Z"
          fill="white"
        />
        <path
          d="M12.0005 38.7202H12.0386C12.0767 38.7393 12.1529 38.7202 12.1719 38.7966V38.8539C12.1529 38.8921 12.1148 38.873 12.0957 38.8921H12.0767C12.0767 38.8871 12.0747 38.8822 12.0711 38.8786C12.0675 38.875 12.0627 38.873 12.0576 38.873H12.0005C12.0014 38.8627 12.0001 38.8523 11.9969 38.8424C11.9936 38.8326 11.9883 38.8235 11.9815 38.8157H11.9624C11.9624 38.7202 12.0005 38.7393 12.0005 38.7202Z"
          fill="#214063"
        />
        <path
          d="M12.229 38.1278H12.2862C12.3052 38.1278 12.2862 38.1087 12.2862 38.1087H12.3243C12.3623 38.0705 12.3814 38.1278 12.4004 38.1087H12.4385C12.4509 38.1252 12.4576 38.1453 12.4576 38.166H12.4766V38.2042C12.4576 38.2042 12.5147 38.2233 12.4766 38.2233C12.4385 38.2233 12.4766 38.2424 12.4766 38.2615H12.4576C12.4766 38.2997 12.4195 38.2997 12.4195 38.3188H12.3623C12.3433 38.3379 12.3243 38.2806 12.2862 38.3188C12.2481 38.357 12.2862 38.2615 12.2481 38.2806H12.229C12.229 38.2615 12.2671 38.2615 12.2481 38.2424C12.229 38.2233 12.229 38.2615 12.21 38.2615C12.1909 38.2615 12.2671 38.2233 12.229 38.2042H12.1909C12.21 38.2042 12.229 38.2042 12.21 38.1851H12.1909C12.21 38.166 12.21 38.1278 12.229 38.1278Z"
          fill="#214063"
        />
        <path
          d="M12.877 38.7967L12.9151 38.7394C12.9341 38.7585 12.9341 38.7012 12.9722 38.7203H13.0103C13.0293 38.7394 13.0674 38.7203 13.1055 38.7585C13.1436 38.7967 13.1055 38.7967 13.1246 38.7967C13.1246 38.8158 13.1436 38.8349 13.1246 38.854L13.0865 38.9113C13.0865 38.9113 13.0484 38.9113 13.0484 38.9304C13.0484 38.9495 13.0293 38.9495 13.0103 38.9495H12.9532C12.9532 38.9304 12.9341 38.9495 12.9151 38.9495H12.8579V38.9113H12.8198C12.877 38.8349 12.8579 38.8158 12.877 38.7967Z"
          fill="#214063"
        />
        <path
          d="M12.8962 37.6314C12.877 37.6506 12.8579 37.6314 12.8579 37.6123L12.8962 37.6314Z"
          fill="#214063"
        />
        <path
          d="M13.124 38.5288C13.1432 38.5288 13.1623 38.5288 13.1623 38.548H13.124C13.124 38.5288 13.1432 38.5288 13.124 38.5288Z"
          fill="#214063"
        />
        <path
          d="M13.3335 37.9371V37.8989H13.4097C13.4287 37.9371 13.4478 37.9371 13.4287 37.9753C13.4097 38.0135 13.4097 37.9944 13.4287 38.0135C13.4478 38.0326 13.3906 37.9944 13.4097 38.0326H13.3335V37.9371Z"
          fill="#214063"
        />
        <path
          d="M13.3906 38.0704C13.3906 38.0513 13.4287 38.0704 13.4287 38.0513H13.5049C13.543 38.0513 13.543 38.0895 13.5621 38.0895C13.5811 38.0895 13.543 38.1277 13.5811 38.1468C13.6192 38.1659 13.5811 38.2041 13.524 38.2232H13.4859C13.4668 38.2614 13.4478 38.2232 13.4287 38.2423H13.3906C13.3716 38.2232 13.3906 38.2041 13.3716 38.2041C13.3716 38.199 13.3736 38.1942 13.3772 38.1906C13.3807 38.187 13.3856 38.185 13.3906 38.185C13.3525 38.1086 13.4097 38.0895 13.3906 38.0704Z"
          fill="#214063"
        />
        <path
          d="M13.7339 38.3953C13.7529 38.3762 13.7339 38.3762 13.7339 38.3762C13.7339 38.3762 13.7529 38.3953 13.7529 38.3762H13.8101C13.8291 38.3762 13.8101 38.338 13.8291 38.3571L13.8672 38.2998H13.9244L13.9625 38.338C13.9434 38.3571 13.9625 38.3571 13.9625 38.3762C13.9625 38.3953 13.9625 38.338 13.9815 38.338C14.0006 38.338 13.9625 38.3762 14.0006 38.3953H14.0767C14.0577 38.3953 14.0577 38.4144 14.0767 38.4335C14.1148 38.4335 14.0767 38.4717 14.0958 38.4717C14.1148 38.4717 14.0958 38.5099 14.1148 38.5099H14.0767V38.5481C14.0767 38.5481 14.0386 38.5672 14.0577 38.5863C14.0386 38.5863 14.0577 38.6054 14.0577 38.6054C14.0577 38.6054 14.0386 38.5672 14.0196 38.6054C13.9815 38.6054 14.0006 38.6818 13.9434 38.6818V38.6436C13.9244 38.6436 13.9244 38.6818 13.8863 38.6627C13.8482 38.6436 13.8672 38.6245 13.8482 38.6245H13.8291C13.8101 38.6245 13.8482 38.6054 13.8291 38.5863H13.8101V38.5481H13.791C13.791 38.529 13.8101 38.529 13.791 38.5099H13.772C13.772 38.5049 13.774 38.5 13.7776 38.4964C13.7811 38.4928 13.786 38.4908 13.791 38.4908H13.772C13.7529 38.4908 13.791 38.4717 13.772 38.4526L13.7339 38.3953Z"
          fill="#214063"
        />
        <path
          d="M11.6768 37.001C11.6958 37.0201 11.7339 37.001 11.7339 37.0392C11.7339 37.0774 11.6958 37.0965 11.6768 37.0774H11.6387V37.0392C11.6437 37.0442 11.6506 37.0471 11.6577 37.0471C11.6649 37.0471 11.6717 37.0442 11.6768 37.0392C11.6818 37.0341 11.6847 37.0272 11.6847 37.0201C11.6847 37.0129 11.6818 37.006 11.6768 37.001Z"
          fill="#214063"
        />
        <path
          d="M11.8483 37.0773H11.8101V37.0581L11.8483 37.0773Z"
          fill="#214063"
        />
        <path
          d="M11.9053 37.0391H12.0386C12.0577 37.0582 12.0577 37.0964 12.0958 37.0964C12.1339 37.0964 12.0767 37.0964 12.0958 37.1155V37.1728L12.0577 37.2301C12.0526 37.2301 12.0478 37.2321 12.0442 37.2357C12.0406 37.2393 12.0386 37.2441 12.0386 37.2492C12.0196 37.2492 12.0196 37.2683 12.0196 37.2874V37.2492H11.9624C11.9434 37.211 11.9053 37.2492 11.8862 37.2492C11.8672 37.2492 11.9243 37.211 11.9053 37.1919C11.8862 37.1728 11.9243 37.1728 11.9053 37.1537H11.8672C11.8835 37.14 11.8958 37.1221 11.9025 37.1018C11.9092 37.0816 11.9102 37.0598 11.9053 37.0391Z"
          fill="#214063"
        />
        <path
          d="M19.2009 9.32178L19.1817 9.34092L19.1626 9.32178H19.2009Z"
          fill="white"
        />
        <path
          d="M14.3434 2.59803L14.4006 2.54073C14.4767 2.52162 14.4767 2.55983 14.4958 2.59803C14.4884 2.62354 14.4735 2.64625 14.4532 2.66326C14.4328 2.68027 14.4079 2.69081 14.3815 2.69354C14.3434 2.69354 14.3244 2.63624 14.3434 2.59803Z"
          fill="#214063"
        />
        <path
          d="M14.286 2.29248C14.3241 2.29248 14.3241 2.31158 14.3431 2.33068C14.3622 2.34979 14.3241 2.38799 14.286 2.40709C14.2479 2.4262 14.1908 2.33068 14.286 2.29248Z"
          fill="#214063"
        />
        <path
          d="M12.4382 14.3457C12.4574 14.3457 12.4765 14.3648 12.4574 14.4031H12.4382C12.4342 14.3995 12.4309 14.3951 12.4287 14.3902C12.4264 14.3852 12.4253 14.3799 12.4253 14.3744C12.4253 14.369 12.4264 14.3636 12.4287 14.3587C12.4309 14.3537 12.4342 14.3493 12.4382 14.3457Z"
          fill="#214063"
        />
        <path
          d="M14.0005 7.67881V7.65967H14.0196L14.0005 7.67881Z"
          fill="#214063"
        />
        <path
          d="M12.3242 14.174C12.3434 14.1549 12.3434 14.174 12.3625 14.174C12.3816 14.174 12.3625 14.2123 12.3434 14.2123C12.3242 14.2123 12.3242 14.1932 12.3242 14.174Z"
          fill="#214063"
        />
        <path
          d="M14.2862 7.39258H14.3243C14.3052 7.44988 14.2481 7.46899 14.191 7.48809C14.1338 7.50719 14.2291 7.39258 14.2862 7.39258Z"
          fill="#214063"
        />
        <path
          d="M12.7052 13.811C12.7433 13.811 12.8004 13.811 12.7814 13.8683C12.7623 13.9256 12.7433 13.9065 12.7052 13.9065C12.6944 13.893 12.6885 13.8762 12.6885 13.8588C12.6885 13.8414 12.6944 13.8246 12.7052 13.811Z"
          fill="#214063"
        />
        <path
          d="M9.67634 14.8807C9.67007 14.8362 9.67365 14.7909 9.68682 14.748C9.69999 14.705 9.72242 14.6656 9.75253 14.6323C9.79063 14.6514 9.77158 14.6896 9.77158 14.7278C9.77158 14.766 9.69539 14.8233 9.69539 14.8998C9.69539 14.9762 9.69539 14.8807 9.67634 14.8807Z"
          fill="#214063"
        />
        <path
          d="M19.067 2.55995H19.0289L19.067 2.52174C19.0099 2.46444 19.1432 2.44533 19.1242 2.40713C19.1978 2.37926 19.2791 2.37926 19.3527 2.40713C19.3908 2.46444 19.3718 2.48354 19.4099 2.54084C19.448 2.59815 19.448 2.67456 19.3337 2.67456C19.2194 2.67456 19.2385 2.67456 19.1813 2.71276C19.1242 2.75097 19.1623 2.69366 19.1242 2.67456H19.0861C19.1242 2.63636 19.067 2.61725 19.0289 2.59815C18.9908 2.57905 19.048 2.57905 19.067 2.55995Z"
          fill="#214063"
        />
        <path
          d="M9.9624 14.3459L10.0198 14.3076C10.0389 14.3268 10.0198 14.3842 10.0007 14.4225L9.9624 14.4608V14.3459Z"
          fill="#214063"
        />
        <path
          d="M9.84795 14.0591H9.88622C9.90535 14.1165 9.84795 14.1548 9.82882 14.2122C9.82474 14.1604 9.83125 14.1083 9.84795 14.0591Z"
          fill="#214063"
        />
        <path
          d="M9.86728 14.0975C9.86728 14.0784 9.88641 14.1166 9.84814 14.1358L9.86728 14.0975Z"
          fill="white"
        />
        <path
          d="M11.8292 11.0029H11.8675C11.8675 11.0412 11.8675 11.0412 11.8483 11.0604C11.8292 11.0795 11.8101 11.0412 11.8292 11.0029Z"
          fill="#214063"
        />
        <path
          d="M11.0288 10.1243C11.0288 10.1051 11.0479 10.086 11.0479 10.0668C11.0479 10.0477 11.0862 10.1051 11.0862 10.1243C11.0862 10.1434 11.0288 10.1434 11.0288 10.1243Z"
          fill="#214063"
        />
        <path
          d="M10.4961 9.83768C10.5151 9.81857 10.5532 9.76127 10.5913 9.79947C10.6294 9.83768 10.6485 9.83768 10.6294 9.89498C10.6104 9.95229 10.5913 9.93319 10.5723 9.95229C10.5532 9.97139 10.5151 9.89498 10.4961 9.83768Z"
          fill="#214063"
        />
        <path
          d="M10.9341 10.0099C10.9341 10.0048 10.9361 9.99992 10.9397 9.99633C10.9433 9.99274 10.9481 9.99072 10.9532 9.99072C10.9583 9.99072 10.9632 9.99274 10.9667 9.99633C10.9703 9.99992 10.9723 10.0048 10.9723 10.0099C10.9723 10.0482 10.9149 10.0482 10.9341 10.0099Z"
          fill="#214063"
        />
        <path
          d="M12.0581 10.1813C12.0772 10.1622 12.0772 10.1431 12.0962 10.1431C12.1152 10.1431 12.1343 10.1622 12.1533 10.2004C12.1467 10.2075 12.1383 10.2128 12.1291 10.2158C12.1198 10.2188 12.11 10.2193 12.1004 10.2174C12.0909 10.2155 12.082 10.2112 12.0746 10.2048C12.0672 10.1985 12.0615 10.1904 12.0581 10.1813Z"
          fill="#214063"
        />
        <path
          d="M11.2769 13.0278V13.0661L11.2578 13.047L11.2769 13.0278Z"
          fill="#214063"
        />
        <path
          d="M11.4289 12.7605C11.467 12.7414 11.486 12.6841 11.5051 12.7223C11.5241 12.7605 11.5051 12.8751 11.486 12.9324C11.467 12.9133 11.4479 12.9324 11.4479 12.9133C11.4479 12.8942 11.3908 12.9324 11.3908 12.9898C11.3749 12.9112 11.3884 12.8296 11.4289 12.7605Z"
          fill="#214063"
        />
        <path
          d="M11.2197 9.68467C11.2197 9.66553 11.2389 9.68467 11.258 9.66553C11.2612 9.67038 11.2633 9.67592 11.2641 9.68171C11.2649 9.6875 11.2643 9.69339 11.2625 9.69894C11.2607 9.70448 11.2576 9.70953 11.2535 9.71369C11.2494 9.71785 11.2444 9.72103 11.2389 9.72296C11.2197 9.72296 11.2197 9.70382 11.2197 9.68467Z"
          fill="#214063"
        />
        <path
          d="M12.077 9.78039C12.0961 9.76125 12.1153 9.78039 12.1344 9.79953C12.1233 9.80935 12.1165 9.82307 12.1153 9.83782C12.0961 9.85697 12.0579 9.81868 12.077 9.78039Z"
          fill="#214063"
        />
        <path
          d="M11.7339 9.58947C11.753 9.57033 11.7722 9.58947 11.7913 9.60862C11.8104 9.62776 11.7722 9.6469 11.753 9.6469C11.7339 9.6469 11.7339 9.60862 11.7339 9.58947Z"
          fill="#214063"
        />
        <path
          d="M12.0581 9.70399C12.0962 9.68489 12.0962 9.58938 12.1343 9.62759C12.1724 9.66579 12.1343 9.7231 12.0962 9.7422C12.0581 9.7613 12.0581 9.7231 12.0581 9.70399Z"
          fill="#214063"
        />
        <path
          d="M11.4868 12.149C11.4962 12.1385 11.5014 12.1249 11.5014 12.1108C11.5014 12.0967 11.4962 12.0831 11.4868 12.0726C11.4678 12.0726 11.4487 12.1108 11.4297 12.0917C11.4106 12.0726 11.5059 11.8242 11.6392 11.786C11.7725 11.7478 11.6773 11.8051 11.6963 11.8433C11.7154 11.8815 11.6773 11.9006 11.6963 11.9198C11.7154 11.9389 11.6773 12.0535 11.6201 12.0917C11.563 12.1299 11.6201 12.0917 11.6201 12.0726L11.4868 12.1872V12.149Z"
          fill="#214063"
        />
        <path
          d="M12.0957 12.0347C12.1909 12.0538 12.0957 12.1493 12.0957 12.2066L12.0195 12.2639C12.0133 12.2224 12.0171 12.18 12.0303 12.1402C12.0435 12.1003 12.0659 12.0642 12.0957 12.0347Z"
          fill="#214063"
        />
        <path
          d="M12.0772 12.1108L12.0964 12.13L12.0581 12.1491L12.0964 12.13L12.0772 12.1108Z"
          fill="white"
        />
        <path
          d="M16.0772 5.979H16.1153C16.1153 6.11272 15.9629 6.18913 15.8677 6.22733H15.7915C15.8176 6.16717 15.8568 6.11364 15.9063 6.07067C15.9557 6.02769 16.0141 5.99637 16.0772 5.979Z"
          fill="#214063"
        />
        <path
          d="M12.2673 11.8819L12.229 11.9011V11.8628L12.2673 11.8819Z"
          fill="#214063"
        />
        <path
          d="M12.4005 11.5953L12.4386 11.5571L12.4767 11.6144C12.4767 11.6908 12.4195 11.729 12.3814 11.7673H12.4005C12.3993 11.7525 12.3924 11.7388 12.3814 11.729C12.3624 11.729 12.3624 11.7482 12.3624 11.7673C12.3545 11.7376 12.3539 11.7066 12.3605 11.6766C12.3671 11.6467 12.3808 11.6188 12.4005 11.5953Z"
          fill="#214063"
        />
        <path
          d="M12.4198 11.6714H12.4007C12.4198 11.6905 12.4007 11.6714 12.4007 11.6905C12.4007 11.7097 12.3624 11.6905 12.4198 11.6714Z"
          fill="white"
        />
        <path
          d="M12.5721 11.4997C12.568 11.4656 12.5709 11.4311 12.5808 11.3982C12.5906 11.3653 12.6071 11.3348 12.6293 11.3087C12.6483 11.2896 12.6864 11.2705 12.6864 11.3087C12.697 11.3368 12.7007 11.3671 12.6974 11.3969C12.6941 11.4268 12.6838 11.4555 12.6674 11.4806C12.6293 11.4806 12.6102 11.5379 12.5912 11.557C12.5721 11.5761 12.6293 11.4806 12.5721 11.4997Z"
          fill="#214063"
        />
        <path
          d="M14.4577 11.461C14.4577 11.4559 14.4597 11.4511 14.4632 11.4475C14.4668 11.4439 14.4717 11.4419 14.4767 11.4419C14.4818 11.4419 14.4866 11.4439 14.4902 11.4475C14.4937 11.4511 14.4958 11.4559 14.4958 11.461C14.5338 11.4992 14.4958 11.5565 14.4767 11.5947C14.4577 11.6329 14.4767 11.652 14.4386 11.652C14.4256 11.5879 14.4323 11.5213 14.4577 11.461Z"
          fill="#214063"
        />
        <path
          d="M9.1817 8.40479C9.25789 8.42389 9.20075 8.5194 9.20075 8.57671C9.20075 8.63401 9.02932 8.74862 8.97218 8.84414L8.93408 8.90144C9.02932 8.76773 8.99122 8.48119 9.1817 8.40479Z"
          fill="#214063"
        />
        <path
          d="M13.9818 9.64648H14.0199C14.039 9.66559 14.0771 9.66559 14.0771 9.70379L14.039 9.7993C14.0199 9.7993 14.0199 9.7993 14.0199 9.7802L13.9818 9.8184C13.9247 9.7611 13.9628 9.70379 13.9818 9.64648Z"
          fill="#214063"
        />
        <path
          d="M14.4006 8.94012C14.3815 8.94012 14.3815 8.95922 14.3815 8.97833C14.3815 8.99743 14.3625 8.88281 14.3815 8.82551C14.4006 8.7682 14.4387 8.7682 14.4768 8.7873C14.5148 8.80641 14.5148 8.82551 14.5339 8.86371C14.5529 8.90192 14.4577 8.92102 14.4768 8.95922H14.4577L14.3815 8.99743C14.3815 8.95922 14.3815 8.94012 14.4006 8.94012Z"
          fill="#214063"
        />
        <path
          d="M10.3058 8.17578L10.2866 8.21407V8.17578H10.3058Z"
          fill="#214063"
        />
        <path
          d="M10.5146 8.23291C10.5146 8.21377 10.5338 8.2712 10.5146 8.2712L10.5912 8.23291L10.5146 8.30949V8.23291Z"
          fill="#214063"
        />
        <path
          d="M10.5342 8.21404C10.5342 8.19494 10.5532 8.17584 10.5532 8.15674C10.5532 8.13763 10.5913 8.13763 10.6104 8.15674C10.6294 8.17584 10.6104 8.17584 10.6104 8.19494C10.6104 8.21404 10.6104 8.15674 10.5913 8.13763C10.5723 8.11853 10.5532 8.17584 10.5532 8.19494C10.5532 8.21404 10.5532 8.19494 10.5723 8.19494L10.5342 8.21404Z"
          fill="#214063"
        />
        <path
          d="M13.0483 8.50074C13.1055 8.42434 13.0864 8.29062 13.2007 8.23331C13.315 8.17601 13.2579 8.30972 13.2388 8.34793C13.2198 8.38613 13.1245 8.44344 13.0674 8.50074H13.0483Z"
          fill="#214063"
        />
        <path
          d="M14.9341 8.55774C14.9722 8.51954 14.9722 8.46223 15.0293 8.48133C15.0865 8.50044 15.0484 8.51954 15.0674 8.55774L15.0103 8.61505C14.9912 8.61505 14.9912 8.59595 14.9722 8.61505L14.9341 8.55774Z"
          fill="#214063"
        />
        <path
          d="M12.1342 7.62182C12.1532 7.58361 12.1913 7.54541 12.2103 7.54541C12.2236 7.55289 12.2342 7.56416 12.241 7.57778C12.2478 7.59139 12.2504 7.60673 12.2484 7.62182C12.2103 7.66002 12.1913 7.71733 12.1532 7.73643C12.1151 7.75553 12.1342 7.66002 12.1342 7.62182Z"
          fill="#214063"
        />
        <path
          d="M15.2008 8.53868C15.2008 8.51953 15.1626 8.53868 15.1626 8.53868C15.1626 8.5336 15.1646 8.52873 15.1682 8.52514C15.1718 8.52155 15.1766 8.51953 15.1817 8.51953H15.2008C15.22 8.53868 15.2008 8.57696 15.1626 8.57696C15.1243 8.57696 15.2008 8.57696 15.2008 8.53868Z"
          fill="#214063"
        />
        <path
          d="M10.4575 6.62823C10.4617 6.60738 10.4708 6.58783 10.4841 6.57122C10.4973 6.55461 10.5143 6.54141 10.5337 6.53271C10.5718 6.55182 10.6099 6.59002 10.5909 6.62823C10.5718 6.66643 10.4575 6.72374 10.4575 6.62823Z"
          fill="#214063"
        />
        <path
          d="M11.2957 6.91507H11.2576C11.2386 6.89597 11.2767 6.87686 11.2957 6.87686C11.3066 6.8187 11.3291 6.76334 11.3618 6.7141C11.3945 6.66487 11.4368 6.62277 11.4862 6.59033C11.5045 6.59826 11.5198 6.61174 11.5301 6.62887C11.5403 6.646 11.545 6.66593 11.5433 6.68584L11.4481 6.85776L11.2767 6.99148C11.2767 6.95327 11.2957 6.93417 11.2957 6.91507Z"
          fill="#214063"
        />
        <path
          d="M12.7621 7.52643C12.7621 7.54553 12.7811 7.54553 12.8002 7.54553C12.8383 7.54553 12.8573 7.52643 12.8383 7.48823C12.8192 7.45002 12.7811 7.46913 12.743 7.48823C12.7049 7.50733 12.7811 7.33541 12.8573 7.35451C12.877 7.37583 12.8902 7.40234 12.8954 7.43092L12.8383 7.54553C12.8573 7.54553 12.8573 7.54553 12.8573 7.52643H12.8383L12.8002 7.56464C12.7951 7.56464 12.7903 7.56262 12.7867 7.55904C12.7831 7.55546 12.7811 7.5506 12.7811 7.54553H12.743C12.7508 7.54078 12.7573 7.53423 12.7621 7.52643Z"
          fill="#214063"
        />
        <path
          d="M16.3622 8.80599C16.4003 8.78689 16.4193 8.82509 16.4193 8.84419C16.4193 8.86329 16.3431 8.9015 16.3431 8.95881C16.3431 9.01611 16.3241 8.82509 16.3622 8.80599Z"
          fill="#214063"
        />
        <path
          d="M12.7812 7.44992H12.8387C12.8578 7.43078 12.8578 7.44992 12.8578 7.44992H12.8195C12.8004 7.43078 12.8195 7.41164 12.7812 7.43078H12.8004C12.8004 7.43586 12.7984 7.44073 12.7948 7.44432C12.7912 7.44791 12.7863 7.44992 12.7812 7.44992Z"
          fill="white"
        />
        <path
          d="M18.6485 5.50117H18.6104C18.6104 5.48206 18.7437 5.48206 18.6675 5.40566C18.5913 5.32925 18.858 5.34835 18.9532 5.40566H18.9342C18.9723 5.36745 19.0104 5.29104 19.0865 5.31014C19.1627 5.32925 19.1246 5.32925 19.1246 5.36745C19.1246 5.40566 18.877 5.38655 18.9151 5.57758C18.8965 5.60631 18.8711 5.63004 18.8412 5.64669C18.8114 5.66333 18.7779 5.6724 18.7437 5.67309L18.7056 5.73039C18.7437 5.69219 18.6865 5.67309 18.6865 5.65398H18.6485V5.61578H18.5913C18.6104 5.55847 18.6485 5.53937 18.6485 5.50117Z"
          fill="#214063"
        />
        <path
          d="M15.486 8.13765C15.5241 8.11855 15.5241 8.08034 15.5812 8.09944C15.6383 8.11855 15.6002 8.15675 15.6002 8.19496C15.6002 8.23316 15.5621 8.19495 15.5621 8.23316C15.5431 8.21406 15.4479 8.17585 15.486 8.13765Z"
          fill="#214063"
        />
        <path
          d="M11.9053 6.53302C11.905 6.50597 11.912 6.47933 11.9254 6.45584C11.9387 6.43234 11.9581 6.41283 11.9815 6.39931C12.0005 6.39931 12.0386 6.3802 12.0386 6.41841C12.0386 6.45661 11.9815 6.51392 11.9434 6.57123C11.9053 6.62853 11.9053 6.55212 11.9053 6.53302Z"
          fill="#214063"
        />
        <path
          d="M11.9626 6.47559L11.9243 6.53302L11.9626 6.47559Z"
          fill="white"
        />
        <path
          d="M16.0769 8.06084C16.0578 8.07995 16.0578 8.02264 16.0388 8.04174C16.0197 8.06084 16.0578 7.96533 16.0959 7.96533C16.134 7.96533 16.1149 8.00354 16.134 8.04174L16.0769 8.06084Z"
          fill="#214063"
        />
        <path
          d="M16.0768 8.04209L16.0959 8.02295V8.04209H16.0768L16.0576 8.02295L16.0768 8.04209Z"
          fill="white"
        />
        <path
          d="M16.3628 7.46905C16.3628 7.44994 16.3628 7.39264 16.4009 7.37354H16.4961C16.5533 7.43084 16.4771 7.48815 16.4771 7.52635C16.439 7.50725 16.4199 7.54546 16.4009 7.54546C16.3818 7.54546 16.3818 7.48815 16.3628 7.46905Z"
          fill="#214063"
        />
        <path
          d="M17.4102 8.2525H17.3911C17.4102 8.19519 17.3911 8.11878 17.4673 8.09968C17.5435 8.08058 17.5244 8.17609 17.5054 8.19519C17.4864 8.21429 17.4483 8.2525 17.4102 8.2716V8.2525Z"
          fill="#214063"
        />
        <path
          d="M12.2675 5.59722C12.2484 5.55902 12.3056 5.46351 12.3436 5.4253C12.358 5.40996 12.3769 5.39977 12.3976 5.39632C12.4182 5.39287 12.4394 5.39634 12.4579 5.4062C12.5151 5.4253 12.496 5.48261 12.496 5.52081C12.496 5.55902 12.4389 5.57812 12.4389 5.61633C12.4389 5.65453 12.3436 5.71184 12.3246 5.61633H12.3055C12.3018 5.6097 12.2962 5.60434 12.2894 5.60094C12.2826 5.59753 12.275 5.59624 12.2675 5.59722Z"
          fill="#214063"
        />
        <path
          d="M16.8008 7.60276H16.7627C16.8198 7.58366 16.8389 7.46905 16.9151 7.50725C16.9913 7.54546 16.9532 7.60276 16.9532 7.64097C16.9532 7.67917 16.9151 7.66007 16.9151 7.67917C16.9151 7.69828 16.896 7.67917 16.896 7.66007C16.896 7.64097 16.877 7.66007 16.8389 7.67917H16.8008C16.8198 7.62187 16.7627 7.62187 16.8008 7.60276Z"
          fill="#214063"
        />
        <path
          d="M13.4102 6.05568C13.4292 6.05568 13.4102 6.09389 13.4102 6.11299L13.353 6.17029C13.3721 6.2085 13.3911 6.15119 13.4102 6.15119L13.3721 6.11299C13.315 6.09389 13.334 6.17029 13.315 6.1894L13.2769 6.2276C13.2959 6.13209 13.334 6.03658 13.4102 6.05568Z"
          fill="#214063"
        />
        <path
          d="M14.7622 5.52051H14.7813C14.7622 5.53965 14.7813 5.53965 14.7622 5.52051Z"
          fill="#214063"
        />
        <path
          d="M16.7052 6.55225H16.7243V6.59053C16.7243 6.57139 16.7052 6.55225 16.686 6.57139L16.7052 6.55225Z"
          fill="#214063"
        />
        <path
          d="M15.3721 4.66064H15.3912C15.3883 4.66232 15.385 4.66321 15.3816 4.66321C15.3783 4.66321 15.375 4.66232 15.3721 4.66064Z"
          fill="#214063"
        />
        <path
          d="M15.4292 4.64147H15.4483V4.60326C15.4483 4.58416 15.4292 4.58416 15.4292 4.56506C15.4292 4.54596 15.3911 4.60326 15.3911 4.64147H15.3721C15.3911 4.58416 15.4292 4.56506 15.4864 4.52686H15.5245C15.5054 4.60326 15.4483 4.62237 15.3911 4.64147H15.4292Z"
          fill="#214063"
        />
        <path
          d="M17.9243 5.63525C17.9446 5.63525 17.9639 5.6433 17.9782 5.65763C17.9925 5.67196 18.0005 5.6914 18.0005 5.71166L17.9624 5.76897C17.9624 5.76897 17.9434 5.71166 17.9243 5.74987C17.9053 5.78807 17.9243 5.78807 17.9053 5.80717H17.9243C17.8862 5.78807 17.8862 5.82628 17.8482 5.82628V5.78807H17.8101C17.8482 5.73076 17.8672 5.65436 17.9243 5.63525Z"
          fill="#214063"
        />
        <path
          d="M16.4194 4.71791C16.4766 4.6606 16.4956 4.6033 16.5718 4.6224C16.648 4.6415 16.5718 4.69881 16.5718 4.73701L16.4956 4.79432H16.4194C16.4385 4.73701 16.4385 4.71791 16.4194 4.71791Z"
          fill="#214063"
        />
        <path
          d="M16.4961 4.66097L16.458 4.69917C16.4592 4.68445 16.466 4.67077 16.4771 4.66097C16.5152 4.64187 16.5152 4.68007 16.5342 4.69917C16.5532 4.71827 16.4771 4.73738 16.4771 4.75648C16.4771 4.77558 16.439 4.71827 16.4961 4.66097Z"
          fill="white"
        />
        <path
          d="M17.7912 6.01709C17.8103 6.01709 17.8103 6.03619 17.8293 6.05529C17.8484 6.0744 17.8103 6.0935 17.7722 6.1126C17.7341 6.1317 17.7912 6.1126 17.7912 6.0744H17.7531C17.7531 6.0935 17.7531 6.1126 17.7341 6.1126C17.715 6.1126 17.7531 6.01709 17.7912 6.01709Z"
          fill="#214063"
        />
        <path
          d="M16.5528 4.25977H16.5718V4.29797H16.5528V4.35528V4.31707L16.4766 4.37438C16.4766 4.33617 16.4956 4.27887 16.5528 4.25977Z"
          fill="#214063"
        />
        <path
          d="M21.2007 5.55902C21.2007 5.50171 21.1626 5.53992 21.1436 5.52081C21.1245 5.50171 21.1817 5.53992 21.2007 5.50171C21.2198 5.46351 21.1626 5.46351 21.1436 5.48261H21.1245C21.1626 5.44441 21.2197 5.48261 21.2388 5.4062C21.2578 5.32979 21.2197 5.3871 21.2197 5.368C21.2197 5.34889 21.2769 5.31069 21.334 5.29159H21.315C21.3531 5.27249 21.3912 5.29159 21.4293 5.29159C21.4674 5.29159 21.5055 5.27249 21.5055 5.21518C21.5055 5.15787 21.5626 5.29159 21.5817 5.25338C21.6353 5.3035 21.6691 5.37132 21.6769 5.44441C21.6959 5.48261 21.6769 5.48261 21.6578 5.53992C21.6578 5.55902 21.6388 5.55902 21.6578 5.57812C21.6769 5.59722 21.6007 5.61633 21.6007 5.63543C21.6007 5.65453 21.5626 5.71184 21.5436 5.69273V5.73094H21.5055C21.4674 5.76914 21.3912 5.76914 21.3531 5.82645H21.3721V5.78824L21.334 5.84555C21.334 5.82645 21.3721 5.78825 21.3531 5.75004C21.334 5.71184 21.315 5.76914 21.2959 5.76914H21.315C21.2959 5.75004 21.2769 5.78825 21.2388 5.76914C21.2007 5.75004 21.2388 5.69273 21.2197 5.67363H21.1436C21.1562 5.6722 21.1682 5.66763 21.1786 5.66034C21.189 5.65305 21.1975 5.64326 21.2031 5.63188C21.2088 5.62049 21.2116 5.60786 21.2111 5.59514C21.2107 5.58241 21.2071 5.57 21.2007 5.55902Z"
          fill="#214063"
        />
        <path
          d="M17.0859 4.24095C17.0668 4.24095 17.0668 4.26005 17.0859 4.26005C17.1049 4.26005 17.124 4.26005 17.143 4.24095C17.124 4.22185 17.124 4.26005 17.1049 4.24095C17.0859 4.22185 17.143 4.22185 17.1811 4.20275C17.2192 4.18364 17.1811 4.26005 17.143 4.27916C17.1049 4.29826 17.0859 4.29826 17.0478 4.29826C17.0441 4.29207 17.0423 4.28496 17.0425 4.27777C17.0427 4.27057 17.0449 4.26358 17.0489 4.25759C17.0529 4.2516 17.0584 4.24686 17.065 4.24392C17.0715 4.24097 17.0788 4.23995 17.0859 4.24095Z"
          fill="#214063"
        />
        <path
          d="M17.6768 4.03072C17.6946 4.02406 17.7142 4.02428 17.7318 4.03134C17.7494 4.03841 17.7638 4.05181 17.772 4.06893C17.7789 4.07668 17.7842 4.08576 17.7874 4.09561C17.7907 4.10546 17.792 4.11588 17.7911 4.12623C17.8292 4.10713 17.8863 4.10713 17.8863 4.16444C17.8863 4.22174 17.6387 4.25995 17.5625 4.27905V4.24085H17.5244C17.528 4.19513 17.5441 4.15129 17.571 4.1142C17.5979 4.07711 17.6345 4.04822 17.6768 4.03072Z"
          fill="#214063"
        />
        <path
          d="M23.9624 3.64824H23.9434C23.9582 3.64824 23.9727 3.64478 23.986 3.63815C23.9992 3.63152 24.0107 3.62189 24.0196 3.61003H23.9815C24.0005 3.61003 24.0386 3.62913 24.0386 3.59093H24.0196C24.0957 3.61003 24.1338 3.55273 24.191 3.57183C24.2481 3.59093 24.3243 3.61003 24.3624 3.61003C24.4005 3.61003 24.4005 3.66734 24.4005 3.68644L24.3624 3.83926L24.2862 3.89656C24.307 3.90835 24.3247 3.92487 24.3379 3.94477C24.3512 3.96468 24.3595 3.98743 24.3624 4.01118C24.3815 4.10669 24.2862 4.08759 24.2672 4.14489C24.2481 4.2022 24.191 4.12579 24.1529 4.14489H24.1338C24.1719 4.08759 24.0767 4.08759 24.0386 4.06848H24.0196C24.0196 4.04938 24.0577 4.06848 24.0577 4.03028H24.0767C24.0577 4.01118 24.0386 3.99208 24.0577 3.95387H23.9053C23.9243 3.70554 24.0005 3.70554 23.9624 3.64824Z"
          fill="#214063"
        />
        <path
          d="M19.7529 5.27245H19.7339C19.772 5.23424 19.772 5.13873 19.8482 5.11963H19.9815C19.9957 5.15284 20.0029 5.18858 20.0029 5.22469C20.0029 5.2608 19.9957 5.29654 19.9815 5.32975C19.9434 5.32975 19.9053 5.38706 19.8672 5.38706H19.8482V5.34886H19.7529C19.7518 5.3234 19.7518 5.2979 19.7529 5.27245Z"
          fill="#214063"
        />
        <path d="M18.1528 4.6417L18.172 4.62256L18.1528 4.6417Z" fill="white" />
        <path
          d="M18.4768 4.2219H18.4576C18.4768 4.20275 18.4385 4.18361 18.4194 4.20275C18.4002 4.2219 18.4576 4.20275 18.4768 4.2219Z"
          fill="#214063"
        />
        <path
          d="M18.7627 4.12593H18.7437C18.7437 4.12593 18.7817 4.08773 18.7627 4.06862C18.7437 4.04952 18.9151 4.12593 18.9532 3.99222C18.9913 3.8585 19.0865 3.97311 19.1246 4.04952C19.1307 4.06191 19.1341 4.07549 19.1345 4.08932C19.1349 4.10315 19.1323 4.1169 19.1268 4.12962C19.1214 4.14234 19.1133 4.15372 19.103 4.16298C19.0928 4.17223 19.0806 4.17915 19.0675 4.18324L19.0103 4.24054H18.9532C18.9532 4.18324 18.896 4.24054 18.877 4.22144C18.8579 4.16414 18.8198 4.22144 18.7817 4.18324H18.7437L18.7627 4.12593Z"
          fill="#214063"
        />
        <path
          d="M20.9339 3.7441C20.9148 3.7441 20.972 3.7441 20.9339 3.70589C20.8958 3.66769 20.972 3.66769 20.991 3.66769C21.0481 3.68679 21.0291 3.57218 21.1243 3.62948C21.2196 3.68679 21.2005 3.66769 21.2386 3.64859C21.2619 3.6698 21.278 3.69771 21.2848 3.72849C21.2917 3.75927 21.2888 3.79141 21.2767 3.82051L21.2005 3.89691V3.93512C21.1815 3.87781 21.1624 3.99243 21.1243 3.93512H21.0481C21.0532 3.93512 21.058 3.93311 21.0616 3.92952C21.0652 3.92594 21.0672 3.92108 21.0672 3.91602H20.9529C20.9148 3.7823 20.991 3.7823 20.9339 3.7441Z"
          fill="#214063"
        />
        <path
          d="M22.229 5.38655C22.2481 5.40565 22.2481 5.36744 22.2671 5.34834C22.2861 5.32924 22.3623 5.36744 22.3623 5.40565V5.48206C22.3433 5.46296 22.3242 5.50116 22.3052 5.52026C22.2861 5.53936 22.2671 5.50116 22.2671 5.50116L22.229 5.46296C22.2384 5.45245 22.2436 5.43885 22.2436 5.42475C22.2436 5.41066 22.2384 5.39705 22.229 5.38655Z"
          fill="#214063"
        />
        <path
          d="M22.2098 7.35456C22.2288 7.35456 22.2669 7.39277 22.2288 7.45007C22.2252 7.45414 22.2208 7.45739 22.2159 7.45962C22.211 7.46185 22.2057 7.46301 22.2002 7.46301C22.1948 7.46301 22.1895 7.46185 22.1846 7.45962C22.1796 7.45739 22.1752 7.45414 22.1717 7.45007C22.1336 7.43097 22.1526 7.33546 22.2098 7.35456Z"
          fill="#214063"
        />
        <path
          d="M23.3338 4.68006C23.3338 4.66096 23.3529 4.66096 23.3529 4.62276C23.3529 4.58455 23.429 4.62276 23.4481 4.66096C23.4671 4.69917 23.4481 4.71827 23.429 4.73737H23.3719C23.3529 4.71827 23.3148 4.69917 23.3338 4.66096V4.68006Z"
          fill="#214063"
        />
        <path
          d="M23.5628 4.60372H23.5437C23.5245 4.60372 23.5054 4.58457 23.5245 4.56543L23.5628 4.60372Z"
          fill="#214063"
        />
        <path
          d="M22.5718 5.88347C22.5737 5.87797 22.5769 5.87298 22.581 5.86889C22.5851 5.8648 22.5902 5.86171 22.5957 5.85987C22.6012 5.85803 22.6071 5.85747 22.6128 5.85825C22.6186 5.85903 22.6241 5.86112 22.6289 5.86437C22.6289 5.88347 22.648 5.90257 22.6289 5.90257H22.5718C22.5667 5.90257 22.5619 5.90056 22.5583 5.89698C22.5547 5.8934 22.5527 5.88854 22.5527 5.88347C22.5527 5.8784 22.5547 5.87355 22.5583 5.86996C22.5619 5.86638 22.5667 5.86437 22.5718 5.86437V5.88347Z"
          fill="#214063"
        />
        <path
          d="M22.5909 5.90248H22.61C22.6292 5.90248 22.5718 5.94076 22.5718 5.90248C22.5718 5.86419 22.5909 5.88333 22.5909 5.90248Z"
          fill="white"
        />
        <path
          d="M23.2582 6.57116H23.2392C23.2582 6.59026 23.2773 6.57116 23.2963 6.55205V6.49475C23.3154 6.51385 23.3344 6.49475 23.3535 6.49475V6.45654C23.4296 6.49475 23.582 6.45654 23.6011 6.59026L23.563 6.72397C23.5249 6.78128 23.4677 6.76218 23.4296 6.81949V6.76218C23.3916 6.80038 23.4106 6.76218 23.3916 6.76218H23.3344C23.3344 6.74308 23.3344 6.74308 23.3535 6.74308C23.3725 6.74308 23.3154 6.72397 23.2963 6.72397C23.2773 6.72397 23.2963 6.66667 23.2773 6.60936H23.2392C23.2011 6.59026 23.2582 6.62846 23.2582 6.57116Z"
          fill="#214063"
        />
        <path
          d="M23.6763 5.34904C23.6953 5.32994 23.6953 5.32994 23.6953 5.29173H23.6763C23.6763 5.29173 23.7144 5.29173 23.7144 5.31084C23.7144 5.32994 23.7334 5.25353 23.7715 5.27263C23.8096 5.29173 23.7715 5.23443 23.7715 5.21532C23.7715 5.19622 23.7906 5.25353 23.8477 5.25353C23.9048 5.25353 23.9429 5.29173 23.981 5.25353L24.0382 5.29173C24.0382 5.31084 24.0572 5.29173 24.0572 5.29173C24.0572 5.29173 24.0953 5.38724 24.1144 5.38724C24.1334 5.38724 24.1334 5.44455 24.1525 5.46365C24.1474 5.46365 24.1426 5.46567 24.139 5.46925C24.1354 5.47283 24.1334 5.47769 24.1334 5.48276C24.1334 5.48782 24.1354 5.49268 24.139 5.49626C24.1426 5.49984 24.1474 5.50186 24.1525 5.50186C24.0953 5.52096 24.2096 5.55916 24.1334 5.57827C24.0572 5.59737 24.1525 5.61647 24.1525 5.61647H24.0953C24.1525 5.67378 24.0382 5.65467 24.0572 5.73108C24.0763 5.80749 24.0191 5.73108 24.0001 5.75019C23.981 5.71198 23.9429 5.76929 23.9048 5.76929C23.8667 5.76929 23.8477 5.69288 23.7906 5.75019C23.7334 5.80749 23.7715 5.65467 23.7144 5.69288H23.6763C23.6572 5.65467 23.7334 5.67378 23.6953 5.63557C23.6572 5.59737 23.6763 5.65467 23.6572 5.65467C23.6382 5.65467 23.7334 5.59737 23.6572 5.55916H23.6001C23.6119 5.55027 23.6215 5.53873 23.6281 5.52547C23.6347 5.51221 23.6382 5.49758 23.6382 5.48276C23.6382 5.44455 23.581 5.50186 23.6001 5.46365C23.6191 5.42545 23.6382 5.46365 23.6382 5.42545L23.6001 5.38724C23.6382 5.42545 23.6382 5.34904 23.6763 5.34904Z"
          fill="#214063"
        />
        <path
          d="M24.9718 6.68607C24.9718 6.66697 24.9718 6.66697 24.9527 6.66697C24.9337 6.66697 25.0289 6.60966 25.0289 6.57146C25.0289 6.53325 25.1051 6.47594 25.1622 6.51415C25.2194 6.55235 25.1813 6.45684 25.2194 6.49505H25.2384C25.2956 6.53325 25.3718 6.51415 25.4289 6.57146C25.4861 6.62876 25.448 6.64786 25.5051 6.64786H25.467C25.4861 6.70517 25.5432 6.72427 25.4861 6.78158V6.81978C25.4509 6.84239 25.4241 6.87594 25.4099 6.9153C25.3718 6.9344 25.3146 6.9153 25.3146 6.9535C25.3146 6.9917 25.2765 6.9917 25.2384 7.01081H25.2003V6.9726C25.1847 6.96418 25.1667 6.96147 25.1493 6.96496C25.1319 6.96845 25.1163 6.9779 25.1051 6.9917C25.1051 6.9726 25.067 7.01081 25.048 6.9917H25.0289C25.0099 6.9535 24.9718 6.9917 24.9527 6.9726C24.9337 6.9535 24.9908 6.9535 24.9718 6.9344V6.89619H24.9337L24.9718 6.85799C24.9527 6.81978 24.9146 6.87709 24.8956 6.83889C24.8765 6.80068 24.9146 6.70517 24.9718 6.68607Z"
          fill="#214063"
        />
        <path
          d="M24.9528 4.27913C24.9528 4.29823 24.9719 4.31734 24.9719 4.33644C24.9719 4.35554 24.9147 4.33644 24.8957 4.31734C24.8766 4.29823 24.9147 4.26003 24.9528 4.27913Z"
          fill="#214063"
        />
        <path
          d="M25.6953 2.94189H25.7144C25.7334 2.9801 25.6953 2.9801 25.6763 2.9801C25.6572 2.9801 25.6763 2.9801 25.6382 2.94189H25.6953Z"
          fill="#214063"
        />
        <path
          d="M25.4868 6.11279L25.544 6.1701C25.5249 6.1701 25.5249 6.2083 25.4868 6.2083H25.4678C25.4487 6.1701 25.5249 6.1892 25.4868 6.151H25.4487L25.4868 6.11279Z"
          fill="#214063"
        />
        <path
          d="M25.8867 4.90931C25.8858 4.89896 25.8871 4.88854 25.8904 4.87869C25.8936 4.86884 25.8989 4.85976 25.9058 4.852C25.9629 4.8138 26.001 4.8329 26.0582 4.8329C26.1153 4.8329 26.1534 4.92841 26.1153 4.98572C26.0772 5.04302 26.0772 5.02392 26.1153 5.04302C26.1534 5.06213 26.0391 5.04302 26.0582 5.08123C26.0772 5.11943 26.0201 5.06213 26.001 5.08123H25.9629C25.9248 5.11943 25.9248 5.06213 25.8867 5.06213H25.9058C25.9058 5.04302 25.8867 5.06213 25.8677 5.04302V4.98572H25.9058L25.8867 4.90931Z"
          fill="#214063"
        />
        <path
          d="M26.001 5.17651C26.02 5.1574 26.0772 5.17651 26.0772 5.1383C26.0772 5.1001 26.0962 5.1383 26.1153 5.1383H26.1343C26.1534 5.1192 26.1534 5.1192 26.1534 5.1001L26.1915 5.1383H26.2296V5.1574C26.3058 5.1383 26.3058 5.19561 26.3438 5.21471C26.3819 5.23381 26.3248 5.29112 26.3819 5.31022C26.4391 5.32932 26.3819 5.44394 26.3058 5.50124C26.2296 5.55855 26.2867 5.50124 26.2867 5.48214C26.2867 5.46304 26.2486 5.52035 26.2677 5.53945L26.2296 5.50124C26.1915 5.57765 26.1343 5.50124 26.0962 5.52035C26.0581 5.53945 26.0581 5.52035 26.0581 5.48214H26.02V5.44394C26.001 5.46304 26.001 5.42483 25.9629 5.46304C25.9248 5.50124 26.001 5.36753 25.9438 5.36753C25.9507 5.35978 25.956 5.3507 25.9593 5.34084C25.9625 5.33099 25.9638 5.32057 25.9629 5.31022C25.9058 5.27202 26.0391 5.23381 26.001 5.17651Z"
          fill="#214063"
        />
        <path
          d="M26.7627 5.82625C26.8008 5.80714 26.7627 5.78804 26.7437 5.76894L26.7818 5.73074C26.7627 5.71163 26.7437 5.73074 26.7437 5.71163C26.7437 5.69253 26.8008 5.74984 26.8008 5.69253H26.8389V5.65433C26.8579 5.65433 26.9151 5.65433 26.9151 5.61612V5.53971C26.9722 5.53971 26.9341 5.46331 26.9722 5.50151C27.0103 5.53971 27.0294 5.406 27.0103 5.36779C26.9913 5.32959 27.0484 5.34869 27.0675 5.32959C27.0675 5.33466 27.0695 5.33951 27.0731 5.3431C27.0766 5.34668 27.0815 5.34869 27.0865 5.34869C27.1056 5.31049 27.1246 5.36779 27.1437 5.34869C27.1627 5.32959 27.1818 5.406 27.2199 5.3869C27.2579 5.36779 27.2579 5.4442 27.2579 5.48241C27.2579 5.52061 27.2579 5.4251 27.296 5.406C27.3341 5.3869 27.2579 5.50151 27.3341 5.52061H27.3722C27.3722 5.52061 27.3722 5.57792 27.4103 5.55882V5.61612H27.4484C27.4484 5.63522 27.4294 5.65433 27.4484 5.65433C27.4675 5.65433 27.4675 5.65433 27.4675 5.65433C27.4666 5.66468 27.4678 5.6751 27.4711 5.68495C27.4744 5.6948 27.4796 5.70388 27.4865 5.71163H27.5246V5.78804C27.5818 5.78804 27.5056 5.82625 27.5627 5.84535C27.6199 5.86445 27.5627 5.92176 27.5818 5.94086C27.6008 5.95996 27.5437 5.92176 27.5437 5.95996C27.5437 5.99817 27.5818 5.97906 27.6008 5.99817H27.5437C27.5343 6.00867 27.5291 6.02228 27.5291 6.03637C27.5291 6.05047 27.5343 6.06407 27.5437 6.07458C27.5437 6.09368 27.4675 6.11278 27.5246 6.15098H27.5056C27.4865 6.18919 27.5246 6.18919 27.5246 6.20829C27.5246 6.22739 27.4675 6.13188 27.4294 6.20829V6.22739C27.3151 6.22739 27.3722 6.38021 27.2579 6.36111C27.1437 6.34201 27.2199 6.3229 27.2008 6.3229C27.1818 6.3229 27.1437 6.38021 27.0865 6.36111C27.0294 6.34201 27.0103 6.2656 26.9913 6.2847C26.9722 6.3038 26.9532 6.3229 26.9341 6.3229C26.9151 6.3229 26.9913 6.2656 26.9341 6.22739H26.896C26.9151 6.20829 26.896 6.17009 26.896 6.15098H26.8579C26.8579 6.13188 26.896 6.11278 26.8579 6.09368H26.8199C26.8199 6.07458 26.8579 6.07458 26.8389 6.05547C26.8199 6.03637 26.8199 5.99817 26.7818 6.01727C26.7437 6.03637 26.8199 5.99817 26.7818 5.95996H26.7437C26.7627 5.94086 26.8008 5.94086 26.7818 5.90266H26.7246C26.7437 5.90266 26.7627 5.90266 26.7627 5.86445H26.7056C26.7246 5.86445 26.7627 5.86445 26.7627 5.82625Z"
          fill="#214063"
        />
        <path
          d="M22.4007 3.15186C22.4388 3.17096 22.4959 3.15186 22.5149 3.20916C22.534 3.26647 22.4768 3.34288 22.4007 3.30467H22.3816L22.3435 3.24737C22.3816 3.22826 22.3054 3.19006 22.3435 3.17096C22.3816 3.15186 22.4007 3.19006 22.4007 3.15186Z"
          fill="#214063"
        />
        <path
          d="M22.7631 3.24756L22.7057 3.2667V3.24756L22.6865 3.2667V3.24756H22.7631Z"
          fill="#214063"
        />
        <path
          d="M22.877 3.19045H22.8579C22.8727 3.19045 22.8873 3.187 22.9005 3.18037C22.9137 3.17374 22.9252 3.16411 22.9341 3.15225H22.9151C22.9887 3.12438 23.07 3.12438 23.1436 3.15225C23.1817 3.19045 23.2198 3.24776 23.277 3.22865C23.3341 3.20955 23.2389 3.24776 23.2579 3.28596C23.277 3.32417 23.296 3.36237 23.3151 3.40057C23.3341 3.43878 23.2579 3.45788 23.2389 3.51519C23.2198 3.57249 23.1817 3.51519 23.1817 3.55339V3.43878C23.1436 3.45788 23.1627 3.49609 23.1436 3.51519V3.47698C23.1055 3.51519 23.0484 3.49609 23.0103 3.51519C22.9722 3.53429 22.9151 3.51519 22.877 3.53429C22.8389 3.55339 22.9532 3.45788 22.9151 3.40057H22.877C22.8389 3.36237 22.9341 3.34327 22.896 3.30506L22.8008 3.36237C22.8198 3.30506 22.896 3.28596 22.877 3.19045Z"
          fill="#214063"
        />
        <path
          d="M23.1246 3.64864H23.1055V3.61035L23.1246 3.64864Z"
          fill="#214063"
        />
        <path
          d="M19.2009 9.32178L19.1817 9.34092L19.1626 9.32178H19.2009Z"
          fill="white"
        />
        <path
          d="M14.3434 2.59803L14.4006 2.54073C14.4767 2.52162 14.4767 2.55983 14.4958 2.59803C14.4884 2.62354 14.4735 2.64625 14.4532 2.66326C14.4328 2.68027 14.4079 2.69081 14.3815 2.69354C14.3434 2.69354 14.3244 2.63624 14.3434 2.59803Z"
          fill="#214063"
        />
        <path
          d="M14.286 2.29248C14.3241 2.29248 14.3241 2.31158 14.3431 2.33068C14.3622 2.34979 14.3241 2.38799 14.286 2.40709C14.2479 2.4262 14.1908 2.33068 14.286 2.29248Z"
          fill="#214063"
        />
        <path
          d="M12.4382 14.3457C12.4574 14.3457 12.4765 14.3648 12.4574 14.4031H12.4382C12.4342 14.3995 12.4309 14.3951 12.4287 14.3902C12.4264 14.3852 12.4253 14.3799 12.4253 14.3744C12.4253 14.369 12.4264 14.3636 12.4287 14.3587C12.4309 14.3537 12.4342 14.3493 12.4382 14.3457Z"
          fill="#214063"
        />
        <path
          d="M14.0005 7.67881V7.65967H14.0196L14.0005 7.67881Z"
          fill="#214063"
        />
        <path
          d="M12.3242 14.174C12.3434 14.1549 12.3434 14.174 12.3625 14.174C12.3816 14.174 12.3625 14.2123 12.3434 14.2123C12.3242 14.2123 12.3242 14.1932 12.3242 14.174Z"
          fill="#214063"
        />
        <path
          d="M14.2862 7.39258H14.3243C14.3052 7.44988 14.2481 7.46899 14.191 7.48809C14.1338 7.50719 14.2291 7.39258 14.2862 7.39258Z"
          fill="#214063"
        />
        <path
          d="M12.7052 13.811C12.7433 13.811 12.8004 13.811 12.7814 13.8683C12.7623 13.9256 12.7433 13.9065 12.7052 13.9065C12.6944 13.893 12.6885 13.8762 12.6885 13.8588C12.6885 13.8414 12.6944 13.8246 12.7052 13.811Z"
          fill="#214063"
        />
        <path
          d="M9.67634 14.8807C9.67007 14.8362 9.67365 14.7909 9.68682 14.748C9.69999 14.705 9.72242 14.6656 9.75253 14.6323C9.79063 14.6514 9.77158 14.6896 9.77158 14.7278C9.77158 14.766 9.69539 14.8233 9.69539 14.8998C9.69539 14.9762 9.69539 14.8807 9.67634 14.8807Z"
          fill="#214063"
        />
        <path
          d="M19.067 2.55995H19.0289L19.067 2.52174C19.0099 2.46444 19.1432 2.44533 19.1242 2.40713C19.1978 2.37926 19.2791 2.37926 19.3527 2.40713C19.3908 2.46444 19.3718 2.48354 19.4099 2.54084C19.448 2.59815 19.448 2.67456 19.3337 2.67456C19.2194 2.67456 19.2385 2.67456 19.1813 2.71276C19.1242 2.75097 19.1623 2.69366 19.1242 2.67456H19.0861C19.1242 2.63636 19.067 2.61725 19.0289 2.59815C18.9908 2.57905 19.048 2.57905 19.067 2.55995Z"
          fill="#214063"
        />
        <path
          d="M9.9624 14.3459L10.0198 14.3076C10.0389 14.3268 10.0198 14.3842 10.0007 14.4225L9.9624 14.4608V14.3459Z"
          fill="#214063"
        />
        <path
          d="M9.84795 14.0591H9.88622C9.90535 14.1165 9.84795 14.1548 9.82882 14.2122C9.82474 14.1604 9.83125 14.1083 9.84795 14.0591Z"
          fill="#214063"
        />
        <path
          d="M9.86728 14.0975C9.86728 14.0784 9.88641 14.1166 9.84814 14.1358L9.86728 14.0975Z"
          fill="white"
        />
        <path
          d="M11.8292 11.0029H11.8675C11.8675 11.0412 11.8675 11.0412 11.8483 11.0604C11.8292 11.0795 11.8101 11.0412 11.8292 11.0029Z"
          fill="#214063"
        />
        <path
          d="M11.0288 10.1243C11.0288 10.1051 11.0479 10.086 11.0479 10.0668C11.0479 10.0477 11.0862 10.1051 11.0862 10.1243C11.0862 10.1434 11.0288 10.1434 11.0288 10.1243Z"
          fill="#214063"
        />
        <path
          d="M10.4961 9.83768C10.5151 9.81857 10.5532 9.76127 10.5913 9.79947C10.6294 9.83768 10.6485 9.83768 10.6294 9.89498C10.6104 9.95229 10.5913 9.93319 10.5723 9.95229C10.5532 9.97139 10.5151 9.89498 10.4961 9.83768Z"
          fill="#214063"
        />
        <path
          d="M10.9341 10.0099C10.9341 10.0048 10.9361 9.99992 10.9397 9.99633C10.9433 9.99274 10.9481 9.99072 10.9532 9.99072C10.9583 9.99072 10.9632 9.99274 10.9667 9.99633C10.9703 9.99992 10.9723 10.0048 10.9723 10.0099C10.9723 10.0482 10.9149 10.0482 10.9341 10.0099Z"
          fill="#214063"
        />
        <path
          d="M12.0581 10.1813C12.0772 10.1622 12.0772 10.1431 12.0962 10.1431C12.1152 10.1431 12.1343 10.1622 12.1533 10.2004C12.1467 10.2075 12.1383 10.2128 12.1291 10.2158C12.1198 10.2188 12.11 10.2193 12.1004 10.2174C12.0909 10.2155 12.082 10.2112 12.0746 10.2048C12.0672 10.1985 12.0615 10.1904 12.0581 10.1813Z"
          fill="#214063"
        />
        <path
          d="M11.2769 13.0278V13.0661L11.2578 13.047L11.2769 13.0278Z"
          fill="#214063"
        />
        <path
          d="M11.4289 12.7605C11.467 12.7414 11.486 12.6841 11.5051 12.7223C11.5241 12.7605 11.5051 12.8751 11.486 12.9324C11.467 12.9133 11.4479 12.9324 11.4479 12.9133C11.4479 12.8942 11.3908 12.9324 11.3908 12.9898C11.3749 12.9112 11.3884 12.8296 11.4289 12.7605Z"
          fill="#214063"
        />
        <path
          d="M11.2197 9.68467C11.2197 9.66553 11.2389 9.68467 11.258 9.66553C11.2612 9.67038 11.2633 9.67592 11.2641 9.68171C11.2649 9.6875 11.2643 9.69339 11.2625 9.69894C11.2607 9.70448 11.2576 9.70953 11.2535 9.71369C11.2494 9.71785 11.2444 9.72103 11.2389 9.72296C11.2197 9.72296 11.2197 9.70382 11.2197 9.68467Z"
          fill="#214063"
        />
        <path
          d="M12.077 9.78039C12.0961 9.76125 12.1153 9.78039 12.1344 9.79953C12.1233 9.80935 12.1165 9.82307 12.1153 9.83782C12.0961 9.85697 12.0579 9.81868 12.077 9.78039Z"
          fill="#214063"
        />
        <path
          d="M11.7339 9.58947C11.753 9.57033 11.7722 9.58947 11.7913 9.60862C11.8104 9.62776 11.7722 9.6469 11.753 9.6469C11.7339 9.6469 11.7339 9.60862 11.7339 9.58947Z"
          fill="#214063"
        />
        <path
          d="M12.0581 9.70399C12.0962 9.68489 12.0962 9.58938 12.1343 9.62759C12.1724 9.66579 12.1343 9.7231 12.0962 9.7422C12.0581 9.7613 12.0581 9.7231 12.0581 9.70399Z"
          fill="#214063"
        />
        <path
          d="M11.4868 12.149C11.4962 12.1385 11.5014 12.1249 11.5014 12.1108C11.5014 12.0967 11.4962 12.0831 11.4868 12.0726C11.4678 12.0726 11.4487 12.1108 11.4297 12.0917C11.4106 12.0726 11.5059 11.8242 11.6392 11.786C11.7725 11.7478 11.6773 11.8051 11.6963 11.8433C11.7154 11.8815 11.6773 11.9006 11.6963 11.9198C11.7154 11.9389 11.6773 12.0535 11.6201 12.0917C11.563 12.1299 11.6201 12.0917 11.6201 12.0726L11.4868 12.1872V12.149Z"
          fill="#214063"
        />
        <path
          d="M12.0957 12.0347C12.1909 12.0538 12.0957 12.1493 12.0957 12.2066L12.0195 12.2639C12.0133 12.2224 12.0171 12.18 12.0303 12.1402C12.0435 12.1003 12.0659 12.0642 12.0957 12.0347Z"
          fill="#214063"
        />
        <path
          d="M12.0772 12.1108L12.0964 12.13L12.0581 12.1491L12.0964 12.13L12.0772 12.1108Z"
          fill="white"
        />
        <path
          d="M16.0772 5.979H16.1153C16.1153 6.11272 15.9629 6.18913 15.8677 6.22733H15.7915C15.8176 6.16717 15.8568 6.11364 15.9063 6.07067C15.9557 6.02769 16.0141 5.99637 16.0772 5.979Z"
          fill="#214063"
        />
        <path
          d="M12.2673 11.8819L12.229 11.9011V11.8628L12.2673 11.8819Z"
          fill="#214063"
        />
        <path
          d="M12.4005 11.5953L12.4386 11.5571L12.4767 11.6144C12.4767 11.6908 12.4195 11.729 12.3814 11.7673H12.4005C12.3993 11.7525 12.3924 11.7388 12.3814 11.729C12.3624 11.729 12.3624 11.7482 12.3624 11.7673C12.3545 11.7376 12.3539 11.7066 12.3605 11.6766C12.3671 11.6467 12.3808 11.6188 12.4005 11.5953Z"
          fill="#214063"
        />
        <path
          d="M12.4198 11.6714H12.4007C12.4198 11.6905 12.4007 11.6714 12.4007 11.6905C12.4007 11.7097 12.3624 11.6905 12.4198 11.6714Z"
          fill="white"
        />
        <path
          d="M12.5721 11.4997C12.568 11.4656 12.5709 11.4311 12.5808 11.3982C12.5906 11.3653 12.6071 11.3348 12.6293 11.3087C12.6483 11.2896 12.6864 11.2705 12.6864 11.3087C12.697 11.3368 12.7007 11.3671 12.6974 11.3969C12.6941 11.4268 12.6838 11.4555 12.6674 11.4806C12.6293 11.4806 12.6102 11.5379 12.5912 11.557C12.5721 11.5761 12.6293 11.4806 12.5721 11.4997Z"
          fill="#214063"
        />
        <path
          d="M14.4577 11.461C14.4577 11.4559 14.4597 11.4511 14.4632 11.4475C14.4668 11.4439 14.4717 11.4419 14.4767 11.4419C14.4818 11.4419 14.4866 11.4439 14.4902 11.4475C14.4937 11.4511 14.4958 11.4559 14.4958 11.461C14.5338 11.4992 14.4958 11.5565 14.4767 11.5947C14.4577 11.6329 14.4767 11.652 14.4386 11.652C14.4256 11.5879 14.4323 11.5213 14.4577 11.461Z"
          fill="#214063"
        />
        <path
          d="M9.1817 8.40479C9.25789 8.42389 9.20075 8.5194 9.20075 8.57671C9.20075 8.63401 9.02932 8.74862 8.97218 8.84414L8.93408 8.90144C9.02932 8.76773 8.99122 8.48119 9.1817 8.40479Z"
          fill="#214063"
        />
        <path
          d="M13.9818 9.64648H14.0199C14.039 9.66559 14.0771 9.66559 14.0771 9.70379L14.039 9.7993C14.0199 9.7993 14.0199 9.7993 14.0199 9.7802L13.9818 9.8184C13.9247 9.7611 13.9628 9.70379 13.9818 9.64648Z"
          fill="#214063"
        />
        <path
          d="M14.4006 8.94012C14.3815 8.94012 14.3815 8.95922 14.3815 8.97833C14.3815 8.99743 14.3625 8.88281 14.3815 8.82551C14.4006 8.7682 14.4387 8.7682 14.4768 8.7873C14.5148 8.80641 14.5148 8.82551 14.5339 8.86371C14.5529 8.90192 14.4577 8.92102 14.4768 8.95922H14.4577L14.3815 8.99743C14.3815 8.95922 14.3815 8.94012 14.4006 8.94012Z"
          fill="#214063"
        />
        <path
          d="M10.3058 8.17578L10.2866 8.21407V8.17578H10.3058Z"
          fill="#214063"
        />
        <path
          d="M10.5146 8.23291C10.5146 8.21377 10.5338 8.2712 10.5146 8.2712L10.5912 8.23291L10.5146 8.30949V8.23291Z"
          fill="#214063"
        />
        <path
          d="M10.5342 8.21404C10.5342 8.19494 10.5532 8.17584 10.5532 8.15674C10.5532 8.13763 10.5913 8.13763 10.6104 8.15674C10.6294 8.17584 10.6104 8.17584 10.6104 8.19494C10.6104 8.21404 10.6104 8.15674 10.5913 8.13763C10.5723 8.11853 10.5532 8.17584 10.5532 8.19494C10.5532 8.21404 10.5532 8.19494 10.5723 8.19494L10.5342 8.21404Z"
          fill="#214063"
        />
        <path
          d="M13.0483 8.50074C13.1055 8.42434 13.0864 8.29062 13.2007 8.23331C13.315 8.17601 13.2579 8.30972 13.2388 8.34793C13.2198 8.38613 13.1245 8.44344 13.0674 8.50074H13.0483Z"
          fill="#214063"
        />
        <path
          d="M14.9341 8.55774C14.9722 8.51954 14.9722 8.46223 15.0293 8.48133C15.0865 8.50044 15.0484 8.51954 15.0674 8.55774L15.0103 8.61505C14.9912 8.61505 14.9912 8.59595 14.9722 8.61505L14.9341 8.55774Z"
          fill="#214063"
        />
        <path
          d="M12.1342 7.62182C12.1532 7.58361 12.1913 7.54541 12.2103 7.54541C12.2236 7.55289 12.2342 7.56416 12.241 7.57778C12.2478 7.59139 12.2504 7.60673 12.2484 7.62182C12.2103 7.66002 12.1913 7.71733 12.1532 7.73643C12.1151 7.75553 12.1342 7.66002 12.1342 7.62182Z"
          fill="#214063"
        />
        <path
          d="M15.2008 8.53868C15.2008 8.51953 15.1626 8.53868 15.1626 8.53868C15.1626 8.5336 15.1646 8.52873 15.1682 8.52514C15.1718 8.52155 15.1766 8.51953 15.1817 8.51953H15.2008C15.22 8.53868 15.2008 8.57696 15.1626 8.57696C15.1243 8.57696 15.2008 8.57696 15.2008 8.53868Z"
          fill="#214063"
        />
        <path
          d="M10.4575 6.62823C10.4617 6.60738 10.4708 6.58783 10.4841 6.57122C10.4973 6.55461 10.5143 6.54141 10.5337 6.53271C10.5718 6.55182 10.6099 6.59002 10.5909 6.62823C10.5718 6.66643 10.4575 6.72374 10.4575 6.62823Z"
          fill="#214063"
        />
        <path
          d="M11.2957 6.91507H11.2576C11.2386 6.89597 11.2767 6.87686 11.2957 6.87686C11.3066 6.8187 11.3291 6.76334 11.3618 6.7141C11.3945 6.66487 11.4368 6.62277 11.4862 6.59033C11.5045 6.59826 11.5198 6.61174 11.5301 6.62887C11.5403 6.646 11.545 6.66593 11.5433 6.68584L11.4481 6.85776L11.2767 6.99148C11.2767 6.95327 11.2957 6.93417 11.2957 6.91507Z"
          fill="#214063"
        />
        <path
          d="M12.7621 7.52643C12.7621 7.54553 12.7811 7.54553 12.8002 7.54553C12.8383 7.54553 12.8573 7.52643 12.8383 7.48823C12.8192 7.45002 12.7811 7.46913 12.743 7.48823C12.7049 7.50733 12.7811 7.33541 12.8573 7.35451C12.877 7.37583 12.8902 7.40234 12.8954 7.43092L12.8383 7.54553C12.8573 7.54553 12.8573 7.54553 12.8573 7.52643H12.8383L12.8002 7.56464C12.7951 7.56464 12.7903 7.56262 12.7867 7.55904C12.7831 7.55546 12.7811 7.5506 12.7811 7.54553H12.743C12.7508 7.54078 12.7573 7.53423 12.7621 7.52643Z"
          fill="#214063"
        />
        <path
          d="M16.3622 8.80599C16.4003 8.78689 16.4193 8.82509 16.4193 8.84419C16.4193 8.86329 16.3431 8.9015 16.3431 8.95881C16.3431 9.01611 16.3241 8.82509 16.3622 8.80599Z"
          fill="#214063"
        />
        <path
          d="M12.7812 7.44992H12.8387C12.8578 7.43078 12.8578 7.44992 12.8578 7.44992H12.8195C12.8004 7.43078 12.8195 7.41164 12.7812 7.43078H12.8004C12.8004 7.43586 12.7984 7.44073 12.7948 7.44432C12.7912 7.44791 12.7863 7.44992 12.7812 7.44992Z"
          fill="white"
        />
        <path
          d="M18.6485 5.50117H18.6104C18.6104 5.48206 18.7437 5.48206 18.6675 5.40566C18.5913 5.32925 18.858 5.34835 18.9532 5.40566H18.9342C18.9723 5.36745 19.0104 5.29104 19.0865 5.31014C19.1627 5.32925 19.1246 5.32925 19.1246 5.36745C19.1246 5.40566 18.877 5.38655 18.9151 5.57758C18.8965 5.60631 18.8711 5.63004 18.8412 5.64669C18.8114 5.66333 18.7779 5.6724 18.7437 5.67309L18.7056 5.73039C18.7437 5.69219 18.6865 5.67309 18.6865 5.65398H18.6485V5.61578H18.5913C18.6104 5.55847 18.6485 5.53937 18.6485 5.50117Z"
          fill="#214063"
        />
        <path
          d="M15.486 8.13765C15.5241 8.11855 15.5241 8.08034 15.5812 8.09944C15.6383 8.11855 15.6002 8.15675 15.6002 8.19496C15.6002 8.23316 15.5621 8.19495 15.5621 8.23316C15.5431 8.21406 15.4479 8.17585 15.486 8.13765Z"
          fill="#214063"
        />
        <path
          d="M11.9053 6.53302C11.905 6.50597 11.912 6.47933 11.9254 6.45584C11.9387 6.43234 11.9581 6.41283 11.9815 6.39931C12.0005 6.39931 12.0386 6.3802 12.0386 6.41841C12.0386 6.45661 11.9815 6.51392 11.9434 6.57123C11.9053 6.62853 11.9053 6.55212 11.9053 6.53302Z"
          fill="#214063"
        />
        <path
          d="M11.9626 6.47559L11.9243 6.53302L11.9626 6.47559Z"
          fill="white"
        />
        <path
          d="M16.0769 8.06084C16.0578 8.07995 16.0578 8.02264 16.0388 8.04174C16.0197 8.06084 16.0578 7.96533 16.0959 7.96533C16.134 7.96533 16.1149 8.00354 16.134 8.04174L16.0769 8.06084Z"
          fill="#214063"
        />
        <path
          d="M16.0768 8.04209L16.0959 8.02295V8.04209H16.0768L16.0576 8.02295L16.0768 8.04209Z"
          fill="white"
        />
        <path
          d="M16.3628 7.46905C16.3628 7.44994 16.3628 7.39264 16.4009 7.37354H16.4961C16.5533 7.43084 16.4771 7.48815 16.4771 7.52635C16.439 7.50725 16.4199 7.54546 16.4009 7.54546C16.3818 7.54546 16.3818 7.48815 16.3628 7.46905Z"
          fill="#214063"
        />
        <path
          d="M17.4102 8.2525H17.3911C17.4102 8.19519 17.3911 8.11878 17.4673 8.09968C17.5435 8.08058 17.5244 8.17609 17.5054 8.19519C17.4864 8.21429 17.4483 8.2525 17.4102 8.2716V8.2525Z"
          fill="#214063"
        />
        <path
          d="M12.2675 5.59722C12.2484 5.55902 12.3056 5.46351 12.3436 5.4253C12.358 5.40996 12.3769 5.39977 12.3976 5.39632C12.4182 5.39287 12.4394 5.39634 12.4579 5.4062C12.5151 5.4253 12.496 5.48261 12.496 5.52081C12.496 5.55902 12.4389 5.57812 12.4389 5.61633C12.4389 5.65453 12.3436 5.71184 12.3246 5.61633H12.3055C12.3018 5.6097 12.2962 5.60434 12.2894 5.60094C12.2826 5.59753 12.275 5.59624 12.2675 5.59722Z"
          fill="#214063"
        />
        <path
          d="M16.8008 7.60276H16.7627C16.8198 7.58366 16.8389 7.46905 16.9151 7.50725C16.9913 7.54546 16.9532 7.60276 16.9532 7.64097C16.9532 7.67917 16.9151 7.66007 16.9151 7.67917C16.9151 7.69828 16.896 7.67917 16.896 7.66007C16.896 7.64097 16.877 7.66007 16.8389 7.67917H16.8008C16.8198 7.62187 16.7627 7.62187 16.8008 7.60276Z"
          fill="#214063"
        />
        <path
          d="M13.4102 6.05568C13.4292 6.05568 13.4102 6.09389 13.4102 6.11299L13.353 6.17029C13.3721 6.2085 13.3911 6.15119 13.4102 6.15119L13.3721 6.11299C13.315 6.09389 13.334 6.17029 13.315 6.1894L13.2769 6.2276C13.2959 6.13209 13.334 6.03658 13.4102 6.05568Z"
          fill="#214063"
        />
        <path
          d="M14.7622 5.52051H14.7813C14.7622 5.53965 14.7813 5.53965 14.7622 5.52051Z"
          fill="#214063"
        />
        <path
          d="M16.7052 6.55225H16.7243V6.59053C16.7243 6.57139 16.7052 6.55225 16.686 6.57139L16.7052 6.55225Z"
          fill="#214063"
        />
        <path
          d="M15.3721 4.66064H15.3912C15.3883 4.66232 15.385 4.66321 15.3816 4.66321C15.3783 4.66321 15.375 4.66232 15.3721 4.66064Z"
          fill="#214063"
        />
        <path
          d="M15.4292 4.64147H15.4483V4.60326C15.4483 4.58416 15.4292 4.58416 15.4292 4.56506C15.4292 4.54596 15.3911 4.60326 15.3911 4.64147H15.3721C15.3911 4.58416 15.4292 4.56506 15.4864 4.52686H15.5245C15.5054 4.60326 15.4483 4.62237 15.3911 4.64147H15.4292Z"
          fill="#214063"
        />
        <path
          d="M17.9243 5.63525C17.9446 5.63525 17.9639 5.6433 17.9782 5.65763C17.9925 5.67196 18.0005 5.6914 18.0005 5.71166L17.9624 5.76897C17.9624 5.76897 17.9434 5.71166 17.9243 5.74987C17.9053 5.78807 17.9243 5.78807 17.9053 5.80717H17.9243C17.8862 5.78807 17.8862 5.82628 17.8482 5.82628V5.78807H17.8101C17.8482 5.73076 17.8672 5.65436 17.9243 5.63525Z"
          fill="#214063"
        />
        <path
          d="M16.4194 4.71791C16.4766 4.6606 16.4956 4.6033 16.5718 4.6224C16.648 4.6415 16.5718 4.69881 16.5718 4.73701L16.4956 4.79432H16.4194C16.4385 4.73701 16.4385 4.71791 16.4194 4.71791Z"
          fill="#214063"
        />
        <path
          d="M16.4961 4.66097L16.458 4.69917C16.4592 4.68445 16.466 4.67077 16.4771 4.66097C16.5152 4.64187 16.5152 4.68007 16.5342 4.69917C16.5532 4.71827 16.4771 4.73738 16.4771 4.75648C16.4771 4.77558 16.439 4.71827 16.4961 4.66097Z"
          fill="white"
        />
        <path
          d="M17.7912 6.01709C17.8103 6.01709 17.8103 6.03619 17.8293 6.05529C17.8484 6.0744 17.8103 6.0935 17.7722 6.1126C17.7341 6.1317 17.7912 6.1126 17.7912 6.0744H17.7531C17.7531 6.0935 17.7531 6.1126 17.7341 6.1126C17.715 6.1126 17.7531 6.01709 17.7912 6.01709Z"
          fill="#214063"
        />
        <path
          d="M16.5528 4.25977H16.5718V4.29797H16.5528V4.35528V4.31707L16.4766 4.37438C16.4766 4.33617 16.4956 4.27887 16.5528 4.25977Z"
          fill="#214063"
        />
        <path
          d="M21.2007 5.55902C21.2007 5.50171 21.1626 5.53992 21.1436 5.52081C21.1245 5.50171 21.1817 5.53992 21.2007 5.50171C21.2198 5.46351 21.1626 5.46351 21.1436 5.48261H21.1245C21.1626 5.44441 21.2197 5.48261 21.2388 5.4062C21.2578 5.32979 21.2197 5.3871 21.2197 5.368C21.2197 5.34889 21.2769 5.31069 21.334 5.29159H21.315C21.3531 5.27249 21.3912 5.29159 21.4293 5.29159C21.4674 5.29159 21.5055 5.27249 21.5055 5.21518C21.5055 5.15787 21.5626 5.29159 21.5817 5.25338C21.6353 5.3035 21.6691 5.37132 21.6769 5.44441C21.6959 5.48261 21.6769 5.48261 21.6578 5.53992C21.6578 5.55902 21.6388 5.55902 21.6578 5.57812C21.6769 5.59722 21.6007 5.61633 21.6007 5.63543C21.6007 5.65453 21.5626 5.71184 21.5436 5.69273V5.73094H21.5055C21.4674 5.76914 21.3912 5.76914 21.3531 5.82645H21.3721V5.78824L21.334 5.84555C21.334 5.82645 21.3721 5.78825 21.3531 5.75004C21.334 5.71184 21.315 5.76914 21.2959 5.76914H21.315C21.2959 5.75004 21.2769 5.78825 21.2388 5.76914C21.2007 5.75004 21.2388 5.69273 21.2197 5.67363H21.1436C21.1562 5.6722 21.1682 5.66763 21.1786 5.66034C21.189 5.65305 21.1975 5.64326 21.2031 5.63188C21.2088 5.62049 21.2116 5.60786 21.2111 5.59514C21.2107 5.58241 21.2071 5.57 21.2007 5.55902Z"
          fill="#214063"
        />
        <path
          d="M17.0859 4.24095C17.0668 4.24095 17.0668 4.26005 17.0859 4.26005C17.1049 4.26005 17.124 4.26005 17.143 4.24095C17.124 4.22185 17.124 4.26005 17.1049 4.24095C17.0859 4.22185 17.143 4.22185 17.1811 4.20275C17.2192 4.18364 17.1811 4.26005 17.143 4.27916C17.1049 4.29826 17.0859 4.29826 17.0478 4.29826C17.0441 4.29207 17.0423 4.28496 17.0425 4.27777C17.0427 4.27057 17.0449 4.26358 17.0489 4.25759C17.0529 4.2516 17.0584 4.24686 17.065 4.24392C17.0715 4.24097 17.0788 4.23995 17.0859 4.24095Z"
          fill="#214063"
        />
        <path
          d="M17.6768 4.03072C17.6946 4.02406 17.7142 4.02428 17.7318 4.03134C17.7494 4.03841 17.7638 4.05181 17.772 4.06893C17.7789 4.07668 17.7842 4.08576 17.7874 4.09561C17.7907 4.10546 17.792 4.11588 17.7911 4.12623C17.8292 4.10713 17.8863 4.10713 17.8863 4.16444C17.8863 4.22174 17.6387 4.25995 17.5625 4.27905V4.24085H17.5244C17.528 4.19513 17.5441 4.15129 17.571 4.1142C17.5979 4.07711 17.6345 4.04822 17.6768 4.03072Z"
          fill="#214063"
        />
        <path
          d="M23.9624 3.64824H23.9434C23.9582 3.64824 23.9727 3.64478 23.986 3.63815C23.9992 3.63152 24.0107 3.62189 24.0196 3.61003H23.9815C24.0005 3.61003 24.0386 3.62913 24.0386 3.59093H24.0196C24.0957 3.61003 24.1338 3.55273 24.191 3.57183C24.2481 3.59093 24.3243 3.61003 24.3624 3.61003C24.4005 3.61003 24.4005 3.66734 24.4005 3.68644L24.3624 3.83926L24.2862 3.89656C24.307 3.90835 24.3247 3.92487 24.3379 3.94477C24.3512 3.96468 24.3595 3.98743 24.3624 4.01118C24.3815 4.10669 24.2862 4.08759 24.2672 4.14489C24.2481 4.2022 24.191 4.12579 24.1529 4.14489H24.1338C24.1719 4.08759 24.0767 4.08759 24.0386 4.06848H24.0196C24.0196 4.04938 24.0577 4.06848 24.0577 4.03028H24.0767C24.0577 4.01118 24.0386 3.99208 24.0577 3.95387H23.9053C23.9243 3.70554 24.0005 3.70554 23.9624 3.64824Z"
          fill="#214063"
        />
        <path
          d="M19.7529 5.27245H19.7339C19.772 5.23424 19.772 5.13873 19.8482 5.11963H19.9815C19.9957 5.15284 20.0029 5.18858 20.0029 5.22469C20.0029 5.2608 19.9957 5.29654 19.9815 5.32975C19.9434 5.32975 19.9053 5.38706 19.8672 5.38706H19.8482V5.34886H19.7529C19.7518 5.3234 19.7518 5.2979 19.7529 5.27245Z"
          fill="#214063"
        />
        <path d="M18.1528 4.6417L18.172 4.62256L18.1528 4.6417Z" fill="white" />
        <path
          d="M18.4768 4.2219H18.4576C18.4768 4.20275 18.4385 4.18361 18.4194 4.20275C18.4002 4.2219 18.4576 4.20275 18.4768 4.2219Z"
          fill="#214063"
        />
        <path
          d="M18.7627 4.12593H18.7437C18.7437 4.12593 18.7817 4.08773 18.7627 4.06862C18.7437 4.04952 18.9151 4.12593 18.9532 3.99222C18.9913 3.8585 19.0865 3.97311 19.1246 4.04952C19.1307 4.06191 19.1341 4.07549 19.1345 4.08932C19.1349 4.10315 19.1323 4.1169 19.1268 4.12962C19.1214 4.14234 19.1133 4.15372 19.103 4.16298C19.0928 4.17223 19.0806 4.17915 19.0675 4.18324L19.0103 4.24054H18.9532C18.9532 4.18324 18.896 4.24054 18.877 4.22144C18.8579 4.16414 18.8198 4.22144 18.7817 4.18324H18.7437L18.7627 4.12593Z"
          fill="#214063"
        />
        <path
          d="M20.9339 3.7441C20.9148 3.7441 20.972 3.7441 20.9339 3.70589C20.8958 3.66769 20.972 3.66769 20.991 3.66769C21.0481 3.68679 21.0291 3.57218 21.1243 3.62948C21.2196 3.68679 21.2005 3.66769 21.2386 3.64859C21.2619 3.6698 21.278 3.69771 21.2848 3.72849C21.2917 3.75927 21.2888 3.79141 21.2767 3.82051L21.2005 3.89691V3.93512C21.1815 3.87781 21.1624 3.99243 21.1243 3.93512H21.0481C21.0532 3.93512 21.058 3.93311 21.0616 3.92952C21.0652 3.92594 21.0672 3.92108 21.0672 3.91602H20.9529C20.9148 3.7823 20.991 3.7823 20.9339 3.7441Z"
          fill="#214063"
        />
        <path
          d="M22.229 5.38655C22.2481 5.40565 22.2481 5.36744 22.2671 5.34834C22.2861 5.32924 22.3623 5.36744 22.3623 5.40565V5.48206C22.3433 5.46296 22.3242 5.50116 22.3052 5.52026C22.2861 5.53936 22.2671 5.50116 22.2671 5.50116L22.229 5.46296C22.2384 5.45245 22.2436 5.43885 22.2436 5.42475C22.2436 5.41066 22.2384 5.39705 22.229 5.38655Z"
          fill="#214063"
        />
        <path
          d="M22.2098 7.35456C22.2288 7.35456 22.2669 7.39277 22.2288 7.45007C22.2252 7.45414 22.2208 7.45739 22.2159 7.45962C22.211 7.46185 22.2057 7.46301 22.2002 7.46301C22.1948 7.46301 22.1895 7.46185 22.1846 7.45962C22.1796 7.45739 22.1752 7.45414 22.1717 7.45007C22.1336 7.43097 22.1526 7.33546 22.2098 7.35456Z"
          fill="#214063"
        />
        <path
          d="M23.3338 4.68006C23.3338 4.66096 23.3529 4.66096 23.3529 4.62276C23.3529 4.58455 23.429 4.62276 23.4481 4.66096C23.4671 4.69917 23.4481 4.71827 23.429 4.73737H23.3719C23.3529 4.71827 23.3148 4.69917 23.3338 4.66096V4.68006Z"
          fill="#214063"
        />
        <path
          d="M23.5628 4.60372H23.5437C23.5245 4.60372 23.5054 4.58457 23.5245 4.56543L23.5628 4.60372Z"
          fill="#214063"
        />
        <path
          d="M22.5718 5.88347C22.5737 5.87797 22.5769 5.87298 22.581 5.86889C22.5851 5.8648 22.5902 5.86171 22.5957 5.85987C22.6012 5.85803 22.6071 5.85747 22.6128 5.85825C22.6186 5.85903 22.6241 5.86112 22.6289 5.86437C22.6289 5.88347 22.648 5.90257 22.6289 5.90257H22.5718C22.5667 5.90257 22.5619 5.90056 22.5583 5.89698C22.5547 5.8934 22.5527 5.88854 22.5527 5.88347C22.5527 5.8784 22.5547 5.87355 22.5583 5.86996C22.5619 5.86638 22.5667 5.86437 22.5718 5.86437V5.88347Z"
          fill="#214063"
        />
        <path
          d="M22.5909 5.90248H22.61C22.6292 5.90248 22.5718 5.94076 22.5718 5.90248C22.5718 5.86419 22.5909 5.88333 22.5909 5.90248Z"
          fill="white"
        />
        <path
          d="M23.2582 6.57116H23.2392C23.2582 6.59026 23.2773 6.57116 23.2963 6.55205V6.49475C23.3154 6.51385 23.3344 6.49475 23.3535 6.49475V6.45654C23.4296 6.49475 23.582 6.45654 23.6011 6.59026L23.563 6.72397C23.5249 6.78128 23.4677 6.76218 23.4296 6.81949V6.76218C23.3916 6.80038 23.4106 6.76218 23.3916 6.76218H23.3344C23.3344 6.74308 23.3344 6.74308 23.3535 6.74308C23.3725 6.74308 23.3154 6.72397 23.2963 6.72397C23.2773 6.72397 23.2963 6.66667 23.2773 6.60936H23.2392C23.2011 6.59026 23.2582 6.62846 23.2582 6.57116Z"
          fill="#214063"
        />
        <path
          d="M23.6763 5.34904C23.6953 5.32994 23.6953 5.32994 23.6953 5.29173H23.6763C23.6763 5.29173 23.7144 5.29173 23.7144 5.31084C23.7144 5.32994 23.7334 5.25353 23.7715 5.27263C23.8096 5.29173 23.7715 5.23443 23.7715 5.21532C23.7715 5.19622 23.7906 5.25353 23.8477 5.25353C23.9048 5.25353 23.9429 5.29173 23.981 5.25353L24.0382 5.29173C24.0382 5.31084 24.0572 5.29173 24.0572 5.29173C24.0572 5.29173 24.0953 5.38724 24.1144 5.38724C24.1334 5.38724 24.1334 5.44455 24.1525 5.46365C24.1474 5.46365 24.1426 5.46567 24.139 5.46925C24.1354 5.47283 24.1334 5.47769 24.1334 5.48276C24.1334 5.48782 24.1354 5.49268 24.139 5.49626C24.1426 5.49984 24.1474 5.50186 24.1525 5.50186C24.0953 5.52096 24.2096 5.55916 24.1334 5.57827C24.0572 5.59737 24.1525 5.61647 24.1525 5.61647H24.0953C24.1525 5.67378 24.0382 5.65467 24.0572 5.73108C24.0763 5.80749 24.0191 5.73108 24.0001 5.75019C23.981 5.71198 23.9429 5.76929 23.9048 5.76929C23.8667 5.76929 23.8477 5.69288 23.7906 5.75019C23.7334 5.80749 23.7715 5.65467 23.7144 5.69288H23.6763C23.6572 5.65467 23.7334 5.67378 23.6953 5.63557C23.6572 5.59737 23.6763 5.65467 23.6572 5.65467C23.6382 5.65467 23.7334 5.59737 23.6572 5.55916H23.6001C23.6119 5.55027 23.6215 5.53873 23.6281 5.52547C23.6347 5.51221 23.6382 5.49758 23.6382 5.48276C23.6382 5.44455 23.581 5.50186 23.6001 5.46365C23.6191 5.42545 23.6382 5.46365 23.6382 5.42545L23.6001 5.38724C23.6382 5.42545 23.6382 5.34904 23.6763 5.34904Z"
          fill="#214063"
        />
        <path
          d="M24.9718 6.68607C24.9718 6.66697 24.9718 6.66697 24.9527 6.66697C24.9337 6.66697 25.0289 6.60966 25.0289 6.57146C25.0289 6.53325 25.1051 6.47594 25.1622 6.51415C25.2194 6.55235 25.1813 6.45684 25.2194 6.49505H25.2384C25.2956 6.53325 25.3718 6.51415 25.4289 6.57146C25.4861 6.62876 25.448 6.64786 25.5051 6.64786H25.467C25.4861 6.70517 25.5432 6.72427 25.4861 6.78158V6.81978C25.4509 6.84239 25.4241 6.87594 25.4099 6.9153C25.3718 6.9344 25.3146 6.9153 25.3146 6.9535C25.3146 6.9917 25.2765 6.9917 25.2384 7.01081H25.2003V6.9726C25.1847 6.96418 25.1667 6.96147 25.1493 6.96496C25.1319 6.96845 25.1163 6.9779 25.1051 6.9917C25.1051 6.9726 25.067 7.01081 25.048 6.9917H25.0289C25.0099 6.9535 24.9718 6.9917 24.9527 6.9726C24.9337 6.9535 24.9908 6.9535 24.9718 6.9344V6.89619H24.9337L24.9718 6.85799C24.9527 6.81978 24.9146 6.87709 24.8956 6.83889C24.8765 6.80068 24.9146 6.70517 24.9718 6.68607Z"
          fill="#214063"
        />
        <path
          d="M24.9528 4.27913C24.9528 4.29823 24.9719 4.31734 24.9719 4.33644C24.9719 4.35554 24.9147 4.33644 24.8957 4.31734C24.8766 4.29823 24.9147 4.26003 24.9528 4.27913Z"
          fill="#214063"
        />
        <path
          d="M25.6953 2.94189H25.7144C25.7334 2.9801 25.6953 2.9801 25.6763 2.9801C25.6572 2.9801 25.6763 2.9801 25.6382 2.94189H25.6953Z"
          fill="#214063"
        />
        <path
          d="M25.4868 6.11279L25.544 6.1701C25.5249 6.1701 25.5249 6.2083 25.4868 6.2083H25.4678C25.4487 6.1701 25.5249 6.1892 25.4868 6.151H25.4487L25.4868 6.11279Z"
          fill="#214063"
        />
        <path
          d="M25.8867 4.90931C25.8858 4.89896 25.8871 4.88854 25.8904 4.87869C25.8936 4.86884 25.8989 4.85976 25.9058 4.852C25.9629 4.8138 26.001 4.8329 26.0582 4.8329C26.1153 4.8329 26.1534 4.92841 26.1153 4.98572C26.0772 5.04302 26.0772 5.02392 26.1153 5.04302C26.1534 5.06213 26.0391 5.04302 26.0582 5.08123C26.0772 5.11943 26.0201 5.06213 26.001 5.08123H25.9629C25.9248 5.11943 25.9248 5.06213 25.8867 5.06213H25.9058C25.9058 5.04302 25.8867 5.06213 25.8677 5.04302V4.98572H25.9058L25.8867 4.90931Z"
          fill="#214063"
        />
        <path
          d="M26.001 5.17651C26.02 5.1574 26.0772 5.17651 26.0772 5.1383C26.0772 5.1001 26.0962 5.1383 26.1153 5.1383H26.1343C26.1534 5.1192 26.1534 5.1192 26.1534 5.1001L26.1915 5.1383H26.2296V5.1574C26.3058 5.1383 26.3058 5.19561 26.3438 5.21471C26.3819 5.23381 26.3248 5.29112 26.3819 5.31022C26.4391 5.32932 26.3819 5.44394 26.3058 5.50124C26.2296 5.55855 26.2867 5.50124 26.2867 5.48214C26.2867 5.46304 26.2486 5.52035 26.2677 5.53945L26.2296 5.50124C26.1915 5.57765 26.1343 5.50124 26.0962 5.52035C26.0581 5.53945 26.0581 5.52035 26.0581 5.48214H26.02V5.44394C26.001 5.46304 26.001 5.42483 25.9629 5.46304C25.9248 5.50124 26.001 5.36753 25.9438 5.36753C25.9507 5.35978 25.956 5.3507 25.9593 5.34084C25.9625 5.33099 25.9638 5.32057 25.9629 5.31022C25.9058 5.27202 26.0391 5.23381 26.001 5.17651Z"
          fill="#214063"
        />
        <path
          d="M26.7627 5.82625C26.8008 5.80714 26.7627 5.78804 26.7437 5.76894L26.7818 5.73074C26.7627 5.71163 26.7437 5.73074 26.7437 5.71163C26.7437 5.69253 26.8008 5.74984 26.8008 5.69253H26.8389V5.65433C26.8579 5.65433 26.9151 5.65433 26.9151 5.61612V5.53971C26.9722 5.53971 26.9341 5.46331 26.9722 5.50151C27.0103 5.53971 27.0294 5.406 27.0103 5.36779C26.9913 5.32959 27.0484 5.34869 27.0675 5.32959C27.0675 5.33466 27.0695 5.33951 27.0731 5.3431C27.0766 5.34668 27.0815 5.34869 27.0865 5.34869C27.1056 5.31049 27.1246 5.36779 27.1437 5.34869C27.1627 5.32959 27.1818 5.406 27.2199 5.3869C27.2579 5.36779 27.2579 5.4442 27.2579 5.48241C27.2579 5.52061 27.2579 5.4251 27.296 5.406C27.3341 5.3869 27.2579 5.50151 27.3341 5.52061H27.3722C27.3722 5.52061 27.3722 5.57792 27.4103 5.55882V5.61612H27.4484C27.4484 5.63522 27.4294 5.65433 27.4484 5.65433C27.4675 5.65433 27.4675 5.65433 27.4675 5.65433C27.4666 5.66468 27.4678 5.6751 27.4711 5.68495C27.4744 5.6948 27.4796 5.70388 27.4865 5.71163H27.5246V5.78804C27.5818 5.78804 27.5056 5.82625 27.5627 5.84535C27.6199 5.86445 27.5627 5.92176 27.5818 5.94086C27.6008 5.95996 27.5437 5.92176 27.5437 5.95996C27.5437 5.99817 27.5818 5.97906 27.6008 5.99817H27.5437C27.5343 6.00867 27.5291 6.02228 27.5291 6.03637C27.5291 6.05047 27.5343 6.06407 27.5437 6.07458C27.5437 6.09368 27.4675 6.11278 27.5246 6.15098H27.5056C27.4865 6.18919 27.5246 6.18919 27.5246 6.20829C27.5246 6.22739 27.4675 6.13188 27.4294 6.20829V6.22739C27.3151 6.22739 27.3722 6.38021 27.2579 6.36111C27.1437 6.34201 27.2199 6.3229 27.2008 6.3229C27.1818 6.3229 27.1437 6.38021 27.0865 6.36111C27.0294 6.34201 27.0103 6.2656 26.9913 6.2847C26.9722 6.3038 26.9532 6.3229 26.9341 6.3229C26.9151 6.3229 26.9913 6.2656 26.9341 6.22739H26.896C26.9151 6.20829 26.896 6.17009 26.896 6.15098H26.8579C26.8579 6.13188 26.896 6.11278 26.8579 6.09368H26.8199C26.8199 6.07458 26.8579 6.07458 26.8389 6.05547C26.8199 6.03637 26.8199 5.99817 26.7818 6.01727C26.7437 6.03637 26.8199 5.99817 26.7818 5.95996H26.7437C26.7627 5.94086 26.8008 5.94086 26.7818 5.90266H26.7246C26.7437 5.90266 26.7627 5.90266 26.7627 5.86445H26.7056C26.7246 5.86445 26.7627 5.86445 26.7627 5.82625Z"
          fill="#214063"
        />
        <path
          d="M22.4007 3.15186C22.4388 3.17096 22.4959 3.15186 22.5149 3.20916C22.534 3.26647 22.4768 3.34288 22.4007 3.30467H22.3816L22.3435 3.24737C22.3816 3.22826 22.3054 3.19006 22.3435 3.17096C22.3816 3.15186 22.4007 3.19006 22.4007 3.15186Z"
          fill="#214063"
        />
        <path
          d="M22.7631 3.24756L22.7057 3.2667V3.24756L22.6865 3.2667V3.24756H22.7631Z"
          fill="#214063"
        />
        <path
          d="M22.877 3.19045H22.8579C22.8727 3.19045 22.8873 3.187 22.9005 3.18037C22.9137 3.17374 22.9252 3.16411 22.9341 3.15225H22.9151C22.9887 3.12438 23.07 3.12438 23.1436 3.15225C23.1817 3.19045 23.2198 3.24776 23.277 3.22865C23.3341 3.20955 23.2389 3.24776 23.2579 3.28596C23.277 3.32417 23.296 3.36237 23.3151 3.40057C23.3341 3.43878 23.2579 3.45788 23.2389 3.51519C23.2198 3.57249 23.1817 3.51519 23.1817 3.55339V3.43878C23.1436 3.45788 23.1627 3.49609 23.1436 3.51519V3.47698C23.1055 3.51519 23.0484 3.49609 23.0103 3.51519C22.9722 3.53429 22.9151 3.51519 22.877 3.53429C22.8389 3.55339 22.9532 3.45788 22.9151 3.40057H22.877C22.8389 3.36237 22.9341 3.34327 22.896 3.30506L22.8008 3.36237C22.8198 3.30506 22.896 3.28596 22.877 3.19045Z"
          fill="#214063"
        />
        <path
          d="M23.1246 3.64864H23.1055V3.61035L23.1246 3.64864Z"
          fill="#214063"
        />
        <path
          d="M19.2009 9.32178L19.1817 9.34092L19.1626 9.32178H19.2009Z"
          fill="white"
        />
        <path
          d="M14.3434 2.59803L14.4006 2.54073C14.4767 2.52162 14.4767 2.55983 14.4958 2.59803C14.4884 2.62354 14.4735 2.64625 14.4532 2.66326C14.4328 2.68027 14.4079 2.69081 14.3815 2.69354C14.3434 2.69354 14.3244 2.63624 14.3434 2.59803Z"
          fill="#214063"
        />
        <path
          d="M14.286 2.29248C14.3241 2.29248 14.3241 2.31158 14.3431 2.33068C14.3622 2.34979 14.3241 2.38799 14.286 2.40709C14.2479 2.4262 14.1908 2.33068 14.286 2.29248Z"
          fill="#214063"
        />
        <path
          d="M12.4382 14.3457C12.4574 14.3457 12.4765 14.3648 12.4574 14.4031H12.4382C12.4342 14.3995 12.4309 14.3951 12.4287 14.3902C12.4264 14.3852 12.4253 14.3799 12.4253 14.3744C12.4253 14.369 12.4264 14.3636 12.4287 14.3587C12.4309 14.3537 12.4342 14.3493 12.4382 14.3457Z"
          fill="#214063"
        />
        <path
          d="M14.0005 7.67881V7.65967H14.0196L14.0005 7.67881Z"
          fill="#214063"
        />
        <path
          d="M12.3242 14.174C12.3434 14.1549 12.3434 14.174 12.3625 14.174C12.3816 14.174 12.3625 14.2123 12.3434 14.2123C12.3242 14.2123 12.3242 14.1932 12.3242 14.174Z"
          fill="#214063"
        />
        <path
          d="M14.2862 7.39258H14.3243C14.3052 7.44988 14.2481 7.46899 14.191 7.48809C14.1338 7.50719 14.2291 7.39258 14.2862 7.39258Z"
          fill="#214063"
        />
        <path
          d="M12.7052 13.811C12.7433 13.811 12.8004 13.811 12.7814 13.8683C12.7623 13.9256 12.7433 13.9065 12.7052 13.9065C12.6944 13.893 12.6885 13.8762 12.6885 13.8588C12.6885 13.8414 12.6944 13.8246 12.7052 13.811Z"
          fill="#214063"
        />
        <path
          d="M9.67634 14.8807C9.67007 14.8362 9.67365 14.7909 9.68682 14.748C9.69999 14.705 9.72242 14.6656 9.75253 14.6323C9.79063 14.6514 9.77158 14.6896 9.77158 14.7278C9.77158 14.766 9.69539 14.8233 9.69539 14.8998C9.69539 14.9762 9.69539 14.8807 9.67634 14.8807Z"
          fill="#214063"
        />
        <path
          d="M19.067 2.55995H19.0289L19.067 2.52174C19.0099 2.46444 19.1432 2.44533 19.1242 2.40713C19.1978 2.37926 19.2791 2.37926 19.3527 2.40713C19.3908 2.46444 19.3718 2.48354 19.4099 2.54084C19.448 2.59815 19.448 2.67456 19.3337 2.67456C19.2194 2.67456 19.2385 2.67456 19.1813 2.71276C19.1242 2.75097 19.1623 2.69366 19.1242 2.67456H19.0861C19.1242 2.63636 19.067 2.61725 19.0289 2.59815C18.9908 2.57905 19.048 2.57905 19.067 2.55995Z"
          fill="#214063"
        />
        <path
          d="M9.9624 14.3459L10.0198 14.3076C10.0389 14.3268 10.0198 14.3842 10.0007 14.4225L9.9624 14.4608V14.3459Z"
          fill="#214063"
        />
        <path
          d="M9.84795 14.0591H9.88622C9.90535 14.1165 9.84795 14.1548 9.82882 14.2122C9.82474 14.1604 9.83125 14.1083 9.84795 14.0591Z"
          fill="#214063"
        />
        <path
          d="M9.86728 14.0975C9.86728 14.0784 9.88641 14.1166 9.84814 14.1358L9.86728 14.0975Z"
          fill="white"
        />
        <path
          d="M11.8292 11.0029H11.8675C11.8675 11.0412 11.8675 11.0412 11.8483 11.0604C11.8292 11.0795 11.8101 11.0412 11.8292 11.0029Z"
          fill="#214063"
        />
        <path
          d="M11.0288 10.1243C11.0288 10.1051 11.0479 10.086 11.0479 10.0668C11.0479 10.0477 11.0862 10.1051 11.0862 10.1243C11.0862 10.1434 11.0288 10.1434 11.0288 10.1243Z"
          fill="#214063"
        />
        <path
          d="M10.4961 9.83768C10.5151 9.81857 10.5532 9.76127 10.5913 9.79947C10.6294 9.83768 10.6485 9.83768 10.6294 9.89498C10.6104 9.95229 10.5913 9.93319 10.5723 9.95229C10.5532 9.97139 10.5151 9.89498 10.4961 9.83768Z"
          fill="#214063"
        />
        <path
          d="M10.9341 10.0099C10.9341 10.0048 10.9361 9.99992 10.9397 9.99633C10.9433 9.99274 10.9481 9.99072 10.9532 9.99072C10.9583 9.99072 10.9632 9.99274 10.9667 9.99633C10.9703 9.99992 10.9723 10.0048 10.9723 10.0099C10.9723 10.0482 10.9149 10.0482 10.9341 10.0099Z"
          fill="#214063"
        />
        <path
          d="M12.0581 10.1813C12.0772 10.1622 12.0772 10.1431 12.0962 10.1431C12.1152 10.1431 12.1343 10.1622 12.1533 10.2004C12.1467 10.2075 12.1383 10.2128 12.1291 10.2158C12.1198 10.2188 12.11 10.2193 12.1004 10.2174C12.0909 10.2155 12.082 10.2112 12.0746 10.2048C12.0672 10.1985 12.0615 10.1904 12.0581 10.1813Z"
          fill="#214063"
        />
        <path
          d="M11.2769 13.0278V13.0661L11.2578 13.047L11.2769 13.0278Z"
          fill="#214063"
        />
        <path
          d="M11.4289 12.7605C11.467 12.7414 11.486 12.6841 11.5051 12.7223C11.5241 12.7605 11.5051 12.8751 11.486 12.9324C11.467 12.9133 11.4479 12.9324 11.4479 12.9133C11.4479 12.8942 11.3908 12.9324 11.3908 12.9898C11.3749 12.9112 11.3884 12.8296 11.4289 12.7605Z"
          fill="#214063"
        />
        <path
          d="M11.2197 9.68467C11.2197 9.66553 11.2389 9.68467 11.258 9.66553C11.2612 9.67038 11.2633 9.67592 11.2641 9.68171C11.2649 9.6875 11.2643 9.69339 11.2625 9.69894C11.2607 9.70448 11.2576 9.70953 11.2535 9.71369C11.2494 9.71785 11.2444 9.72103 11.2389 9.72296C11.2197 9.72296 11.2197 9.70382 11.2197 9.68467Z"
          fill="#214063"
        />
        <path
          d="M12.077 9.78039C12.0961 9.76125 12.1153 9.78039 12.1344 9.79953C12.1233 9.80935 12.1165 9.82307 12.1153 9.83782C12.0961 9.85697 12.0579 9.81868 12.077 9.78039Z"
          fill="#214063"
        />
        <path
          d="M11.7339 9.58947C11.753 9.57033 11.7722 9.58947 11.7913 9.60862C11.8104 9.62776 11.7722 9.6469 11.753 9.6469C11.7339 9.6469 11.7339 9.60862 11.7339 9.58947Z"
          fill="#214063"
        />
        <path
          d="M12.0581 9.70399C12.0962 9.68489 12.0962 9.58938 12.1343 9.62759C12.1724 9.66579 12.1343 9.7231 12.0962 9.7422C12.0581 9.7613 12.0581 9.7231 12.0581 9.70399Z"
          fill="#214063"
        />
        <path
          d="M11.4868 12.149C11.4962 12.1385 11.5014 12.1249 11.5014 12.1108C11.5014 12.0967 11.4962 12.0831 11.4868 12.0726C11.4678 12.0726 11.4487 12.1108 11.4297 12.0917C11.4106 12.0726 11.5059 11.8242 11.6392 11.786C11.7725 11.7478 11.6773 11.8051 11.6963 11.8433C11.7154 11.8815 11.6773 11.9006 11.6963 11.9198C11.7154 11.9389 11.6773 12.0535 11.6201 12.0917C11.563 12.1299 11.6201 12.0917 11.6201 12.0726L11.4868 12.1872V12.149Z"
          fill="#214063"
        />
        <path
          d="M12.0957 12.0347C12.1909 12.0538 12.0957 12.1493 12.0957 12.2066L12.0195 12.2639C12.0133 12.2224 12.0171 12.18 12.0303 12.1402C12.0435 12.1003 12.0659 12.0642 12.0957 12.0347Z"
          fill="#214063"
        />
        <path
          d="M12.0772 12.1108L12.0964 12.13L12.0581 12.1491L12.0964 12.13L12.0772 12.1108Z"
          fill="white"
        />
        <path
          d="M16.0772 5.979H16.1153C16.1153 6.11272 15.9629 6.18913 15.8677 6.22733H15.7915C15.8176 6.16717 15.8568 6.11364 15.9063 6.07067C15.9557 6.02769 16.0141 5.99637 16.0772 5.979Z"
          fill="#214063"
        />
        <path
          d="M12.2673 11.8819L12.229 11.9011V11.8628L12.2673 11.8819Z"
          fill="#214063"
        />
        <path
          d="M12.4005 11.5953L12.4386 11.5571L12.4767 11.6144C12.4767 11.6908 12.4195 11.729 12.3814 11.7673H12.4005C12.3993 11.7525 12.3924 11.7388 12.3814 11.729C12.3624 11.729 12.3624 11.7482 12.3624 11.7673C12.3545 11.7376 12.3539 11.7066 12.3605 11.6766C12.3671 11.6467 12.3808 11.6188 12.4005 11.5953Z"
          fill="#214063"
        />
        <path
          d="M12.4198 11.6714H12.4007C12.4198 11.6905 12.4007 11.6714 12.4007 11.6905C12.4007 11.7097 12.3624 11.6905 12.4198 11.6714Z"
          fill="white"
        />
        <path
          d="M12.5721 11.4997C12.568 11.4656 12.5709 11.4311 12.5808 11.3982C12.5906 11.3653 12.6071 11.3348 12.6293 11.3087C12.6483 11.2896 12.6864 11.2705 12.6864 11.3087C12.697 11.3368 12.7007 11.3671 12.6974 11.3969C12.6941 11.4268 12.6838 11.4555 12.6674 11.4806C12.6293 11.4806 12.6102 11.5379 12.5912 11.557C12.5721 11.5761 12.6293 11.4806 12.5721 11.4997Z"
          fill="#214063"
        />
        <path
          d="M14.4577 11.461C14.4577 11.4559 14.4597 11.4511 14.4632 11.4475C14.4668 11.4439 14.4717 11.4419 14.4767 11.4419C14.4818 11.4419 14.4866 11.4439 14.4902 11.4475C14.4937 11.4511 14.4958 11.4559 14.4958 11.461C14.5338 11.4992 14.4958 11.5565 14.4767 11.5947C14.4577 11.6329 14.4767 11.652 14.4386 11.652C14.4256 11.5879 14.4323 11.5213 14.4577 11.461Z"
          fill="#214063"
        />
        <path
          d="M9.1817 8.40479C9.25789 8.42389 9.20075 8.5194 9.20075 8.57671C9.20075 8.63401 9.02932 8.74862 8.97218 8.84414L8.93408 8.90144C9.02932 8.76773 8.99122 8.48119 9.1817 8.40479Z"
          fill="#214063"
        />
        <path
          d="M13.9818 9.64648H14.0199C14.039 9.66559 14.0771 9.66559 14.0771 9.70379L14.039 9.7993C14.0199 9.7993 14.0199 9.7993 14.0199 9.7802L13.9818 9.8184C13.9247 9.7611 13.9628 9.70379 13.9818 9.64648Z"
          fill="#214063"
        />
        <path
          d="M14.4006 8.94012C14.3815 8.94012 14.3815 8.95922 14.3815 8.97833C14.3815 8.99743 14.3625 8.88281 14.3815 8.82551C14.4006 8.7682 14.4387 8.7682 14.4768 8.7873C14.5148 8.80641 14.5148 8.82551 14.5339 8.86371C14.5529 8.90192 14.4577 8.92102 14.4768 8.95922H14.4577L14.3815 8.99743C14.3815 8.95922 14.3815 8.94012 14.4006 8.94012Z"
          fill="#214063"
        />
        <path
          d="M10.3058 8.17578L10.2866 8.21407V8.17578H10.3058Z"
          fill="#214063"
        />
        <path
          d="M10.5146 8.23291C10.5146 8.21377 10.5338 8.2712 10.5146 8.2712L10.5912 8.23291L10.5146 8.30949V8.23291Z"
          fill="#214063"
        />
        <path
          d="M10.5342 8.21404C10.5342 8.19494 10.5532 8.17584 10.5532 8.15674C10.5532 8.13763 10.5913 8.13763 10.6104 8.15674C10.6294 8.17584 10.6104 8.17584 10.6104 8.19494C10.6104 8.21404 10.6104 8.15674 10.5913 8.13763C10.5723 8.11853 10.5532 8.17584 10.5532 8.19494C10.5532 8.21404 10.5532 8.19494 10.5723 8.19494L10.5342 8.21404Z"
          fill="#214063"
        />
        <path
          d="M13.0483 8.50074C13.1055 8.42434 13.0864 8.29062 13.2007 8.23331C13.315 8.17601 13.2579 8.30972 13.2388 8.34793C13.2198 8.38613 13.1245 8.44344 13.0674 8.50074H13.0483Z"
          fill="#214063"
        />
        <path
          d="M14.9341 8.55774C14.9722 8.51954 14.9722 8.46223 15.0293 8.48133C15.0865 8.50044 15.0484 8.51954 15.0674 8.55774L15.0103 8.61505C14.9912 8.61505 14.9912 8.59595 14.9722 8.61505L14.9341 8.55774Z"
          fill="#214063"
        />
        <path
          d="M12.1342 7.62182C12.1532 7.58361 12.1913 7.54541 12.2103 7.54541C12.2236 7.55289 12.2342 7.56416 12.241 7.57778C12.2478 7.59139 12.2504 7.60673 12.2484 7.62182C12.2103 7.66002 12.1913 7.71733 12.1532 7.73643C12.1151 7.75553 12.1342 7.66002 12.1342 7.62182Z"
          fill="#214063"
        />
        <path
          d="M15.2008 8.53868C15.2008 8.51953 15.1626 8.53868 15.1626 8.53868C15.1626 8.5336 15.1646 8.52873 15.1682 8.52514C15.1718 8.52155 15.1766 8.51953 15.1817 8.51953H15.2008C15.22 8.53868 15.2008 8.57696 15.1626 8.57696C15.1243 8.57696 15.2008 8.57696 15.2008 8.53868Z"
          fill="#214063"
        />
        <path
          d="M10.4575 6.62823C10.4617 6.60738 10.4708 6.58783 10.4841 6.57122C10.4973 6.55461 10.5143 6.54141 10.5337 6.53271C10.5718 6.55182 10.6099 6.59002 10.5909 6.62823C10.5718 6.66643 10.4575 6.72374 10.4575 6.62823Z"
          fill="#214063"
        />
        <path
          d="M11.2957 6.91507H11.2576C11.2386 6.89597 11.2767 6.87686 11.2957 6.87686C11.3066 6.8187 11.3291 6.76334 11.3618 6.7141C11.3945 6.66487 11.4368 6.62277 11.4862 6.59033C11.5045 6.59826 11.5198 6.61174 11.5301 6.62887C11.5403 6.646 11.545 6.66593 11.5433 6.68584L11.4481 6.85776L11.2767 6.99148C11.2767 6.95327 11.2957 6.93417 11.2957 6.91507Z"
          fill="#214063"
        />
        <path
          d="M12.7621 7.52643C12.7621 7.54553 12.7811 7.54553 12.8002 7.54553C12.8383 7.54553 12.8573 7.52643 12.8383 7.48823C12.8192 7.45002 12.7811 7.46913 12.743 7.48823C12.7049 7.50733 12.7811 7.33541 12.8573 7.35451C12.877 7.37583 12.8902 7.40234 12.8954 7.43092L12.8383 7.54553C12.8573 7.54553 12.8573 7.54553 12.8573 7.52643H12.8383L12.8002 7.56464C12.7951 7.56464 12.7903 7.56262 12.7867 7.55904C12.7831 7.55546 12.7811 7.5506 12.7811 7.54553H12.743C12.7508 7.54078 12.7573 7.53423 12.7621 7.52643Z"
          fill="#214063"
        />
        <path
          d="M16.3622 8.80599C16.4003 8.78689 16.4193 8.82509 16.4193 8.84419C16.4193 8.86329 16.3431 8.9015 16.3431 8.95881C16.3431 9.01611 16.3241 8.82509 16.3622 8.80599Z"
          fill="#214063"
        />
        <path
          d="M12.7812 7.44992H12.8387C12.8578 7.43078 12.8578 7.44992 12.8578 7.44992H12.8195C12.8004 7.43078 12.8195 7.41164 12.7812 7.43078H12.8004C12.8004 7.43586 12.7984 7.44073 12.7948 7.44432C12.7912 7.44791 12.7863 7.44992 12.7812 7.44992Z"
          fill="white"
        />
        <path
          d="M18.6485 5.50117H18.6104C18.6104 5.48206 18.7437 5.48206 18.6675 5.40566C18.5913 5.32925 18.858 5.34835 18.9532 5.40566H18.9342C18.9723 5.36745 19.0104 5.29104 19.0865 5.31014C19.1627 5.32925 19.1246 5.32925 19.1246 5.36745C19.1246 5.40566 18.877 5.38655 18.9151 5.57758C18.8965 5.60631 18.8711 5.63004 18.8412 5.64669C18.8114 5.66333 18.7779 5.6724 18.7437 5.67309L18.7056 5.73039C18.7437 5.69219 18.6865 5.67309 18.6865 5.65398H18.6485V5.61578H18.5913C18.6104 5.55847 18.6485 5.53937 18.6485 5.50117Z"
          fill="#214063"
        />
        <path
          d="M15.486 8.13765C15.5241 8.11855 15.5241 8.08034 15.5812 8.09944C15.6383 8.11855 15.6002 8.15675 15.6002 8.19496C15.6002 8.23316 15.5621 8.19495 15.5621 8.23316C15.5431 8.21406 15.4479 8.17585 15.486 8.13765Z"
          fill="#214063"
        />
        <path
          d="M11.9053 6.53302C11.905 6.50597 11.912 6.47933 11.9254 6.45584C11.9387 6.43234 11.9581 6.41283 11.9815 6.39931C12.0005 6.39931 12.0386 6.3802 12.0386 6.41841C12.0386 6.45661 11.9815 6.51392 11.9434 6.57123C11.9053 6.62853 11.9053 6.55212 11.9053 6.53302Z"
          fill="#214063"
        />
        <path
          d="M11.9626 6.47559L11.9243 6.53302L11.9626 6.47559Z"
          fill="white"
        />
        <path
          d="M16.0769 8.06084C16.0578 8.07995 16.0578 8.02264 16.0388 8.04174C16.0197 8.06084 16.0578 7.96533 16.0959 7.96533C16.134 7.96533 16.1149 8.00354 16.134 8.04174L16.0769 8.06084Z"
          fill="#214063"
        />
        <path
          d="M16.0768 8.04209L16.0959 8.02295V8.04209H16.0768L16.0576 8.02295L16.0768 8.04209Z"
          fill="white"
        />
        <path
          d="M16.3628 7.46905C16.3628 7.44994 16.3628 7.39264 16.4009 7.37354H16.4961C16.5533 7.43084 16.4771 7.48815 16.4771 7.52635C16.439 7.50725 16.4199 7.54546 16.4009 7.54546C16.3818 7.54546 16.3818 7.48815 16.3628 7.46905Z"
          fill="#214063"
        />
        <path
          d="M17.4102 8.2525H17.3911C17.4102 8.19519 17.3911 8.11878 17.4673 8.09968C17.5435 8.08058 17.5244 8.17609 17.5054 8.19519C17.4864 8.21429 17.4483 8.2525 17.4102 8.2716V8.2525Z"
          fill="#214063"
        />
        <path
          d="M12.2675 5.59722C12.2484 5.55902 12.3056 5.46351 12.3436 5.4253C12.358 5.40996 12.3769 5.39977 12.3976 5.39632C12.4182 5.39287 12.4394 5.39634 12.4579 5.4062C12.5151 5.4253 12.496 5.48261 12.496 5.52081C12.496 5.55902 12.4389 5.57812 12.4389 5.61633C12.4389 5.65453 12.3436 5.71184 12.3246 5.61633H12.3055C12.3018 5.6097 12.2962 5.60434 12.2894 5.60094C12.2826 5.59753 12.275 5.59624 12.2675 5.59722Z"
          fill="#214063"
        />
        <path
          d="M16.8008 7.60276H16.7627C16.8198 7.58366 16.8389 7.46905 16.9151 7.50725C16.9913 7.54546 16.9532 7.60276 16.9532 7.64097C16.9532 7.67917 16.9151 7.66007 16.9151 7.67917C16.9151 7.69828 16.896 7.67917 16.896 7.66007C16.896 7.64097 16.877 7.66007 16.8389 7.67917H16.8008C16.8198 7.62187 16.7627 7.62187 16.8008 7.60276Z"
          fill="#214063"
        />
        <path
          d="M13.4102 6.05568C13.4292 6.05568 13.4102 6.09389 13.4102 6.11299L13.353 6.17029C13.3721 6.2085 13.3911 6.15119 13.4102 6.15119L13.3721 6.11299C13.315 6.09389 13.334 6.17029 13.315 6.1894L13.2769 6.2276C13.2959 6.13209 13.334 6.03658 13.4102 6.05568Z"
          fill="#214063"
        />
        <path
          d="M14.7622 5.52051H14.7813C14.7622 5.53965 14.7813 5.53965 14.7622 5.52051Z"
          fill="#214063"
        />
        <path
          d="M16.7052 6.55225H16.7243V6.59053C16.7243 6.57139 16.7052 6.55225 16.686 6.57139L16.7052 6.55225Z"
          fill="#214063"
        />
        <path
          d="M15.3721 4.66064H15.3912C15.3883 4.66232 15.385 4.66321 15.3816 4.66321C15.3783 4.66321 15.375 4.66232 15.3721 4.66064Z"
          fill="#214063"
        />
        <path
          d="M15.4292 4.64147H15.4483V4.60326C15.4483 4.58416 15.4292 4.58416 15.4292 4.56506C15.4292 4.54596 15.3911 4.60326 15.3911 4.64147H15.3721C15.3911 4.58416 15.4292 4.56506 15.4864 4.52686H15.5245C15.5054 4.60326 15.4483 4.62237 15.3911 4.64147H15.4292Z"
          fill="#214063"
        />
        <path
          d="M17.9243 5.63525C17.9446 5.63525 17.9639 5.6433 17.9782 5.65763C17.9925 5.67196 18.0005 5.6914 18.0005 5.71166L17.9624 5.76897C17.9624 5.76897 17.9434 5.71166 17.9243 5.74987C17.9053 5.78807 17.9243 5.78807 17.9053 5.80717H17.9243C17.8862 5.78807 17.8862 5.82628 17.8482 5.82628V5.78807H17.8101C17.8482 5.73076 17.8672 5.65436 17.9243 5.63525Z"
          fill="#214063"
        />
        <path
          d="M16.4194 4.71791C16.4766 4.6606 16.4956 4.6033 16.5718 4.6224C16.648 4.6415 16.5718 4.69881 16.5718 4.73701L16.4956 4.79432H16.4194C16.4385 4.73701 16.4385 4.71791 16.4194 4.71791Z"
          fill="#214063"
        />
        <path
          d="M16.4961 4.66097L16.458 4.69917C16.4592 4.68445 16.466 4.67077 16.4771 4.66097C16.5152 4.64187 16.5152 4.68007 16.5342 4.69917C16.5532 4.71827 16.4771 4.73738 16.4771 4.75648C16.4771 4.77558 16.439 4.71827 16.4961 4.66097Z"
          fill="white"
        />
        <path
          d="M17.7912 6.01709C17.8103 6.01709 17.8103 6.03619 17.8293 6.05529C17.8484 6.0744 17.8103 6.0935 17.7722 6.1126C17.7341 6.1317 17.7912 6.1126 17.7912 6.0744H17.7531C17.7531 6.0935 17.7531 6.1126 17.7341 6.1126C17.715 6.1126 17.7531 6.01709 17.7912 6.01709Z"
          fill="#214063"
        />
        <path
          d="M16.5528 4.25977H16.5718V4.29797H16.5528V4.35528V4.31707L16.4766 4.37438C16.4766 4.33617 16.4956 4.27887 16.5528 4.25977Z"
          fill="#214063"
        />
        <path
          d="M21.2007 5.55902C21.2007 5.50171 21.1626 5.53992 21.1436 5.52081C21.1245 5.50171 21.1817 5.53992 21.2007 5.50171C21.2198 5.46351 21.1626 5.46351 21.1436 5.48261H21.1245C21.1626 5.44441 21.2197 5.48261 21.2388 5.4062C21.2578 5.32979 21.2197 5.3871 21.2197 5.368C21.2197 5.34889 21.2769 5.31069 21.334 5.29159H21.315C21.3531 5.27249 21.3912 5.29159 21.4293 5.29159C21.4674 5.29159 21.5055 5.27249 21.5055 5.21518C21.5055 5.15787 21.5626 5.29159 21.5817 5.25338C21.6353 5.3035 21.6691 5.37132 21.6769 5.44441C21.6959 5.48261 21.6769 5.48261 21.6578 5.53992C21.6578 5.55902 21.6388 5.55902 21.6578 5.57812C21.6769 5.59722 21.6007 5.61633 21.6007 5.63543C21.6007 5.65453 21.5626 5.71184 21.5436 5.69273V5.73094H21.5055C21.4674 5.76914 21.3912 5.76914 21.3531 5.82645H21.3721V5.78824L21.334 5.84555C21.334 5.82645 21.3721 5.78825 21.3531 5.75004C21.334 5.71184 21.315 5.76914 21.2959 5.76914H21.315C21.2959 5.75004 21.2769 5.78825 21.2388 5.76914C21.2007 5.75004 21.2388 5.69273 21.2197 5.67363H21.1436C21.1562 5.6722 21.1682 5.66763 21.1786 5.66034C21.189 5.65305 21.1975 5.64326 21.2031 5.63188C21.2088 5.62049 21.2116 5.60786 21.2111 5.59514C21.2107 5.58241 21.2071 5.57 21.2007 5.55902Z"
          fill="#214063"
        />
        <path
          d="M17.0859 4.24095C17.0668 4.24095 17.0668 4.26005 17.0859 4.26005C17.1049 4.26005 17.124 4.26005 17.143 4.24095C17.124 4.22185 17.124 4.26005 17.1049 4.24095C17.0859 4.22185 17.143 4.22185 17.1811 4.20275C17.2192 4.18364 17.1811 4.26005 17.143 4.27916C17.1049 4.29826 17.0859 4.29826 17.0478 4.29826C17.0441 4.29207 17.0423 4.28496 17.0425 4.27777C17.0427 4.27057 17.0449 4.26358 17.0489 4.25759C17.0529 4.2516 17.0584 4.24686 17.065 4.24392C17.0715 4.24097 17.0788 4.23995 17.0859 4.24095Z"
          fill="#214063"
        />
        <path
          d="M17.6768 4.03072C17.6946 4.02406 17.7142 4.02428 17.7318 4.03134C17.7494 4.03841 17.7638 4.05181 17.772 4.06893C17.7789 4.07668 17.7842 4.08576 17.7874 4.09561C17.7907 4.10546 17.792 4.11588 17.7911 4.12623C17.8292 4.10713 17.8863 4.10713 17.8863 4.16444C17.8863 4.22174 17.6387 4.25995 17.5625 4.27905V4.24085H17.5244C17.528 4.19513 17.5441 4.15129 17.571 4.1142C17.5979 4.07711 17.6345 4.04822 17.6768 4.03072Z"
          fill="#214063"
        />
        <path
          d="M23.9624 3.64824H23.9434C23.9582 3.64824 23.9727 3.64478 23.986 3.63815C23.9992 3.63152 24.0107 3.62189 24.0196 3.61003H23.9815C24.0005 3.61003 24.0386 3.62913 24.0386 3.59093H24.0196C24.0957 3.61003 24.1338 3.55273 24.191 3.57183C24.2481 3.59093 24.3243 3.61003 24.3624 3.61003C24.4005 3.61003 24.4005 3.66734 24.4005 3.68644L24.3624 3.83926L24.2862 3.89656C24.307 3.90835 24.3247 3.92487 24.3379 3.94477C24.3512 3.96468 24.3595 3.98743 24.3624 4.01118C24.3815 4.10669 24.2862 4.08759 24.2672 4.14489C24.2481 4.2022 24.191 4.12579 24.1529 4.14489H24.1338C24.1719 4.08759 24.0767 4.08759 24.0386 4.06848H24.0196C24.0196 4.04938 24.0577 4.06848 24.0577 4.03028H24.0767C24.0577 4.01118 24.0386 3.99208 24.0577 3.95387H23.9053C23.9243 3.70554 24.0005 3.70554 23.9624 3.64824Z"
          fill="#214063"
        />
        <path
          d="M19.7529 5.27245H19.7339C19.772 5.23424 19.772 5.13873 19.8482 5.11963H19.9815C19.9957 5.15284 20.0029 5.18858 20.0029 5.22469C20.0029 5.2608 19.9957 5.29654 19.9815 5.32975C19.9434 5.32975 19.9053 5.38706 19.8672 5.38706H19.8482V5.34886H19.7529C19.7518 5.3234 19.7518 5.2979 19.7529 5.27245Z"
          fill="#214063"
        />
        <path d="M18.1528 4.6417L18.172 4.62256L18.1528 4.6417Z" fill="white" />
        <path
          d="M18.4768 4.2219H18.4576C18.4768 4.20275 18.4385 4.18361 18.4194 4.20275C18.4002 4.2219 18.4576 4.20275 18.4768 4.2219Z"
          fill="#214063"
        />
        <path
          d="M18.7627 4.12593H18.7437C18.7437 4.12593 18.7817 4.08773 18.7627 4.06862C18.7437 4.04952 18.9151 4.12593 18.9532 3.99222C18.9913 3.8585 19.0865 3.97311 19.1246 4.04952C19.1307 4.06191 19.1341 4.07549 19.1345 4.08932C19.1349 4.10315 19.1323 4.1169 19.1268 4.12962C19.1214 4.14234 19.1133 4.15372 19.103 4.16298C19.0928 4.17223 19.0806 4.17915 19.0675 4.18324L19.0103 4.24054H18.9532C18.9532 4.18324 18.896 4.24054 18.877 4.22144C18.8579 4.16414 18.8198 4.22144 18.7817 4.18324H18.7437L18.7627 4.12593Z"
          fill="#214063"
        />
        <path
          d="M20.9339 3.7441C20.9148 3.7441 20.972 3.7441 20.9339 3.70589C20.8958 3.66769 20.972 3.66769 20.991 3.66769C21.0481 3.68679 21.0291 3.57218 21.1243 3.62948C21.2196 3.68679 21.2005 3.66769 21.2386 3.64859C21.2619 3.6698 21.278 3.69771 21.2848 3.72849C21.2917 3.75927 21.2888 3.79141 21.2767 3.82051L21.2005 3.89691V3.93512C21.1815 3.87781 21.1624 3.99243 21.1243 3.93512H21.0481C21.0532 3.93512 21.058 3.93311 21.0616 3.92952C21.0652 3.92594 21.0672 3.92108 21.0672 3.91602H20.9529C20.9148 3.7823 20.991 3.7823 20.9339 3.7441Z"
          fill="#214063"
        />
        <path
          d="M22.229 5.38655C22.2481 5.40565 22.2481 5.36744 22.2671 5.34834C22.2861 5.32924 22.3623 5.36744 22.3623 5.40565V5.48206C22.3433 5.46296 22.3242 5.50116 22.3052 5.52026C22.2861 5.53936 22.2671 5.50116 22.2671 5.50116L22.229 5.46296C22.2384 5.45245 22.2436 5.43885 22.2436 5.42475C22.2436 5.41066 22.2384 5.39705 22.229 5.38655Z"
          fill="#214063"
        />
        <path
          d="M22.2098 7.35456C22.2288 7.35456 22.2669 7.39277 22.2288 7.45007C22.2252 7.45414 22.2208 7.45739 22.2159 7.45962C22.211 7.46185 22.2057 7.46301 22.2002 7.46301C22.1948 7.46301 22.1895 7.46185 22.1846 7.45962C22.1796 7.45739 22.1752 7.45414 22.1717 7.45007C22.1336 7.43097 22.1526 7.33546 22.2098 7.35456Z"
          fill="#214063"
        />
        <path
          d="M23.3338 4.68006C23.3338 4.66096 23.3529 4.66096 23.3529 4.62276C23.3529 4.58455 23.429 4.62276 23.4481 4.66096C23.4671 4.69917 23.4481 4.71827 23.429 4.73737H23.3719C23.3529 4.71827 23.3148 4.69917 23.3338 4.66096V4.68006Z"
          fill="#214063"
        />
        <path
          d="M23.5628 4.60372H23.5437C23.5245 4.60372 23.5054 4.58457 23.5245 4.56543L23.5628 4.60372Z"
          fill="#214063"
        />
        <path
          d="M22.5718 5.88347C22.5737 5.87797 22.5769 5.87298 22.581 5.86889C22.5851 5.8648 22.5902 5.86171 22.5957 5.85987C22.6012 5.85803 22.6071 5.85747 22.6128 5.85825C22.6186 5.85903 22.6241 5.86112 22.6289 5.86437C22.6289 5.88347 22.648 5.90257 22.6289 5.90257H22.5718C22.5667 5.90257 22.5619 5.90056 22.5583 5.89698C22.5547 5.8934 22.5527 5.88854 22.5527 5.88347C22.5527 5.8784 22.5547 5.87355 22.5583 5.86996C22.5619 5.86638 22.5667 5.86437 22.5718 5.86437V5.88347Z"
          fill="#214063"
        />
        <path
          d="M22.5909 5.90248H22.61C22.6292 5.90248 22.5718 5.94076 22.5718 5.90248C22.5718 5.86419 22.5909 5.88333 22.5909 5.90248Z"
          fill="white"
        />
        <path
          d="M23.2582 6.57116H23.2392C23.2582 6.59026 23.2773 6.57116 23.2963 6.55205V6.49475C23.3154 6.51385 23.3344 6.49475 23.3535 6.49475V6.45654C23.4296 6.49475 23.582 6.45654 23.6011 6.59026L23.563 6.72397C23.5249 6.78128 23.4677 6.76218 23.4296 6.81949V6.76218C23.3916 6.80038 23.4106 6.76218 23.3916 6.76218H23.3344C23.3344 6.74308 23.3344 6.74308 23.3535 6.74308C23.3725 6.74308 23.3154 6.72397 23.2963 6.72397C23.2773 6.72397 23.2963 6.66667 23.2773 6.60936H23.2392C23.2011 6.59026 23.2582 6.62846 23.2582 6.57116Z"
          fill="#214063"
        />
        <path
          d="M23.6763 5.34904C23.6953 5.32994 23.6953 5.32994 23.6953 5.29173H23.6763C23.6763 5.29173 23.7144 5.29173 23.7144 5.31084C23.7144 5.32994 23.7334 5.25353 23.7715 5.27263C23.8096 5.29173 23.7715 5.23443 23.7715 5.21532C23.7715 5.19622 23.7906 5.25353 23.8477 5.25353C23.9048 5.25353 23.9429 5.29173 23.981 5.25353L24.0382 5.29173C24.0382 5.31084 24.0572 5.29173 24.0572 5.29173C24.0572 5.29173 24.0953 5.38724 24.1144 5.38724C24.1334 5.38724 24.1334 5.44455 24.1525 5.46365C24.1474 5.46365 24.1426 5.46567 24.139 5.46925C24.1354 5.47283 24.1334 5.47769 24.1334 5.48276C24.1334 5.48782 24.1354 5.49268 24.139 5.49626C24.1426 5.49984 24.1474 5.50186 24.1525 5.50186C24.0953 5.52096 24.2096 5.55916 24.1334 5.57827C24.0572 5.59737 24.1525 5.61647 24.1525 5.61647H24.0953C24.1525 5.67378 24.0382 5.65467 24.0572 5.73108C24.0763 5.80749 24.0191 5.73108 24.0001 5.75019C23.981 5.71198 23.9429 5.76929 23.9048 5.76929C23.8667 5.76929 23.8477 5.69288 23.7906 5.75019C23.7334 5.80749 23.7715 5.65467 23.7144 5.69288H23.6763C23.6572 5.65467 23.7334 5.67378 23.6953 5.63557C23.6572 5.59737 23.6763 5.65467 23.6572 5.65467C23.6382 5.65467 23.7334 5.59737 23.6572 5.55916H23.6001C23.6119 5.55027 23.6215 5.53873 23.6281 5.52547C23.6347 5.51221 23.6382 5.49758 23.6382 5.48276C23.6382 5.44455 23.581 5.50186 23.6001 5.46365C23.6191 5.42545 23.6382 5.46365 23.6382 5.42545L23.6001 5.38724C23.6382 5.42545 23.6382 5.34904 23.6763 5.34904Z"
          fill="#214063"
        />
        <path
          d="M24.9718 6.68607C24.9718 6.66697 24.9718 6.66697 24.9527 6.66697C24.9337 6.66697 25.0289 6.60966 25.0289 6.57146C25.0289 6.53325 25.1051 6.47594 25.1622 6.51415C25.2194 6.55235 25.1813 6.45684 25.2194 6.49505H25.2384C25.2956 6.53325 25.3718 6.51415 25.4289 6.57146C25.4861 6.62876 25.448 6.64786 25.5051 6.64786H25.467C25.4861 6.70517 25.5432 6.72427 25.4861 6.78158V6.81978C25.4509 6.84239 25.4241 6.87594 25.4099 6.9153C25.3718 6.9344 25.3146 6.9153 25.3146 6.9535C25.3146 6.9917 25.2765 6.9917 25.2384 7.01081H25.2003V6.9726C25.1847 6.96418 25.1667 6.96147 25.1493 6.96496C25.1319 6.96845 25.1163 6.9779 25.1051 6.9917C25.1051 6.9726 25.067 7.01081 25.048 6.9917H25.0289C25.0099 6.9535 24.9718 6.9917 24.9527 6.9726C24.9337 6.9535 24.9908 6.9535 24.9718 6.9344V6.89619H24.9337L24.9718 6.85799C24.9527 6.81978 24.9146 6.87709 24.8956 6.83889C24.8765 6.80068 24.9146 6.70517 24.9718 6.68607Z"
          fill="#214063"
        />
        <path
          d="M24.9528 4.27913C24.9528 4.29823 24.9719 4.31734 24.9719 4.33644C24.9719 4.35554 24.9147 4.33644 24.8957 4.31734C24.8766 4.29823 24.9147 4.26003 24.9528 4.27913Z"
          fill="#214063"
        />
        <path
          d="M25.6953 2.94189H25.7144C25.7334 2.9801 25.6953 2.9801 25.6763 2.9801C25.6572 2.9801 25.6763 2.9801 25.6382 2.94189H25.6953Z"
          fill="#214063"
        />
        <path
          d="M25.4868 6.11279L25.544 6.1701C25.5249 6.1701 25.5249 6.2083 25.4868 6.2083H25.4678C25.4487 6.1701 25.5249 6.1892 25.4868 6.151H25.4487L25.4868 6.11279Z"
          fill="#214063"
        />
        <path
          d="M25.8867 4.90931C25.8858 4.89896 25.8871 4.88854 25.8904 4.87869C25.8936 4.86884 25.8989 4.85976 25.9058 4.852C25.9629 4.8138 26.001 4.8329 26.0582 4.8329C26.1153 4.8329 26.1534 4.92841 26.1153 4.98572C26.0772 5.04302 26.0772 5.02392 26.1153 5.04302C26.1534 5.06213 26.0391 5.04302 26.0582 5.08123C26.0772 5.11943 26.0201 5.06213 26.001 5.08123H25.9629C25.9248 5.11943 25.9248 5.06213 25.8867 5.06213H25.9058C25.9058 5.04302 25.8867 5.06213 25.8677 5.04302V4.98572H25.9058L25.8867 4.90931Z"
          fill="#214063"
        />
        <path
          d="M26.001 5.17651C26.02 5.1574 26.0772 5.17651 26.0772 5.1383C26.0772 5.1001 26.0962 5.1383 26.1153 5.1383H26.1343C26.1534 5.1192 26.1534 5.1192 26.1534 5.1001L26.1915 5.1383H26.2296V5.1574C26.3058 5.1383 26.3058 5.19561 26.3438 5.21471C26.3819 5.23381 26.3248 5.29112 26.3819 5.31022C26.4391 5.32932 26.3819 5.44394 26.3058 5.50124C26.2296 5.55855 26.2867 5.50124 26.2867 5.48214C26.2867 5.46304 26.2486 5.52035 26.2677 5.53945L26.2296 5.50124C26.1915 5.57765 26.1343 5.50124 26.0962 5.52035C26.0581 5.53945 26.0581 5.52035 26.0581 5.48214H26.02V5.44394C26.001 5.46304 26.001 5.42483 25.9629 5.46304C25.9248 5.50124 26.001 5.36753 25.9438 5.36753C25.9507 5.35978 25.956 5.3507 25.9593 5.34084C25.9625 5.33099 25.9638 5.32057 25.9629 5.31022C25.9058 5.27202 26.0391 5.23381 26.001 5.17651Z"
          fill="#214063"
        />
        <path
          d="M26.7627 5.82625C26.8008 5.80714 26.7627 5.78804 26.7437 5.76894L26.7818 5.73074C26.7627 5.71163 26.7437 5.73074 26.7437 5.71163C26.7437 5.69253 26.8008 5.74984 26.8008 5.69253H26.8389V5.65433C26.8579 5.65433 26.9151 5.65433 26.9151 5.61612V5.53971C26.9722 5.53971 26.9341 5.46331 26.9722 5.50151C27.0103 5.53971 27.0294 5.406 27.0103 5.36779C26.9913 5.32959 27.0484 5.34869 27.0675 5.32959C27.0675 5.33466 27.0695 5.33951 27.0731 5.3431C27.0766 5.34668 27.0815 5.34869 27.0865 5.34869C27.1056 5.31049 27.1246 5.36779 27.1437 5.34869C27.1627 5.32959 27.1818 5.406 27.2199 5.3869C27.2579 5.36779 27.2579 5.4442 27.2579 5.48241C27.2579 5.52061 27.2579 5.4251 27.296 5.406C27.3341 5.3869 27.2579 5.50151 27.3341 5.52061H27.3722C27.3722 5.52061 27.3722 5.57792 27.4103 5.55882V5.61612H27.4484C27.4484 5.63522 27.4294 5.65433 27.4484 5.65433C27.4675 5.65433 27.4675 5.65433 27.4675 5.65433C27.4666 5.66468 27.4678 5.6751 27.4711 5.68495C27.4744 5.6948 27.4796 5.70388 27.4865 5.71163H27.5246V5.78804C27.5818 5.78804 27.5056 5.82625 27.5627 5.84535C27.6199 5.86445 27.5627 5.92176 27.5818 5.94086C27.6008 5.95996 27.5437 5.92176 27.5437 5.95996C27.5437 5.99817 27.5818 5.97906 27.6008 5.99817H27.5437C27.5343 6.00867 27.5291 6.02228 27.5291 6.03637C27.5291 6.05047 27.5343 6.06407 27.5437 6.07458C27.5437 6.09368 27.4675 6.11278 27.5246 6.15098H27.5056C27.4865 6.18919 27.5246 6.18919 27.5246 6.20829C27.5246 6.22739 27.4675 6.13188 27.4294 6.20829V6.22739C27.3151 6.22739 27.3722 6.38021 27.2579 6.36111C27.1437 6.34201 27.2199 6.3229 27.2008 6.3229C27.1818 6.3229 27.1437 6.38021 27.0865 6.36111C27.0294 6.34201 27.0103 6.2656 26.9913 6.2847C26.9722 6.3038 26.9532 6.3229 26.9341 6.3229C26.9151 6.3229 26.9913 6.2656 26.9341 6.22739H26.896C26.9151 6.20829 26.896 6.17009 26.896 6.15098H26.8579C26.8579 6.13188 26.896 6.11278 26.8579 6.09368H26.8199C26.8199 6.07458 26.8579 6.07458 26.8389 6.05547C26.8199 6.03637 26.8199 5.99817 26.7818 6.01727C26.7437 6.03637 26.8199 5.99817 26.7818 5.95996H26.7437C26.7627 5.94086 26.8008 5.94086 26.7818 5.90266H26.7246C26.7437 5.90266 26.7627 5.90266 26.7627 5.86445H26.7056C26.7246 5.86445 26.7627 5.86445 26.7627 5.82625Z"
          fill="#214063"
        />
        <path
          d="M22.4007 3.15186C22.4388 3.17096 22.4959 3.15186 22.5149 3.20916C22.534 3.26647 22.4768 3.34288 22.4007 3.30467H22.3816L22.3435 3.24737C22.3816 3.22826 22.3054 3.19006 22.3435 3.17096C22.3816 3.15186 22.4007 3.19006 22.4007 3.15186Z"
          fill="#214063"
        />
        <path
          d="M22.7631 3.24756L22.7057 3.2667V3.24756L22.6865 3.2667V3.24756H22.7631Z"
          fill="#214063"
        />
        <path
          d="M22.877 3.19045H22.8579C22.8727 3.19045 22.8873 3.187 22.9005 3.18037C22.9137 3.17374 22.9252 3.16411 22.9341 3.15225H22.9151C22.9887 3.12438 23.07 3.12438 23.1436 3.15225C23.1817 3.19045 23.2198 3.24776 23.277 3.22865C23.3341 3.20955 23.2389 3.24776 23.2579 3.28596C23.277 3.32417 23.296 3.36237 23.3151 3.40057C23.3341 3.43878 23.2579 3.45788 23.2389 3.51519C23.2198 3.57249 23.1817 3.51519 23.1817 3.55339V3.43878C23.1436 3.45788 23.1627 3.49609 23.1436 3.51519V3.47698C23.1055 3.51519 23.0484 3.49609 23.0103 3.51519C22.9722 3.53429 22.9151 3.51519 22.877 3.53429C22.8389 3.55339 22.9532 3.45788 22.9151 3.40057H22.877C22.8389 3.36237 22.9341 3.34327 22.896 3.30506L22.8008 3.36237C22.8198 3.30506 22.896 3.28596 22.877 3.19045Z"
          fill="#214063"
        />
        <path
          d="M23.1246 3.64864H23.1055V3.61035L23.1246 3.64864Z"
          fill="#214063"
        />
        <path
          d="M19.2009 9.32178L19.1817 9.34092L19.1626 9.32178H19.2009Z"
          fill="white"
        />
        <path
          d="M14.3434 2.59803L14.4006 2.54073C14.4767 2.52162 14.4767 2.55983 14.4958 2.59803C14.4884 2.62354 14.4735 2.64625 14.4532 2.66326C14.4328 2.68027 14.4079 2.69081 14.3815 2.69354C14.3434 2.69354 14.3244 2.63624 14.3434 2.59803Z"
          fill="#214063"
        />
        <path
          d="M14.286 2.29248C14.3241 2.29248 14.3241 2.31158 14.3431 2.33068C14.3622 2.34979 14.3241 2.38799 14.286 2.40709C14.2479 2.4262 14.1908 2.33068 14.286 2.29248Z"
          fill="#214063"
        />
        <path
          d="M12.4382 14.3457C12.4574 14.3457 12.4765 14.3648 12.4574 14.4031H12.4382C12.4342 14.3995 12.4309 14.3951 12.4287 14.3902C12.4264 14.3852 12.4253 14.3799 12.4253 14.3744C12.4253 14.369 12.4264 14.3636 12.4287 14.3587C12.4309 14.3537 12.4342 14.3493 12.4382 14.3457Z"
          fill="#214063"
        />
        <path
          d="M14.0005 7.67881V7.65967H14.0196L14.0005 7.67881Z"
          fill="#214063"
        />
        <path
          d="M12.3242 14.174C12.3434 14.1549 12.3434 14.174 12.3625 14.174C12.3816 14.174 12.3625 14.2123 12.3434 14.2123C12.3242 14.2123 12.3242 14.1932 12.3242 14.174Z"
          fill="#214063"
        />
        <path
          d="M14.2862 7.39258H14.3243C14.3052 7.44988 14.2481 7.46899 14.191 7.48809C14.1338 7.50719 14.2291 7.39258 14.2862 7.39258Z"
          fill="#214063"
        />
        <path
          d="M12.7052 13.811C12.7433 13.811 12.8004 13.811 12.7814 13.8683C12.7623 13.9256 12.7433 13.9065 12.7052 13.9065C12.6944 13.893 12.6885 13.8762 12.6885 13.8588C12.6885 13.8414 12.6944 13.8246 12.7052 13.811Z"
          fill="#214063"
        />
        <path
          d="M9.67634 14.8807C9.67007 14.8362 9.67365 14.7909 9.68682 14.748C9.69999 14.705 9.72242 14.6656 9.75253 14.6323C9.79063 14.6514 9.77158 14.6896 9.77158 14.7278C9.77158 14.766 9.69539 14.8233 9.69539 14.8998C9.69539 14.9762 9.69539 14.8807 9.67634 14.8807Z"
          fill="#214063"
        />
        <path
          d="M19.067 2.55995H19.0289L19.067 2.52174C19.0099 2.46444 19.1432 2.44533 19.1242 2.40713C19.1978 2.37926 19.2791 2.37926 19.3527 2.40713C19.3908 2.46444 19.3718 2.48354 19.4099 2.54084C19.448 2.59815 19.448 2.67456 19.3337 2.67456C19.2194 2.67456 19.2385 2.67456 19.1813 2.71276C19.1242 2.75097 19.1623 2.69366 19.1242 2.67456H19.0861C19.1242 2.63636 19.067 2.61725 19.0289 2.59815C18.9908 2.57905 19.048 2.57905 19.067 2.55995Z"
          fill="#214063"
        />
        <path
          d="M9.9624 14.3459L10.0198 14.3076C10.0389 14.3268 10.0198 14.3842 10.0007 14.4225L9.9624 14.4608V14.3459Z"
          fill="#214063"
        />
        <path
          d="M9.84795 14.0591H9.88622C9.90535 14.1165 9.84795 14.1548 9.82882 14.2122C9.82474 14.1604 9.83125 14.1083 9.84795 14.0591Z"
          fill="#214063"
        />
        <path
          d="M9.86728 14.0975C9.86728 14.0784 9.88641 14.1166 9.84814 14.1358L9.86728 14.0975Z"
          fill="white"
        />
        <path
          d="M11.8292 11.0029H11.8675C11.8675 11.0412 11.8675 11.0412 11.8483 11.0604C11.8292 11.0795 11.8101 11.0412 11.8292 11.0029Z"
          fill="#214063"
        />
        <path
          d="M11.0288 10.1243C11.0288 10.1051 11.0479 10.086 11.0479 10.0668C11.0479 10.0477 11.0862 10.1051 11.0862 10.1243C11.0862 10.1434 11.0288 10.1434 11.0288 10.1243Z"
          fill="#214063"
        />
        <path
          d="M10.4961 9.83768C10.5151 9.81857 10.5532 9.76127 10.5913 9.79947C10.6294 9.83768 10.6485 9.83768 10.6294 9.89498C10.6104 9.95229 10.5913 9.93319 10.5723 9.95229C10.5532 9.97139 10.5151 9.89498 10.4961 9.83768Z"
          fill="#214063"
        />
        <path
          d="M10.9341 10.0099C10.9341 10.0048 10.9361 9.99992 10.9397 9.99633C10.9433 9.99274 10.9481 9.99072 10.9532 9.99072C10.9583 9.99072 10.9632 9.99274 10.9667 9.99633C10.9703 9.99992 10.9723 10.0048 10.9723 10.0099C10.9723 10.0482 10.9149 10.0482 10.9341 10.0099Z"
          fill="#214063"
        />
        <path
          d="M12.0581 10.1813C12.0772 10.1622 12.0772 10.1431 12.0962 10.1431C12.1152 10.1431 12.1343 10.1622 12.1533 10.2004C12.1467 10.2075 12.1383 10.2128 12.1291 10.2158C12.1198 10.2188 12.11 10.2193 12.1004 10.2174C12.0909 10.2155 12.082 10.2112 12.0746 10.2048C12.0672 10.1985 12.0615 10.1904 12.0581 10.1813Z"
          fill="#214063"
        />
        <path
          d="M11.2769 13.0278V13.0661L11.2578 13.047L11.2769 13.0278Z"
          fill="#214063"
        />
        <path
          d="M11.4289 12.7605C11.467 12.7414 11.486 12.6841 11.5051 12.7223C11.5241 12.7605 11.5051 12.8751 11.486 12.9324C11.467 12.9133 11.4479 12.9324 11.4479 12.9133C11.4479 12.8942 11.3908 12.9324 11.3908 12.9898C11.3749 12.9112 11.3884 12.8296 11.4289 12.7605Z"
          fill="#214063"
        />
        <path
          d="M11.2197 9.68467C11.2197 9.66553 11.2389 9.68467 11.258 9.66553C11.2612 9.67038 11.2633 9.67592 11.2641 9.68171C11.2649 9.6875 11.2643 9.69339 11.2625 9.69894C11.2607 9.70448 11.2576 9.70953 11.2535 9.71369C11.2494 9.71785 11.2444 9.72103 11.2389 9.72296C11.2197 9.72296 11.2197 9.70382 11.2197 9.68467Z"
          fill="#214063"
        />
        <path
          d="M12.077 9.78039C12.0961 9.76125 12.1153 9.78039 12.1344 9.79953C12.1233 9.80935 12.1165 9.82307 12.1153 9.83782C12.0961 9.85697 12.0579 9.81868 12.077 9.78039Z"
          fill="#214063"
        />
        <path
          d="M11.7339 9.58947C11.753 9.57033 11.7722 9.58947 11.7913 9.60862C11.8104 9.62776 11.7722 9.6469 11.753 9.6469C11.7339 9.6469 11.7339 9.60862 11.7339 9.58947Z"
          fill="#214063"
        />
        <path
          d="M12.0581 9.70399C12.0962 9.68489 12.0962 9.58938 12.1343 9.62759C12.1724 9.66579 12.1343 9.7231 12.0962 9.7422C12.0581 9.7613 12.0581 9.7231 12.0581 9.70399Z"
          fill="#214063"
        />
        <path
          d="M11.4868 12.149C11.4962 12.1385 11.5014 12.1249 11.5014 12.1108C11.5014 12.0967 11.4962 12.0831 11.4868 12.0726C11.4678 12.0726 11.4487 12.1108 11.4297 12.0917C11.4106 12.0726 11.5059 11.8242 11.6392 11.786C11.7725 11.7478 11.6773 11.8051 11.6963 11.8433C11.7154 11.8815 11.6773 11.9006 11.6963 11.9198C11.7154 11.9389 11.6773 12.0535 11.6201 12.0917C11.563 12.1299 11.6201 12.0917 11.6201 12.0726L11.4868 12.1872V12.149Z"
          fill="#214063"
        />
        <path
          d="M12.0957 12.0347C12.1909 12.0538 12.0957 12.1493 12.0957 12.2066L12.0195 12.2639C12.0133 12.2224 12.0171 12.18 12.0303 12.1402C12.0435 12.1003 12.0659 12.0642 12.0957 12.0347Z"
          fill="#214063"
        />
        <path
          d="M12.0772 12.1108L12.0964 12.13L12.0581 12.1491L12.0964 12.13L12.0772 12.1108Z"
          fill="white"
        />
        <path
          d="M16.0772 5.979H16.1153C16.1153 6.11272 15.9629 6.18913 15.8677 6.22733H15.7915C15.8176 6.16717 15.8568 6.11364 15.9063 6.07067C15.9557 6.02769 16.0141 5.99637 16.0772 5.979Z"
          fill="#214063"
        />
        <path
          d="M12.2673 11.8819L12.229 11.9011V11.8628L12.2673 11.8819Z"
          fill="#214063"
        />
        <path
          d="M12.4005 11.5953L12.4386 11.5571L12.4767 11.6144C12.4767 11.6908 12.4195 11.729 12.3814 11.7673H12.4005C12.3993 11.7525 12.3924 11.7388 12.3814 11.729C12.3624 11.729 12.3624 11.7482 12.3624 11.7673C12.3545 11.7376 12.3539 11.7066 12.3605 11.6766C12.3671 11.6467 12.3808 11.6188 12.4005 11.5953Z"
          fill="#214063"
        />
        <path
          d="M12.4198 11.6714H12.4007C12.4198 11.6905 12.4007 11.6714 12.4007 11.6905C12.4007 11.7097 12.3624 11.6905 12.4198 11.6714Z"
          fill="white"
        />
        <path
          d="M12.5721 11.4997C12.568 11.4656 12.5709 11.4311 12.5808 11.3982C12.5906 11.3653 12.6071 11.3348 12.6293 11.3087C12.6483 11.2896 12.6864 11.2705 12.6864 11.3087C12.697 11.3368 12.7007 11.3671 12.6974 11.3969C12.6941 11.4268 12.6838 11.4555 12.6674 11.4806C12.6293 11.4806 12.6102 11.5379 12.5912 11.557C12.5721 11.5761 12.6293 11.4806 12.5721 11.4997Z"
          fill="#214063"
        />
        <path
          d="M14.4577 11.461C14.4577 11.4559 14.4597 11.4511 14.4632 11.4475C14.4668 11.4439 14.4717 11.4419 14.4767 11.4419C14.4818 11.4419 14.4866 11.4439 14.4902 11.4475C14.4937 11.4511 14.4958 11.4559 14.4958 11.461C14.5338 11.4992 14.4958 11.5565 14.4767 11.5947C14.4577 11.6329 14.4767 11.652 14.4386 11.652C14.4256 11.5879 14.4323 11.5213 14.4577 11.461Z"
          fill="#214063"
        />
        <path
          d="M9.1817 8.40479C9.25789 8.42389 9.20075 8.5194 9.20075 8.57671C9.20075 8.63401 9.02932 8.74862 8.97218 8.84414L8.93408 8.90144C9.02932 8.76773 8.99122 8.48119 9.1817 8.40479Z"
          fill="#214063"
        />
        <path
          d="M13.9818 9.64648H14.0199C14.039 9.66559 14.0771 9.66559 14.0771 9.70379L14.039 9.7993C14.0199 9.7993 14.0199 9.7993 14.0199 9.7802L13.9818 9.8184C13.9247 9.7611 13.9628 9.70379 13.9818 9.64648Z"
          fill="#214063"
        />
        <path
          d="M14.4006 8.94012C14.3815 8.94012 14.3815 8.95922 14.3815 8.97833C14.3815 8.99743 14.3625 8.88281 14.3815 8.82551C14.4006 8.7682 14.4387 8.7682 14.4768 8.7873C14.5148 8.80641 14.5148 8.82551 14.5339 8.86371C14.5529 8.90192 14.4577 8.92102 14.4768 8.95922H14.4577L14.3815 8.99743C14.3815 8.95922 14.3815 8.94012 14.4006 8.94012Z"
          fill="#214063"
        />
        <path
          d="M10.3058 8.17578L10.2866 8.21407V8.17578H10.3058Z"
          fill="#214063"
        />
        <path
          d="M10.5146 8.23291C10.5146 8.21377 10.5338 8.2712 10.5146 8.2712L10.5912 8.23291L10.5146 8.30949V8.23291Z"
          fill="#214063"
        />
        <path
          d="M10.5342 8.21404C10.5342 8.19494 10.5532 8.17584 10.5532 8.15674C10.5532 8.13763 10.5913 8.13763 10.6104 8.15674C10.6294 8.17584 10.6104 8.17584 10.6104 8.19494C10.6104 8.21404 10.6104 8.15674 10.5913 8.13763C10.5723 8.11853 10.5532 8.17584 10.5532 8.19494C10.5532 8.21404 10.5532 8.19494 10.5723 8.19494L10.5342 8.21404Z"
          fill="#214063"
        />
        <path
          d="M13.0483 8.50074C13.1055 8.42434 13.0864 8.29062 13.2007 8.23331C13.315 8.17601 13.2579 8.30972 13.2388 8.34793C13.2198 8.38613 13.1245 8.44344 13.0674 8.50074H13.0483Z"
          fill="#214063"
        />
        <path
          d="M14.9341 8.55774C14.9722 8.51954 14.9722 8.46223 15.0293 8.48133C15.0865 8.50044 15.0484 8.51954 15.0674 8.55774L15.0103 8.61505C14.9912 8.61505 14.9912 8.59595 14.9722 8.61505L14.9341 8.55774Z"
          fill="#214063"
        />
        <path
          d="M12.1342 7.62182C12.1532 7.58361 12.1913 7.54541 12.2103 7.54541C12.2236 7.55289 12.2342 7.56416 12.241 7.57778C12.2478 7.59139 12.2504 7.60673 12.2484 7.62182C12.2103 7.66002 12.1913 7.71733 12.1532 7.73643C12.1151 7.75553 12.1342 7.66002 12.1342 7.62182Z"
          fill="#214063"
        />
        <path
          d="M15.2008 8.53868C15.2008 8.51953 15.1626 8.53868 15.1626 8.53868C15.1626 8.5336 15.1646 8.52873 15.1682 8.52514C15.1718 8.52155 15.1766 8.51953 15.1817 8.51953H15.2008C15.22 8.53868 15.2008 8.57696 15.1626 8.57696C15.1243 8.57696 15.2008 8.57696 15.2008 8.53868Z"
          fill="#214063"
        />
        <path
          d="M10.4575 6.62823C10.4617 6.60738 10.4708 6.58783 10.4841 6.57122C10.4973 6.55461 10.5143 6.54141 10.5337 6.53271C10.5718 6.55182 10.6099 6.59002 10.5909 6.62823C10.5718 6.66643 10.4575 6.72374 10.4575 6.62823Z"
          fill="#214063"
        />
        <path
          d="M11.2957 6.91507H11.2576C11.2386 6.89597 11.2767 6.87686 11.2957 6.87686C11.3066 6.8187 11.3291 6.76334 11.3618 6.7141C11.3945 6.66487 11.4368 6.62277 11.4862 6.59033C11.5045 6.59826 11.5198 6.61174 11.5301 6.62887C11.5403 6.646 11.545 6.66593 11.5433 6.68584L11.4481 6.85776L11.2767 6.99148C11.2767 6.95327 11.2957 6.93417 11.2957 6.91507Z"
          fill="#214063"
        />
        <path
          d="M12.7621 7.52643C12.7621 7.54553 12.7811 7.54553 12.8002 7.54553C12.8383 7.54553 12.8573 7.52643 12.8383 7.48823C12.8192 7.45002 12.7811 7.46913 12.743 7.48823C12.7049 7.50733 12.7811 7.33541 12.8573 7.35451C12.877 7.37583 12.8902 7.40234 12.8954 7.43092L12.8383 7.54553C12.8573 7.54553 12.8573 7.54553 12.8573 7.52643H12.8383L12.8002 7.56464C12.7951 7.56464 12.7903 7.56262 12.7867 7.55904C12.7831 7.55546 12.7811 7.5506 12.7811 7.54553H12.743C12.7508 7.54078 12.7573 7.53423 12.7621 7.52643Z"
          fill="#214063"
        />
        <path
          d="M16.3622 8.80599C16.4003 8.78689 16.4193 8.82509 16.4193 8.84419C16.4193 8.86329 16.3431 8.9015 16.3431 8.95881C16.3431 9.01611 16.3241 8.82509 16.3622 8.80599Z"
          fill="#214063"
        />
        <path
          d="M12.7812 7.44992H12.8387C12.8578 7.43078 12.8578 7.44992 12.8578 7.44992H12.8195C12.8004 7.43078 12.8195 7.41164 12.7812 7.43078H12.8004C12.8004 7.43586 12.7984 7.44073 12.7948 7.44432C12.7912 7.44791 12.7863 7.44992 12.7812 7.44992Z"
          fill="white"
        />
        <path
          d="M18.6485 5.50117H18.6104C18.6104 5.48206 18.7437 5.48206 18.6675 5.40566C18.5913 5.32925 18.858 5.34835 18.9532 5.40566H18.9342C18.9723 5.36745 19.0104 5.29104 19.0865 5.31014C19.1627 5.32925 19.1246 5.32925 19.1246 5.36745C19.1246 5.40566 18.877 5.38655 18.9151 5.57758C18.8965 5.60631 18.8711 5.63004 18.8412 5.64669C18.8114 5.66333 18.7779 5.6724 18.7437 5.67309L18.7056 5.73039C18.7437 5.69219 18.6865 5.67309 18.6865 5.65398H18.6485V5.61578H18.5913C18.6104 5.55847 18.6485 5.53937 18.6485 5.50117Z"
          fill="#214063"
        />
        <path
          d="M15.486 8.13765C15.5241 8.11855 15.5241 8.08034 15.5812 8.09944C15.6383 8.11855 15.6002 8.15675 15.6002 8.19496C15.6002 8.23316 15.5621 8.19495 15.5621 8.23316C15.5431 8.21406 15.4479 8.17585 15.486 8.13765Z"
          fill="#214063"
        />
        <path
          d="M11.9053 6.53302C11.905 6.50597 11.912 6.47933 11.9254 6.45584C11.9387 6.43234 11.9581 6.41283 11.9815 6.39931C12.0005 6.39931 12.0386 6.3802 12.0386 6.41841C12.0386 6.45661 11.9815 6.51392 11.9434 6.57123C11.9053 6.62853 11.9053 6.55212 11.9053 6.53302Z"
          fill="#214063"
        />
        <path
          d="M11.9626 6.47559L11.9243 6.53302L11.9626 6.47559Z"
          fill="white"
        />
        <path
          d="M16.0769 8.06084C16.0578 8.07995 16.0578 8.02264 16.0388 8.04174C16.0197 8.06084 16.0578 7.96533 16.0959 7.96533C16.134 7.96533 16.1149 8.00354 16.134 8.04174L16.0769 8.06084Z"
          fill="#214063"
        />
        <path
          d="M16.0768 8.04209L16.0959 8.02295V8.04209H16.0768L16.0576 8.02295L16.0768 8.04209Z"
          fill="white"
        />
        <path
          d="M16.3628 7.46905C16.3628 7.44994 16.3628 7.39264 16.4009 7.37354H16.4961C16.5533 7.43084 16.4771 7.48815 16.4771 7.52635C16.439 7.50725 16.4199 7.54546 16.4009 7.54546C16.3818 7.54546 16.3818 7.48815 16.3628 7.46905Z"
          fill="#214063"
        />
        <path
          d="M17.4102 8.2525H17.3911C17.4102 8.19519 17.3911 8.11878 17.4673 8.09968C17.5435 8.08058 17.5244 8.17609 17.5054 8.19519C17.4864 8.21429 17.4483 8.2525 17.4102 8.2716V8.2525Z"
          fill="#214063"
        />
        <path
          d="M12.2675 5.59722C12.2484 5.55902 12.3056 5.46351 12.3436 5.4253C12.358 5.40996 12.3769 5.39977 12.3976 5.39632C12.4182 5.39287 12.4394 5.39634 12.4579 5.4062C12.5151 5.4253 12.496 5.48261 12.496 5.52081C12.496 5.55902 12.4389 5.57812 12.4389 5.61633C12.4389 5.65453 12.3436 5.71184 12.3246 5.61633H12.3055C12.3018 5.6097 12.2962 5.60434 12.2894 5.60094C12.2826 5.59753 12.275 5.59624 12.2675 5.59722Z"
          fill="#214063"
        />
        <path
          d="M16.8008 7.60276H16.7627C16.8198 7.58366 16.8389 7.46905 16.9151 7.50725C16.9913 7.54546 16.9532 7.60276 16.9532 7.64097C16.9532 7.67917 16.9151 7.66007 16.9151 7.67917C16.9151 7.69828 16.896 7.67917 16.896 7.66007C16.896 7.64097 16.877 7.66007 16.8389 7.67917H16.8008C16.8198 7.62187 16.7627 7.62187 16.8008 7.60276Z"
          fill="#214063"
        />
        <path
          d="M13.4102 6.05568C13.4292 6.05568 13.4102 6.09389 13.4102 6.11299L13.353 6.17029C13.3721 6.2085 13.3911 6.15119 13.4102 6.15119L13.3721 6.11299C13.315 6.09389 13.334 6.17029 13.315 6.1894L13.2769 6.2276C13.2959 6.13209 13.334 6.03658 13.4102 6.05568Z"
          fill="#214063"
        />
        <path
          d="M14.7622 5.52051H14.7813C14.7622 5.53965 14.7813 5.53965 14.7622 5.52051Z"
          fill="#214063"
        />
        <path
          d="M16.7052 6.55225H16.7243V6.59053C16.7243 6.57139 16.7052 6.55225 16.686 6.57139L16.7052 6.55225Z"
          fill="#214063"
        />
        <path
          d="M15.3721 4.66064H15.3912C15.3883 4.66232 15.385 4.66321 15.3816 4.66321C15.3783 4.66321 15.375 4.66232 15.3721 4.66064Z"
          fill="#214063"
        />
        <path
          d="M15.4292 4.64147H15.4483V4.60326C15.4483 4.58416 15.4292 4.58416 15.4292 4.56506C15.4292 4.54596 15.3911 4.60326 15.3911 4.64147H15.3721C15.3911 4.58416 15.4292 4.56506 15.4864 4.52686H15.5245C15.5054 4.60326 15.4483 4.62237 15.3911 4.64147H15.4292Z"
          fill="#214063"
        />
        <path
          d="M17.9243 5.63525C17.9446 5.63525 17.9639 5.6433 17.9782 5.65763C17.9925 5.67196 18.0005 5.6914 18.0005 5.71166L17.9624 5.76897C17.9624 5.76897 17.9434 5.71166 17.9243 5.74987C17.9053 5.78807 17.9243 5.78807 17.9053 5.80717H17.9243C17.8862 5.78807 17.8862 5.82628 17.8482 5.82628V5.78807H17.8101C17.8482 5.73076 17.8672 5.65436 17.9243 5.63525Z"
          fill="#214063"
        />
        <path
          d="M16.4194 4.71791C16.4766 4.6606 16.4956 4.6033 16.5718 4.6224C16.648 4.6415 16.5718 4.69881 16.5718 4.73701L16.4956 4.79432H16.4194C16.4385 4.73701 16.4385 4.71791 16.4194 4.71791Z"
          fill="#214063"
        />
        <path
          d="M16.4961 4.66097L16.458 4.69917C16.4592 4.68445 16.466 4.67077 16.4771 4.66097C16.5152 4.64187 16.5152 4.68007 16.5342 4.69917C16.5532 4.71827 16.4771 4.73738 16.4771 4.75648C16.4771 4.77558 16.439 4.71827 16.4961 4.66097Z"
          fill="white"
        />
        <path
          d="M17.7912 6.01709C17.8103 6.01709 17.8103 6.03619 17.8293 6.05529C17.8484 6.0744 17.8103 6.0935 17.7722 6.1126C17.7341 6.1317 17.7912 6.1126 17.7912 6.0744H17.7531C17.7531 6.0935 17.7531 6.1126 17.7341 6.1126C17.715 6.1126 17.7531 6.01709 17.7912 6.01709Z"
          fill="#214063"
        />
        <path
          d="M16.5528 4.25977H16.5718V4.29797H16.5528V4.35528V4.31707L16.4766 4.37438C16.4766 4.33617 16.4956 4.27887 16.5528 4.25977Z"
          fill="#214063"
        />
        <path
          d="M21.2007 5.55902C21.2007 5.50171 21.1626 5.53992 21.1436 5.52081C21.1245 5.50171 21.1817 5.53992 21.2007 5.50171C21.2198 5.46351 21.1626 5.46351 21.1436 5.48261H21.1245C21.1626 5.44441 21.2197 5.48261 21.2388 5.4062C21.2578 5.32979 21.2197 5.3871 21.2197 5.368C21.2197 5.34889 21.2769 5.31069 21.334 5.29159H21.315C21.3531 5.27249 21.3912 5.29159 21.4293 5.29159C21.4674 5.29159 21.5055 5.27249 21.5055 5.21518C21.5055 5.15787 21.5626 5.29159 21.5817 5.25338C21.6353 5.3035 21.6691 5.37132 21.6769 5.44441C21.6959 5.48261 21.6769 5.48261 21.6578 5.53992C21.6578 5.55902 21.6388 5.55902 21.6578 5.57812C21.6769 5.59722 21.6007 5.61633 21.6007 5.63543C21.6007 5.65453 21.5626 5.71184 21.5436 5.69273V5.73094H21.5055C21.4674 5.76914 21.3912 5.76914 21.3531 5.82645H21.3721V5.78824L21.334 5.84555C21.334 5.82645 21.3721 5.78825 21.3531 5.75004C21.334 5.71184 21.315 5.76914 21.2959 5.76914H21.315C21.2959 5.75004 21.2769 5.78825 21.2388 5.76914C21.2007 5.75004 21.2388 5.69273 21.2197 5.67363H21.1436C21.1562 5.6722 21.1682 5.66763 21.1786 5.66034C21.189 5.65305 21.1975 5.64326 21.2031 5.63188C21.2088 5.62049 21.2116 5.60786 21.2111 5.59514C21.2107 5.58241 21.2071 5.57 21.2007 5.55902Z"
          fill="#214063"
        />
        <path
          d="M17.0859 4.24095C17.0668 4.24095 17.0668 4.26005 17.0859 4.26005C17.1049 4.26005 17.124 4.26005 17.143 4.24095C17.124 4.22185 17.124 4.26005 17.1049 4.24095C17.0859 4.22185 17.143 4.22185 17.1811 4.20275C17.2192 4.18364 17.1811 4.26005 17.143 4.27916C17.1049 4.29826 17.0859 4.29826 17.0478 4.29826C17.0441 4.29207 17.0423 4.28496 17.0425 4.27777C17.0427 4.27057 17.0449 4.26358 17.0489 4.25759C17.0529 4.2516 17.0584 4.24686 17.065 4.24392C17.0715 4.24097 17.0788 4.23995 17.0859 4.24095Z"
          fill="#214063"
        />
        <path
          d="M17.6768 4.03072C17.6946 4.02406 17.7142 4.02428 17.7318 4.03134C17.7494 4.03841 17.7638 4.05181 17.772 4.06893C17.7789 4.07668 17.7842 4.08576 17.7874 4.09561C17.7907 4.10546 17.792 4.11588 17.7911 4.12623C17.8292 4.10713 17.8863 4.10713 17.8863 4.16444C17.8863 4.22174 17.6387 4.25995 17.5625 4.27905V4.24085H17.5244C17.528 4.19513 17.5441 4.15129 17.571 4.1142C17.5979 4.07711 17.6345 4.04822 17.6768 4.03072Z"
          fill="#214063"
        />
        <path
          d="M23.9624 3.64824H23.9434C23.9582 3.64824 23.9727 3.64478 23.986 3.63815C23.9992 3.63152 24.0107 3.62189 24.0196 3.61003H23.9815C24.0005 3.61003 24.0386 3.62913 24.0386 3.59093H24.0196C24.0957 3.61003 24.1338 3.55273 24.191 3.57183C24.2481 3.59093 24.3243 3.61003 24.3624 3.61003C24.4005 3.61003 24.4005 3.66734 24.4005 3.68644L24.3624 3.83926L24.2862 3.89656C24.307 3.90835 24.3247 3.92487 24.3379 3.94477C24.3512 3.96468 24.3595 3.98743 24.3624 4.01118C24.3815 4.10669 24.2862 4.08759 24.2672 4.14489C24.2481 4.2022 24.191 4.12579 24.1529 4.14489H24.1338C24.1719 4.08759 24.0767 4.08759 24.0386 4.06848H24.0196C24.0196 4.04938 24.0577 4.06848 24.0577 4.03028H24.0767C24.0577 4.01118 24.0386 3.99208 24.0577 3.95387H23.9053C23.9243 3.70554 24.0005 3.70554 23.9624 3.64824Z"
          fill="#214063"
        />
        <path
          d="M19.7529 5.27245H19.7339C19.772 5.23424 19.772 5.13873 19.8482 5.11963H19.9815C19.9957 5.15284 20.0029 5.18858 20.0029 5.22469C20.0029 5.2608 19.9957 5.29654 19.9815 5.32975C19.9434 5.32975 19.9053 5.38706 19.8672 5.38706H19.8482V5.34886H19.7529C19.7518 5.3234 19.7518 5.2979 19.7529 5.27245Z"
          fill="#214063"
        />
        <path d="M18.1528 4.6417L18.172 4.62256L18.1528 4.6417Z" fill="white" />
        <path
          d="M18.4768 4.2219H18.4576C18.4768 4.20275 18.4385 4.18361 18.4194 4.20275C18.4002 4.2219 18.4576 4.20275 18.4768 4.2219Z"
          fill="#214063"
        />
        <path
          d="M18.7627 4.12593H18.7437C18.7437 4.12593 18.7817 4.08773 18.7627 4.06862C18.7437 4.04952 18.9151 4.12593 18.9532 3.99222C18.9913 3.8585 19.0865 3.97311 19.1246 4.04952C19.1307 4.06191 19.1341 4.07549 19.1345 4.08932C19.1349 4.10315 19.1323 4.1169 19.1268 4.12962C19.1214 4.14234 19.1133 4.15372 19.103 4.16298C19.0928 4.17223 19.0806 4.17915 19.0675 4.18324L19.0103 4.24054H18.9532C18.9532 4.18324 18.896 4.24054 18.877 4.22144C18.8579 4.16414 18.8198 4.22144 18.7817 4.18324H18.7437L18.7627 4.12593Z"
          fill="#214063"
        />
        <path
          d="M20.9339 3.7441C20.9148 3.7441 20.972 3.7441 20.9339 3.70589C20.8958 3.66769 20.972 3.66769 20.991 3.66769C21.0481 3.68679 21.0291 3.57218 21.1243 3.62948C21.2196 3.68679 21.2005 3.66769 21.2386 3.64859C21.2619 3.6698 21.278 3.69771 21.2848 3.72849C21.2917 3.75927 21.2888 3.79141 21.2767 3.82051L21.2005 3.89691V3.93512C21.1815 3.87781 21.1624 3.99243 21.1243 3.93512H21.0481C21.0532 3.93512 21.058 3.93311 21.0616 3.92952C21.0652 3.92594 21.0672 3.92108 21.0672 3.91602H20.9529C20.9148 3.7823 20.991 3.7823 20.9339 3.7441Z"
          fill="#214063"
        />
        <path
          d="M22.229 5.38655C22.2481 5.40565 22.2481 5.36744 22.2671 5.34834C22.2861 5.32924 22.3623 5.36744 22.3623 5.40565V5.48206C22.3433 5.46296 22.3242 5.50116 22.3052 5.52026C22.2861 5.53936 22.2671 5.50116 22.2671 5.50116L22.229 5.46296C22.2384 5.45245 22.2436 5.43885 22.2436 5.42475C22.2436 5.41066 22.2384 5.39705 22.229 5.38655Z"
          fill="#214063"
        />
        <path
          d="M22.2098 7.35456C22.2288 7.35456 22.2669 7.39277 22.2288 7.45007C22.2252 7.45414 22.2208 7.45739 22.2159 7.45962C22.211 7.46185 22.2057 7.46301 22.2002 7.46301C22.1948 7.46301 22.1895 7.46185 22.1846 7.45962C22.1796 7.45739 22.1752 7.45414 22.1717 7.45007C22.1336 7.43097 22.1526 7.33546 22.2098 7.35456Z"
          fill="#214063"
        />
        <path
          d="M23.3338 4.68006C23.3338 4.66096 23.3529 4.66096 23.3529 4.62276C23.3529 4.58455 23.429 4.62276 23.4481 4.66096C23.4671 4.69917 23.4481 4.71827 23.429 4.73737H23.3719C23.3529 4.71827 23.3148 4.69917 23.3338 4.66096V4.68006Z"
          fill="#214063"
        />
        <path
          d="M23.5628 4.60372H23.5437C23.5245 4.60372 23.5054 4.58457 23.5245 4.56543L23.5628 4.60372Z"
          fill="#214063"
        />
        <path
          d="M22.5718 5.88347C22.5737 5.87797 22.5769 5.87298 22.581 5.86889C22.5851 5.8648 22.5902 5.86171 22.5957 5.85987C22.6012 5.85803 22.6071 5.85747 22.6128 5.85825C22.6186 5.85903 22.6241 5.86112 22.6289 5.86437C22.6289 5.88347 22.648 5.90257 22.6289 5.90257H22.5718C22.5667 5.90257 22.5619 5.90056 22.5583 5.89698C22.5547 5.8934 22.5527 5.88854 22.5527 5.88347C22.5527 5.8784 22.5547 5.87355 22.5583 5.86996C22.5619 5.86638 22.5667 5.86437 22.5718 5.86437V5.88347Z"
          fill="#214063"
        />
        <path
          d="M22.5909 5.90248H22.61C22.6292 5.90248 22.5718 5.94076 22.5718 5.90248C22.5718 5.86419 22.5909 5.88333 22.5909 5.90248Z"
          fill="white"
        />
        <path
          d="M23.2582 6.57116H23.2392C23.2582 6.59026 23.2773 6.57116 23.2963 6.55205V6.49475C23.3154 6.51385 23.3344 6.49475 23.3535 6.49475V6.45654C23.4296 6.49475 23.582 6.45654 23.6011 6.59026L23.563 6.72397C23.5249 6.78128 23.4677 6.76218 23.4296 6.81949V6.76218C23.3916 6.80038 23.4106 6.76218 23.3916 6.76218H23.3344C23.3344 6.74308 23.3344 6.74308 23.3535 6.74308C23.3725 6.74308 23.3154 6.72397 23.2963 6.72397C23.2773 6.72397 23.2963 6.66667 23.2773 6.60936H23.2392C23.2011 6.59026 23.2582 6.62846 23.2582 6.57116Z"
          fill="#214063"
        />
        <path
          d="M23.6763 5.34904C23.6953 5.32994 23.6953 5.32994 23.6953 5.29173H23.6763C23.6763 5.29173 23.7144 5.29173 23.7144 5.31084C23.7144 5.32994 23.7334 5.25353 23.7715 5.27263C23.8096 5.29173 23.7715 5.23443 23.7715 5.21532C23.7715 5.19622 23.7906 5.25353 23.8477 5.25353C23.9048 5.25353 23.9429 5.29173 23.981 5.25353L24.0382 5.29173C24.0382 5.31084 24.0572 5.29173 24.0572 5.29173C24.0572 5.29173 24.0953 5.38724 24.1144 5.38724C24.1334 5.38724 24.1334 5.44455 24.1525 5.46365C24.1474 5.46365 24.1426 5.46567 24.139 5.46925C24.1354 5.47283 24.1334 5.47769 24.1334 5.48276C24.1334 5.48782 24.1354 5.49268 24.139 5.49626C24.1426 5.49984 24.1474 5.50186 24.1525 5.50186C24.0953 5.52096 24.2096 5.55916 24.1334 5.57827C24.0572 5.59737 24.1525 5.61647 24.1525 5.61647H24.0953C24.1525 5.67378 24.0382 5.65467 24.0572 5.73108C24.0763 5.80749 24.0191 5.73108 24.0001 5.75019C23.981 5.71198 23.9429 5.76929 23.9048 5.76929C23.8667 5.76929 23.8477 5.69288 23.7906 5.75019C23.7334 5.80749 23.7715 5.65467 23.7144 5.69288H23.6763C23.6572 5.65467 23.7334 5.67378 23.6953 5.63557C23.6572 5.59737 23.6763 5.65467 23.6572 5.65467C23.6382 5.65467 23.7334 5.59737 23.6572 5.55916H23.6001C23.6119 5.55027 23.6215 5.53873 23.6281 5.52547C23.6347 5.51221 23.6382 5.49758 23.6382 5.48276C23.6382 5.44455 23.581 5.50186 23.6001 5.46365C23.6191 5.42545 23.6382 5.46365 23.6382 5.42545L23.6001 5.38724C23.6382 5.42545 23.6382 5.34904 23.6763 5.34904Z"
          fill="#214063"
        />
        <path
          d="M24.9718 6.68607C24.9718 6.66697 24.9718 6.66697 24.9527 6.66697C24.9337 6.66697 25.0289 6.60966 25.0289 6.57146C25.0289 6.53325 25.1051 6.47594 25.1622 6.51415C25.2194 6.55235 25.1813 6.45684 25.2194 6.49505H25.2384C25.2956 6.53325 25.3718 6.51415 25.4289 6.57146C25.4861 6.62876 25.448 6.64786 25.5051 6.64786H25.467C25.4861 6.70517 25.5432 6.72427 25.4861 6.78158V6.81978C25.4509 6.84239 25.4241 6.87594 25.4099 6.9153C25.3718 6.9344 25.3146 6.9153 25.3146 6.9535C25.3146 6.9917 25.2765 6.9917 25.2384 7.01081H25.2003V6.9726C25.1847 6.96418 25.1667 6.96147 25.1493 6.96496C25.1319 6.96845 25.1163 6.9779 25.1051 6.9917C25.1051 6.9726 25.067 7.01081 25.048 6.9917H25.0289C25.0099 6.9535 24.9718 6.9917 24.9527 6.9726C24.9337 6.9535 24.9908 6.9535 24.9718 6.9344V6.89619H24.9337L24.9718 6.85799C24.9527 6.81978 24.9146 6.87709 24.8956 6.83889C24.8765 6.80068 24.9146 6.70517 24.9718 6.68607Z"
          fill="#214063"
        />
        <path
          d="M24.9528 4.27913C24.9528 4.29823 24.9719 4.31734 24.9719 4.33644C24.9719 4.35554 24.9147 4.33644 24.8957 4.31734C24.8766 4.29823 24.9147 4.26003 24.9528 4.27913Z"
          fill="#214063"
        />
        <path
          d="M25.6953 2.94189H25.7144C25.7334 2.9801 25.6953 2.9801 25.6763 2.9801C25.6572 2.9801 25.6763 2.9801 25.6382 2.94189H25.6953Z"
          fill="#214063"
        />
        <path
          d="M25.4868 6.11279L25.544 6.1701C25.5249 6.1701 25.5249 6.2083 25.4868 6.2083H25.4678C25.4487 6.1701 25.5249 6.1892 25.4868 6.151H25.4487L25.4868 6.11279Z"
          fill="#214063"
        />
        <path
          d="M25.8867 4.90931C25.8858 4.89896 25.8871 4.88854 25.8904 4.87869C25.8936 4.86884 25.8989 4.85976 25.9058 4.852C25.9629 4.8138 26.001 4.8329 26.0582 4.8329C26.1153 4.8329 26.1534 4.92841 26.1153 4.98572C26.0772 5.04302 26.0772 5.02392 26.1153 5.04302C26.1534 5.06213 26.0391 5.04302 26.0582 5.08123C26.0772 5.11943 26.0201 5.06213 26.001 5.08123H25.9629C25.9248 5.11943 25.9248 5.06213 25.8867 5.06213H25.9058C25.9058 5.04302 25.8867 5.06213 25.8677 5.04302V4.98572H25.9058L25.8867 4.90931Z"
          fill="#214063"
        />
        <path
          d="M26.001 5.17651C26.02 5.1574 26.0772 5.17651 26.0772 5.1383C26.0772 5.1001 26.0962 5.1383 26.1153 5.1383H26.1343C26.1534 5.1192 26.1534 5.1192 26.1534 5.1001L26.1915 5.1383H26.2296V5.1574C26.3058 5.1383 26.3058 5.19561 26.3438 5.21471C26.3819 5.23381 26.3248 5.29112 26.3819 5.31022C26.4391 5.32932 26.3819 5.44394 26.3058 5.50124C26.2296 5.55855 26.2867 5.50124 26.2867 5.48214C26.2867 5.46304 26.2486 5.52035 26.2677 5.53945L26.2296 5.50124C26.1915 5.57765 26.1343 5.50124 26.0962 5.52035C26.0581 5.53945 26.0581 5.52035 26.0581 5.48214H26.02V5.44394C26.001 5.46304 26.001 5.42483 25.9629 5.46304C25.9248 5.50124 26.001 5.36753 25.9438 5.36753C25.9507 5.35978 25.956 5.3507 25.9593 5.34084C25.9625 5.33099 25.9638 5.32057 25.9629 5.31022C25.9058 5.27202 26.0391 5.23381 26.001 5.17651Z"
          fill="#214063"
        />
        <path
          d="M26.7627 5.82625C26.8008 5.80714 26.7627 5.78804 26.7437 5.76894L26.7818 5.73074C26.7627 5.71163 26.7437 5.73074 26.7437 5.71163C26.7437 5.69253 26.8008 5.74984 26.8008 5.69253H26.8389V5.65433C26.8579 5.65433 26.9151 5.65433 26.9151 5.61612V5.53971C26.9722 5.53971 26.9341 5.46331 26.9722 5.50151C27.0103 5.53971 27.0294 5.406 27.0103 5.36779C26.9913 5.32959 27.0484 5.34869 27.0675 5.32959C27.0675 5.33466 27.0695 5.33951 27.0731 5.3431C27.0766 5.34668 27.0815 5.34869 27.0865 5.34869C27.1056 5.31049 27.1246 5.36779 27.1437 5.34869C27.1627 5.32959 27.1818 5.406 27.2199 5.3869C27.2579 5.36779 27.2579 5.4442 27.2579 5.48241C27.2579 5.52061 27.2579 5.4251 27.296 5.406C27.3341 5.3869 27.2579 5.50151 27.3341 5.52061H27.3722C27.3722 5.52061 27.3722 5.57792 27.4103 5.55882V5.61612H27.4484C27.4484 5.63522 27.4294 5.65433 27.4484 5.65433C27.4675 5.65433 27.4675 5.65433 27.4675 5.65433C27.4666 5.66468 27.4678 5.6751 27.4711 5.68495C27.4744 5.6948 27.4796 5.70388 27.4865 5.71163H27.5246V5.78804C27.5818 5.78804 27.5056 5.82625 27.5627 5.84535C27.6199 5.86445 27.5627 5.92176 27.5818 5.94086C27.6008 5.95996 27.5437 5.92176 27.5437 5.95996C27.5437 5.99817 27.5818 5.97906 27.6008 5.99817H27.5437C27.5343 6.00867 27.5291 6.02228 27.5291 6.03637C27.5291 6.05047 27.5343 6.06407 27.5437 6.07458C27.5437 6.09368 27.4675 6.11278 27.5246 6.15098H27.5056C27.4865 6.18919 27.5246 6.18919 27.5246 6.20829C27.5246 6.22739 27.4675 6.13188 27.4294 6.20829V6.22739C27.3151 6.22739 27.3722 6.38021 27.2579 6.36111C27.1437 6.34201 27.2199 6.3229 27.2008 6.3229C27.1818 6.3229 27.1437 6.38021 27.0865 6.36111C27.0294 6.34201 27.0103 6.2656 26.9913 6.2847C26.9722 6.3038 26.9532 6.3229 26.9341 6.3229C26.9151 6.3229 26.9913 6.2656 26.9341 6.22739H26.896C26.9151 6.20829 26.896 6.17009 26.896 6.15098H26.8579C26.8579 6.13188 26.896 6.11278 26.8579 6.09368H26.8199C26.8199 6.07458 26.8579 6.07458 26.8389 6.05547C26.8199 6.03637 26.8199 5.99817 26.7818 6.01727C26.7437 6.03637 26.8199 5.99817 26.7818 5.95996H26.7437C26.7627 5.94086 26.8008 5.94086 26.7818 5.90266H26.7246C26.7437 5.90266 26.7627 5.90266 26.7627 5.86445H26.7056C26.7246 5.86445 26.7627 5.86445 26.7627 5.82625Z"
          fill="#214063"
        />
        <path
          d="M22.4007 3.15186C22.4388 3.17096 22.4959 3.15186 22.5149 3.20916C22.534 3.26647 22.4768 3.34288 22.4007 3.30467H22.3816L22.3435 3.24737C22.3816 3.22826 22.3054 3.19006 22.3435 3.17096C22.3816 3.15186 22.4007 3.19006 22.4007 3.15186Z"
          fill="#214063"
        />
        <path
          d="M22.7631 3.24756L22.7057 3.2667V3.24756L22.6865 3.2667V3.24756H22.7631Z"
          fill="#214063"
        />
        <path
          d="M22.877 3.19045H22.8579C22.8727 3.19045 22.8873 3.187 22.9005 3.18037C22.9137 3.17374 22.9252 3.16411 22.9341 3.15225H22.9151C22.9887 3.12438 23.07 3.12438 23.1436 3.15225C23.1817 3.19045 23.2198 3.24776 23.277 3.22865C23.3341 3.20955 23.2389 3.24776 23.2579 3.28596C23.277 3.32417 23.296 3.36237 23.3151 3.40057C23.3341 3.43878 23.2579 3.45788 23.2389 3.51519C23.2198 3.57249 23.1817 3.51519 23.1817 3.55339V3.43878C23.1436 3.45788 23.1627 3.49609 23.1436 3.51519V3.47698C23.1055 3.51519 23.0484 3.49609 23.0103 3.51519C22.9722 3.53429 22.9151 3.51519 22.877 3.53429C22.8389 3.55339 22.9532 3.45788 22.9151 3.40057H22.877C22.8389 3.36237 22.9341 3.34327 22.896 3.30506L22.8008 3.36237C22.8198 3.30506 22.896 3.28596 22.877 3.19045Z"
          fill="#214063"
        />
        <path
          d="M23.1246 3.64864H23.1055V3.61035L23.1246 3.64864Z"
          fill="#214063"
        />
        <path
          d="M19.2009 9.32178L19.1817 9.34092L19.1626 9.32178H19.2009Z"
          fill="white"
        />
        <path
          d="M14.3434 2.59803L14.4006 2.54073C14.4767 2.52162 14.4767 2.55983 14.4958 2.59803C14.4884 2.62354 14.4735 2.64625 14.4532 2.66326C14.4328 2.68027 14.4079 2.69081 14.3815 2.69354C14.3434 2.69354 14.3244 2.63624 14.3434 2.59803Z"
          fill="#214063"
        />
        <path
          d="M14.286 2.29248C14.3241 2.29248 14.3241 2.31158 14.3431 2.33068C14.3622 2.34979 14.3241 2.38799 14.286 2.40709C14.2479 2.4262 14.1908 2.33068 14.286 2.29248Z"
          fill="#214063"
        />
        <path
          d="M12.4382 14.3457C12.4574 14.3457 12.4765 14.3648 12.4574 14.4031H12.4382C12.4342 14.3995 12.4309 14.3951 12.4287 14.3902C12.4264 14.3852 12.4253 14.3799 12.4253 14.3744C12.4253 14.369 12.4264 14.3636 12.4287 14.3587C12.4309 14.3537 12.4342 14.3493 12.4382 14.3457Z"
          fill="#214063"
        />
        <path
          d="M14.0005 7.67881V7.65967H14.0196L14.0005 7.67881Z"
          fill="#214063"
        />
        <path
          d="M12.3242 14.174C12.3434 14.1549 12.3434 14.174 12.3625 14.174C12.3816 14.174 12.3625 14.2123 12.3434 14.2123C12.3242 14.2123 12.3242 14.1932 12.3242 14.174Z"
          fill="#214063"
        />
        <path
          d="M14.2862 7.39258H14.3243C14.3052 7.44988 14.2481 7.46899 14.191 7.48809C14.1338 7.50719 14.2291 7.39258 14.2862 7.39258Z"
          fill="#214063"
        />
        <path
          d="M12.7052 13.811C12.7433 13.811 12.8004 13.811 12.7814 13.8683C12.7623 13.9256 12.7433 13.9065 12.7052 13.9065C12.6944 13.893 12.6885 13.8762 12.6885 13.8588C12.6885 13.8414 12.6944 13.8246 12.7052 13.811Z"
          fill="#214063"
        />
        <path
          d="M9.67634 14.8807C9.67007 14.8362 9.67365 14.7909 9.68682 14.748C9.69999 14.705 9.72242 14.6656 9.75253 14.6323C9.79063 14.6514 9.77158 14.6896 9.77158 14.7278C9.77158 14.766 9.69539 14.8233 9.69539 14.8998C9.69539 14.9762 9.69539 14.8807 9.67634 14.8807Z"
          fill="#214063"
        />
        <path
          d="M19.067 2.55995H19.0289L19.067 2.52174C19.0099 2.46444 19.1432 2.44533 19.1242 2.40713C19.1978 2.37926 19.2791 2.37926 19.3527 2.40713C19.3908 2.46444 19.3718 2.48354 19.4099 2.54084C19.448 2.59815 19.448 2.67456 19.3337 2.67456C19.2194 2.67456 19.2385 2.67456 19.1813 2.71276C19.1242 2.75097 19.1623 2.69366 19.1242 2.67456H19.0861C19.1242 2.63636 19.067 2.61725 19.0289 2.59815C18.9908 2.57905 19.048 2.57905 19.067 2.55995Z"
          fill="#214063"
        />
        <path
          d="M9.9624 14.3459L10.0198 14.3076C10.0389 14.3268 10.0198 14.3842 10.0007 14.4225L9.9624 14.4608V14.3459Z"
          fill="#214063"
        />
        <path
          d="M9.84795 14.0591H9.88622C9.90535 14.1165 9.84795 14.1548 9.82882 14.2122C9.82474 14.1604 9.83125 14.1083 9.84795 14.0591Z"
          fill="#214063"
        />
        <path
          d="M9.86728 14.0975C9.86728 14.0784 9.88641 14.1166 9.84814 14.1358L9.86728 14.0975Z"
          fill="white"
        />
        <path
          d="M11.8292 11.0029H11.8675C11.8675 11.0412 11.8675 11.0412 11.8483 11.0604C11.8292 11.0795 11.8101 11.0412 11.8292 11.0029Z"
          fill="#214063"
        />
        <path
          d="M11.0288 10.1243C11.0288 10.1051 11.0479 10.086 11.0479 10.0668C11.0479 10.0477 11.0862 10.1051 11.0862 10.1243C11.0862 10.1434 11.0288 10.1434 11.0288 10.1243Z"
          fill="#214063"
        />
        <path
          d="M10.4961 9.83768C10.5151 9.81857 10.5532 9.76127 10.5913 9.79947C10.6294 9.83768 10.6485 9.83768 10.6294 9.89498C10.6104 9.95229 10.5913 9.93319 10.5723 9.95229C10.5532 9.97139 10.5151 9.89498 10.4961 9.83768Z"
          fill="#214063"
        />
        <path
          d="M10.9341 10.0099C10.9341 10.0048 10.9361 9.99992 10.9397 9.99633C10.9433 9.99274 10.9481 9.99072 10.9532 9.99072C10.9583 9.99072 10.9632 9.99274 10.9667 9.99633C10.9703 9.99992 10.9723 10.0048 10.9723 10.0099C10.9723 10.0482 10.9149 10.0482 10.9341 10.0099Z"
          fill="#214063"
        />
        <path
          d="M12.0581 10.1813C12.0772 10.1622 12.0772 10.1431 12.0962 10.1431C12.1152 10.1431 12.1343 10.1622 12.1533 10.2004C12.1467 10.2075 12.1383 10.2128 12.1291 10.2158C12.1198 10.2188 12.11 10.2193 12.1004 10.2174C12.0909 10.2155 12.082 10.2112 12.0746 10.2048C12.0672 10.1985 12.0615 10.1904 12.0581 10.1813Z"
          fill="#214063"
        />
        <path
          d="M11.2769 13.0278V13.0661L11.2578 13.047L11.2769 13.0278Z"
          fill="#214063"
        />
        <path
          d="M11.4289 12.7605C11.467 12.7414 11.486 12.6841 11.5051 12.7223C11.5241 12.7605 11.5051 12.8751 11.486 12.9324C11.467 12.9133 11.4479 12.9324 11.4479 12.9133C11.4479 12.8942 11.3908 12.9324 11.3908 12.9898C11.3749 12.9112 11.3884 12.8296 11.4289 12.7605Z"
          fill="#214063"
        />
        <path
          d="M11.2197 9.68467C11.2197 9.66553 11.2389 9.68467 11.258 9.66553C11.2612 9.67038 11.2633 9.67592 11.2641 9.68171C11.2649 9.6875 11.2643 9.69339 11.2625 9.69894C11.2607 9.70448 11.2576 9.70953 11.2535 9.71369C11.2494 9.71785 11.2444 9.72103 11.2389 9.72296C11.2197 9.72296 11.2197 9.70382 11.2197 9.68467Z"
          fill="#214063"
        />
        <path
          d="M12.077 9.78039C12.0961 9.76125 12.1153 9.78039 12.1344 9.79953C12.1233 9.80935 12.1165 9.82307 12.1153 9.83782C12.0961 9.85697 12.0579 9.81868 12.077 9.78039Z"
          fill="#214063"
        />
        <path
          d="M11.7339 9.58947C11.753 9.57033 11.7722 9.58947 11.7913 9.60862C11.8104 9.62776 11.7722 9.6469 11.753 9.6469C11.7339 9.6469 11.7339 9.60862 11.7339 9.58947Z"
          fill="#214063"
        />
        <path
          d="M12.0581 9.70399C12.0962 9.68489 12.0962 9.58938 12.1343 9.62759C12.1724 9.66579 12.1343 9.7231 12.0962 9.7422C12.0581 9.7613 12.0581 9.7231 12.0581 9.70399Z"
          fill="#214063"
        />
        <path
          d="M11.4868 12.149C11.4962 12.1385 11.5014 12.1249 11.5014 12.1108C11.5014 12.0967 11.4962 12.0831 11.4868 12.0726C11.4678 12.0726 11.4487 12.1108 11.4297 12.0917C11.4106 12.0726 11.5059 11.8242 11.6392 11.786C11.7725 11.7478 11.6773 11.8051 11.6963 11.8433C11.7154 11.8815 11.6773 11.9006 11.6963 11.9198C11.7154 11.9389 11.6773 12.0535 11.6201 12.0917C11.563 12.1299 11.6201 12.0917 11.6201 12.0726L11.4868 12.1872V12.149Z"
          fill="#214063"
        />
        <path
          d="M12.0957 12.0347C12.1909 12.0538 12.0957 12.1493 12.0957 12.2066L12.0195 12.2639C12.0133 12.2224 12.0171 12.18 12.0303 12.1402C12.0435 12.1003 12.0659 12.0642 12.0957 12.0347Z"
          fill="#214063"
        />
        <path
          d="M12.0772 12.1108L12.0964 12.13L12.0581 12.1491L12.0964 12.13L12.0772 12.1108Z"
          fill="white"
        />
        <path
          d="M16.0772 5.979H16.1153C16.1153 6.11272 15.9629 6.18913 15.8677 6.22733H15.7915C15.8176 6.16717 15.8568 6.11364 15.9063 6.07067C15.9557 6.02769 16.0141 5.99637 16.0772 5.979Z"
          fill="#214063"
        />
        <path
          d="M12.2673 11.8819L12.229 11.9011V11.8628L12.2673 11.8819Z"
          fill="#214063"
        />
        <path
          d="M12.4005 11.5953L12.4386 11.5571L12.4767 11.6144C12.4767 11.6908 12.4195 11.729 12.3814 11.7673H12.4005C12.3993 11.7525 12.3924 11.7388 12.3814 11.729C12.3624 11.729 12.3624 11.7482 12.3624 11.7673C12.3545 11.7376 12.3539 11.7066 12.3605 11.6766C12.3671 11.6467 12.3808 11.6188 12.4005 11.5953Z"
          fill="#214063"
        />
        <path
          d="M12.4198 11.6714H12.4007C12.4198 11.6905 12.4007 11.6714 12.4007 11.6905C12.4007 11.7097 12.3624 11.6905 12.4198 11.6714Z"
          fill="white"
        />
        <path
          d="M12.5721 11.4997C12.568 11.4656 12.5709 11.4311 12.5808 11.3982C12.5906 11.3653 12.6071 11.3348 12.6293 11.3087C12.6483 11.2896 12.6864 11.2705 12.6864 11.3087C12.697 11.3368 12.7007 11.3671 12.6974 11.3969C12.6941 11.4268 12.6838 11.4555 12.6674 11.4806C12.6293 11.4806 12.6102 11.5379 12.5912 11.557C12.5721 11.5761 12.6293 11.4806 12.5721 11.4997Z"
          fill="#214063"
        />
        <path
          d="M14.4577 11.461C14.4577 11.4559 14.4597 11.4511 14.4632 11.4475C14.4668 11.4439 14.4717 11.4419 14.4767 11.4419C14.4818 11.4419 14.4866 11.4439 14.4902 11.4475C14.4937 11.4511 14.4958 11.4559 14.4958 11.461C14.5338 11.4992 14.4958 11.5565 14.4767 11.5947C14.4577 11.6329 14.4767 11.652 14.4386 11.652C14.4256 11.5879 14.4323 11.5213 14.4577 11.461Z"
          fill="#214063"
        />
        <path
          d="M9.1817 8.40479C9.25789 8.42389 9.20075 8.5194 9.20075 8.57671C9.20075 8.63401 9.02932 8.74862 8.97218 8.84414L8.93408 8.90144C9.02932 8.76773 8.99122 8.48119 9.1817 8.40479Z"
          fill="#214063"
        />
        <path
          d="M13.9818 9.64648H14.0199C14.039 9.66559 14.0771 9.66559 14.0771 9.70379L14.039 9.7993C14.0199 9.7993 14.0199 9.7993 14.0199 9.7802L13.9818 9.8184C13.9247 9.7611 13.9628 9.70379 13.9818 9.64648Z"
          fill="#214063"
        />
        <path
          d="M14.4006 8.94012C14.3815 8.94012 14.3815 8.95922 14.3815 8.97833C14.3815 8.99743 14.3625 8.88281 14.3815 8.82551C14.4006 8.7682 14.4387 8.7682 14.4768 8.7873C14.5148 8.80641 14.5148 8.82551 14.5339 8.86371C14.5529 8.90192 14.4577 8.92102 14.4768 8.95922H14.4577L14.3815 8.99743C14.3815 8.95922 14.3815 8.94012 14.4006 8.94012Z"
          fill="#214063"
        />
        <path
          d="M10.3058 8.17578L10.2866 8.21407V8.17578H10.3058Z"
          fill="#214063"
        />
        <path
          d="M10.5146 8.23291C10.5146 8.21377 10.5338 8.2712 10.5146 8.2712L10.5912 8.23291L10.5146 8.30949V8.23291Z"
          fill="#214063"
        />
        <path
          d="M10.5342 8.21404C10.5342 8.19494 10.5532 8.17584 10.5532 8.15674C10.5532 8.13763 10.5913 8.13763 10.6104 8.15674C10.6294 8.17584 10.6104 8.17584 10.6104 8.19494C10.6104 8.21404 10.6104 8.15674 10.5913 8.13763C10.5723 8.11853 10.5532 8.17584 10.5532 8.19494C10.5532 8.21404 10.5532 8.19494 10.5723 8.19494L10.5342 8.21404Z"
          fill="#214063"
        />
        <path
          d="M13.0483 8.50074C13.1055 8.42434 13.0864 8.29062 13.2007 8.23331C13.315 8.17601 13.2579 8.30972 13.2388 8.34793C13.2198 8.38613 13.1245 8.44344 13.0674 8.50074H13.0483Z"
          fill="#214063"
        />
        <path
          d="M14.9341 8.55774C14.9722 8.51954 14.9722 8.46223 15.0293 8.48133C15.0865 8.50044 15.0484 8.51954 15.0674 8.55774L15.0103 8.61505C14.9912 8.61505 14.9912 8.59595 14.9722 8.61505L14.9341 8.55774Z"
          fill="#214063"
        />
        <path
          d="M12.1342 7.62182C12.1532 7.58361 12.1913 7.54541 12.2103 7.54541C12.2236 7.55289 12.2342 7.56416 12.241 7.57778C12.2478 7.59139 12.2504 7.60673 12.2484 7.62182C12.2103 7.66002 12.1913 7.71733 12.1532 7.73643C12.1151 7.75553 12.1342 7.66002 12.1342 7.62182Z"
          fill="#214063"
        />
        <path
          d="M15.2008 8.53868C15.2008 8.51953 15.1626 8.53868 15.1626 8.53868C15.1626 8.5336 15.1646 8.52873 15.1682 8.52514C15.1718 8.52155 15.1766 8.51953 15.1817 8.51953H15.2008C15.22 8.53868 15.2008 8.57696 15.1626 8.57696C15.1243 8.57696 15.2008 8.57696 15.2008 8.53868Z"
          fill="#214063"
        />
        <path
          d="M10.4575 6.62823C10.4617 6.60738 10.4708 6.58783 10.4841 6.57122C10.4973 6.55461 10.5143 6.54141 10.5337 6.53271C10.5718 6.55182 10.6099 6.59002 10.5909 6.62823C10.5718 6.66643 10.4575 6.72374 10.4575 6.62823Z"
          fill="#214063"
        />
        <path
          d="M11.2957 6.91507H11.2576C11.2386 6.89597 11.2767 6.87686 11.2957 6.87686C11.3066 6.8187 11.3291 6.76334 11.3618 6.7141C11.3945 6.66487 11.4368 6.62277 11.4862 6.59033C11.5045 6.59826 11.5198 6.61174 11.5301 6.62887C11.5403 6.646 11.545 6.66593 11.5433 6.68584L11.4481 6.85776L11.2767 6.99148C11.2767 6.95327 11.2957 6.93417 11.2957 6.91507Z"
          fill="#214063"
        />
        <path
          d="M12.7621 7.52643C12.7621 7.54553 12.7811 7.54553 12.8002 7.54553C12.8383 7.54553 12.8573 7.52643 12.8383 7.48823C12.8192 7.45002 12.7811 7.46913 12.743 7.48823C12.7049 7.50733 12.7811 7.33541 12.8573 7.35451C12.877 7.37583 12.8902 7.40234 12.8954 7.43092L12.8383 7.54553C12.8573 7.54553 12.8573 7.54553 12.8573 7.52643H12.8383L12.8002 7.56464C12.7951 7.56464 12.7903 7.56262 12.7867 7.55904C12.7831 7.55546 12.7811 7.5506 12.7811 7.54553H12.743C12.7508 7.54078 12.7573 7.53423 12.7621 7.52643Z"
          fill="#214063"
        />
        <path
          d="M16.3622 8.80599C16.4003 8.78689 16.4193 8.82509 16.4193 8.84419C16.4193 8.86329 16.3431 8.9015 16.3431 8.95881C16.3431 9.01611 16.3241 8.82509 16.3622 8.80599Z"
          fill="#214063"
        />
        <path
          d="M12.7812 7.44992H12.8387C12.8578 7.43078 12.8578 7.44992 12.8578 7.44992H12.8195C12.8004 7.43078 12.8195 7.41164 12.7812 7.43078H12.8004C12.8004 7.43586 12.7984 7.44073 12.7948 7.44432C12.7912 7.44791 12.7863 7.44992 12.7812 7.44992Z"
          fill="white"
        />
        <path
          d="M18.6485 5.50117H18.6104C18.6104 5.48206 18.7437 5.48206 18.6675 5.40566C18.5913 5.32925 18.858 5.34835 18.9532 5.40566H18.9342C18.9723 5.36745 19.0104 5.29104 19.0865 5.31014C19.1627 5.32925 19.1246 5.32925 19.1246 5.36745C19.1246 5.40566 18.877 5.38655 18.9151 5.57758C18.8965 5.60631 18.8711 5.63004 18.8412 5.64669C18.8114 5.66333 18.7779 5.6724 18.7437 5.67309L18.7056 5.73039C18.7437 5.69219 18.6865 5.67309 18.6865 5.65398H18.6485V5.61578H18.5913C18.6104 5.55847 18.6485 5.53937 18.6485 5.50117Z"
          fill="#214063"
        />
        <path
          d="M15.486 8.13765C15.5241 8.11855 15.5241 8.08034 15.5812 8.09944C15.6383 8.11855 15.6002 8.15675 15.6002 8.19496C15.6002 8.23316 15.5621 8.19495 15.5621 8.23316C15.5431 8.21406 15.4479 8.17585 15.486 8.13765Z"
          fill="#214063"
        />
        <path
          d="M11.9053 6.53302C11.905 6.50597 11.912 6.47933 11.9254 6.45584C11.9387 6.43234 11.9581 6.41283 11.9815 6.39931C12.0005 6.39931 12.0386 6.3802 12.0386 6.41841C12.0386 6.45661 11.9815 6.51392 11.9434 6.57123C11.9053 6.62853 11.9053 6.55212 11.9053 6.53302Z"
          fill="#214063"
        />
        <path
          d="M11.9626 6.47559L11.9243 6.53302L11.9626 6.47559Z"
          fill="white"
        />
        <path
          d="M16.0769 8.06084C16.0578 8.07995 16.0578 8.02264 16.0388 8.04174C16.0197 8.06084 16.0578 7.96533 16.0959 7.96533C16.134 7.96533 16.1149 8.00354 16.134 8.04174L16.0769 8.06084Z"
          fill="#214063"
        />
        <path
          d="M16.0768 8.04209L16.0959 8.02295V8.04209H16.0768L16.0576 8.02295L16.0768 8.04209Z"
          fill="white"
        />
        <path
          d="M16.3628 7.46905C16.3628 7.44994 16.3628 7.39264 16.4009 7.37354H16.4961C16.5533 7.43084 16.4771 7.48815 16.4771 7.52635C16.439 7.50725 16.4199 7.54546 16.4009 7.54546C16.3818 7.54546 16.3818 7.48815 16.3628 7.46905Z"
          fill="#214063"
        />
        <path
          d="M17.4102 8.2525H17.3911C17.4102 8.19519 17.3911 8.11878 17.4673 8.09968C17.5435 8.08058 17.5244 8.17609 17.5054 8.19519C17.4864 8.21429 17.4483 8.2525 17.4102 8.2716V8.2525Z"
          fill="#214063"
        />
        <path
          d="M12.2675 5.59722C12.2484 5.55902 12.3056 5.46351 12.3436 5.4253C12.358 5.40996 12.3769 5.39977 12.3976 5.39632C12.4182 5.39287 12.4394 5.39634 12.4579 5.4062C12.5151 5.4253 12.496 5.48261 12.496 5.52081C12.496 5.55902 12.4389 5.57812 12.4389 5.61633C12.4389 5.65453 12.3436 5.71184 12.3246 5.61633H12.3055C12.3018 5.6097 12.2962 5.60434 12.2894 5.60094C12.2826 5.59753 12.275 5.59624 12.2675 5.59722Z"
          fill="#214063"
        />
        <path
          d="M16.8008 7.60276H16.7627C16.8198 7.58366 16.8389 7.46905 16.9151 7.50725C16.9913 7.54546 16.9532 7.60276 16.9532 7.64097C16.9532 7.67917 16.9151 7.66007 16.9151 7.67917C16.9151 7.69828 16.896 7.67917 16.896 7.66007C16.896 7.64097 16.877 7.66007 16.8389 7.67917H16.8008C16.8198 7.62187 16.7627 7.62187 16.8008 7.60276Z"
          fill="#214063"
        />
        <path
          d="M13.4102 6.05568C13.4292 6.05568 13.4102 6.09389 13.4102 6.11299L13.353 6.17029C13.3721 6.2085 13.3911 6.15119 13.4102 6.15119L13.3721 6.11299C13.315 6.09389 13.334 6.17029 13.315 6.1894L13.2769 6.2276C13.2959 6.13209 13.334 6.03658 13.4102 6.05568Z"
          fill="#214063"
        />
        <path
          d="M14.7622 5.52051H14.7813C14.7622 5.53965 14.7813 5.53965 14.7622 5.52051Z"
          fill="#214063"
        />
        <path
          d="M16.7052 6.55225H16.7243V6.59053C16.7243 6.57139 16.7052 6.55225 16.686 6.57139L16.7052 6.55225Z"
          fill="#214063"
        />
        <path
          d="M15.3721 4.66064H15.3912C15.3883 4.66232 15.385 4.66321 15.3816 4.66321C15.3783 4.66321 15.375 4.66232 15.3721 4.66064Z"
          fill="#214063"
        />
        <path
          d="M15.4292 4.64147H15.4483V4.60326C15.4483 4.58416 15.4292 4.58416 15.4292 4.56506C15.4292 4.54596 15.3911 4.60326 15.3911 4.64147H15.3721C15.3911 4.58416 15.4292 4.56506 15.4864 4.52686H15.5245C15.5054 4.60326 15.4483 4.62237 15.3911 4.64147H15.4292Z"
          fill="#214063"
        />
        <path
          d="M17.9243 5.63525C17.9446 5.63525 17.9639 5.6433 17.9782 5.65763C17.9925 5.67196 18.0005 5.6914 18.0005 5.71166L17.9624 5.76897C17.9624 5.76897 17.9434 5.71166 17.9243 5.74987C17.9053 5.78807 17.9243 5.78807 17.9053 5.80717H17.9243C17.8862 5.78807 17.8862 5.82628 17.8482 5.82628V5.78807H17.8101C17.8482 5.73076 17.8672 5.65436 17.9243 5.63525Z"
          fill="#214063"
        />
        <path
          d="M16.4194 4.71791C16.4766 4.6606 16.4956 4.6033 16.5718 4.6224C16.648 4.6415 16.5718 4.69881 16.5718 4.73701L16.4956 4.79432H16.4194C16.4385 4.73701 16.4385 4.71791 16.4194 4.71791Z"
          fill="#214063"
        />
        <path
          d="M16.4961 4.66097L16.458 4.69917C16.4592 4.68445 16.466 4.67077 16.4771 4.66097C16.5152 4.64187 16.5152 4.68007 16.5342 4.69917C16.5532 4.71827 16.4771 4.73738 16.4771 4.75648C16.4771 4.77558 16.439 4.71827 16.4961 4.66097Z"
          fill="white"
        />
        <path
          d="M17.7912 6.01709C17.8103 6.01709 17.8103 6.03619 17.8293 6.05529C17.8484 6.0744 17.8103 6.0935 17.7722 6.1126C17.7341 6.1317 17.7912 6.1126 17.7912 6.0744H17.7531C17.7531 6.0935 17.7531 6.1126 17.7341 6.1126C17.715 6.1126 17.7531 6.01709 17.7912 6.01709Z"
          fill="#214063"
        />
        <path
          d="M16.5528 4.25977H16.5718V4.29797H16.5528V4.35528V4.31707L16.4766 4.37438C16.4766 4.33617 16.4956 4.27887 16.5528 4.25977Z"
          fill="#214063"
        />
        <path
          d="M21.2007 5.55902C21.2007 5.50171 21.1626 5.53992 21.1436 5.52081C21.1245 5.50171 21.1817 5.53992 21.2007 5.50171C21.2198 5.46351 21.1626 5.46351 21.1436 5.48261H21.1245C21.1626 5.44441 21.2197 5.48261 21.2388 5.4062C21.2578 5.32979 21.2197 5.3871 21.2197 5.368C21.2197 5.34889 21.2769 5.31069 21.334 5.29159H21.315C21.3531 5.27249 21.3912 5.29159 21.4293 5.29159C21.4674 5.29159 21.5055 5.27249 21.5055 5.21518C21.5055 5.15787 21.5626 5.29159 21.5817 5.25338C21.6353 5.3035 21.6691 5.37132 21.6769 5.44441C21.6959 5.48261 21.6769 5.48261 21.6578 5.53992C21.6578 5.55902 21.6388 5.55902 21.6578 5.57812C21.6769 5.59722 21.6007 5.61633 21.6007 5.63543C21.6007 5.65453 21.5626 5.71184 21.5436 5.69273V5.73094H21.5055C21.4674 5.76914 21.3912 5.76914 21.3531 5.82645H21.3721V5.78824L21.334 5.84555C21.334 5.82645 21.3721 5.78825 21.3531 5.75004C21.334 5.71184 21.315 5.76914 21.2959 5.76914H21.315C21.2959 5.75004 21.2769 5.78825 21.2388 5.76914C21.2007 5.75004 21.2388 5.69273 21.2197 5.67363H21.1436C21.1562 5.6722 21.1682 5.66763 21.1786 5.66034C21.189 5.65305 21.1975 5.64326 21.2031 5.63188C21.2088 5.62049 21.2116 5.60786 21.2111 5.59514C21.2107 5.58241 21.2071 5.57 21.2007 5.55902Z"
          fill="#214063"
        />
        <path
          d="M17.0859 4.24095C17.0668 4.24095 17.0668 4.26005 17.0859 4.26005C17.1049 4.26005 17.124 4.26005 17.143 4.24095C17.124 4.22185 17.124 4.26005 17.1049 4.24095C17.0859 4.22185 17.143 4.22185 17.1811 4.20275C17.2192 4.18364 17.1811 4.26005 17.143 4.27916C17.1049 4.29826 17.0859 4.29826 17.0478 4.29826C17.0441 4.29207 17.0423 4.28496 17.0425 4.27777C17.0427 4.27057 17.0449 4.26358 17.0489 4.25759C17.0529 4.2516 17.0584 4.24686 17.065 4.24392C17.0715 4.24097 17.0788 4.23995 17.0859 4.24095Z"
          fill="#214063"
        />
        <path
          d="M17.6768 4.03072C17.6946 4.02406 17.7142 4.02428 17.7318 4.03134C17.7494 4.03841 17.7638 4.05181 17.772 4.06893C17.7789 4.07668 17.7842 4.08576 17.7874 4.09561C17.7907 4.10546 17.792 4.11588 17.7911 4.12623C17.8292 4.10713 17.8863 4.10713 17.8863 4.16444C17.8863 4.22174 17.6387 4.25995 17.5625 4.27905V4.24085H17.5244C17.528 4.19513 17.5441 4.15129 17.571 4.1142C17.5979 4.07711 17.6345 4.04822 17.6768 4.03072Z"
          fill="#214063"
        />
        <path
          d="M23.9624 3.64824H23.9434C23.9582 3.64824 23.9727 3.64478 23.986 3.63815C23.9992 3.63152 24.0107 3.62189 24.0196 3.61003H23.9815C24.0005 3.61003 24.0386 3.62913 24.0386 3.59093H24.0196C24.0957 3.61003 24.1338 3.55273 24.191 3.57183C24.2481 3.59093 24.3243 3.61003 24.3624 3.61003C24.4005 3.61003 24.4005 3.66734 24.4005 3.68644L24.3624 3.83926L24.2862 3.89656C24.307 3.90835 24.3247 3.92487 24.3379 3.94477C24.3512 3.96468 24.3595 3.98743 24.3624 4.01118C24.3815 4.10669 24.2862 4.08759 24.2672 4.14489C24.2481 4.2022 24.191 4.12579 24.1529 4.14489H24.1338C24.1719 4.08759 24.0767 4.08759 24.0386 4.06848H24.0196C24.0196 4.04938 24.0577 4.06848 24.0577 4.03028H24.0767C24.0577 4.01118 24.0386 3.99208 24.0577 3.95387H23.9053C23.9243 3.70554 24.0005 3.70554 23.9624 3.64824Z"
          fill="#214063"
        />
        <path
          d="M19.7529 5.27245H19.7339C19.772 5.23424 19.772 5.13873 19.8482 5.11963H19.9815C19.9957 5.15284 20.0029 5.18858 20.0029 5.22469C20.0029 5.2608 19.9957 5.29654 19.9815 5.32975C19.9434 5.32975 19.9053 5.38706 19.8672 5.38706H19.8482V5.34886H19.7529C19.7518 5.3234 19.7518 5.2979 19.7529 5.27245Z"
          fill="#214063"
        />
        <path d="M18.1528 4.6417L18.172 4.62256L18.1528 4.6417Z" fill="white" />
        <path
          d="M18.4768 4.2219H18.4576C18.4768 4.20275 18.4385 4.18361 18.4194 4.20275C18.4002 4.2219 18.4576 4.20275 18.4768 4.2219Z"
          fill="#214063"
        />
        <path
          d="M18.7627 4.12593H18.7437C18.7437 4.12593 18.7817 4.08773 18.7627 4.06862C18.7437 4.04952 18.9151 4.12593 18.9532 3.99222C18.9913 3.8585 19.0865 3.97311 19.1246 4.04952C19.1307 4.06191 19.1341 4.07549 19.1345 4.08932C19.1349 4.10315 19.1323 4.1169 19.1268 4.12962C19.1214 4.14234 19.1133 4.15372 19.103 4.16298C19.0928 4.17223 19.0806 4.17915 19.0675 4.18324L19.0103 4.24054H18.9532C18.9532 4.18324 18.896 4.24054 18.877 4.22144C18.8579 4.16414 18.8198 4.22144 18.7817 4.18324H18.7437L18.7627 4.12593Z"
          fill="#214063"
        />
        <path
          d="M20.9339 3.7441C20.9148 3.7441 20.972 3.7441 20.9339 3.70589C20.8958 3.66769 20.972 3.66769 20.991 3.66769C21.0481 3.68679 21.0291 3.57218 21.1243 3.62948C21.2196 3.68679 21.2005 3.66769 21.2386 3.64859C21.2619 3.6698 21.278 3.69771 21.2848 3.72849C21.2917 3.75927 21.2888 3.79141 21.2767 3.82051L21.2005 3.89691V3.93512C21.1815 3.87781 21.1624 3.99243 21.1243 3.93512H21.0481C21.0532 3.93512 21.058 3.93311 21.0616 3.92952C21.0652 3.92594 21.0672 3.92108 21.0672 3.91602H20.9529C20.9148 3.7823 20.991 3.7823 20.9339 3.7441Z"
          fill="#214063"
        />
        <path
          d="M22.229 5.38655C22.2481 5.40565 22.2481 5.36744 22.2671 5.34834C22.2861 5.32924 22.3623 5.36744 22.3623 5.40565V5.48206C22.3433 5.46296 22.3242 5.50116 22.3052 5.52026C22.2861 5.53936 22.2671 5.50116 22.2671 5.50116L22.229 5.46296C22.2384 5.45245 22.2436 5.43885 22.2436 5.42475C22.2436 5.41066 22.2384 5.39705 22.229 5.38655Z"
          fill="#214063"
        />
        <path
          d="M22.2098 7.35456C22.2288 7.35456 22.2669 7.39277 22.2288 7.45007C22.2252 7.45414 22.2208 7.45739 22.2159 7.45962C22.211 7.46185 22.2057 7.46301 22.2002 7.46301C22.1948 7.46301 22.1895 7.46185 22.1846 7.45962C22.1796 7.45739 22.1752 7.45414 22.1717 7.45007C22.1336 7.43097 22.1526 7.33546 22.2098 7.35456Z"
          fill="#214063"
        />
        <path
          d="M23.3338 4.68006C23.3338 4.66096 23.3529 4.66096 23.3529 4.62276C23.3529 4.58455 23.429 4.62276 23.4481 4.66096C23.4671 4.69917 23.4481 4.71827 23.429 4.73737H23.3719C23.3529 4.71827 23.3148 4.69917 23.3338 4.66096V4.68006Z"
          fill="#214063"
        />
        <path
          d="M23.5628 4.60372H23.5437C23.5245 4.60372 23.5054 4.58457 23.5245 4.56543L23.5628 4.60372Z"
          fill="#214063"
        />
        <path
          d="M22.5718 5.88347C22.5737 5.87797 22.5769 5.87298 22.581 5.86889C22.5851 5.8648 22.5902 5.86171 22.5957 5.85987C22.6012 5.85803 22.6071 5.85747 22.6128 5.85825C22.6186 5.85903 22.6241 5.86112 22.6289 5.86437C22.6289 5.88347 22.648 5.90257 22.6289 5.90257H22.5718C22.5667 5.90257 22.5619 5.90056 22.5583 5.89698C22.5547 5.8934 22.5527 5.88854 22.5527 5.88347C22.5527 5.8784 22.5547 5.87355 22.5583 5.86996C22.5619 5.86638 22.5667 5.86437 22.5718 5.86437V5.88347Z"
          fill="#214063"
        />
        <path
          d="M22.5909 5.90248H22.61C22.6292 5.90248 22.5718 5.94076 22.5718 5.90248C22.5718 5.86419 22.5909 5.88333 22.5909 5.90248Z"
          fill="white"
        />
        <path
          d="M23.2582 6.57116H23.2392C23.2582 6.59026 23.2773 6.57116 23.2963 6.55205V6.49475C23.3154 6.51385 23.3344 6.49475 23.3535 6.49475V6.45654C23.4296 6.49475 23.582 6.45654 23.6011 6.59026L23.563 6.72397C23.5249 6.78128 23.4677 6.76218 23.4296 6.81949V6.76218C23.3916 6.80038 23.4106 6.76218 23.3916 6.76218H23.3344C23.3344 6.74308 23.3344 6.74308 23.3535 6.74308C23.3725 6.74308 23.3154 6.72397 23.2963 6.72397C23.2773 6.72397 23.2963 6.66667 23.2773 6.60936H23.2392C23.2011 6.59026 23.2582 6.62846 23.2582 6.57116Z"
          fill="#214063"
        />
        <path
          d="M23.6763 5.34904C23.6953 5.32994 23.6953 5.32994 23.6953 5.29173H23.6763C23.6763 5.29173 23.7144 5.29173 23.7144 5.31084C23.7144 5.32994 23.7334 5.25353 23.7715 5.27263C23.8096 5.29173 23.7715 5.23443 23.7715 5.21532C23.7715 5.19622 23.7906 5.25353 23.8477 5.25353C23.9048 5.25353 23.9429 5.29173 23.981 5.25353L24.0382 5.29173C24.0382 5.31084 24.0572 5.29173 24.0572 5.29173C24.0572 5.29173 24.0953 5.38724 24.1144 5.38724C24.1334 5.38724 24.1334 5.44455 24.1525 5.46365C24.1474 5.46365 24.1426 5.46567 24.139 5.46925C24.1354 5.47283 24.1334 5.47769 24.1334 5.48276C24.1334 5.48782 24.1354 5.49268 24.139 5.49626C24.1426 5.49984 24.1474 5.50186 24.1525 5.50186C24.0953 5.52096 24.2096 5.55916 24.1334 5.57827C24.0572 5.59737 24.1525 5.61647 24.1525 5.61647H24.0953C24.1525 5.67378 24.0382 5.65467 24.0572 5.73108C24.0763 5.80749 24.0191 5.73108 24.0001 5.75019C23.981 5.71198 23.9429 5.76929 23.9048 5.76929C23.8667 5.76929 23.8477 5.69288 23.7906 5.75019C23.7334 5.80749 23.7715 5.65467 23.7144 5.69288H23.6763C23.6572 5.65467 23.7334 5.67378 23.6953 5.63557C23.6572 5.59737 23.6763 5.65467 23.6572 5.65467C23.6382 5.65467 23.7334 5.59737 23.6572 5.55916H23.6001C23.6119 5.55027 23.6215 5.53873 23.6281 5.52547C23.6347 5.51221 23.6382 5.49758 23.6382 5.48276C23.6382 5.44455 23.581 5.50186 23.6001 5.46365C23.6191 5.42545 23.6382 5.46365 23.6382 5.42545L23.6001 5.38724C23.6382 5.42545 23.6382 5.34904 23.6763 5.34904Z"
          fill="#214063"
        />
        <path
          d="M24.9718 6.68607C24.9718 6.66697 24.9718 6.66697 24.9527 6.66697C24.9337 6.66697 25.0289 6.60966 25.0289 6.57146C25.0289 6.53325 25.1051 6.47594 25.1622 6.51415C25.2194 6.55235 25.1813 6.45684 25.2194 6.49505H25.2384C25.2956 6.53325 25.3718 6.51415 25.4289 6.57146C25.4861 6.62876 25.448 6.64786 25.5051 6.64786H25.467C25.4861 6.70517 25.5432 6.72427 25.4861 6.78158V6.81978C25.4509 6.84239 25.4241 6.87594 25.4099 6.9153C25.3718 6.9344 25.3146 6.9153 25.3146 6.9535C25.3146 6.9917 25.2765 6.9917 25.2384 7.01081H25.2003V6.9726C25.1847 6.96418 25.1667 6.96147 25.1493 6.96496C25.1319 6.96845 25.1163 6.9779 25.1051 6.9917C25.1051 6.9726 25.067 7.01081 25.048 6.9917H25.0289C25.0099 6.9535 24.9718 6.9917 24.9527 6.9726C24.9337 6.9535 24.9908 6.9535 24.9718 6.9344V6.89619H24.9337L24.9718 6.85799C24.9527 6.81978 24.9146 6.87709 24.8956 6.83889C24.8765 6.80068 24.9146 6.70517 24.9718 6.68607Z"
          fill="#214063"
        />
        <path
          d="M24.9528 4.27913C24.9528 4.29823 24.9719 4.31734 24.9719 4.33644C24.9719 4.35554 24.9147 4.33644 24.8957 4.31734C24.8766 4.29823 24.9147 4.26003 24.9528 4.27913Z"
          fill="#214063"
        />
        <path
          d="M25.6953 2.94189H25.7144C25.7334 2.9801 25.6953 2.9801 25.6763 2.9801C25.6572 2.9801 25.6763 2.9801 25.6382 2.94189H25.6953Z"
          fill="#214063"
        />
        <path
          d="M25.4868 6.11279L25.544 6.1701C25.5249 6.1701 25.5249 6.2083 25.4868 6.2083H25.4678C25.4487 6.1701 25.5249 6.1892 25.4868 6.151H25.4487L25.4868 6.11279Z"
          fill="#214063"
        />
        <path
          d="M25.8867 4.90931C25.8858 4.89896 25.8871 4.88854 25.8904 4.87869C25.8936 4.86884 25.8989 4.85976 25.9058 4.852C25.9629 4.8138 26.001 4.8329 26.0582 4.8329C26.1153 4.8329 26.1534 4.92841 26.1153 4.98572C26.0772 5.04302 26.0772 5.02392 26.1153 5.04302C26.1534 5.06213 26.0391 5.04302 26.0582 5.08123C26.0772 5.11943 26.0201 5.06213 26.001 5.08123H25.9629C25.9248 5.11943 25.9248 5.06213 25.8867 5.06213H25.9058C25.9058 5.04302 25.8867 5.06213 25.8677 5.04302V4.98572H25.9058L25.8867 4.90931Z"
          fill="#214063"
        />
        <path
          d="M26.001 5.17651C26.02 5.1574 26.0772 5.17651 26.0772 5.1383C26.0772 5.1001 26.0962 5.1383 26.1153 5.1383H26.1343C26.1534 5.1192 26.1534 5.1192 26.1534 5.1001L26.1915 5.1383H26.2296V5.1574C26.3058 5.1383 26.3058 5.19561 26.3438 5.21471C26.3819 5.23381 26.3248 5.29112 26.3819 5.31022C26.4391 5.32932 26.3819 5.44394 26.3058 5.50124C26.2296 5.55855 26.2867 5.50124 26.2867 5.48214C26.2867 5.46304 26.2486 5.52035 26.2677 5.53945L26.2296 5.50124C26.1915 5.57765 26.1343 5.50124 26.0962 5.52035C26.0581 5.53945 26.0581 5.52035 26.0581 5.48214H26.02V5.44394C26.001 5.46304 26.001 5.42483 25.9629 5.46304C25.9248 5.50124 26.001 5.36753 25.9438 5.36753C25.9507 5.35978 25.956 5.3507 25.9593 5.34084C25.9625 5.33099 25.9638 5.32057 25.9629 5.31022C25.9058 5.27202 26.0391 5.23381 26.001 5.17651Z"
          fill="#214063"
        />
        <path
          d="M26.7627 5.82625C26.8008 5.80714 26.7627 5.78804 26.7437 5.76894L26.7818 5.73074C26.7627 5.71163 26.7437 5.73074 26.7437 5.71163C26.7437 5.69253 26.8008 5.74984 26.8008 5.69253H26.8389V5.65433C26.8579 5.65433 26.9151 5.65433 26.9151 5.61612V5.53971C26.9722 5.53971 26.9341 5.46331 26.9722 5.50151C27.0103 5.53971 27.0294 5.406 27.0103 5.36779C26.9913 5.32959 27.0484 5.34869 27.0675 5.32959C27.0675 5.33466 27.0695 5.33951 27.0731 5.3431C27.0766 5.34668 27.0815 5.34869 27.0865 5.34869C27.1056 5.31049 27.1246 5.36779 27.1437 5.34869C27.1627 5.32959 27.1818 5.406 27.2199 5.3869C27.2579 5.36779 27.2579 5.4442 27.2579 5.48241C27.2579 5.52061 27.2579 5.4251 27.296 5.406C27.3341 5.3869 27.2579 5.50151 27.3341 5.52061H27.3722C27.3722 5.52061 27.3722 5.57792 27.4103 5.55882V5.61612H27.4484C27.4484 5.63522 27.4294 5.65433 27.4484 5.65433C27.4675 5.65433 27.4675 5.65433 27.4675 5.65433C27.4666 5.66468 27.4678 5.6751 27.4711 5.68495C27.4744 5.6948 27.4796 5.70388 27.4865 5.71163H27.5246V5.78804C27.5818 5.78804 27.5056 5.82625 27.5627 5.84535C27.6199 5.86445 27.5627 5.92176 27.5818 5.94086C27.6008 5.95996 27.5437 5.92176 27.5437 5.95996C27.5437 5.99817 27.5818 5.97906 27.6008 5.99817H27.5437C27.5343 6.00867 27.5291 6.02228 27.5291 6.03637C27.5291 6.05047 27.5343 6.06407 27.5437 6.07458C27.5437 6.09368 27.4675 6.11278 27.5246 6.15098H27.5056C27.4865 6.18919 27.5246 6.18919 27.5246 6.20829C27.5246 6.22739 27.4675 6.13188 27.4294 6.20829V6.22739C27.3151 6.22739 27.3722 6.38021 27.2579 6.36111C27.1437 6.34201 27.2199 6.3229 27.2008 6.3229C27.1818 6.3229 27.1437 6.38021 27.0865 6.36111C27.0294 6.34201 27.0103 6.2656 26.9913 6.2847C26.9722 6.3038 26.9532 6.3229 26.9341 6.3229C26.9151 6.3229 26.9913 6.2656 26.9341 6.22739H26.896C26.9151 6.20829 26.896 6.17009 26.896 6.15098H26.8579C26.8579 6.13188 26.896 6.11278 26.8579 6.09368H26.8199C26.8199 6.07458 26.8579 6.07458 26.8389 6.05547C26.8199 6.03637 26.8199 5.99817 26.7818 6.01727C26.7437 6.03637 26.8199 5.99817 26.7818 5.95996H26.7437C26.7627 5.94086 26.8008 5.94086 26.7818 5.90266H26.7246C26.7437 5.90266 26.7627 5.90266 26.7627 5.86445H26.7056C26.7246 5.86445 26.7627 5.86445 26.7627 5.82625Z"
          fill="#214063"
        />
        <path
          d="M22.4007 3.15186C22.4388 3.17096 22.4959 3.15186 22.5149 3.20916C22.534 3.26647 22.4768 3.34288 22.4007 3.30467H22.3816L22.3435 3.24737C22.3816 3.22826 22.3054 3.19006 22.3435 3.17096C22.3816 3.15186 22.4007 3.19006 22.4007 3.15186Z"
          fill="#214063"
        />
        <path
          d="M22.7631 3.24756L22.7057 3.2667V3.24756L22.6865 3.2667V3.24756H22.7631Z"
          fill="#214063"
        />
        <path
          d="M22.877 3.19045H22.8579C22.8727 3.19045 22.8873 3.187 22.9005 3.18037C22.9137 3.17374 22.9252 3.16411 22.9341 3.15225H22.9151C22.9887 3.12438 23.07 3.12438 23.1436 3.15225C23.1817 3.19045 23.2198 3.24776 23.277 3.22865C23.3341 3.20955 23.2389 3.24776 23.2579 3.28596C23.277 3.32417 23.296 3.36237 23.3151 3.40057C23.3341 3.43878 23.2579 3.45788 23.2389 3.51519C23.2198 3.57249 23.1817 3.51519 23.1817 3.55339V3.43878C23.1436 3.45788 23.1627 3.49609 23.1436 3.51519V3.47698C23.1055 3.51519 23.0484 3.49609 23.0103 3.51519C22.9722 3.53429 22.9151 3.51519 22.877 3.53429C22.8389 3.55339 22.9532 3.45788 22.9151 3.40057H22.877C22.8389 3.36237 22.9341 3.34327 22.896 3.30506L22.8008 3.36237C22.8198 3.30506 22.896 3.28596 22.877 3.19045Z"
          fill="#214063"
        />
        <path
          d="M23.1246 3.64864H23.1055V3.61035L23.1246 3.64864Z"
          fill="#214063"
        />
        <path
          d="M19.2009 9.32178L19.1817 9.34092L19.1626 9.32178H19.2009Z"
          fill="white"
        />
        <path
          d="M14.3434 2.59803L14.4006 2.54073C14.4767 2.52162 14.4767 2.55983 14.4958 2.59803C14.4884 2.62354 14.4735 2.64625 14.4532 2.66326C14.4328 2.68027 14.4079 2.69081 14.3815 2.69354C14.3434 2.69354 14.3244 2.63624 14.3434 2.59803Z"
          fill="#214063"
        />
        <path
          d="M14.286 2.29248C14.3241 2.29248 14.3241 2.31158 14.3431 2.33068C14.3622 2.34979 14.3241 2.38799 14.286 2.40709C14.2479 2.4262 14.1908 2.33068 14.286 2.29248Z"
          fill="#214063"
        />
        <path
          d="M12.4382 14.3457C12.4574 14.3457 12.4765 14.3648 12.4574 14.4031H12.4382C12.4342 14.3995 12.4309 14.3951 12.4287 14.3902C12.4264 14.3852 12.4253 14.3799 12.4253 14.3744C12.4253 14.369 12.4264 14.3636 12.4287 14.3587C12.4309 14.3537 12.4342 14.3493 12.4382 14.3457Z"
          fill="#214063"
        />
        <path
          d="M14.0005 7.67881V7.65967H14.0196L14.0005 7.67881Z"
          fill="#214063"
        />
        <path
          d="M12.3242 14.174C12.3434 14.1549 12.3434 14.174 12.3625 14.174C12.3816 14.174 12.3625 14.2123 12.3434 14.2123C12.3242 14.2123 12.3242 14.1932 12.3242 14.174Z"
          fill="#214063"
        />
        <path
          d="M14.2862 7.39258H14.3243C14.3052 7.44988 14.2481 7.46899 14.191 7.48809C14.1338 7.50719 14.2291 7.39258 14.2862 7.39258Z"
          fill="#214063"
        />
        <path
          d="M12.7052 13.811C12.7433 13.811 12.8004 13.811 12.7814 13.8683C12.7623 13.9256 12.7433 13.9065 12.7052 13.9065C12.6944 13.893 12.6885 13.8762 12.6885 13.8588C12.6885 13.8414 12.6944 13.8246 12.7052 13.811Z"
          fill="#214063"
        />
        <path
          d="M9.67634 14.8807C9.67007 14.8362 9.67365 14.7909 9.68682 14.748C9.69999 14.705 9.72242 14.6656 9.75253 14.6323C9.79063 14.6514 9.77158 14.6896 9.77158 14.7278C9.77158 14.766 9.69539 14.8233 9.69539 14.8998C9.69539 14.9762 9.69539 14.8807 9.67634 14.8807Z"
          fill="#214063"
        />
        <path
          d="M19.067 2.55995H19.0289L19.067 2.52174C19.0099 2.46444 19.1432 2.44533 19.1242 2.40713C19.1978 2.37926 19.2791 2.37926 19.3527 2.40713C19.3908 2.46444 19.3718 2.48354 19.4099 2.54084C19.448 2.59815 19.448 2.67456 19.3337 2.67456C19.2194 2.67456 19.2385 2.67456 19.1813 2.71276C19.1242 2.75097 19.1623 2.69366 19.1242 2.67456H19.0861C19.1242 2.63636 19.067 2.61725 19.0289 2.59815C18.9908 2.57905 19.048 2.57905 19.067 2.55995Z"
          fill="#214063"
        />
        <path
          d="M9.9624 14.3459L10.0198 14.3076C10.0389 14.3268 10.0198 14.3842 10.0007 14.4225L9.9624 14.4608V14.3459Z"
          fill="#214063"
        />
        <path
          d="M9.84795 14.0591H9.88622C9.90535 14.1165 9.84795 14.1548 9.82882 14.2122C9.82474 14.1604 9.83125 14.1083 9.84795 14.0591Z"
          fill="#214063"
        />
        <path
          d="M9.86728 14.0975C9.86728 14.0784 9.88641 14.1166 9.84814 14.1358L9.86728 14.0975Z"
          fill="white"
        />
        <path
          d="M11.8292 11.0029H11.8675C11.8675 11.0412 11.8675 11.0412 11.8483 11.0604C11.8292 11.0795 11.8101 11.0412 11.8292 11.0029Z"
          fill="#214063"
        />
        <path
          d="M11.0288 10.1243C11.0288 10.1051 11.0479 10.086 11.0479 10.0668C11.0479 10.0477 11.0862 10.1051 11.0862 10.1243C11.0862 10.1434 11.0288 10.1434 11.0288 10.1243Z"
          fill="#214063"
        />
        <path
          d="M10.4961 9.83768C10.5151 9.81857 10.5532 9.76127 10.5913 9.79947C10.6294 9.83768 10.6485 9.83768 10.6294 9.89498C10.6104 9.95229 10.5913 9.93319 10.5723 9.95229C10.5532 9.97139 10.5151 9.89498 10.4961 9.83768Z"
          fill="#214063"
        />
        <path
          d="M10.9341 10.0099C10.9341 10.0048 10.9361 9.99992 10.9397 9.99633C10.9433 9.99274 10.9481 9.99072 10.9532 9.99072C10.9583 9.99072 10.9632 9.99274 10.9667 9.99633C10.9703 9.99992 10.9723 10.0048 10.9723 10.0099C10.9723 10.0482 10.9149 10.0482 10.9341 10.0099Z"
          fill="#214063"
        />
        <path
          d="M12.0581 10.1813C12.0772 10.1622 12.0772 10.1431 12.0962 10.1431C12.1152 10.1431 12.1343 10.1622 12.1533 10.2004C12.1467 10.2075 12.1383 10.2128 12.1291 10.2158C12.1198 10.2188 12.11 10.2193 12.1004 10.2174C12.0909 10.2155 12.082 10.2112 12.0746 10.2048C12.0672 10.1985 12.0615 10.1904 12.0581 10.1813Z"
          fill="#214063"
        />
        <path
          d="M11.2769 13.0278V13.0661L11.2578 13.047L11.2769 13.0278Z"
          fill="#214063"
        />
        <path
          d="M11.4289 12.7605C11.467 12.7414 11.486 12.6841 11.5051 12.7223C11.5241 12.7605 11.5051 12.8751 11.486 12.9324C11.467 12.9133 11.4479 12.9324 11.4479 12.9133C11.4479 12.8942 11.3908 12.9324 11.3908 12.9898C11.3749 12.9112 11.3884 12.8296 11.4289 12.7605Z"
          fill="#214063"
        />
        <path
          d="M11.2197 9.68467C11.2197 9.66553 11.2389 9.68467 11.258 9.66553C11.2612 9.67038 11.2633 9.67592 11.2641 9.68171C11.2649 9.6875 11.2643 9.69339 11.2625 9.69894C11.2607 9.70448 11.2576 9.70953 11.2535 9.71369C11.2494 9.71785 11.2444 9.72103 11.2389 9.72296C11.2197 9.72296 11.2197 9.70382 11.2197 9.68467Z"
          fill="#214063"
        />
        <path
          d="M12.077 9.78039C12.0961 9.76125 12.1153 9.78039 12.1344 9.79953C12.1233 9.80935 12.1165 9.82307 12.1153 9.83782C12.0961 9.85697 12.0579 9.81868 12.077 9.78039Z"
          fill="#214063"
        />
        <path
          d="M11.7339 9.58947C11.753 9.57033 11.7722 9.58947 11.7913 9.60862C11.8104 9.62776 11.7722 9.6469 11.753 9.6469C11.7339 9.6469 11.7339 9.60862 11.7339 9.58947Z"
          fill="#214063"
        />
        <path
          d="M12.0581 9.70399C12.0962 9.68489 12.0962 9.58938 12.1343 9.62759C12.1724 9.66579 12.1343 9.7231 12.0962 9.7422C12.0581 9.7613 12.0581 9.7231 12.0581 9.70399Z"
          fill="#214063"
        />
        <path
          d="M11.4868 12.149C11.4962 12.1385 11.5014 12.1249 11.5014 12.1108C11.5014 12.0967 11.4962 12.0831 11.4868 12.0726C11.4678 12.0726 11.4487 12.1108 11.4297 12.0917C11.4106 12.0726 11.5059 11.8242 11.6392 11.786C11.7725 11.7478 11.6773 11.8051 11.6963 11.8433C11.7154 11.8815 11.6773 11.9006 11.6963 11.9198C11.7154 11.9389 11.6773 12.0535 11.6201 12.0917C11.563 12.1299 11.6201 12.0917 11.6201 12.0726L11.4868 12.1872V12.149Z"
          fill="#214063"
        />
        <path
          d="M12.0957 12.0347C12.1909 12.0538 12.0957 12.1493 12.0957 12.2066L12.0195 12.2639C12.0133 12.2224 12.0171 12.18 12.0303 12.1402C12.0435 12.1003 12.0659 12.0642 12.0957 12.0347Z"
          fill="#214063"
        />
        <path
          d="M12.0772 12.1108L12.0964 12.13L12.0581 12.1491L12.0964 12.13L12.0772 12.1108Z"
          fill="white"
        />
        <path
          d="M16.0772 5.979H16.1153C16.1153 6.11272 15.9629 6.18913 15.8677 6.22733H15.7915C15.8176 6.16717 15.8568 6.11364 15.9063 6.07067C15.9557 6.02769 16.0141 5.99637 16.0772 5.979Z"
          fill="#214063"
        />
        <path
          d="M12.2673 11.8819L12.229 11.9011V11.8628L12.2673 11.8819Z"
          fill="#214063"
        />
        <path
          d="M12.4005 11.5953L12.4386 11.5571L12.4767 11.6144C12.4767 11.6908 12.4195 11.729 12.3814 11.7673H12.4005C12.3993 11.7525 12.3924 11.7388 12.3814 11.729C12.3624 11.729 12.3624 11.7482 12.3624 11.7673C12.3545 11.7376 12.3539 11.7066 12.3605 11.6766C12.3671 11.6467 12.3808 11.6188 12.4005 11.5953Z"
          fill="#214063"
        />
        <path
          d="M12.4198 11.6714H12.4007C12.4198 11.6905 12.4007 11.6714 12.4007 11.6905C12.4007 11.7097 12.3624 11.6905 12.4198 11.6714Z"
          fill="white"
        />
        <path
          d="M12.5721 11.4997C12.568 11.4656 12.5709 11.4311 12.5808 11.3982C12.5906 11.3653 12.6071 11.3348 12.6293 11.3087C12.6483 11.2896 12.6864 11.2705 12.6864 11.3087C12.697 11.3368 12.7007 11.3671 12.6974 11.3969C12.6941 11.4268 12.6838 11.4555 12.6674 11.4806C12.6293 11.4806 12.6102 11.5379 12.5912 11.557C12.5721 11.5761 12.6293 11.4806 12.5721 11.4997Z"
          fill="#214063"
        />
        <path
          d="M14.4577 11.461C14.4577 11.4559 14.4597 11.4511 14.4632 11.4475C14.4668 11.4439 14.4717 11.4419 14.4767 11.4419C14.4818 11.4419 14.4866 11.4439 14.4902 11.4475C14.4937 11.4511 14.4958 11.4559 14.4958 11.461C14.5338 11.4992 14.4958 11.5565 14.4767 11.5947C14.4577 11.6329 14.4767 11.652 14.4386 11.652C14.4256 11.5879 14.4323 11.5213 14.4577 11.461Z"
          fill="#214063"
        />
        <path
          d="M9.1817 8.40479C9.25789 8.42389 9.20075 8.5194 9.20075 8.57671C9.20075 8.63401 9.02932 8.74862 8.97218 8.84414L8.93408 8.90144C9.02932 8.76773 8.99122 8.48119 9.1817 8.40479Z"
          fill="#214063"
        />
        <path
          d="M13.9818 9.64648H14.0199C14.039 9.66559 14.0771 9.66559 14.0771 9.70379L14.039 9.7993C14.0199 9.7993 14.0199 9.7993 14.0199 9.7802L13.9818 9.8184C13.9247 9.7611 13.9628 9.70379 13.9818 9.64648Z"
          fill="#214063"
        />
        <path
          d="M14.4006 8.94012C14.3815 8.94012 14.3815 8.95922 14.3815 8.97833C14.3815 8.99743 14.3625 8.88281 14.3815 8.82551C14.4006 8.7682 14.4387 8.7682 14.4768 8.7873C14.5148 8.80641 14.5148 8.82551 14.5339 8.86371C14.5529 8.90192 14.4577 8.92102 14.4768 8.95922H14.4577L14.3815 8.99743C14.3815 8.95922 14.3815 8.94012 14.4006 8.94012Z"
          fill="#214063"
        />
        <path
          d="M10.3058 8.17578L10.2866 8.21407V8.17578H10.3058Z"
          fill="#214063"
        />
        <path
          d="M10.5146 8.23291C10.5146 8.21377 10.5338 8.2712 10.5146 8.2712L10.5912 8.23291L10.5146 8.30949V8.23291Z"
          fill="#214063"
        />
        <path
          d="M10.5342 8.21404C10.5342 8.19494 10.5532 8.17584 10.5532 8.15674C10.5532 8.13763 10.5913 8.13763 10.6104 8.15674C10.6294 8.17584 10.6104 8.17584 10.6104 8.19494C10.6104 8.21404 10.6104 8.15674 10.5913 8.13763C10.5723 8.11853 10.5532 8.17584 10.5532 8.19494C10.5532 8.21404 10.5532 8.19494 10.5723 8.19494L10.5342 8.21404Z"
          fill="#214063"
        />
        <path
          d="M13.0483 8.50074C13.1055 8.42434 13.0864 8.29062 13.2007 8.23331C13.315 8.17601 13.2579 8.30972 13.2388 8.34793C13.2198 8.38613 13.1245 8.44344 13.0674 8.50074H13.0483Z"
          fill="#214063"
        />
        <path
          d="M14.9341 8.55774C14.9722 8.51954 14.9722 8.46223 15.0293 8.48133C15.0865 8.50044 15.0484 8.51954 15.0674 8.55774L15.0103 8.61505C14.9912 8.61505 14.9912 8.59595 14.9722 8.61505L14.9341 8.55774Z"
          fill="#214063"
        />
        <path
          d="M12.1342 7.62182C12.1532 7.58361 12.1913 7.54541 12.2103 7.54541C12.2236 7.55289 12.2342 7.56416 12.241 7.57778C12.2478 7.59139 12.2504 7.60673 12.2484 7.62182C12.2103 7.66002 12.1913 7.71733 12.1532 7.73643C12.1151 7.75553 12.1342 7.66002 12.1342 7.62182Z"
          fill="#214063"
        />
        <path
          d="M15.2008 8.53868C15.2008 8.51953 15.1626 8.53868 15.1626 8.53868C15.1626 8.5336 15.1646 8.52873 15.1682 8.52514C15.1718 8.52155 15.1766 8.51953 15.1817 8.51953H15.2008C15.22 8.53868 15.2008 8.57696 15.1626 8.57696C15.1243 8.57696 15.2008 8.57696 15.2008 8.53868Z"
          fill="#214063"
        />
        <path
          d="M10.4575 6.62823C10.4617 6.60738 10.4708 6.58783 10.4841 6.57122C10.4973 6.55461 10.5143 6.54141 10.5337 6.53271C10.5718 6.55182 10.6099 6.59002 10.5909 6.62823C10.5718 6.66643 10.4575 6.72374 10.4575 6.62823Z"
          fill="#214063"
        />
        <path
          d="M11.2957 6.91507H11.2576C11.2386 6.89597 11.2767 6.87686 11.2957 6.87686C11.3066 6.8187 11.3291 6.76334 11.3618 6.7141C11.3945 6.66487 11.4368 6.62277 11.4862 6.59033C11.5045 6.59826 11.5198 6.61174 11.5301 6.62887C11.5403 6.646 11.545 6.66593 11.5433 6.68584L11.4481 6.85776L11.2767 6.99148C11.2767 6.95327 11.2957 6.93417 11.2957 6.91507Z"
          fill="#214063"
        />
        <path
          d="M12.7621 7.52643C12.7621 7.54553 12.7811 7.54553 12.8002 7.54553C12.8383 7.54553 12.8573 7.52643 12.8383 7.48823C12.8192 7.45002 12.7811 7.46913 12.743 7.48823C12.7049 7.50733 12.7811 7.33541 12.8573 7.35451C12.877 7.37583 12.8902 7.40234 12.8954 7.43092L12.8383 7.54553C12.8573 7.54553 12.8573 7.54553 12.8573 7.52643H12.8383L12.8002 7.56464C12.7951 7.56464 12.7903 7.56262 12.7867 7.55904C12.7831 7.55546 12.7811 7.5506 12.7811 7.54553H12.743C12.7508 7.54078 12.7573 7.53423 12.7621 7.52643Z"
          fill="#214063"
        />
        <path
          d="M16.3622 8.80599C16.4003 8.78689 16.4193 8.82509 16.4193 8.84419C16.4193 8.86329 16.3431 8.9015 16.3431 8.95881C16.3431 9.01611 16.3241 8.82509 16.3622 8.80599Z"
          fill="#214063"
        />
        <path
          d="M12.7812 7.44992H12.8387C12.8578 7.43078 12.8578 7.44992 12.8578 7.44992H12.8195C12.8004 7.43078 12.8195 7.41164 12.7812 7.43078H12.8004C12.8004 7.43586 12.7984 7.44073 12.7948 7.44432C12.7912 7.44791 12.7863 7.44992 12.7812 7.44992Z"
          fill="white"
        />
        <path
          d="M18.6485 5.50117H18.6104C18.6104 5.48206 18.7437 5.48206 18.6675 5.40566C18.5913 5.32925 18.858 5.34835 18.9532 5.40566H18.9342C18.9723 5.36745 19.0104 5.29104 19.0865 5.31014C19.1627 5.32925 19.1246 5.32925 19.1246 5.36745C19.1246 5.40566 18.877 5.38655 18.9151 5.57758C18.8965 5.60631 18.8711 5.63004 18.8412 5.64669C18.8114 5.66333 18.7779 5.6724 18.7437 5.67309L18.7056 5.73039C18.7437 5.69219 18.6865 5.67309 18.6865 5.65398H18.6485V5.61578H18.5913C18.6104 5.55847 18.6485 5.53937 18.6485 5.50117Z"
          fill="#214063"
        />
        <path
          d="M15.486 8.13765C15.5241 8.11855 15.5241 8.08034 15.5812 8.09944C15.6383 8.11855 15.6002 8.15675 15.6002 8.19496C15.6002 8.23316 15.5621 8.19495 15.5621 8.23316C15.5431 8.21406 15.4479 8.17585 15.486 8.13765Z"
          fill="#214063"
        />
        <path
          d="M11.9053 6.53302C11.905 6.50597 11.912 6.47933 11.9254 6.45584C11.9387 6.43234 11.9581 6.41283 11.9815 6.39931C12.0005 6.39931 12.0386 6.3802 12.0386 6.41841C12.0386 6.45661 11.9815 6.51392 11.9434 6.57123C11.9053 6.62853 11.9053 6.55212 11.9053 6.53302Z"
          fill="#214063"
        />
        <path
          d="M11.9626 6.47559L11.9243 6.53302L11.9626 6.47559Z"
          fill="white"
        />
        <path
          d="M16.0769 8.06084C16.0578 8.07995 16.0578 8.02264 16.0388 8.04174C16.0197 8.06084 16.0578 7.96533 16.0959 7.96533C16.134 7.96533 16.1149 8.00354 16.134 8.04174L16.0769 8.06084Z"
          fill="#214063"
        />
        <path
          d="M16.0768 8.04209L16.0959 8.02295V8.04209H16.0768L16.0576 8.02295L16.0768 8.04209Z"
          fill="white"
        />
        <path
          d="M16.3628 7.46905C16.3628 7.44994 16.3628 7.39264 16.4009 7.37354H16.4961C16.5533 7.43084 16.4771 7.48815 16.4771 7.52635C16.439 7.50725 16.4199 7.54546 16.4009 7.54546C16.3818 7.54546 16.3818 7.48815 16.3628 7.46905Z"
          fill="#214063"
        />
        <path
          d="M17.4102 8.2525H17.3911C17.4102 8.19519 17.3911 8.11878 17.4673 8.09968C17.5435 8.08058 17.5244 8.17609 17.5054 8.19519C17.4864 8.21429 17.4483 8.2525 17.4102 8.2716V8.2525Z"
          fill="#214063"
        />
        <path
          d="M12.2675 5.59722C12.2484 5.55902 12.3056 5.46351 12.3436 5.4253C12.358 5.40996 12.3769 5.39977 12.3976 5.39632C12.4182 5.39287 12.4394 5.39634 12.4579 5.4062C12.5151 5.4253 12.496 5.48261 12.496 5.52081C12.496 5.55902 12.4389 5.57812 12.4389 5.61633C12.4389 5.65453 12.3436 5.71184 12.3246 5.61633H12.3055C12.3018 5.6097 12.2962 5.60434 12.2894 5.60094C12.2826 5.59753 12.275 5.59624 12.2675 5.59722Z"
          fill="#214063"
        />
        <path
          d="M16.8008 7.60276H16.7627C16.8198 7.58366 16.8389 7.46905 16.9151 7.50725C16.9913 7.54546 16.9532 7.60276 16.9532 7.64097C16.9532 7.67917 16.9151 7.66007 16.9151 7.67917C16.9151 7.69828 16.896 7.67917 16.896 7.66007C16.896 7.64097 16.877 7.66007 16.8389 7.67917H16.8008C16.8198 7.62187 16.7627 7.62187 16.8008 7.60276Z"
          fill="#214063"
        />
        <path
          d="M13.4102 6.05568C13.4292 6.05568 13.4102 6.09389 13.4102 6.11299L13.353 6.17029C13.3721 6.2085 13.3911 6.15119 13.4102 6.15119L13.3721 6.11299C13.315 6.09389 13.334 6.17029 13.315 6.1894L13.2769 6.2276C13.2959 6.13209 13.334 6.03658 13.4102 6.05568Z"
          fill="#214063"
        />
        <path
          d="M14.7622 5.52051H14.7813C14.7622 5.53965 14.7813 5.53965 14.7622 5.52051Z"
          fill="#214063"
        />
        <path
          d="M16.7052 6.55225H16.7243V6.59053C16.7243 6.57139 16.7052 6.55225 16.686 6.57139L16.7052 6.55225Z"
          fill="#214063"
        />
        <path
          d="M15.3721 4.66064H15.3912C15.3883 4.66232 15.385 4.66321 15.3816 4.66321C15.3783 4.66321 15.375 4.66232 15.3721 4.66064Z"
          fill="#214063"
        />
        <path
          d="M15.4292 4.64147H15.4483V4.60326C15.4483 4.58416 15.4292 4.58416 15.4292 4.56506C15.4292 4.54596 15.3911 4.60326 15.3911 4.64147H15.3721C15.3911 4.58416 15.4292 4.56506 15.4864 4.52686H15.5245C15.5054 4.60326 15.4483 4.62237 15.3911 4.64147H15.4292Z"
          fill="#214063"
        />
        <path
          d="M17.9243 5.63525C17.9446 5.63525 17.9639 5.6433 17.9782 5.65763C17.9925 5.67196 18.0005 5.6914 18.0005 5.71166L17.9624 5.76897C17.9624 5.76897 17.9434 5.71166 17.9243 5.74987C17.9053 5.78807 17.9243 5.78807 17.9053 5.80717H17.9243C17.8862 5.78807 17.8862 5.82628 17.8482 5.82628V5.78807H17.8101C17.8482 5.73076 17.8672 5.65436 17.9243 5.63525Z"
          fill="#214063"
        />
        <path
          d="M16.4194 4.71791C16.4766 4.6606 16.4956 4.6033 16.5718 4.6224C16.648 4.6415 16.5718 4.69881 16.5718 4.73701L16.4956 4.79432H16.4194C16.4385 4.73701 16.4385 4.71791 16.4194 4.71791Z"
          fill="#214063"
        />
        <path
          d="M16.4961 4.66097L16.458 4.69917C16.4592 4.68445 16.466 4.67077 16.4771 4.66097C16.5152 4.64187 16.5152 4.68007 16.5342 4.69917C16.5532 4.71827 16.4771 4.73738 16.4771 4.75648C16.4771 4.77558 16.439 4.71827 16.4961 4.66097Z"
          fill="white"
        />
        <path
          d="M17.7912 6.01709C17.8103 6.01709 17.8103 6.03619 17.8293 6.05529C17.8484 6.0744 17.8103 6.0935 17.7722 6.1126C17.7341 6.1317 17.7912 6.1126 17.7912 6.0744H17.7531C17.7531 6.0935 17.7531 6.1126 17.7341 6.1126C17.715 6.1126 17.7531 6.01709 17.7912 6.01709Z"
          fill="#214063"
        />
        <path
          d="M16.5528 4.25977H16.5718V4.29797H16.5528V4.35528V4.31707L16.4766 4.37438C16.4766 4.33617 16.4956 4.27887 16.5528 4.25977Z"
          fill="#214063"
        />
        <path
          d="M21.2007 5.55902C21.2007 5.50171 21.1626 5.53992 21.1436 5.52081C21.1245 5.50171 21.1817 5.53992 21.2007 5.50171C21.2198 5.46351 21.1626 5.46351 21.1436 5.48261H21.1245C21.1626 5.44441 21.2197 5.48261 21.2388 5.4062C21.2578 5.32979 21.2197 5.3871 21.2197 5.368C21.2197 5.34889 21.2769 5.31069 21.334 5.29159H21.315C21.3531 5.27249 21.3912 5.29159 21.4293 5.29159C21.4674 5.29159 21.5055 5.27249 21.5055 5.21518C21.5055 5.15787 21.5626 5.29159 21.5817 5.25338C21.6353 5.3035 21.6691 5.37132 21.6769 5.44441C21.6959 5.48261 21.6769 5.48261 21.6578 5.53992C21.6578 5.55902 21.6388 5.55902 21.6578 5.57812C21.6769 5.59722 21.6007 5.61633 21.6007 5.63543C21.6007 5.65453 21.5626 5.71184 21.5436 5.69273V5.73094H21.5055C21.4674 5.76914 21.3912 5.76914 21.3531 5.82645H21.3721V5.78824L21.334 5.84555C21.334 5.82645 21.3721 5.78825 21.3531 5.75004C21.334 5.71184 21.315 5.76914 21.2959 5.76914H21.315C21.2959 5.75004 21.2769 5.78825 21.2388 5.76914C21.2007 5.75004 21.2388 5.69273 21.2197 5.67363H21.1436C21.1562 5.6722 21.1682 5.66763 21.1786 5.66034C21.189 5.65305 21.1975 5.64326 21.2031 5.63188C21.2088 5.62049 21.2116 5.60786 21.2111 5.59514C21.2107 5.58241 21.2071 5.57 21.2007 5.55902Z"
          fill="#214063"
        />
        <path
          d="M17.0859 4.24095C17.0668 4.24095 17.0668 4.26005 17.0859 4.26005C17.1049 4.26005 17.124 4.26005 17.143 4.24095C17.124 4.22185 17.124 4.26005 17.1049 4.24095C17.0859 4.22185 17.143 4.22185 17.1811 4.20275C17.2192 4.18364 17.1811 4.26005 17.143 4.27916C17.1049 4.29826 17.0859 4.29826 17.0478 4.29826C17.0441 4.29207 17.0423 4.28496 17.0425 4.27777C17.0427 4.27057 17.0449 4.26358 17.0489 4.25759C17.0529 4.2516 17.0584 4.24686 17.065 4.24392C17.0715 4.24097 17.0788 4.23995 17.0859 4.24095Z"
          fill="#214063"
        />
        <path
          d="M17.6768 4.03072C17.6946 4.02406 17.7142 4.02428 17.7318 4.03134C17.7494 4.03841 17.7638 4.05181 17.772 4.06893C17.7789 4.07668 17.7842 4.08576 17.7874 4.09561C17.7907 4.10546 17.792 4.11588 17.7911 4.12623C17.8292 4.10713 17.8863 4.10713 17.8863 4.16444C17.8863 4.22174 17.6387 4.25995 17.5625 4.27905V4.24085H17.5244C17.528 4.19513 17.5441 4.15129 17.571 4.1142C17.5979 4.07711 17.6345 4.04822 17.6768 4.03072Z"
          fill="#214063"
        />
        <path
          d="M23.9624 3.64824H23.9434C23.9582 3.64824 23.9727 3.64478 23.986 3.63815C23.9992 3.63152 24.0107 3.62189 24.0196 3.61003H23.9815C24.0005 3.61003 24.0386 3.62913 24.0386 3.59093H24.0196C24.0957 3.61003 24.1338 3.55273 24.191 3.57183C24.2481 3.59093 24.3243 3.61003 24.3624 3.61003C24.4005 3.61003 24.4005 3.66734 24.4005 3.68644L24.3624 3.83926L24.2862 3.89656C24.307 3.90835 24.3247 3.92487 24.3379 3.94477C24.3512 3.96468 24.3595 3.98743 24.3624 4.01118C24.3815 4.10669 24.2862 4.08759 24.2672 4.14489C24.2481 4.2022 24.191 4.12579 24.1529 4.14489H24.1338C24.1719 4.08759 24.0767 4.08759 24.0386 4.06848H24.0196C24.0196 4.04938 24.0577 4.06848 24.0577 4.03028H24.0767C24.0577 4.01118 24.0386 3.99208 24.0577 3.95387H23.9053C23.9243 3.70554 24.0005 3.70554 23.9624 3.64824Z"
          fill="#214063"
        />
        <path
          d="M19.7529 5.27245H19.7339C19.772 5.23424 19.772 5.13873 19.8482 5.11963H19.9815C19.9957 5.15284 20.0029 5.18858 20.0029 5.22469C20.0029 5.2608 19.9957 5.29654 19.9815 5.32975C19.9434 5.32975 19.9053 5.38706 19.8672 5.38706H19.8482V5.34886H19.7529C19.7518 5.3234 19.7518 5.2979 19.7529 5.27245Z"
          fill="#214063"
        />
        <path d="M18.1528 4.6417L18.172 4.62256L18.1528 4.6417Z" fill="white" />
        <path
          d="M18.4768 4.2219H18.4576C18.4768 4.20275 18.4385 4.18361 18.4194 4.20275C18.4002 4.2219 18.4576 4.20275 18.4768 4.2219Z"
          fill="#214063"
        />
        <path
          d="M18.7627 4.12593H18.7437C18.7437 4.12593 18.7817 4.08773 18.7627 4.06862C18.7437 4.04952 18.9151 4.12593 18.9532 3.99222C18.9913 3.8585 19.0865 3.97311 19.1246 4.04952C19.1307 4.06191 19.1341 4.07549 19.1345 4.08932C19.1349 4.10315 19.1323 4.1169 19.1268 4.12962C19.1214 4.14234 19.1133 4.15372 19.103 4.16298C19.0928 4.17223 19.0806 4.17915 19.0675 4.18324L19.0103 4.24054H18.9532C18.9532 4.18324 18.896 4.24054 18.877 4.22144C18.8579 4.16414 18.8198 4.22144 18.7817 4.18324H18.7437L18.7627 4.12593Z"
          fill="#214063"
        />
        <path
          d="M20.9339 3.7441C20.9148 3.7441 20.972 3.7441 20.9339 3.70589C20.8958 3.66769 20.972 3.66769 20.991 3.66769C21.0481 3.68679 21.0291 3.57218 21.1243 3.62948C21.2196 3.68679 21.2005 3.66769 21.2386 3.64859C21.2619 3.6698 21.278 3.69771 21.2848 3.72849C21.2917 3.75927 21.2888 3.79141 21.2767 3.82051L21.2005 3.89691V3.93512C21.1815 3.87781 21.1624 3.99243 21.1243 3.93512H21.0481C21.0532 3.93512 21.058 3.93311 21.0616 3.92952C21.0652 3.92594 21.0672 3.92108 21.0672 3.91602H20.9529C20.9148 3.7823 20.991 3.7823 20.9339 3.7441Z"
          fill="#214063"
        />
        <path
          d="M22.229 5.38655C22.2481 5.40565 22.2481 5.36744 22.2671 5.34834C22.2861 5.32924 22.3623 5.36744 22.3623 5.40565V5.48206C22.3433 5.46296 22.3242 5.50116 22.3052 5.52026C22.2861 5.53936 22.2671 5.50116 22.2671 5.50116L22.229 5.46296C22.2384 5.45245 22.2436 5.43885 22.2436 5.42475C22.2436 5.41066 22.2384 5.39705 22.229 5.38655Z"
          fill="#214063"
        />
        <path
          d="M22.2098 7.35456C22.2288 7.35456 22.2669 7.39277 22.2288 7.45007C22.2252 7.45414 22.2208 7.45739 22.2159 7.45962C22.211 7.46185 22.2057 7.46301 22.2002 7.46301C22.1948 7.46301 22.1895 7.46185 22.1846 7.45962C22.1796 7.45739 22.1752 7.45414 22.1717 7.45007C22.1336 7.43097 22.1526 7.33546 22.2098 7.35456Z"
          fill="#214063"
        />
        <path
          d="M23.3338 4.68006C23.3338 4.66096 23.3529 4.66096 23.3529 4.62276C23.3529 4.58455 23.429 4.62276 23.4481 4.66096C23.4671 4.69917 23.4481 4.71827 23.429 4.73737H23.3719C23.3529 4.71827 23.3148 4.69917 23.3338 4.66096V4.68006Z"
          fill="#214063"
        />
        <path
          d="M23.5628 4.60372H23.5437C23.5245 4.60372 23.5054 4.58457 23.5245 4.56543L23.5628 4.60372Z"
          fill="#214063"
        />
        <path
          d="M22.5718 5.88347C22.5737 5.87797 22.5769 5.87298 22.581 5.86889C22.5851 5.8648 22.5902 5.86171 22.5957 5.85987C22.6012 5.85803 22.6071 5.85747 22.6128 5.85825C22.6186 5.85903 22.6241 5.86112 22.6289 5.86437C22.6289 5.88347 22.648 5.90257 22.6289 5.90257H22.5718C22.5667 5.90257 22.5619 5.90056 22.5583 5.89698C22.5547 5.8934 22.5527 5.88854 22.5527 5.88347C22.5527 5.8784 22.5547 5.87355 22.5583 5.86996C22.5619 5.86638 22.5667 5.86437 22.5718 5.86437V5.88347Z"
          fill="#214063"
        />
        <path
          d="M22.5909 5.90248H22.61C22.6292 5.90248 22.5718 5.94076 22.5718 5.90248C22.5718 5.86419 22.5909 5.88333 22.5909 5.90248Z"
          fill="white"
        />
        <path
          d="M23.2582 6.57116H23.2392C23.2582 6.59026 23.2773 6.57116 23.2963 6.55205V6.49475C23.3154 6.51385 23.3344 6.49475 23.3535 6.49475V6.45654C23.4296 6.49475 23.582 6.45654 23.6011 6.59026L23.563 6.72397C23.5249 6.78128 23.4677 6.76218 23.4296 6.81949V6.76218C23.3916 6.80038 23.4106 6.76218 23.3916 6.76218H23.3344C23.3344 6.74308 23.3344 6.74308 23.3535 6.74308C23.3725 6.74308 23.3154 6.72397 23.2963 6.72397C23.2773 6.72397 23.2963 6.66667 23.2773 6.60936H23.2392C23.2011 6.59026 23.2582 6.62846 23.2582 6.57116Z"
          fill="#214063"
        />
        <path
          d="M23.6763 5.34904C23.6953 5.32994 23.6953 5.32994 23.6953 5.29173H23.6763C23.6763 5.29173 23.7144 5.29173 23.7144 5.31084C23.7144 5.32994 23.7334 5.25353 23.7715 5.27263C23.8096 5.29173 23.7715 5.23443 23.7715 5.21532C23.7715 5.19622 23.7906 5.25353 23.8477 5.25353C23.9048 5.25353 23.9429 5.29173 23.981 5.25353L24.0382 5.29173C24.0382 5.31084 24.0572 5.29173 24.0572 5.29173C24.0572 5.29173 24.0953 5.38724 24.1144 5.38724C24.1334 5.38724 24.1334 5.44455 24.1525 5.46365C24.1474 5.46365 24.1426 5.46567 24.139 5.46925C24.1354 5.47283 24.1334 5.47769 24.1334 5.48276C24.1334 5.48782 24.1354 5.49268 24.139 5.49626C24.1426 5.49984 24.1474 5.50186 24.1525 5.50186C24.0953 5.52096 24.2096 5.55916 24.1334 5.57827C24.0572 5.59737 24.1525 5.61647 24.1525 5.61647H24.0953C24.1525 5.67378 24.0382 5.65467 24.0572 5.73108C24.0763 5.80749 24.0191 5.73108 24.0001 5.75019C23.981 5.71198 23.9429 5.76929 23.9048 5.76929C23.8667 5.76929 23.8477 5.69288 23.7906 5.75019C23.7334 5.80749 23.7715 5.65467 23.7144 5.69288H23.6763C23.6572 5.65467 23.7334 5.67378 23.6953 5.63557C23.6572 5.59737 23.6763 5.65467 23.6572 5.65467C23.6382 5.65467 23.7334 5.59737 23.6572 5.55916H23.6001C23.6119 5.55027 23.6215 5.53873 23.6281 5.52547C23.6347 5.51221 23.6382 5.49758 23.6382 5.48276C23.6382 5.44455 23.581 5.50186 23.6001 5.46365C23.6191 5.42545 23.6382 5.46365 23.6382 5.42545L23.6001 5.38724C23.6382 5.42545 23.6382 5.34904 23.6763 5.34904Z"
          fill="#214063"
        />
        <path
          d="M24.9718 6.68607C24.9718 6.66697 24.9718 6.66697 24.9527 6.66697C24.9337 6.66697 25.0289 6.60966 25.0289 6.57146C25.0289 6.53325 25.1051 6.47594 25.1622 6.51415C25.2194 6.55235 25.1813 6.45684 25.2194 6.49505H25.2384C25.2956 6.53325 25.3718 6.51415 25.4289 6.57146C25.4861 6.62876 25.448 6.64786 25.5051 6.64786H25.467C25.4861 6.70517 25.5432 6.72427 25.4861 6.78158V6.81978C25.4509 6.84239 25.4241 6.87594 25.4099 6.9153C25.3718 6.9344 25.3146 6.9153 25.3146 6.9535C25.3146 6.9917 25.2765 6.9917 25.2384 7.01081H25.2003V6.9726C25.1847 6.96418 25.1667 6.96147 25.1493 6.96496C25.1319 6.96845 25.1163 6.9779 25.1051 6.9917C25.1051 6.9726 25.067 7.01081 25.048 6.9917H25.0289C25.0099 6.9535 24.9718 6.9917 24.9527 6.9726C24.9337 6.9535 24.9908 6.9535 24.9718 6.9344V6.89619H24.9337L24.9718 6.85799C24.9527 6.81978 24.9146 6.87709 24.8956 6.83889C24.8765 6.80068 24.9146 6.70517 24.9718 6.68607Z"
          fill="#214063"
        />
        <path
          d="M24.9528 4.27913C24.9528 4.29823 24.9719 4.31734 24.9719 4.33644C24.9719 4.35554 24.9147 4.33644 24.8957 4.31734C24.8766 4.29823 24.9147 4.26003 24.9528 4.27913Z"
          fill="#214063"
        />
        <path
          d="M25.6953 2.94189H25.7144C25.7334 2.9801 25.6953 2.9801 25.6763 2.9801C25.6572 2.9801 25.6763 2.9801 25.6382 2.94189H25.6953Z"
          fill="#214063"
        />
        <path
          d="M25.4868 6.11279L25.544 6.1701C25.5249 6.1701 25.5249 6.2083 25.4868 6.2083H25.4678C25.4487 6.1701 25.5249 6.1892 25.4868 6.151H25.4487L25.4868 6.11279Z"
          fill="#214063"
        />
        <path
          d="M25.8867 4.90931C25.8858 4.89896 25.8871 4.88854 25.8904 4.87869C25.8936 4.86884 25.8989 4.85976 25.9058 4.852C25.9629 4.8138 26.001 4.8329 26.0582 4.8329C26.1153 4.8329 26.1534 4.92841 26.1153 4.98572C26.0772 5.04302 26.0772 5.02392 26.1153 5.04302C26.1534 5.06213 26.0391 5.04302 26.0582 5.08123C26.0772 5.11943 26.0201 5.06213 26.001 5.08123H25.9629C25.9248 5.11943 25.9248 5.06213 25.8867 5.06213H25.9058C25.9058 5.04302 25.8867 5.06213 25.8677 5.04302V4.98572H25.9058L25.8867 4.90931Z"
          fill="#214063"
        />
        <path
          d="M26.001 5.17651C26.02 5.1574 26.0772 5.17651 26.0772 5.1383C26.0772 5.1001 26.0962 5.1383 26.1153 5.1383H26.1343C26.1534 5.1192 26.1534 5.1192 26.1534 5.1001L26.1915 5.1383H26.2296V5.1574C26.3058 5.1383 26.3058 5.19561 26.3438 5.21471C26.3819 5.23381 26.3248 5.29112 26.3819 5.31022C26.4391 5.32932 26.3819 5.44394 26.3058 5.50124C26.2296 5.55855 26.2867 5.50124 26.2867 5.48214C26.2867 5.46304 26.2486 5.52035 26.2677 5.53945L26.2296 5.50124C26.1915 5.57765 26.1343 5.50124 26.0962 5.52035C26.0581 5.53945 26.0581 5.52035 26.0581 5.48214H26.02V5.44394C26.001 5.46304 26.001 5.42483 25.9629 5.46304C25.9248 5.50124 26.001 5.36753 25.9438 5.36753C25.9507 5.35978 25.956 5.3507 25.9593 5.34084C25.9625 5.33099 25.9638 5.32057 25.9629 5.31022C25.9058 5.27202 26.0391 5.23381 26.001 5.17651Z"
          fill="#214063"
        />
        <path
          d="M26.7627 5.82625C26.8008 5.80714 26.7627 5.78804 26.7437 5.76894L26.7818 5.73074C26.7627 5.71163 26.7437 5.73074 26.7437 5.71163C26.7437 5.69253 26.8008 5.74984 26.8008 5.69253H26.8389V5.65433C26.8579 5.65433 26.9151 5.65433 26.9151 5.61612V5.53971C26.9722 5.53971 26.9341 5.46331 26.9722 5.50151C27.0103 5.53971 27.0294 5.406 27.0103 5.36779C26.9913 5.32959 27.0484 5.34869 27.0675 5.32959C27.0675 5.33466 27.0695 5.33951 27.0731 5.3431C27.0766 5.34668 27.0815 5.34869 27.0865 5.34869C27.1056 5.31049 27.1246 5.36779 27.1437 5.34869C27.1627 5.32959 27.1818 5.406 27.2199 5.3869C27.2579 5.36779 27.2579 5.4442 27.2579 5.48241C27.2579 5.52061 27.2579 5.4251 27.296 5.406C27.3341 5.3869 27.2579 5.50151 27.3341 5.52061H27.3722C27.3722 5.52061 27.3722 5.57792 27.4103 5.55882V5.61612H27.4484C27.4484 5.63522 27.4294 5.65433 27.4484 5.65433C27.4675 5.65433 27.4675 5.65433 27.4675 5.65433C27.4666 5.66468 27.4678 5.6751 27.4711 5.68495C27.4744 5.6948 27.4796 5.70388 27.4865 5.71163H27.5246V5.78804C27.5818 5.78804 27.5056 5.82625 27.5627 5.84535C27.6199 5.86445 27.5627 5.92176 27.5818 5.94086C27.6008 5.95996 27.5437 5.92176 27.5437 5.95996C27.5437 5.99817 27.5818 5.97906 27.6008 5.99817H27.5437C27.5343 6.00867 27.5291 6.02228 27.5291 6.03637C27.5291 6.05047 27.5343 6.06407 27.5437 6.07458C27.5437 6.09368 27.4675 6.11278 27.5246 6.15098H27.5056C27.4865 6.18919 27.5246 6.18919 27.5246 6.20829C27.5246 6.22739 27.4675 6.13188 27.4294 6.20829V6.22739C27.3151 6.22739 27.3722 6.38021 27.2579 6.36111C27.1437 6.34201 27.2199 6.3229 27.2008 6.3229C27.1818 6.3229 27.1437 6.38021 27.0865 6.36111C27.0294 6.34201 27.0103 6.2656 26.9913 6.2847C26.9722 6.3038 26.9532 6.3229 26.9341 6.3229C26.9151 6.3229 26.9913 6.2656 26.9341 6.22739H26.896C26.9151 6.20829 26.896 6.17009 26.896 6.15098H26.8579C26.8579 6.13188 26.896 6.11278 26.8579 6.09368H26.8199C26.8199 6.07458 26.8579 6.07458 26.8389 6.05547C26.8199 6.03637 26.8199 5.99817 26.7818 6.01727C26.7437 6.03637 26.8199 5.99817 26.7818 5.95996H26.7437C26.7627 5.94086 26.8008 5.94086 26.7818 5.90266H26.7246C26.7437 5.90266 26.7627 5.90266 26.7627 5.86445H26.7056C26.7246 5.86445 26.7627 5.86445 26.7627 5.82625Z"
          fill="#214063"
        />
        <path
          d="M22.4007 3.15186C22.4388 3.17096 22.4959 3.15186 22.5149 3.20916C22.534 3.26647 22.4768 3.34288 22.4007 3.30467H22.3816L22.3435 3.24737C22.3816 3.22826 22.3054 3.19006 22.3435 3.17096C22.3816 3.15186 22.4007 3.19006 22.4007 3.15186Z"
          fill="#214063"
        />
        <path
          d="M22.7631 3.24756L22.7057 3.2667V3.24756L22.6865 3.2667V3.24756H22.7631Z"
          fill="#214063"
        />
        <path
          d="M22.877 3.19045H22.8579C22.8727 3.19045 22.8873 3.187 22.9005 3.18037C22.9137 3.17374 22.9252 3.16411 22.9341 3.15225H22.9151C22.9887 3.12438 23.07 3.12438 23.1436 3.15225C23.1817 3.19045 23.2198 3.24776 23.277 3.22865C23.3341 3.20955 23.2389 3.24776 23.2579 3.28596C23.277 3.32417 23.296 3.36237 23.3151 3.40057C23.3341 3.43878 23.2579 3.45788 23.2389 3.51519C23.2198 3.57249 23.1817 3.51519 23.1817 3.55339V3.43878C23.1436 3.45788 23.1627 3.49609 23.1436 3.51519V3.47698C23.1055 3.51519 23.0484 3.49609 23.0103 3.51519C22.9722 3.53429 22.9151 3.51519 22.877 3.53429C22.8389 3.55339 22.9532 3.45788 22.9151 3.40057H22.877C22.8389 3.36237 22.9341 3.34327 22.896 3.30506L22.8008 3.36237C22.8198 3.30506 22.896 3.28596 22.877 3.19045Z"
          fill="#214063"
        />
        <path
          d="M23.1246 3.64864H23.1055V3.61035L23.1246 3.64864Z"
          fill="#214063"
        />
        <path
          d="M19.2009 9.32178L19.1817 9.34092L19.1626 9.32178H19.2009Z"
          fill="white"
        />
        <path
          d="M14.3434 2.59803L14.4006 2.54073C14.4767 2.52162 14.4767 2.55983 14.4958 2.59803C14.4884 2.62354 14.4735 2.64625 14.4532 2.66326C14.4328 2.68027 14.4079 2.69081 14.3815 2.69354C14.3434 2.69354 14.3244 2.63624 14.3434 2.59803Z"
          fill="#214063"
        />
        <path
          d="M14.286 2.29248C14.3241 2.29248 14.3241 2.31158 14.3431 2.33068C14.3622 2.34979 14.3241 2.38799 14.286 2.40709C14.2479 2.4262 14.1908 2.33068 14.286 2.29248Z"
          fill="#214063"
        />
        <path
          d="M12.4382 14.3457C12.4574 14.3457 12.4765 14.3648 12.4574 14.4031H12.4382C12.4342 14.3995 12.4309 14.3951 12.4287 14.3902C12.4264 14.3852 12.4253 14.3799 12.4253 14.3744C12.4253 14.369 12.4264 14.3636 12.4287 14.3587C12.4309 14.3537 12.4342 14.3493 12.4382 14.3457Z"
          fill="#214063"
        />
        <path
          d="M14.0005 7.67881V7.65967H14.0196L14.0005 7.67881Z"
          fill="#214063"
        />
        <path
          d="M12.3242 14.174C12.3434 14.1549 12.3434 14.174 12.3625 14.174C12.3816 14.174 12.3625 14.2123 12.3434 14.2123C12.3242 14.2123 12.3242 14.1932 12.3242 14.174Z"
          fill="#214063"
        />
        <path
          d="M14.2862 7.39258H14.3243C14.3052 7.44988 14.2481 7.46899 14.191 7.48809C14.1338 7.50719 14.2291 7.39258 14.2862 7.39258Z"
          fill="#214063"
        />
        <path
          d="M12.7052 13.811C12.7433 13.811 12.8004 13.811 12.7814 13.8683C12.7623 13.9256 12.7433 13.9065 12.7052 13.9065C12.6944 13.893 12.6885 13.8762 12.6885 13.8588C12.6885 13.8414 12.6944 13.8246 12.7052 13.811Z"
          fill="#214063"
        />
        <path
          d="M9.67634 14.8807C9.67007 14.8362 9.67365 14.7909 9.68682 14.748C9.69999 14.705 9.72242 14.6656 9.75253 14.6323C9.79063 14.6514 9.77158 14.6896 9.77158 14.7278C9.77158 14.766 9.69539 14.8233 9.69539 14.8998C9.69539 14.9762 9.69539 14.8807 9.67634 14.8807Z"
          fill="#214063"
        />
        <path
          d="M19.067 2.55995H19.0289L19.067 2.52174C19.0099 2.46444 19.1432 2.44533 19.1242 2.40713C19.1978 2.37926 19.2791 2.37926 19.3527 2.40713C19.3908 2.46444 19.3718 2.48354 19.4099 2.54084C19.448 2.59815 19.448 2.67456 19.3337 2.67456C19.2194 2.67456 19.2385 2.67456 19.1813 2.71276C19.1242 2.75097 19.1623 2.69366 19.1242 2.67456H19.0861C19.1242 2.63636 19.067 2.61725 19.0289 2.59815C18.9908 2.57905 19.048 2.57905 19.067 2.55995Z"
          fill="#214063"
        />
        <path
          d="M9.9624 14.3459L10.0198 14.3076C10.0389 14.3268 10.0198 14.3842 10.0007 14.4225L9.9624 14.4608V14.3459Z"
          fill="#214063"
        />
        <path
          d="M9.84795 14.0591H9.88622C9.90535 14.1165 9.84795 14.1548 9.82882 14.2122C9.82474 14.1604 9.83125 14.1083 9.84795 14.0591Z"
          fill="#214063"
        />
        <path
          d="M9.86728 14.0975C9.86728 14.0784 9.88641 14.1166 9.84814 14.1358L9.86728 14.0975Z"
          fill="white"
        />
        <path
          d="M11.8292 11.0029H11.8675C11.8675 11.0412 11.8675 11.0412 11.8483 11.0604C11.8292 11.0795 11.8101 11.0412 11.8292 11.0029Z"
          fill="#214063"
        />
        <path
          d="M11.0288 10.1243C11.0288 10.1051 11.0479 10.086 11.0479 10.0668C11.0479 10.0477 11.0862 10.1051 11.0862 10.1243C11.0862 10.1434 11.0288 10.1434 11.0288 10.1243Z"
          fill="#214063"
        />
        <path
          d="M10.4961 9.83768C10.5151 9.81857 10.5532 9.76127 10.5913 9.79947C10.6294 9.83768 10.6485 9.83768 10.6294 9.89498C10.6104 9.95229 10.5913 9.93319 10.5723 9.95229C10.5532 9.97139 10.5151 9.89498 10.4961 9.83768Z"
          fill="#214063"
        />
        <path
          d="M10.9341 10.0099C10.9341 10.0048 10.9361 9.99992 10.9397 9.99633C10.9433 9.99274 10.9481 9.99072 10.9532 9.99072C10.9583 9.99072 10.9632 9.99274 10.9667 9.99633C10.9703 9.99992 10.9723 10.0048 10.9723 10.0099C10.9723 10.0482 10.9149 10.0482 10.9341 10.0099Z"
          fill="#214063"
        />
        <path
          d="M12.0581 10.1813C12.0772 10.1622 12.0772 10.1431 12.0962 10.1431C12.1152 10.1431 12.1343 10.1622 12.1533 10.2004C12.1467 10.2075 12.1383 10.2128 12.1291 10.2158C12.1198 10.2188 12.11 10.2193 12.1004 10.2174C12.0909 10.2155 12.082 10.2112 12.0746 10.2048C12.0672 10.1985 12.0615 10.1904 12.0581 10.1813Z"
          fill="#214063"
        />
        <path
          d="M11.2769 13.0278V13.0661L11.2578 13.047L11.2769 13.0278Z"
          fill="#214063"
        />
        <path
          d="M11.4289 12.7605C11.467 12.7414 11.486 12.6841 11.5051 12.7223C11.5241 12.7605 11.5051 12.8751 11.486 12.9324C11.467 12.9133 11.4479 12.9324 11.4479 12.9133C11.4479 12.8942 11.3908 12.9324 11.3908 12.9898C11.3749 12.9112 11.3884 12.8296 11.4289 12.7605Z"
          fill="#214063"
        />
        <path
          d="M11.2197 9.68467C11.2197 9.66553 11.2389 9.68467 11.258 9.66553C11.2612 9.67038 11.2633 9.67592 11.2641 9.68171C11.2649 9.6875 11.2643 9.69339 11.2625 9.69894C11.2607 9.70448 11.2576 9.70953 11.2535 9.71369C11.2494 9.71785 11.2444 9.72103 11.2389 9.72296C11.2197 9.72296 11.2197 9.70382 11.2197 9.68467Z"
          fill="#214063"
        />
        <path
          d="M12.077 9.78039C12.0961 9.76125 12.1153 9.78039 12.1344 9.79953C12.1233 9.80935 12.1165 9.82307 12.1153 9.83782C12.0961 9.85697 12.0579 9.81868 12.077 9.78039Z"
          fill="#214063"
        />
        <path
          d="M11.7339 9.58947C11.753 9.57033 11.7722 9.58947 11.7913 9.60862C11.8104 9.62776 11.7722 9.6469 11.753 9.6469C11.7339 9.6469 11.7339 9.60862 11.7339 9.58947Z"
          fill="#214063"
        />
        <path
          d="M12.0581 9.70399C12.0962 9.68489 12.0962 9.58938 12.1343 9.62759C12.1724 9.66579 12.1343 9.7231 12.0962 9.7422C12.0581 9.7613 12.0581 9.7231 12.0581 9.70399Z"
          fill="#214063"
        />
        <path
          d="M11.4868 12.149C11.4962 12.1385 11.5014 12.1249 11.5014 12.1108C11.5014 12.0967 11.4962 12.0831 11.4868 12.0726C11.4678 12.0726 11.4487 12.1108 11.4297 12.0917C11.4106 12.0726 11.5059 11.8242 11.6392 11.786C11.7725 11.7478 11.6773 11.8051 11.6963 11.8433C11.7154 11.8815 11.6773 11.9006 11.6963 11.9198C11.7154 11.9389 11.6773 12.0535 11.6201 12.0917C11.563 12.1299 11.6201 12.0917 11.6201 12.0726L11.4868 12.1872V12.149Z"
          fill="#214063"
        />
        <path
          d="M12.0957 12.0347C12.1909 12.0538 12.0957 12.1493 12.0957 12.2066L12.0195 12.2639C12.0133 12.2224 12.0171 12.18 12.0303 12.1402C12.0435 12.1003 12.0659 12.0642 12.0957 12.0347Z"
          fill="#214063"
        />
        <path
          d="M12.0772 12.1108L12.0964 12.13L12.0581 12.1491L12.0964 12.13L12.0772 12.1108Z"
          fill="white"
        />
        <path
          d="M16.0772 5.979H16.1153C16.1153 6.11272 15.9629 6.18913 15.8677 6.22733H15.7915C15.8176 6.16717 15.8568 6.11364 15.9063 6.07067C15.9557 6.02769 16.0141 5.99637 16.0772 5.979Z"
          fill="#214063"
        />
        <path
          d="M12.2673 11.8819L12.229 11.9011V11.8628L12.2673 11.8819Z"
          fill="#214063"
        />
        <path
          d="M12.4005 11.5953L12.4386 11.5571L12.4767 11.6144C12.4767 11.6908 12.4195 11.729 12.3814 11.7673H12.4005C12.3993 11.7525 12.3924 11.7388 12.3814 11.729C12.3624 11.729 12.3624 11.7482 12.3624 11.7673C12.3545 11.7376 12.3539 11.7066 12.3605 11.6766C12.3671 11.6467 12.3808 11.6188 12.4005 11.5953Z"
          fill="#214063"
        />
        <path
          d="M12.4198 11.6714H12.4007C12.4198 11.6905 12.4007 11.6714 12.4007 11.6905C12.4007 11.7097 12.3624 11.6905 12.4198 11.6714Z"
          fill="white"
        />
        <path
          d="M12.5721 11.4997C12.568 11.4656 12.5709 11.4311 12.5808 11.3982C12.5906 11.3653 12.6071 11.3348 12.6293 11.3087C12.6483 11.2896 12.6864 11.2705 12.6864 11.3087C12.697 11.3368 12.7007 11.3671 12.6974 11.3969C12.6941 11.4268 12.6838 11.4555 12.6674 11.4806C12.6293 11.4806 12.6102 11.5379 12.5912 11.557C12.5721 11.5761 12.6293 11.4806 12.5721 11.4997Z"
          fill="#214063"
        />
        <path
          d="M14.4577 11.461C14.4577 11.4559 14.4597 11.4511 14.4632 11.4475C14.4668 11.4439 14.4717 11.4419 14.4767 11.4419C14.4818 11.4419 14.4866 11.4439 14.4902 11.4475C14.4937 11.4511 14.4958 11.4559 14.4958 11.461C14.5338 11.4992 14.4958 11.5565 14.4767 11.5947C14.4577 11.6329 14.4767 11.652 14.4386 11.652C14.4256 11.5879 14.4323 11.5213 14.4577 11.461Z"
          fill="#214063"
        />
        <path
          d="M9.1817 8.40479C9.25789 8.42389 9.20075 8.5194 9.20075 8.57671C9.20075 8.63401 9.02932 8.74862 8.97218 8.84414L8.93408 8.90144C9.02932 8.76773 8.99122 8.48119 9.1817 8.40479Z"
          fill="#214063"
        />
        <path
          d="M13.9818 9.64648H14.0199C14.039 9.66559 14.0771 9.66559 14.0771 9.70379L14.039 9.7993C14.0199 9.7993 14.0199 9.7993 14.0199 9.7802L13.9818 9.8184C13.9247 9.7611 13.9628 9.70379 13.9818 9.64648Z"
          fill="#214063"
        />
        <path
          d="M14.4006 8.94012C14.3815 8.94012 14.3815 8.95922 14.3815 8.97833C14.3815 8.99743 14.3625 8.88281 14.3815 8.82551C14.4006 8.7682 14.4387 8.7682 14.4768 8.7873C14.5148 8.80641 14.5148 8.82551 14.5339 8.86371C14.5529 8.90192 14.4577 8.92102 14.4768 8.95922H14.4577L14.3815 8.99743C14.3815 8.95922 14.3815 8.94012 14.4006 8.94012Z"
          fill="#214063"
        />
        <path
          d="M10.3058 8.17578L10.2866 8.21407V8.17578H10.3058Z"
          fill="#214063"
        />
        <path
          d="M10.5146 8.23291C10.5146 8.21377 10.5338 8.2712 10.5146 8.2712L10.5912 8.23291L10.5146 8.30949V8.23291Z"
          fill="#214063"
        />
        <path
          d="M10.5342 8.21404C10.5342 8.19494 10.5532 8.17584 10.5532 8.15674C10.5532 8.13763 10.5913 8.13763 10.6104 8.15674C10.6294 8.17584 10.6104 8.17584 10.6104 8.19494C10.6104 8.21404 10.6104 8.15674 10.5913 8.13763C10.5723 8.11853 10.5532 8.17584 10.5532 8.19494C10.5532 8.21404 10.5532 8.19494 10.5723 8.19494L10.5342 8.21404Z"
          fill="#214063"
        />
        <path
          d="M13.0483 8.50074C13.1055 8.42434 13.0864 8.29062 13.2007 8.23331C13.315 8.17601 13.2579 8.30972 13.2388 8.34793C13.2198 8.38613 13.1245 8.44344 13.0674 8.50074H13.0483Z"
          fill="#214063"
        />
        <path
          d="M14.9341 8.55774C14.9722 8.51954 14.9722 8.46223 15.0293 8.48133C15.0865 8.50044 15.0484 8.51954 15.0674 8.55774L15.0103 8.61505C14.9912 8.61505 14.9912 8.59595 14.9722 8.61505L14.9341 8.55774Z"
          fill="#214063"
        />
        <path
          d="M12.1342 7.62182C12.1532 7.58361 12.1913 7.54541 12.2103 7.54541C12.2236 7.55289 12.2342 7.56416 12.241 7.57778C12.2478 7.59139 12.2504 7.60673 12.2484 7.62182C12.2103 7.66002 12.1913 7.71733 12.1532 7.73643C12.1151 7.75553 12.1342 7.66002 12.1342 7.62182Z"
          fill="#214063"
        />
        <path
          d="M15.2008 8.53868C15.2008 8.51953 15.1626 8.53868 15.1626 8.53868C15.1626 8.5336 15.1646 8.52873 15.1682 8.52514C15.1718 8.52155 15.1766 8.51953 15.1817 8.51953H15.2008C15.22 8.53868 15.2008 8.57696 15.1626 8.57696C15.1243 8.57696 15.2008 8.57696 15.2008 8.53868Z"
          fill="#214063"
        />
        <path
          d="M10.4575 6.62823C10.4617 6.60738 10.4708 6.58783 10.4841 6.57122C10.4973 6.55461 10.5143 6.54141 10.5337 6.53271C10.5718 6.55182 10.6099 6.59002 10.5909 6.62823C10.5718 6.66643 10.4575 6.72374 10.4575 6.62823Z"
          fill="#214063"
        />
        <path
          d="M11.2957 6.91507H11.2576C11.2386 6.89597 11.2767 6.87686 11.2957 6.87686C11.3066 6.8187 11.3291 6.76334 11.3618 6.7141C11.3945 6.66487 11.4368 6.62277 11.4862 6.59033C11.5045 6.59826 11.5198 6.61174 11.5301 6.62887C11.5403 6.646 11.545 6.66593 11.5433 6.68584L11.4481 6.85776L11.2767 6.99148C11.2767 6.95327 11.2957 6.93417 11.2957 6.91507Z"
          fill="#214063"
        />
        <path
          d="M12.7621 7.52643C12.7621 7.54553 12.7811 7.54553 12.8002 7.54553C12.8383 7.54553 12.8573 7.52643 12.8383 7.48823C12.8192 7.45002 12.7811 7.46913 12.743 7.48823C12.7049 7.50733 12.7811 7.33541 12.8573 7.35451C12.877 7.37583 12.8902 7.40234 12.8954 7.43092L12.8383 7.54553C12.8573 7.54553 12.8573 7.54553 12.8573 7.52643H12.8383L12.8002 7.56464C12.7951 7.56464 12.7903 7.56262 12.7867 7.55904C12.7831 7.55546 12.7811 7.5506 12.7811 7.54553H12.743C12.7508 7.54078 12.7573 7.53423 12.7621 7.52643Z"
          fill="#214063"
        />
        <path
          d="M16.3622 8.80599C16.4003 8.78689 16.4193 8.82509 16.4193 8.84419C16.4193 8.86329 16.3431 8.9015 16.3431 8.95881C16.3431 9.01611 16.3241 8.82509 16.3622 8.80599Z"
          fill="#214063"
        />
        <path
          d="M12.7812 7.44992H12.8387C12.8578 7.43078 12.8578 7.44992 12.8578 7.44992H12.8195C12.8004 7.43078 12.8195 7.41164 12.7812 7.43078H12.8004C12.8004 7.43586 12.7984 7.44073 12.7948 7.44432C12.7912 7.44791 12.7863 7.44992 12.7812 7.44992Z"
          fill="white"
        />
        <path
          d="M18.6485 5.50117H18.6104C18.6104 5.48206 18.7437 5.48206 18.6675 5.40566C18.5913 5.32925 18.858 5.34835 18.9532 5.40566H18.9342C18.9723 5.36745 19.0104 5.29104 19.0865 5.31014C19.1627 5.32925 19.1246 5.32925 19.1246 5.36745C19.1246 5.40566 18.877 5.38655 18.9151 5.57758C18.8965 5.60631 18.8711 5.63004 18.8412 5.64669C18.8114 5.66333 18.7779 5.6724 18.7437 5.67309L18.7056 5.73039C18.7437 5.69219 18.6865 5.67309 18.6865 5.65398H18.6485V5.61578H18.5913C18.6104 5.55847 18.6485 5.53937 18.6485 5.50117Z"
          fill="#214063"
        />
        <path
          d="M15.486 8.13765C15.5241 8.11855 15.5241 8.08034 15.5812 8.09944C15.6383 8.11855 15.6002 8.15675 15.6002 8.19496C15.6002 8.23316 15.5621 8.19495 15.5621 8.23316C15.5431 8.21406 15.4479 8.17585 15.486 8.13765Z"
          fill="#214063"
        />
        <path
          d="M11.9053 6.53302C11.905 6.50597 11.912 6.47933 11.9254 6.45584C11.9387 6.43234 11.9581 6.41283 11.9815 6.39931C12.0005 6.39931 12.0386 6.3802 12.0386 6.41841C12.0386 6.45661 11.9815 6.51392 11.9434 6.57123C11.9053 6.62853 11.9053 6.55212 11.9053 6.53302Z"
          fill="#214063"
        />
        <path
          d="M11.9626 6.47559L11.9243 6.53302L11.9626 6.47559Z"
          fill="white"
        />
        <path
          d="M16.0769 8.06084C16.0578 8.07995 16.0578 8.02264 16.0388 8.04174C16.0197 8.06084 16.0578 7.96533 16.0959 7.96533C16.134 7.96533 16.1149 8.00354 16.134 8.04174L16.0769 8.06084Z"
          fill="#214063"
        />
        <path
          d="M16.0768 8.04209L16.0959 8.02295V8.04209H16.0768L16.0576 8.02295L16.0768 8.04209Z"
          fill="white"
        />
        <path
          d="M16.3628 7.46905C16.3628 7.44994 16.3628 7.39264 16.4009 7.37354H16.4961C16.5533 7.43084 16.4771 7.48815 16.4771 7.52635C16.439 7.50725 16.4199 7.54546 16.4009 7.54546C16.3818 7.54546 16.3818 7.48815 16.3628 7.46905Z"
          fill="#214063"
        />
        <path
          d="M17.4102 8.2525H17.3911C17.4102 8.19519 17.3911 8.11878 17.4673 8.09968C17.5435 8.08058 17.5244 8.17609 17.5054 8.19519C17.4864 8.21429 17.4483 8.2525 17.4102 8.2716V8.2525Z"
          fill="#214063"
        />
        <path
          d="M12.2675 5.59722C12.2484 5.55902 12.3056 5.46351 12.3436 5.4253C12.358 5.40996 12.3769 5.39977 12.3976 5.39632C12.4182 5.39287 12.4394 5.39634 12.4579 5.4062C12.5151 5.4253 12.496 5.48261 12.496 5.52081C12.496 5.55902 12.4389 5.57812 12.4389 5.61633C12.4389 5.65453 12.3436 5.71184 12.3246 5.61633H12.3055C12.3018 5.6097 12.2962 5.60434 12.2894 5.60094C12.2826 5.59753 12.275 5.59624 12.2675 5.59722Z"
          fill="#214063"
        />
        <path
          d="M16.8008 7.60276H16.7627C16.8198 7.58366 16.8389 7.46905 16.9151 7.50725C16.9913 7.54546 16.9532 7.60276 16.9532 7.64097C16.9532 7.67917 16.9151 7.66007 16.9151 7.67917C16.9151 7.69828 16.896 7.67917 16.896 7.66007C16.896 7.64097 16.877 7.66007 16.8389 7.67917H16.8008C16.8198 7.62187 16.7627 7.62187 16.8008 7.60276Z"
          fill="#214063"
        />
        <path
          d="M13.4102 6.05568C13.4292 6.05568 13.4102 6.09389 13.4102 6.11299L13.353 6.17029C13.3721 6.2085 13.3911 6.15119 13.4102 6.15119L13.3721 6.11299C13.315 6.09389 13.334 6.17029 13.315 6.1894L13.2769 6.2276C13.2959 6.13209 13.334 6.03658 13.4102 6.05568Z"
          fill="#214063"
        />
        <path
          d="M14.7622 5.52051H14.7813C14.7622 5.53965 14.7813 5.53965 14.7622 5.52051Z"
          fill="#214063"
        />
        <path
          d="M16.7052 6.55225H16.7243V6.59053C16.7243 6.57139 16.7052 6.55225 16.686 6.57139L16.7052 6.55225Z"
          fill="#214063"
        />
        <path
          d="M15.3721 4.66064H15.3912C15.3883 4.66232 15.385 4.66321 15.3816 4.66321C15.3783 4.66321 15.375 4.66232 15.3721 4.66064Z"
          fill="#214063"
        />
        <path
          d="M15.4292 4.64147H15.4483V4.60326C15.4483 4.58416 15.4292 4.58416 15.4292 4.56506C15.4292 4.54596 15.3911 4.60326 15.3911 4.64147H15.3721C15.3911 4.58416 15.4292 4.56506 15.4864 4.52686H15.5245C15.5054 4.60326 15.4483 4.62237 15.3911 4.64147H15.4292Z"
          fill="#214063"
        />
        <path
          d="M17.9243 5.63525C17.9446 5.63525 17.9639 5.6433 17.9782 5.65763C17.9925 5.67196 18.0005 5.6914 18.0005 5.71166L17.9624 5.76897C17.9624 5.76897 17.9434 5.71166 17.9243 5.74987C17.9053 5.78807 17.9243 5.78807 17.9053 5.80717H17.9243C17.8862 5.78807 17.8862 5.82628 17.8482 5.82628V5.78807H17.8101C17.8482 5.73076 17.8672 5.65436 17.9243 5.63525Z"
          fill="#214063"
        />
        <path
          d="M16.4194 4.71791C16.4766 4.6606 16.4956 4.6033 16.5718 4.6224C16.648 4.6415 16.5718 4.69881 16.5718 4.73701L16.4956 4.79432H16.4194C16.4385 4.73701 16.4385 4.71791 16.4194 4.71791Z"
          fill="#214063"
        />
        <path
          d="M16.4961 4.66097L16.458 4.69917C16.4592 4.68445 16.466 4.67077 16.4771 4.66097C16.5152 4.64187 16.5152 4.68007 16.5342 4.69917C16.5532 4.71827 16.4771 4.73738 16.4771 4.75648C16.4771 4.77558 16.439 4.71827 16.4961 4.66097Z"
          fill="white"
        />
        <path
          d="M17.7912 6.01709C17.8103 6.01709 17.8103 6.03619 17.8293 6.05529C17.8484 6.0744 17.8103 6.0935 17.7722 6.1126C17.7341 6.1317 17.7912 6.1126 17.7912 6.0744H17.7531C17.7531 6.0935 17.7531 6.1126 17.7341 6.1126C17.715 6.1126 17.7531 6.01709 17.7912 6.01709Z"
          fill="#214063"
        />
        <path
          d="M16.5528 4.25977H16.5718V4.29797H16.5528V4.35528V4.31707L16.4766 4.37438C16.4766 4.33617 16.4956 4.27887 16.5528 4.25977Z"
          fill="#214063"
        />
        <path
          d="M21.2007 5.55902C21.2007 5.50171 21.1626 5.53992 21.1436 5.52081C21.1245 5.50171 21.1817 5.53992 21.2007 5.50171C21.2198 5.46351 21.1626 5.46351 21.1436 5.48261H21.1245C21.1626 5.44441 21.2197 5.48261 21.2388 5.4062C21.2578 5.32979 21.2197 5.3871 21.2197 5.368C21.2197 5.34889 21.2769 5.31069 21.334 5.29159H21.315C21.3531 5.27249 21.3912 5.29159 21.4293 5.29159C21.4674 5.29159 21.5055 5.27249 21.5055 5.21518C21.5055 5.15787 21.5626 5.29159 21.5817 5.25338C21.6353 5.3035 21.6691 5.37132 21.6769 5.44441C21.6959 5.48261 21.6769 5.48261 21.6578 5.53992C21.6578 5.55902 21.6388 5.55902 21.6578 5.57812C21.6769 5.59722 21.6007 5.61633 21.6007 5.63543C21.6007 5.65453 21.5626 5.71184 21.5436 5.69273V5.73094H21.5055C21.4674 5.76914 21.3912 5.76914 21.3531 5.82645H21.3721V5.78824L21.334 5.84555C21.334 5.82645 21.3721 5.78825 21.3531 5.75004C21.334 5.71184 21.315 5.76914 21.2959 5.76914H21.315C21.2959 5.75004 21.2769 5.78825 21.2388 5.76914C21.2007 5.75004 21.2388 5.69273 21.2197 5.67363H21.1436C21.1562 5.6722 21.1682 5.66763 21.1786 5.66034C21.189 5.65305 21.1975 5.64326 21.2031 5.63188C21.2088 5.62049 21.2116 5.60786 21.2111 5.59514C21.2107 5.58241 21.2071 5.57 21.2007 5.55902Z"
          fill="#214063"
        />
        <path
          d="M17.0859 4.24095C17.0668 4.24095 17.0668 4.26005 17.0859 4.26005C17.1049 4.26005 17.124 4.26005 17.143 4.24095C17.124 4.22185 17.124 4.26005 17.1049 4.24095C17.0859 4.22185 17.143 4.22185 17.1811 4.20275C17.2192 4.18364 17.1811 4.26005 17.143 4.27916C17.1049 4.29826 17.0859 4.29826 17.0478 4.29826C17.0441 4.29207 17.0423 4.28496 17.0425 4.27777C17.0427 4.27057 17.0449 4.26358 17.0489 4.25759C17.0529 4.2516 17.0584 4.24686 17.065 4.24392C17.0715 4.24097 17.0788 4.23995 17.0859 4.24095Z"
          fill="#214063"
        />
        <path
          d="M17.6768 4.03072C17.6946 4.02406 17.7142 4.02428 17.7318 4.03134C17.7494 4.03841 17.7638 4.05181 17.772 4.06893C17.7789 4.07668 17.7842 4.08576 17.7874 4.09561C17.7907 4.10546 17.792 4.11588 17.7911 4.12623C17.8292 4.10713 17.8863 4.10713 17.8863 4.16444C17.8863 4.22174 17.6387 4.25995 17.5625 4.27905V4.24085H17.5244C17.528 4.19513 17.5441 4.15129 17.571 4.1142C17.5979 4.07711 17.6345 4.04822 17.6768 4.03072Z"
          fill="#214063"
        />
        <path
          d="M23.9624 3.64824H23.9434C23.9582 3.64824 23.9727 3.64478 23.986 3.63815C23.9992 3.63152 24.0107 3.62189 24.0196 3.61003H23.9815C24.0005 3.61003 24.0386 3.62913 24.0386 3.59093H24.0196C24.0957 3.61003 24.1338 3.55273 24.191 3.57183C24.2481 3.59093 24.3243 3.61003 24.3624 3.61003C24.4005 3.61003 24.4005 3.66734 24.4005 3.68644L24.3624 3.83926L24.2862 3.89656C24.307 3.90835 24.3247 3.92487 24.3379 3.94477C24.3512 3.96468 24.3595 3.98743 24.3624 4.01118C24.3815 4.10669 24.2862 4.08759 24.2672 4.14489C24.2481 4.2022 24.191 4.12579 24.1529 4.14489H24.1338C24.1719 4.08759 24.0767 4.08759 24.0386 4.06848H24.0196C24.0196 4.04938 24.0577 4.06848 24.0577 4.03028H24.0767C24.0577 4.01118 24.0386 3.99208 24.0577 3.95387H23.9053C23.9243 3.70554 24.0005 3.70554 23.9624 3.64824Z"
          fill="#214063"
        />
        <path
          d="M19.7529 5.27245H19.7339C19.772 5.23424 19.772 5.13873 19.8482 5.11963H19.9815C19.9957 5.15284 20.0029 5.18858 20.0029 5.22469C20.0029 5.2608 19.9957 5.29654 19.9815 5.32975C19.9434 5.32975 19.9053 5.38706 19.8672 5.38706H19.8482V5.34886H19.7529C19.7518 5.3234 19.7518 5.2979 19.7529 5.27245Z"
          fill="#214063"
        />
        <path d="M18.1528 4.6417L18.172 4.62256L18.1528 4.6417Z" fill="white" />
        <path
          d="M18.4768 4.2219H18.4576C18.4768 4.20275 18.4385 4.18361 18.4194 4.20275C18.4002 4.2219 18.4576 4.20275 18.4768 4.2219Z"
          fill="#214063"
        />
        <path
          d="M18.7627 4.12593H18.7437C18.7437 4.12593 18.7817 4.08773 18.7627 4.06862C18.7437 4.04952 18.9151 4.12593 18.9532 3.99222C18.9913 3.8585 19.0865 3.97311 19.1246 4.04952C19.1307 4.06191 19.1341 4.07549 19.1345 4.08932C19.1349 4.10315 19.1323 4.1169 19.1268 4.12962C19.1214 4.14234 19.1133 4.15372 19.103 4.16298C19.0928 4.17223 19.0806 4.17915 19.0675 4.18324L19.0103 4.24054H18.9532C18.9532 4.18324 18.896 4.24054 18.877 4.22144C18.8579 4.16414 18.8198 4.22144 18.7817 4.18324H18.7437L18.7627 4.12593Z"
          fill="#214063"
        />
        <path
          d="M20.9339 3.7441C20.9148 3.7441 20.972 3.7441 20.9339 3.70589C20.8958 3.66769 20.972 3.66769 20.991 3.66769C21.0481 3.68679 21.0291 3.57218 21.1243 3.62948C21.2196 3.68679 21.2005 3.66769 21.2386 3.64859C21.2619 3.6698 21.278 3.69771 21.2848 3.72849C21.2917 3.75927 21.2888 3.79141 21.2767 3.82051L21.2005 3.89691V3.93512C21.1815 3.87781 21.1624 3.99243 21.1243 3.93512H21.0481C21.0532 3.93512 21.058 3.93311 21.0616 3.92952C21.0652 3.92594 21.0672 3.92108 21.0672 3.91602H20.9529C20.9148 3.7823 20.991 3.7823 20.9339 3.7441Z"
          fill="#214063"
        />
        <path
          d="M22.229 5.38655C22.2481 5.40565 22.2481 5.36744 22.2671 5.34834C22.2861 5.32924 22.3623 5.36744 22.3623 5.40565V5.48206C22.3433 5.46296 22.3242 5.50116 22.3052 5.52026C22.2861 5.53936 22.2671 5.50116 22.2671 5.50116L22.229 5.46296C22.2384 5.45245 22.2436 5.43885 22.2436 5.42475C22.2436 5.41066 22.2384 5.39705 22.229 5.38655Z"
          fill="#214063"
        />
        <path
          d="M22.2098 7.35456C22.2288 7.35456 22.2669 7.39277 22.2288 7.45007C22.2252 7.45414 22.2208 7.45739 22.2159 7.45962C22.211 7.46185 22.2057 7.46301 22.2002 7.46301C22.1948 7.46301 22.1895 7.46185 22.1846 7.45962C22.1796 7.45739 22.1752 7.45414 22.1717 7.45007C22.1336 7.43097 22.1526 7.33546 22.2098 7.35456Z"
          fill="#214063"
        />
        <path
          d="M23.3338 4.68006C23.3338 4.66096 23.3529 4.66096 23.3529 4.62276C23.3529 4.58455 23.429 4.62276 23.4481 4.66096C23.4671 4.69917 23.4481 4.71827 23.429 4.73737H23.3719C23.3529 4.71827 23.3148 4.69917 23.3338 4.66096V4.68006Z"
          fill="#214063"
        />
        <path
          d="M23.5628 4.60372H23.5437C23.5245 4.60372 23.5054 4.58457 23.5245 4.56543L23.5628 4.60372Z"
          fill="#214063"
        />
        <path
          d="M22.5718 5.88347C22.5737 5.87797 22.5769 5.87298 22.581 5.86889C22.5851 5.8648 22.5902 5.86171 22.5957 5.85987C22.6012 5.85803 22.6071 5.85747 22.6128 5.85825C22.6186 5.85903 22.6241 5.86112 22.6289 5.86437C22.6289 5.88347 22.648 5.90257 22.6289 5.90257H22.5718C22.5667 5.90257 22.5619 5.90056 22.5583 5.89698C22.5547 5.8934 22.5527 5.88854 22.5527 5.88347C22.5527 5.8784 22.5547 5.87355 22.5583 5.86996C22.5619 5.86638 22.5667 5.86437 22.5718 5.86437V5.88347Z"
          fill="#214063"
        />
        <path
          d="M22.5909 5.90248H22.61C22.6292 5.90248 22.5718 5.94076 22.5718 5.90248C22.5718 5.86419 22.5909 5.88333 22.5909 5.90248Z"
          fill="white"
        />
        <path
          d="M23.2582 6.57116H23.2392C23.2582 6.59026 23.2773 6.57116 23.2963 6.55205V6.49475C23.3154 6.51385 23.3344 6.49475 23.3535 6.49475V6.45654C23.4296 6.49475 23.582 6.45654 23.6011 6.59026L23.563 6.72397C23.5249 6.78128 23.4677 6.76218 23.4296 6.81949V6.76218C23.3916 6.80038 23.4106 6.76218 23.3916 6.76218H23.3344C23.3344 6.74308 23.3344 6.74308 23.3535 6.74308C23.3725 6.74308 23.3154 6.72397 23.2963 6.72397C23.2773 6.72397 23.2963 6.66667 23.2773 6.60936H23.2392C23.2011 6.59026 23.2582 6.62846 23.2582 6.57116Z"
          fill="#214063"
        />
        <path
          d="M23.6763 5.34904C23.6953 5.32994 23.6953 5.32994 23.6953 5.29173H23.6763C23.6763 5.29173 23.7144 5.29173 23.7144 5.31084C23.7144 5.32994 23.7334 5.25353 23.7715 5.27263C23.8096 5.29173 23.7715 5.23443 23.7715 5.21532C23.7715 5.19622 23.7906 5.25353 23.8477 5.25353C23.9048 5.25353 23.9429 5.29173 23.981 5.25353L24.0382 5.29173C24.0382 5.31084 24.0572 5.29173 24.0572 5.29173C24.0572 5.29173 24.0953 5.38724 24.1144 5.38724C24.1334 5.38724 24.1334 5.44455 24.1525 5.46365C24.1474 5.46365 24.1426 5.46567 24.139 5.46925C24.1354 5.47283 24.1334 5.47769 24.1334 5.48276C24.1334 5.48782 24.1354 5.49268 24.139 5.49626C24.1426 5.49984 24.1474 5.50186 24.1525 5.50186C24.0953 5.52096 24.2096 5.55916 24.1334 5.57827C24.0572 5.59737 24.1525 5.61647 24.1525 5.61647H24.0953C24.1525 5.67378 24.0382 5.65467 24.0572 5.73108C24.0763 5.80749 24.0191 5.73108 24.0001 5.75019C23.981 5.71198 23.9429 5.76929 23.9048 5.76929C23.8667 5.76929 23.8477 5.69288 23.7906 5.75019C23.7334 5.80749 23.7715 5.65467 23.7144 5.69288H23.6763C23.6572 5.65467 23.7334 5.67378 23.6953 5.63557C23.6572 5.59737 23.6763 5.65467 23.6572 5.65467C23.6382 5.65467 23.7334 5.59737 23.6572 5.55916H23.6001C23.6119 5.55027 23.6215 5.53873 23.6281 5.52547C23.6347 5.51221 23.6382 5.49758 23.6382 5.48276C23.6382 5.44455 23.581 5.50186 23.6001 5.46365C23.6191 5.42545 23.6382 5.46365 23.6382 5.42545L23.6001 5.38724C23.6382 5.42545 23.6382 5.34904 23.6763 5.34904Z"
          fill="#214063"
        />
        <path
          d="M24.9718 6.68607C24.9718 6.66697 24.9718 6.66697 24.9527 6.66697C24.9337 6.66697 25.0289 6.60966 25.0289 6.57146C25.0289 6.53325 25.1051 6.47594 25.1622 6.51415C25.2194 6.55235 25.1813 6.45684 25.2194 6.49505H25.2384C25.2956 6.53325 25.3718 6.51415 25.4289 6.57146C25.4861 6.62876 25.448 6.64786 25.5051 6.64786H25.467C25.4861 6.70517 25.5432 6.72427 25.4861 6.78158V6.81978C25.4509 6.84239 25.4241 6.87594 25.4099 6.9153C25.3718 6.9344 25.3146 6.9153 25.3146 6.9535C25.3146 6.9917 25.2765 6.9917 25.2384 7.01081H25.2003V6.9726C25.1847 6.96418 25.1667 6.96147 25.1493 6.96496C25.1319 6.96845 25.1163 6.9779 25.1051 6.9917C25.1051 6.9726 25.067 7.01081 25.048 6.9917H25.0289C25.0099 6.9535 24.9718 6.9917 24.9527 6.9726C24.9337 6.9535 24.9908 6.9535 24.9718 6.9344V6.89619H24.9337L24.9718 6.85799C24.9527 6.81978 24.9146 6.87709 24.8956 6.83889C24.8765 6.80068 24.9146 6.70517 24.9718 6.68607Z"
          fill="#214063"
        />
        <path
          d="M24.9528 4.27913C24.9528 4.29823 24.9719 4.31734 24.9719 4.33644C24.9719 4.35554 24.9147 4.33644 24.8957 4.31734C24.8766 4.29823 24.9147 4.26003 24.9528 4.27913Z"
          fill="#214063"
        />
        <path
          d="M25.6953 2.94189H25.7144C25.7334 2.9801 25.6953 2.9801 25.6763 2.9801C25.6572 2.9801 25.6763 2.9801 25.6382 2.94189H25.6953Z"
          fill="#214063"
        />
        <path
          d="M25.4868 6.11279L25.544 6.1701C25.5249 6.1701 25.5249 6.2083 25.4868 6.2083H25.4678C25.4487 6.1701 25.5249 6.1892 25.4868 6.151H25.4487L25.4868 6.11279Z"
          fill="#214063"
        />
        <path
          d="M25.8867 4.90931C25.8858 4.89896 25.8871 4.88854 25.8904 4.87869C25.8936 4.86884 25.8989 4.85976 25.9058 4.852C25.9629 4.8138 26.001 4.8329 26.0582 4.8329C26.1153 4.8329 26.1534 4.92841 26.1153 4.98572C26.0772 5.04302 26.0772 5.02392 26.1153 5.04302C26.1534 5.06213 26.0391 5.04302 26.0582 5.08123C26.0772 5.11943 26.0201 5.06213 26.001 5.08123H25.9629C25.9248 5.11943 25.9248 5.06213 25.8867 5.06213H25.9058C25.9058 5.04302 25.8867 5.06213 25.8677 5.04302V4.98572H25.9058L25.8867 4.90931Z"
          fill="#214063"
        />
        <path
          d="M26.001 5.17651C26.02 5.1574 26.0772 5.17651 26.0772 5.1383C26.0772 5.1001 26.0962 5.1383 26.1153 5.1383H26.1343C26.1534 5.1192 26.1534 5.1192 26.1534 5.1001L26.1915 5.1383H26.2296V5.1574C26.3058 5.1383 26.3058 5.19561 26.3438 5.21471C26.3819 5.23381 26.3248 5.29112 26.3819 5.31022C26.4391 5.32932 26.3819 5.44394 26.3058 5.50124C26.2296 5.55855 26.2867 5.50124 26.2867 5.48214C26.2867 5.46304 26.2486 5.52035 26.2677 5.53945L26.2296 5.50124C26.1915 5.57765 26.1343 5.50124 26.0962 5.52035C26.0581 5.53945 26.0581 5.52035 26.0581 5.48214H26.02V5.44394C26.001 5.46304 26.001 5.42483 25.9629 5.46304C25.9248 5.50124 26.001 5.36753 25.9438 5.36753C25.9507 5.35978 25.956 5.3507 25.9593 5.34084C25.9625 5.33099 25.9638 5.32057 25.9629 5.31022C25.9058 5.27202 26.0391 5.23381 26.001 5.17651Z"
          fill="#214063"
        />
        <path
          d="M26.7627 5.82625C26.8008 5.80714 26.7627 5.78804 26.7437 5.76894L26.7818 5.73074C26.7627 5.71163 26.7437 5.73074 26.7437 5.71163C26.7437 5.69253 26.8008 5.74984 26.8008 5.69253H26.8389V5.65433C26.8579 5.65433 26.9151 5.65433 26.9151 5.61612V5.53971C26.9722 5.53971 26.9341 5.46331 26.9722 5.50151C27.0103 5.53971 27.0294 5.406 27.0103 5.36779C26.9913 5.32959 27.0484 5.34869 27.0675 5.32959C27.0675 5.33466 27.0695 5.33951 27.0731 5.3431C27.0766 5.34668 27.0815 5.34869 27.0865 5.34869C27.1056 5.31049 27.1246 5.36779 27.1437 5.34869C27.1627 5.32959 27.1818 5.406 27.2199 5.3869C27.2579 5.36779 27.2579 5.4442 27.2579 5.48241C27.2579 5.52061 27.2579 5.4251 27.296 5.406C27.3341 5.3869 27.2579 5.50151 27.3341 5.52061H27.3722C27.3722 5.52061 27.3722 5.57792 27.4103 5.55882V5.61612H27.4484C27.4484 5.63522 27.4294 5.65433 27.4484 5.65433C27.4675 5.65433 27.4675 5.65433 27.4675 5.65433C27.4666 5.66468 27.4678 5.6751 27.4711 5.68495C27.4744 5.6948 27.4796 5.70388 27.4865 5.71163H27.5246V5.78804C27.5818 5.78804 27.5056 5.82625 27.5627 5.84535C27.6199 5.86445 27.5627 5.92176 27.5818 5.94086C27.6008 5.95996 27.5437 5.92176 27.5437 5.95996C27.5437 5.99817 27.5818 5.97906 27.6008 5.99817H27.5437C27.5343 6.00867 27.5291 6.02228 27.5291 6.03637C27.5291 6.05047 27.5343 6.06407 27.5437 6.07458C27.5437 6.09368 27.4675 6.11278 27.5246 6.15098H27.5056C27.4865 6.18919 27.5246 6.18919 27.5246 6.20829C27.5246 6.22739 27.4675 6.13188 27.4294 6.20829V6.22739C27.3151 6.22739 27.3722 6.38021 27.2579 6.36111C27.1437 6.34201 27.2199 6.3229 27.2008 6.3229C27.1818 6.3229 27.1437 6.38021 27.0865 6.36111C27.0294 6.34201 27.0103 6.2656 26.9913 6.2847C26.9722 6.3038 26.9532 6.3229 26.9341 6.3229C26.9151 6.3229 26.9913 6.2656 26.9341 6.22739H26.896C26.9151 6.20829 26.896 6.17009 26.896 6.15098H26.8579C26.8579 6.13188 26.896 6.11278 26.8579 6.09368H26.8199C26.8199 6.07458 26.8579 6.07458 26.8389 6.05547C26.8199 6.03637 26.8199 5.99817 26.7818 6.01727C26.7437 6.03637 26.8199 5.99817 26.7818 5.95996H26.7437C26.7627 5.94086 26.8008 5.94086 26.7818 5.90266H26.7246C26.7437 5.90266 26.7627 5.90266 26.7627 5.86445H26.7056C26.7246 5.86445 26.7627 5.86445 26.7627 5.82625Z"
          fill="#214063"
        />
        <path
          d="M22.4007 3.15186C22.4388 3.17096 22.4959 3.15186 22.5149 3.20916C22.534 3.26647 22.4768 3.34288 22.4007 3.30467H22.3816L22.3435 3.24737C22.3816 3.22826 22.3054 3.19006 22.3435 3.17096C22.3816 3.15186 22.4007 3.19006 22.4007 3.15186Z"
          fill="#214063"
        />
        <path
          d="M22.7631 3.24756L22.7057 3.2667V3.24756L22.6865 3.2667V3.24756H22.7631Z"
          fill="#214063"
        />
        <path
          d="M22.877 3.19045H22.8579C22.8727 3.19045 22.8873 3.187 22.9005 3.18037C22.9137 3.17374 22.9252 3.16411 22.9341 3.15225H22.9151C22.9887 3.12438 23.07 3.12438 23.1436 3.15225C23.1817 3.19045 23.2198 3.24776 23.277 3.22865C23.3341 3.20955 23.2389 3.24776 23.2579 3.28596C23.277 3.32417 23.296 3.36237 23.3151 3.40057C23.3341 3.43878 23.2579 3.45788 23.2389 3.51519C23.2198 3.57249 23.1817 3.51519 23.1817 3.55339V3.43878C23.1436 3.45788 23.1627 3.49609 23.1436 3.51519V3.47698C23.1055 3.51519 23.0484 3.49609 23.0103 3.51519C22.9722 3.53429 22.9151 3.51519 22.877 3.53429C22.8389 3.55339 22.9532 3.45788 22.9151 3.40057H22.877C22.8389 3.36237 22.9341 3.34327 22.896 3.30506L22.8008 3.36237C22.8198 3.30506 22.896 3.28596 22.877 3.19045Z"
          fill="#214063"
        />
        <path
          d="M23.1246 3.64864H23.1055V3.61035L23.1246 3.64864Z"
          fill="#214063"
        />
        <path
          d="M9.39111 36.4468L9.41025 36.4659V36.4468H9.39111Z"
          fill="white"
        />
        <path
          d="M8.26738 39.1023H8.24825C8.22912 39.0831 8.24825 39.0831 8.24825 39.064H8.28652C8.28652 39.0831 8.28652 39.1023 8.26738 39.1023Z"
          fill="#241F20"
        />
        <path
          d="M8.21016 39.1788C8.19103 39.1788 8.21016 39.1597 8.21016 39.1597H8.2293C8.24843 39.1788 8.2293 39.198 8.21016 39.1788Z"
          fill="#241F20"
        />
        <path
          d="M11.8291 38.6247C11.8291 38.6056 11.8291 38.5864 11.8482 38.6056H11.8291V38.6247Z"
          fill="#241F20"
        />
        <path
          d="M12.1345 39.6943H12.0962C12.1153 39.7135 12.1153 39.7326 12.1345 39.7326V39.6943Z"
          fill="#241F20"
        />
        <path
          d="M7.39162 38.0515C7.39162 38.0897 7.35353 38.0706 7.35353 38.0897L7.29639 38.0515V37.9942C7.31543 37.9942 7.31543 37.956 7.35353 37.9751C7.39162 37.9942 7.37258 37.9751 7.39162 37.9751C7.41067 37.9751 7.39162 37.9942 7.39162 37.9942H7.41067C7.39163 37.9942 7.39163 38.0133 7.41067 38.0133L7.39162 38.0515Z"
          fill="#241F20"
        />
        <path
          d="M11.9624 39.5796H12.0007C11.9815 39.5987 11.9624 39.5987 11.9624 39.5796Z"
          fill="#241F20"
        />
        <path
          d="M10.877 38.9304C10.8579 38.9304 10.8579 38.9304 10.8579 38.9112C10.8579 38.8921 10.877 38.9113 10.877 38.9304Z"
          fill="#241F20"
        />
        <path
          d="M10.5913 39.236C10.6104 39.2169 10.6104 39.236 10.5913 39.236V39.236Z"
          fill="#241F20"
        />
        <path
          d="M10.5152 39.427C10.5152 39.4078 10.4961 39.4078 10.4961 39.3887H10.5535C10.5535 39.4078 10.5344 39.4078 10.5152 39.427Z"
          fill="#241F20"
        />
        <path
          d="M10.5913 38.8733C10.6104 38.8733 10.6296 38.8541 10.5913 38.8733V38.8733Z"
          fill="#241F20"
        />
        <path
          d="M11.4484 39.0642C11.4484 39.0451 11.4294 39.0451 11.4484 39.026C11.4675 39.0069 11.4865 39.026 11.5056 39.0451C11.5246 39.0451 11.5056 39.0833 11.5246 39.0833L11.4484 39.0642Z"
          fill="#241F20"
        />
        <path
          d="M10.439 38.8922C10.439 38.8922 10.4008 38.8922 10.4199 38.873H10.439V38.8922Z"
          fill="#241F20"
        />
        <path
          d="M11.2578 39.0447H11.2388C11.2007 39.0256 11.1436 39.0065 11.1245 38.9683H11.2197L11.2578 39.0065V39.0447Z"
          fill="#241F20"
        />
        <path
          d="M11.2197 38.8351C11.2197 38.7968 11.258 38.8159 11.2771 38.8351H11.2197Z"
          fill="#241F20"
        />
        <path
          d="M11.2388 38.8351V38.8159L11.2579 38.8351H11.2388Z"
          fill="white"
        />
        <path
          d="M8.87695 37.9368C8.91505 37.9177 8.95314 37.9559 8.99124 37.9751H9.01029C8.97219 37.9942 8.896 37.9751 8.87695 37.9368Z"
          fill="#241F20"
        />
        <path
          d="M11.0674 38.7202H11.1248C11.1056 38.7394 11.1248 38.7394 11.1248 38.7394L11.0674 38.7202Z"
          fill="#241F20"
        />
        <path
          d="M11.0864 38.7202H11.1056C11.0864 38.7202 11.1056 38.7394 11.0864 38.7202Z"
          fill="white"
        />
        <path
          d="M11.0294 38.6631H10.9723C10.9532 38.6631 10.9532 38.644 10.9723 38.644H11.0294C11.0294 38.6631 11.0485 38.6631 11.0485 38.6822L11.0294 38.6631Z"
          fill="#241F20"
        />
        <path
          d="M10.1147 39.9423C10.1147 39.9041 10.1528 39.9232 10.1719 39.9232C10.1909 39.9232 10.21 39.9805 10.2481 39.9805H10.2671C10.229 39.9805 10.1338 39.9996 10.1147 39.9423Z"
          fill="#241F20"
        />
        <path
          d="M10.0774 38.1276H10.02V38.0894H10.0774V38.1276Z"
          fill="#241F20"
        />
        <path
          d="M10.0386 39.5031C10.0386 39.5031 10.0577 39.484 10.0577 39.5031H10.0386Z"
          fill="#241F20"
        />
        <path
          d="M10.0392 39.5036H10.02V39.4653C10.02 39.4704 10.022 39.4753 10.0256 39.4789C10.0292 39.4825 10.0341 39.4845 10.0392 39.4845V39.5036Z"
          fill="#241F20"
        />
        <path
          d="M10.0196 38.6246C9.98146 38.6055 9.94336 38.6246 9.92432 38.5864H9.96241L10.0196 38.6437V38.6246Z"
          fill="#241F20"
        />
        <path
          d="M9.88641 37.9752C9.86728 37.9752 9.84814 37.9752 9.84814 37.9561H9.90554C9.88641 37.9752 9.90554 37.9752 9.88641 37.9752Z"
          fill="#241F20"
        />
        <path
          d="M9.60068 39.6565H9.58154C9.58154 39.6373 9.58154 39.6182 9.60068 39.6373C9.60236 39.6402 9.60324 39.6435 9.60324 39.6469C9.60324 39.6503 9.60236 39.6536 9.60068 39.6565Z"
          fill="#241F20"
        />
        <path
          d="M9.6387 39.3502H9.61965C9.6046 39.3522 9.58931 39.3496 9.57573 39.3428C9.56216 39.336 9.55092 39.3253 9.54346 39.312H9.61965L9.65774 39.3502H9.6387Z"
          fill="#241F20"
        />
        <path
          d="M9.73398 38.7964H9.71484C9.71992 38.7964 9.72478 38.7984 9.72837 38.802C9.73196 38.8056 9.73398 38.8105 9.73398 38.8155C9.73398 38.8206 9.73196 38.8255 9.72837 38.8291C9.72478 38.8327 9.71992 38.8347 9.71484 38.8347H9.73398V38.7964Z"
          fill="#241F20"
        />
        <path
          d="M9.81026 37.4786C9.79113 37.4595 9.81026 37.4595 9.81026 37.4595V37.4786Z"
          fill="#241F20"
        />
        <path
          d="M8.11479 37.3258H8.13384C8.13384 37.3449 8.09575 37.3067 8.09575 37.3449C8.05651 37.3306 8.02304 37.3037 8.00051 37.2685H7.92432C7.98146 37.2303 8.01955 37.3258 8.05765 37.2685C8.09575 37.2112 8.11479 37.2685 8.13384 37.2876H8.17194C8.13384 37.2685 8.15289 37.3067 8.15289 37.3067H8.11479V37.3258Z"
          fill="#241F20"
        />
        <path
          d="M9.67627 37.8415V37.8032H9.71454C9.71454 37.8032 9.6954 37.8415 9.67627 37.8415Z"
          fill="#241F20"
        />
        <path
          d="M9.5625 37.6504C9.58163 37.6504 9.5625 37.6504 9.5625 37.6695V37.6504Z"
          fill="#241F20"
        />
        <path
          d="M9.56259 37.6505H9.54346L9.56259 37.6313V37.6505Z"
          fill="white"
        />
        <path
          d="M9.3153 37.6313H9.27704L9.23877 37.593C9.2579 37.5738 9.29617 37.593 9.3153 37.593V37.6313Z"
          fill="#241F20"
        />
        <path
          d="M9.22 39.1784H9.1626V39.1401H9.20086C9.18173 39.1593 9.22 39.1401 9.20086 39.1593L9.22 39.1784Z"
          fill="#241F20"
        />
        <path
          d="M9.27713 37.4597C9.25799 37.4405 9.21973 37.4597 9.21973 37.4214H9.27713V37.4597Z"
          fill="#241F20"
        />
        <path
          d="M9.25732 38.7584H9.27646C9.29559 38.7393 9.27646 38.7393 9.27646 38.7393H9.29559C9.27646 38.7967 9.25732 38.7967 9.25732 38.7584Z"
          fill="#241F20"
        />
        <path
          d="M8.61007 38.3956C8.59093 38.3956 8.61007 38.3956 8.61007 38.3765V38.3956Z"
          fill="#241F20"
        />
        <path
          d="M8.38135 37.4787V37.4404H8.45788C8.41961 37.4787 8.40048 37.4979 8.38135 37.4787Z"
          fill="#241F20"
        />
        <path
          d="M8.45828 38.0899H8.40088C8.40088 38.0708 8.42001 38.0708 8.43915 38.0708H8.45828V38.0899Z"
          fill="#241F20"
        />
        <path
          d="M8.41943 38.0705H8.43857C8.43857 38.0514 8.4577 38.0705 8.4577 38.0705H8.41943Z"
          fill="white"
        />
        <path
          d="M7.12457 36.7717C7.10552 36.7908 7.14362 36.7908 7.14362 36.7908H7.08647C7.08647 36.8099 7.10552 36.8099 7.08647 36.8099H6.93409C6.92226 36.801 6.91266 36.7894 6.90605 36.7762C6.89944 36.7629 6.896 36.7483 6.896 36.7335H6.91504C6.91504 36.7335 6.93409 36.7144 6.91504 36.7144H7.10552C7.08647 36.7144 7.06742 36.7144 7.08647 36.7335H7.12457C7.10552 36.7526 7.12457 36.7526 7.12457 36.7717Z"
          fill="#241F20"
        />
        <path
          d="M8.19099 38.0323H8.17186C8.15273 38.0132 8.19099 38.0132 8.19099 38.0132V38.0323Z"
          fill="#241F20"
        />
        <path
          d="M8.01961 37.918C8.00057 37.918 7.98152 37.8989 8.00057 37.8798C8.01961 37.8607 8.07676 37.918 8.0958 37.9371H8.01961V37.918Z"
          fill="#241F20"
        />
        <path
          d="M5.96244 37.249H5.88625C5.8672 37.2681 5.84815 37.2299 5.82911 37.2299H5.81006V37.1726H5.84815L5.81006 37.1344C5.81006 37.1243 5.81407 37.1145 5.82122 37.1074C5.82836 37.1002 5.83805 37.0962 5.84815 37.0962H5.9053C5.88625 37.1153 5.92434 37.1153 5.92434 37.1153H5.94339L5.96244 37.249Z"
          fill="#241F20"
        />
        <path
          d="M7.69583 37.1155H7.61964L7.58154 37.0773C7.58154 37.0391 7.60059 37.0391 7.61964 37.02H7.71488C7.70225 37.0175 7.68913 37.0201 7.67842 37.0272C7.6677 37.0344 7.66026 37.0455 7.65773 37.0582C7.65521 37.0709 7.6578 37.084 7.66495 37.0948C7.67209 37.1055 7.6832 37.113 7.69583 37.1155Z"
          fill="#241F20"
        />
        <path
          d="M7.77201 37.6506H7.75296C7.71486 37.6697 7.71486 37.5933 7.67677 37.6315C7.63867 37.6697 7.63867 37.6124 7.63867 37.5742C7.63867 37.536 7.67677 37.5551 7.69582 37.5551H7.73391C7.71486 37.5742 7.75296 37.5742 7.75296 37.5933H7.77201V37.6506Z"
          fill="#241F20"
        />
        <path
          d="M7.01007 37.4021C7.02911 37.4021 7.01007 37.4021 7.01007 37.4212H6.99102C6.97197 37.4212 6.97197 37.4594 6.93388 37.4212C6.89578 37.383 6.91483 37.4021 6.89578 37.4021C6.89491 37.3918 6.89614 37.3813 6.89942 37.3715C6.90269 37.3616 6.90794 37.3526 6.91483 37.3448H7.02911C7.02154 37.3423 7.01327 37.3429 7.00612 37.3464C6.99898 37.35 6.99354 37.3563 6.99102 37.3639C6.98849 37.3715 6.98908 37.3798 6.99265 37.387C6.99622 37.3941 7.00249 37.3996 7.01007 37.4021Z"
          fill="#241F20"
        />
        <path
          d="M6.66726 36.7145H6.64813C6.629 36.7145 6.60986 36.7145 6.60986 36.6953H6.66726V36.7145Z"
          fill="#241F20"
        />
        <path
          d="M6.7629 36.0456C6.74376 36.0456 6.72463 36.0265 6.74377 36.0073H6.78203C6.80116 36.0265 6.78203 36.0648 6.7629 36.0456Z"
          fill="#241F20"
        />
        <path
          d="M6.21063 36.9055H6.17236V36.8672H6.21063C6.21063 36.8672 6.22976 36.8863 6.21063 36.8863V36.9055Z"
          fill="#241F20"
        />
        <path
          d="M6.28617 36.2558H6.24807C6.22902 36.2367 6.17188 36.2558 6.15283 36.1985V36.1603L6.20997 36.1221H6.28617C6.26712 36.1412 6.28617 36.1603 6.28617 36.1794H6.30521C6.30521 36.2558 6.28617 36.2367 6.28617 36.2558Z"
          fill="#241F20"
        />
        <path
          d="M6.09556 36.6759H6.07651C6.05747 36.6759 6.07651 36.695 6.07651 36.695H6.03842C6.01937 36.7332 6.00032 36.6759 5.98128 36.695C5.96223 36.7141 5.96223 36.695 5.98128 36.6759H5.96223C5.94318 36.6759 5.96223 36.6376 5.94318 36.6376C5.94318 36.6326 5.94117 36.6277 5.9376 36.6241C5.93403 36.6206 5.92918 36.6185 5.92413 36.6185C5.92413 36.6185 5.94318 36.6185 5.92413 36.5994C5.90508 36.5803 5.90509 36.5803 5.94318 36.5803H5.96223C5.94318 36.5612 5.98128 36.5803 5.98128 36.5421C6.00032 36.5612 6.01937 36.523 6.01937 36.5421C6.01937 36.5612 6.03842 36.5612 6.07651 36.5421C6.11461 36.523 6.07651 36.5803 6.09556 36.5612H6.11461C6.11461 36.5612 6.09556 36.5803 6.11461 36.5803H6.13366C6.1286 36.5803 6.12376 36.5824 6.12019 36.5859C6.11662 36.5895 6.11461 36.5944 6.11461 36.5994H6.13366L6.09556 36.6759Z"
          fill="#241F20"
        />
        <path
          d="M5.65792 36.1794V36.2176C5.63887 36.2176 5.63887 36.2558 5.61982 36.2367C5.60077 36.2176 5.60077 36.2558 5.60077 36.2367C5.59572 36.2367 5.59088 36.2388 5.58731 36.2423C5.58373 36.2459 5.58173 36.2508 5.58173 36.2558L5.52458 36.2176H5.50554C5.50554 36.1985 5.48649 36.1794 5.50554 36.1794V36.103H5.65792C5.65792 36.103 5.63887 36.1221 5.65792 36.1221C5.65792 36.1221 5.67696 36.103 5.67696 36.1221L5.65792 36.1794Z"
          fill="#241F20"
        />
        <path
          d="M5.63887 37.0201C5.63887 37.0201 5.61974 37.001 5.63887 37.001V37.0201Z"
          fill="#241F20"
        />
        <path
          d="M5.35303 37.4785H5.37216C5.39129 37.4977 5.37216 37.4977 5.37216 37.4977L5.35303 37.4785Z"
          fill="#241F20"
        />
        <path
          d="M5.46786 36.3703H5.44873C5.46786 36.3703 5.46786 36.3512 5.46786 36.3703H5.487C5.487 36.3703 5.46786 36.3703 5.487 36.3895H5.46786V36.3703Z"
          fill="#241F20"
        />
        <path
          d="M5.315 36.7908H5.25786C5.25096 36.7831 5.24572 36.774 5.24245 36.7641C5.23917 36.7543 5.23793 36.7439 5.23881 36.7335C5.23881 36.7335 5.25786 36.7335 5.23881 36.7144C5.21976 36.6953 5.2769 36.7144 5.25786 36.6953C5.25786 36.7004 5.25986 36.7052 5.26343 36.7088C5.26701 36.7124 5.27185 36.7144 5.2769 36.7144H5.29595C5.315 36.6953 5.315 36.7144 5.315 36.7144V36.7908Z"
          fill="#241F20"
        />
        <path
          d="M5.27696 36.6956H5.16267C5.16267 36.6765 5.18172 36.6574 5.16267 36.6574C5.14363 36.6574 5.16267 36.6192 5.18172 36.6001H5.29601C5.29601 36.6192 5.27696 36.6383 5.29601 36.6383C5.31506 36.6574 5.27696 36.6765 5.27696 36.6956Z"
          fill="#241F20"
        />
        <path
          d="M5.04857 36.4468C5.02952 36.4659 5.04857 36.4659 5.04857 36.4659H4.97237V36.5041H4.87714C4.87714 36.485 4.89618 36.4659 4.87714 36.4659H4.81999C4.83904 36.4659 4.83904 36.4468 4.81999 36.4468V36.4086C4.80095 36.4086 4.81999 36.4086 4.80095 36.3895C4.7819 36.3704 4.80095 36.3704 4.80095 36.3704H4.81999C4.81999 36.3704 4.85809 36.3704 4.83904 36.3513C4.85809 36.3322 4.83904 36.3322 4.83904 36.3322H4.87714C4.91523 36.3322 4.89618 36.2749 4.93428 36.2749H4.99142C4.97237 36.294 5.01047 36.3131 5.01047 36.294H5.02952C5.02952 36.3131 5.01047 36.3322 5.02952 36.3322H5.04857C5.02952 36.3322 5.02952 36.3513 5.04857 36.3513C5.04857 36.3513 5.02952 36.3704 5.04857 36.3704H5.06761C5.08666 36.3704 5.06761 36.3895 5.06761 36.3895L5.04857 36.4468Z"
          fill="#241F20"
        />
        <path
          d="M6.47674 37.4786H6.43848C6.45761 37.4594 6.45761 37.4211 6.47674 37.4403H6.51501C6.49588 37.4403 6.51501 37.4594 6.49588 37.4786H6.47674Z"
          fill="#241F20"
        />
        <path
          d="M6.36279 37.4214H6.38193H6.40106L6.38193 37.4405L6.36279 37.4214Z"
          fill="#241F20"
        />
        <path
          d="M6.32425 37.4404H6.3052C6.28616 37.4595 6.24806 37.4404 6.22901 37.4404L6.19092 37.4022C6.19092 37.383 6.20997 37.4022 6.19092 37.383V37.3066H6.32425C6.32425 37.3257 6.3052 37.3257 6.32425 37.3448C6.3433 37.3639 6.3052 37.3639 6.32425 37.383H6.3433C6.3433 37.4022 6.32425 37.4022 6.32425 37.4404Z"
          fill="#241F20"
        />
        <path
          d="M9.39111 36.4468L9.41025 36.4659V36.4468H9.39111Z"
          fill="white"
        />
        <path
          d="M8.26738 39.1023H8.24825C8.22912 39.0831 8.24825 39.0831 8.24825 39.064H8.28652C8.28652 39.0831 8.28652 39.1023 8.26738 39.1023Z"
          fill="#214063"
        />
        <path
          d="M8.21016 39.1788C8.19103 39.1788 8.21016 39.1597 8.21016 39.1597H8.2293C8.24843 39.1788 8.2293 39.198 8.21016 39.1788Z"
          fill="#214063"
        />
        <path
          d="M11.8291 38.6247C11.8291 38.6056 11.8291 38.5864 11.8482 38.6056H11.8291V38.6247Z"
          fill="#214063"
        />
        <path
          d="M12.1345 39.6943H12.0962C12.1153 39.7135 12.1153 39.7326 12.1345 39.7326V39.6943Z"
          fill="#214063"
        />
        <path
          d="M7.39162 38.0515C7.39162 38.0897 7.35353 38.0706 7.35353 38.0897L7.29639 38.0515V37.9942C7.31543 37.9942 7.31543 37.956 7.35353 37.9751C7.39162 37.9942 7.37258 37.9751 7.39162 37.9751C7.41067 37.9751 7.39162 37.9942 7.39162 37.9942H7.41067C7.39163 37.9942 7.39163 38.0133 7.41067 38.0133L7.39162 38.0515Z"
          fill="#214063"
        />
        <path
          d="M11.9624 39.5796H12.0007C11.9815 39.5987 11.9624 39.5987 11.9624 39.5796Z"
          fill="#214063"
        />
        <path
          d="M10.877 38.9304C10.8579 38.9304 10.8579 38.9304 10.8579 38.9112C10.8579 38.8921 10.877 38.9113 10.877 38.9304Z"
          fill="#214063"
        />
        <path
          d="M10.5913 39.236C10.6104 39.2169 10.6104 39.236 10.5913 39.236V39.236Z"
          fill="#214063"
        />
        <path
          d="M10.5152 39.427C10.5152 39.4078 10.4961 39.4078 10.4961 39.3887H10.5535C10.5535 39.4078 10.5344 39.4078 10.5152 39.427Z"
          fill="#214063"
        />
        <path
          d="M10.5913 38.8733C10.6104 38.8733 10.6296 38.8541 10.5913 38.8733V38.8733Z"
          fill="#214063"
        />
        <path
          d="M11.4484 39.0642C11.4484 39.0451 11.4294 39.0451 11.4484 39.026C11.4675 39.0069 11.4865 39.026 11.5056 39.0451C11.5246 39.0451 11.5056 39.0833 11.5246 39.0833L11.4484 39.0642Z"
          fill="#214063"
        />
        <path
          d="M10.439 38.8922C10.439 38.8922 10.4008 38.8922 10.4199 38.873H10.439V38.8922Z"
          fill="#214063"
        />
        <path
          d="M11.2578 39.0447H11.2388C11.2007 39.0256 11.1436 39.0065 11.1245 38.9683H11.2197L11.2578 39.0065V39.0447Z"
          fill="#214063"
        />
        <path
          d="M11.2197 38.8351C11.2197 38.7968 11.258 38.8159 11.2771 38.8351H11.2197Z"
          fill="#214063"
        />
        <path
          d="M11.2388 38.8351V38.8159L11.2579 38.8351H11.2388Z"
          fill="white"
        />
        <path
          d="M8.87695 37.9368C8.91505 37.9177 8.95314 37.9559 8.99124 37.9751H9.01029C8.97219 37.9942 8.896 37.9751 8.87695 37.9368Z"
          fill="#214063"
        />
        <path
          d="M11.0674 38.7202H11.1248C11.1056 38.7394 11.1248 38.7394 11.1248 38.7394L11.0674 38.7202Z"
          fill="#214063"
        />
        <path
          d="M11.0864 38.7202H11.1056C11.0864 38.7202 11.1056 38.7394 11.0864 38.7202Z"
          fill="white"
        />
        <path
          d="M11.0294 38.6631H10.9723C10.9532 38.6631 10.9532 38.644 10.9723 38.644H11.0294C11.0294 38.6631 11.0485 38.6631 11.0485 38.6822L11.0294 38.6631Z"
          fill="#214063"
        />
        <path
          d="M10.1147 39.9423C10.1147 39.9041 10.1528 39.9232 10.1719 39.9232C10.1909 39.9232 10.21 39.9805 10.2481 39.9805H10.2671C10.229 39.9805 10.1338 39.9996 10.1147 39.9423Z"
          fill="#214063"
        />
        <path
          d="M10.0774 38.1276H10.02V38.0894H10.0774V38.1276Z"
          fill="#214063"
        />
        <path
          d="M10.0386 39.5031C10.0386 39.5031 10.0577 39.484 10.0577 39.5031H10.0386Z"
          fill="#214063"
        />
        <path
          d="M10.0392 39.5036H10.02V39.4653C10.02 39.4704 10.022 39.4753 10.0256 39.4789C10.0292 39.4825 10.0341 39.4845 10.0392 39.4845V39.5036Z"
          fill="#214063"
        />
        <path
          d="M10.0196 38.6246C9.98146 38.6055 9.94336 38.6246 9.92432 38.5864H9.96241L10.0196 38.6437V38.6246Z"
          fill="#214063"
        />
        <path
          d="M9.88641 37.9752C9.86728 37.9752 9.84814 37.9752 9.84814 37.9561H9.90554C9.88641 37.9752 9.90554 37.9752 9.88641 37.9752Z"
          fill="#214063"
        />
        <path
          d="M9.60068 39.6565H9.58154C9.58154 39.6373 9.58154 39.6182 9.60068 39.6373C9.60236 39.6402 9.60324 39.6435 9.60324 39.6469C9.60324 39.6503 9.60236 39.6536 9.60068 39.6565Z"
          fill="#214063"
        />
        <path
          d="M9.6387 39.3502H9.61965C9.6046 39.3522 9.58931 39.3496 9.57573 39.3428C9.56216 39.336 9.55092 39.3253 9.54346 39.312H9.61965L9.65774 39.3502H9.6387Z"
          fill="#214063"
        />
        <path
          d="M9.73398 38.7964H9.71484C9.71992 38.7964 9.72478 38.7984 9.72837 38.802C9.73196 38.8056 9.73398 38.8105 9.73398 38.8155C9.73398 38.8206 9.73196 38.8255 9.72837 38.8291C9.72478 38.8327 9.71992 38.8347 9.71484 38.8347H9.73398V38.7964Z"
          fill="#214063"
        />
        <path
          d="M9.81026 37.4786C9.79113 37.4595 9.81026 37.4595 9.81026 37.4595V37.4786Z"
          fill="#214063"
        />
        <path
          d="M8.11479 37.3258H8.13384C8.13384 37.3449 8.09575 37.3067 8.09575 37.3449C8.05651 37.3306 8.02304 37.3037 8.00051 37.2685H7.92432C7.98146 37.2303 8.01955 37.3258 8.05765 37.2685C8.09575 37.2112 8.11479 37.2685 8.13384 37.2876H8.17194C8.13384 37.2685 8.15289 37.3067 8.15289 37.3067H8.11479V37.3258Z"
          fill="#214063"
        />
        <path
          d="M9.67627 37.8415V37.8032H9.71454C9.71454 37.8032 9.6954 37.8415 9.67627 37.8415Z"
          fill="#214063"
        />
        <path
          d="M9.5625 37.6504C9.58163 37.6504 9.5625 37.6504 9.5625 37.6695V37.6504Z"
          fill="#214063"
        />
        <path
          d="M9.56259 37.6505H9.54346L9.56259 37.6313V37.6505Z"
          fill="white"
        />
        <path
          d="M9.3153 37.6313H9.27704L9.23877 37.593C9.2579 37.5738 9.29617 37.593 9.3153 37.593V37.6313Z"
          fill="#214063"
        />
        <path
          d="M9.22 39.1784H9.1626V39.1401H9.20086C9.18173 39.1593 9.22 39.1401 9.20086 39.1593L9.22 39.1784Z"
          fill="#214063"
        />
        <path
          d="M9.27713 37.4597C9.25799 37.4405 9.21973 37.4597 9.21973 37.4214H9.27713V37.4597Z"
          fill="#214063"
        />
        <path
          d="M9.25732 38.7584H9.27646C9.29559 38.7393 9.27646 38.7393 9.27646 38.7393H9.29559C9.27646 38.7967 9.25732 38.7967 9.25732 38.7584Z"
          fill="#214063"
        />
        <path
          d="M8.61007 38.3956C8.59093 38.3956 8.61007 38.3956 8.61007 38.3765V38.3956Z"
          fill="#214063"
        />
        <path
          d="M8.38135 37.4787V37.4404H8.45788C8.41961 37.4787 8.40048 37.4979 8.38135 37.4787Z"
          fill="#214063"
        />
        <path
          d="M8.45828 38.0899H8.40088C8.40088 38.0708 8.42001 38.0708 8.43915 38.0708H8.45828V38.0899Z"
          fill="#214063"
        />
        <path
          d="M8.41943 38.0705H8.43857C8.43857 38.0514 8.4577 38.0705 8.4577 38.0705H8.41943Z"
          fill="white"
        />
        <path
          d="M7.12457 36.7717C7.10552 36.7908 7.14362 36.7908 7.14362 36.7908H7.08647C7.08647 36.8099 7.10552 36.8099 7.08647 36.8099H6.93409C6.92226 36.801 6.91266 36.7894 6.90605 36.7762C6.89944 36.7629 6.896 36.7483 6.896 36.7335H6.91504C6.91504 36.7335 6.93409 36.7144 6.91504 36.7144H7.10552C7.08647 36.7144 7.06742 36.7144 7.08647 36.7335H7.12457C7.10552 36.7526 7.12457 36.7526 7.12457 36.7717Z"
          fill="#214063"
        />
        <path
          d="M8.19099 38.0323H8.17186C8.15273 38.0132 8.19099 38.0132 8.19099 38.0132V38.0323Z"
          fill="#214063"
        />
        <path
          d="M8.01961 37.918C8.00057 37.918 7.98152 37.8989 8.00057 37.8798C8.01961 37.8607 8.07676 37.918 8.0958 37.9371H8.01961V37.918Z"
          fill="#214063"
        />
        <path
          d="M5.96244 37.249H5.88625C5.8672 37.2681 5.84815 37.2299 5.82911 37.2299H5.81006V37.1726H5.84815L5.81006 37.1344C5.81006 37.1243 5.81407 37.1145 5.82122 37.1074C5.82836 37.1002 5.83805 37.0962 5.84815 37.0962H5.9053C5.88625 37.1153 5.92434 37.1153 5.92434 37.1153H5.94339L5.96244 37.249Z"
          fill="#214063"
        />
        <path
          d="M7.69583 37.1155H7.61964L7.58154 37.0773C7.58154 37.0391 7.60059 37.0391 7.61964 37.02H7.71488C7.70225 37.0175 7.68913 37.0201 7.67842 37.0272C7.6677 37.0344 7.66026 37.0455 7.65773 37.0582C7.65521 37.0709 7.6578 37.084 7.66495 37.0948C7.67209 37.1055 7.6832 37.113 7.69583 37.1155Z"
          fill="#214063"
        />
        <path
          d="M7.77201 37.6506H7.75296C7.71486 37.6697 7.71486 37.5933 7.67677 37.6315C7.63867 37.6697 7.63867 37.6124 7.63867 37.5742C7.63867 37.536 7.67677 37.5551 7.69582 37.5551H7.73391C7.71486 37.5742 7.75296 37.5742 7.75296 37.5933H7.77201V37.6506Z"
          fill="#214063"
        />
        <path
          d="M7.01007 37.4021C7.02911 37.4021 7.01007 37.4021 7.01007 37.4212H6.99102C6.97197 37.4212 6.97197 37.4594 6.93388 37.4212C6.89578 37.383 6.91483 37.4021 6.89578 37.4021C6.89491 37.3918 6.89614 37.3813 6.89942 37.3715C6.90269 37.3616 6.90794 37.3526 6.91483 37.3448H7.02911C7.02154 37.3423 7.01327 37.3429 7.00612 37.3464C6.99898 37.35 6.99354 37.3563 6.99102 37.3639C6.98849 37.3715 6.98908 37.3798 6.99265 37.387C6.99622 37.3941 7.00249 37.3996 7.01007 37.4021Z"
          fill="#214063"
        />
        <path
          d="M6.66726 36.7145H6.64813C6.629 36.7145 6.60986 36.7145 6.60986 36.6953H6.66726V36.7145Z"
          fill="#214063"
        />
        <path
          d="M6.7629 36.0456C6.74376 36.0456 6.72463 36.0265 6.74377 36.0073H6.78203C6.80116 36.0265 6.78203 36.0648 6.7629 36.0456Z"
          fill="#214063"
        />
        <path
          d="M6.21063 36.9055H6.17236V36.8672H6.21063C6.21063 36.8672 6.22976 36.8863 6.21063 36.8863V36.9055Z"
          fill="#214063"
        />
        <path
          d="M6.28617 36.2558H6.24807C6.22902 36.2367 6.17188 36.2558 6.15283 36.1985V36.1603L6.20997 36.1221H6.28617C6.26712 36.1412 6.28617 36.1603 6.28617 36.1794H6.30521C6.30521 36.2558 6.28617 36.2367 6.28617 36.2558Z"
          fill="#214063"
        />
        <path
          d="M6.09556 36.6759H6.07651C6.05747 36.6759 6.07651 36.695 6.07651 36.695H6.03842C6.01937 36.7332 6.00032 36.6759 5.98128 36.695C5.96223 36.7141 5.96223 36.695 5.98128 36.6759H5.96223C5.94318 36.6759 5.96223 36.6376 5.94318 36.6376C5.94318 36.6326 5.94117 36.6277 5.9376 36.6241C5.93403 36.6206 5.92918 36.6185 5.92413 36.6185C5.92413 36.6185 5.94318 36.6185 5.92413 36.5994C5.90508 36.5803 5.90509 36.5803 5.94318 36.5803H5.96223C5.94318 36.5612 5.98128 36.5803 5.98128 36.5421C6.00032 36.5612 6.01937 36.523 6.01937 36.5421C6.01937 36.5612 6.03842 36.5612 6.07651 36.5421C6.11461 36.523 6.07651 36.5803 6.09556 36.5612H6.11461C6.11461 36.5612 6.09556 36.5803 6.11461 36.5803H6.13366C6.1286 36.5803 6.12376 36.5824 6.12019 36.5859C6.11662 36.5895 6.11461 36.5944 6.11461 36.5994H6.13366L6.09556 36.6759Z"
          fill="#214063"
        />
        <path
          d="M5.65792 36.1794V36.2176C5.63887 36.2176 5.63887 36.2558 5.61982 36.2367C5.60077 36.2176 5.60077 36.2558 5.60077 36.2367C5.59572 36.2367 5.59088 36.2388 5.58731 36.2423C5.58373 36.2459 5.58173 36.2508 5.58173 36.2558L5.52458 36.2176H5.50554C5.50554 36.1985 5.48649 36.1794 5.50554 36.1794V36.103H5.65792C5.65792 36.103 5.63887 36.1221 5.65792 36.1221C5.65792 36.1221 5.67696 36.103 5.67696 36.1221L5.65792 36.1794Z"
          fill="#214063"
        />
        <path
          d="M5.63887 37.0201C5.63887 37.0201 5.61974 37.001 5.63887 37.001V37.0201Z"
          fill="#214063"
        />
        <path
          d="M5.35303 37.4785H5.37216C5.39129 37.4977 5.37216 37.4977 5.37216 37.4977L5.35303 37.4785Z"
          fill="#214063"
        />
        <path
          d="M5.46786 36.3703H5.44873C5.46786 36.3703 5.46786 36.3512 5.46786 36.3703H5.487C5.487 36.3703 5.46786 36.3703 5.487 36.3895H5.46786V36.3703Z"
          fill="#214063"
        />
        <path
          d="M5.315 36.7908H5.25786C5.25096 36.7831 5.24572 36.774 5.24245 36.7641C5.23917 36.7543 5.23793 36.7439 5.23881 36.7335C5.23881 36.7335 5.25786 36.7335 5.23881 36.7144C5.21976 36.6953 5.2769 36.7144 5.25786 36.6953C5.25786 36.7004 5.25986 36.7052 5.26343 36.7088C5.26701 36.7124 5.27185 36.7144 5.2769 36.7144H5.29595C5.315 36.6953 5.315 36.7144 5.315 36.7144V36.7908Z"
          fill="#214063"
        />
        <path
          d="M5.27696 36.6956H5.16267C5.16267 36.6765 5.18172 36.6574 5.16267 36.6574C5.14363 36.6574 5.16267 36.6192 5.18172 36.6001H5.29601C5.29601 36.6192 5.27696 36.6383 5.29601 36.6383C5.31506 36.6574 5.27696 36.6765 5.27696 36.6956Z"
          fill="#214063"
        />
        <path
          d="M5.04857 36.4468C5.02952 36.4659 5.04857 36.4659 5.04857 36.4659H4.97237V36.5041H4.87714C4.87714 36.485 4.89618 36.4659 4.87714 36.4659H4.81999C4.83904 36.4659 4.83904 36.4468 4.81999 36.4468V36.4086C4.80095 36.4086 4.81999 36.4086 4.80095 36.3895C4.7819 36.3704 4.80095 36.3704 4.80095 36.3704H4.81999C4.81999 36.3704 4.85809 36.3704 4.83904 36.3513C4.85809 36.3322 4.83904 36.3322 4.83904 36.3322H4.87714C4.91523 36.3322 4.89618 36.2749 4.93428 36.2749H4.99142C4.97237 36.294 5.01047 36.3131 5.01047 36.294H5.02952C5.02952 36.3131 5.01047 36.3322 5.02952 36.3322H5.04857C5.02952 36.3322 5.02952 36.3513 5.04857 36.3513C5.04857 36.3513 5.02952 36.3704 5.04857 36.3704H5.06761C5.08666 36.3704 5.06761 36.3895 5.06761 36.3895L5.04857 36.4468Z"
          fill="#214063"
        />
        <path
          d="M6.47674 37.4786H6.43848C6.45761 37.4594 6.45761 37.4211 6.47674 37.4403H6.51501C6.49588 37.4403 6.51501 37.4594 6.49588 37.4786H6.47674Z"
          fill="#214063"
        />
        <path
          d="M6.36279 37.4214H6.38193H6.40106L6.38193 37.4405L6.36279 37.4214Z"
          fill="#214063"
        />
        <path
          d="M6.32425 37.4404H6.3052C6.28616 37.4595 6.24806 37.4404 6.22901 37.4404L6.19092 37.4022C6.19092 37.383 6.20997 37.4022 6.19092 37.383V37.3066H6.32425C6.32425 37.3257 6.3052 37.3257 6.32425 37.3448C6.3433 37.3639 6.3052 37.3639 6.32425 37.383H6.3433C6.3433 37.4022 6.32425 37.4022 6.32425 37.4404Z"
          fill="#214063"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2023_11961"
          x1="39.3154"
          y1="7.02792"
          x2="57.4411"
          y2="7.42488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0068CA" />
          <stop offset="0.1" stopColor="#1475D2" stopOpacity="0.84" />
          <stop offset="0.27" stopColor="#348BE0" stopOpacity="0.59" />
          <stop offset="0.43" stopColor="#4E9CEB" stopOpacity="0.38" />
          <stop offset="0.59" stopColor="#62AAF4" stopOpacity="0.21" />
          <stop offset="0.74" stopColor="#71B4FA" stopOpacity="0.1" />
          <stop offset="0.88" stopColor="#7ABAFE" stopOpacity="0.02" />
          <stop offset="1" stopColor="#7DBCFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2023_11961"
          x1="38.9852"
          y1="22.1932"
          x2="57.1091"
          y2="22.5901"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0068CA" />
          <stop offset="0.1" stopColor="#1475D2" stopOpacity="0.84" />
          <stop offset="0.27" stopColor="#348BE0" stopOpacity="0.59" />
          <stop offset="0.43" stopColor="#4E9CEB" stopOpacity="0.38" />
          <stop offset="0.59" stopColor="#62AAF4" stopOpacity="0.21" />
          <stop offset="0.74" stopColor="#71B4FA" stopOpacity="0.1" />
          <stop offset="0.88" stopColor="#7ABAFE" stopOpacity="0.02" />
          <stop offset="1" stopColor="#7DBCFF" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_2023_11961">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
